import { forwardRef as i } from "react";
import { jsxs as a, jsx as l } from "react/jsx-runtime";
export * from "@nv-brand-assets/icons";
function c(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5 3.25a.25.25 0 1 1 .5 0 .25.25 0 0 1-.5 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7.5 5.5H3V1h4.5zM5.25 2a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M13 5.5H8.5V1H13zM3 10V6.5h10V10a5 5 0 0 1-10 0"
          }
        )
      ]
    }
  );
}
const d = /* @__PURE__ */ i(c);
function w(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 2.293 2.354 2.353-.707.708L8.5 4.207v4.504l3.901 2.252-.42-1.566.966-.258.862 3.215-3.215.861-.26-.966 1.567-.42-3.9-2.252-3.902 2.252 1.566.42-.259.966-3.215-.861.862-3.215.966.258-.42 1.566L7.5 8.712V4.207L6.354 5.354l-.707-.708z"
        }
      )
    }
  );
}
const v = /* @__PURE__ */ i(w);
function m(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 7H2V2h5zm4 4V9h1v2h2v1h-2v2h-1v-2H9v-1zm-4 3H2V9h5zm7-7H9V2h5z"
        }
      )
    }
  );
}
const g = /* @__PURE__ */ i(m);
function s(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 7H2V2h5zm0 7H2V9h5zm7 0H9V9h5zm0-7H9V2h5z"
        }
      )
    }
  );
}
const f = /* @__PURE__ */ i(s);
function u(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6M4.456 8H8.67a4.5 4.5 0 0 0-.912 6h-4.91zM11 14.5V12H8.5v-1H11V8.5h1V11h2.5v1H12v2.5z"
        }
      )
    }
  );
}
const p = /* @__PURE__ */ i(u);
function H(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3.671 4a4.5 4.5 0 0 0-.913 6h-4.91l1.608-6zm-.525 3.854.708-.707 1.646 1.646 4.147-4.147.707.708-4.854 4.853z"
        }
      )
    }
  );
}
const M = /* @__PURE__ */ i(H);
function x(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-.544 4H7.67a4.5 4.5 0 0 0-.912 6h-3.91zM8.5 10.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m1.5 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3.5-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
        }
      )
    }
  );
}
const z = /* @__PURE__ */ i(x);
function V(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6M4.456 8H8.67a4.5 4.5 0 0 0-.912 6h-4.91zM8.5 11h6v1h-6z"
        }
      )
    }
  );
}
const C = /* @__PURE__ */ i(V);
function L(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7.5 7.5V2h1v5.5H14v1H8.5V14h-1V8.5H2v-1z" })
    }
  );
}
const $ = /* @__PURE__ */ i(L);
function S(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7.5 4V8.5H12v-1H8.5V4h-1v3.5H4v1h3.5V12z"
        }
      )
    }
  );
}
const k = /* @__PURE__ */ i(S);
function y(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9.2 4.1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m2.451 6.8H6.748l.804-3h3.295z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 14H3v-3H2v-1h1V8.5H2v-1h1V6H2V5h1V2h11zM4 11v2h9V3H4v2h1v1H4v1.5h1v1H4V10h1v1z"
          }
        )
      ]
    }
  );
}
const b = /* @__PURE__ */ i(y);
function R(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m9.384 2 1.072 4H13a2 2 0 1 1 0 4h-2.544l-1.072 4H7v-4H4.384l-.268 1H1.179l.804-3-.804-3h2.937l.268 1H7V2z"
        }
      )
    }
  );
}
const B = /* @__PURE__ */ i(R);
function F(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 2.293v2.414l-1 1V8h2v1h-1v4h1v1H2v-1h1V9H2V8h7V5.707l-1-1V2.293L9.293 1h2.414zM11 6h-1v7h1zm.293-1L12 4.293V4H9v.293L9.707 5zM9 3h3v-.293L11.293 2H9.707L9 2.707zm-3 7H5v1h1zm2 0H7v1h1z"
        }
      )
    }
  );
}
const A = /* @__PURE__ */ i(F);
function q(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.354 2.354-2 2-.708-.708 2-2zm6-.708 2 2-.707.708-2-2zM3 8a5 5 0 1 1 8.504 3.567l.483 1.804-.966.258-.372-1.388a5 5 0 0 1-5.295.002l-.371 1.386-.966-.258.482-1.8A5 5 0 0 1 3 8m3.74-2.769.852 3.177 3.177.852.259-.966-2.62-.702-.702-2.62z"
        }
      )
    }
  );
}
const O = /* @__PURE__ */ i(q);
function D(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 3a2 2 0 1 1 2.5 1.937V7H10v1H8.5v5.42a7 7 0 0 1 .544-.315c.239-.127.49-.25.74-.371l.092-.046q.423-.202.835-.426c.976-.536 1.833-1.199 2.248-2.383l-1.13-.409.341-.94 1.988.72-.102.434c-.44 1.856-1.67 2.798-2.863 3.454-.297.163-.595.31-.877.449l-.093.045c-.251.123-.487.238-.71.356-.506.27-.882.523-1.123.824L8 15.3l-.39-.488c-.241-.3-.617-.555-1.124-.824-.222-.118-.458-.233-.709-.356l-.093-.045a21 21 0 0 1-.877-.449c-1.194-.656-2.423-1.598-2.863-3.454l-.102-.433L3.83 8.53l.34.94-1.128.41c.414 1.183 1.271 1.846 2.247 2.382.274.15.553.288.835.426l.093.046c.248.121.5.244.739.371q.277.145.544.315V8H6V7h1.5V4.937A2 2 0 0 1 6 3"
        }
      )
    }
  );
}
const P = /* @__PURE__ */ i(D);
function T(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M3 3h10v10H3zm3 7h4V6H6zm3-3v2H7V7z" })
    }
  );
}
const W = /* @__PURE__ */ i(T);
function G(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 3h10v3h-3v4h3v3H3zm4 3H6v1h1zm0 3H6v1h1z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 9h-2V7h2z" })
      ]
    }
  );
}
const E = /* @__PURE__ */ i(G);
function N(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 13V3h3v3h4V3h3v10zm3-4v1h1V9zm3 0v1h1V9z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M9 3v2H7V3z" })
      ]
    }
  );
}
const j = /* @__PURE__ */ i(N);
function U(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 7h4v6H3V3h6zm2-2V3h2v2zm-1 5V9H9v1zM7 6H6v1h1zm0 4V9H6v1z"
        }
      )
    }
  );
}
const I = /* @__PURE__ */ i(U);
function Q(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 7V3h6v10H3V7zM5 5H3V3h2zm5 1H9v1h1zM6 9v1h1V9zm4 0H9v1h1z"
        }
      )
    }
  );
}
const K = /* @__PURE__ */ i(Q);
function J(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 3v10h-3v-3H6v3H3V3zm-3 4V6H9v1zM7 7V6H6v1z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7 13v-2h2v2z" })
      ]
    }
  );
}
const X = /* @__PURE__ */ i(J);
function Y(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 9v4H3V3h10v6zm2 2h2v2h-2zm-5-1h1V9H6zm4-3V6H9v1zM6 7h1V6H6z"
        }
      )
    }
  );
}
const Z = /* @__PURE__ */ i(Y);
function _(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 9H3V3h10v10H7zm-2 2v2H3v-2zm1-5v1h1V6zm3 4h1V9H9zm0-4v1h1V6z"
        }
      )
    }
  );
}
const n1 = /* @__PURE__ */ i(_);
function l1(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 13H3v-3h3V6H3V3h10zm-4-3h1V9H9zm0-3h1V6H9z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M3 7h2v2H3z" })
      ]
    }
  );
}
const t1 = /* @__PURE__ */ i(l1);
function i1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.5 8.482 3 .804 2.871-.769.259.966-3.13.838-3-.803-2.87.769-.259-.966zm0-3 3 .804 2.871-.769.259.966-3.13.839-3-.804-2.87.769-.259-.966z"
        }
      )
    }
  );
}
const e1 = /* @__PURE__ */ i(i1);
function o1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 5H2V2h3zm4.5 0h-3V2h3zM14 5h-3V2h3zM5 9.5H2v-3h3zm4.5 0h-3v-3h3zm4.5 0h-3v-3h3zM5 14H2v-3h3zm4.5 0h-3v-3h3zm4.5 0h-3v-3h3z"
        }
      )
    }
  );
}
const r1 = /* @__PURE__ */ i(o1);
function h1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 5H2V3h12zm-1 8H3V6h10zM6 8h4V7H6z" })
    }
  );
}
const a1 = /* @__PURE__ */ i(h1);
function c1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.275 9.629 3.048 3.048-1.646 1.646-3.048-3.048L7.5 15 1.75 1.75 15 7.5z"
        }
      )
    }
  );
}
const d1 = /* @__PURE__ */ i(c1);
function w1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 3v7.793l3.146-3.147.708.708L8 12.707 3.646 8.354l.708-.708L7.5 10.793V3z"
        }
      )
    }
  );
}
const v1 = /* @__PURE__ */ i(w1);
function m1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 12V6h1v4.293l5.646-5.647.708.708L5.707 11H10v1z"
        }
      )
    }
  );
}
const g1 = /* @__PURE__ */ i(m1);
function s1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 2v7.793l3.146-3.147.708.708L8 11.707 3.646 7.354l.708-.708L7.5 9.793V2zM13 12v1H3v-1z"
        }
      )
    }
  );
}
const f1 = /* @__PURE__ */ i(s1);
function u1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 12H6v-1h4.293L4.646 5.354l.708-.708L11 10.293V6h1z"
        }
      )
    }
  );
}
const p1 = /* @__PURE__ */ i(u1);
function H1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m7.647 3.646.707.708L5.207 7.5H13v1H5.207l3.147 3.146-.707.708L3.293 8z"
        }
      )
    }
  );
}
const M1 = /* @__PURE__ */ i(H1);
function x1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 13V3h1v10zm5.646-9.354.708.708L6.207 7.5H14v1H6.207l3.147 3.146-.708.708L4.293 8z"
        }
      )
    }
  );
}
const z1 = /* @__PURE__ */ i(x1);
function V1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m3.207 8.5 2.147 2.146-.707.708L1.293 8l3.354-3.354.707.708L3.207 7.5h9.586l-2.146-2.146.707-.708L14.707 8l-3.353 3.354-.707-.707L12.793 8.5z"
        }
      )
    }
  );
}
const C1 = /* @__PURE__ */ i(V1);
function L1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.793 7.5 7.646 4.354l.708-.708L12.707 8l-4.353 4.354-.708-.707L10.793 8.5H3v-1z"
        }
      )
    }
  );
}
const $1 = /* @__PURE__ */ i(L1);
function S1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 13h-1V3h1zM9.793 7.5 6.646 4.354l.708-.708L11.707 8l-4.353 4.354-.708-.708L9.793 8.5H2v-1z"
        }
      )
    }
  );
}
const k1 = /* @__PURE__ */ i(S1);
function y1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 3.293 4.354 4.353-.707.708L8.5 5.207V13h-1V5.207L4.354 8.354l-.708-.708z"
        }
      )
    }
  );
}
const b1 = /* @__PURE__ */ i(y1);
function R1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 1.293 3.354 3.353-.707.708L8.5 3.207v9.586l2.146-2.147.708.707L8 14.708l-3.354-3.354.708-.707L7.5 12.793V3.207L5.354 5.354l-.708-.708z"
        }
      )
    }
  );
}
const B1 = /* @__PURE__ */ i(R1);
function F1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 4h6v1H5.707l5.647 5.646-.708.708L5 5.707V10H4z"
        }
      )
    }
  );
}
const A1 = /* @__PURE__ */ i(F1);
function q1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 4H3V3h10zm-5 .293 4.354 4.353-.708.708L8.5 6.207V14h-1V6.207L4.354 9.354l-.708-.708z"
        }
      )
    }
  );
}
const O1 = /* @__PURE__ */ i(q1);
function D1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 4v6h-1V5.707l-5.646 5.647-.708-.708L10.293 5H6V4z"
        }
      )
    }
  );
}
const P1 = /* @__PURE__ */ i(D1);
function T1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.293 2h7.414L14 4.293v4.414l-1.985 1.985-2.366-.634-.942.942H5.793L5 10.207V8.793l.741-.741L9 7.179v-.972L8.793 6H6.207l-.353.354-.708-.708L5.793 5h3.414l.793.793v3.323l1.717.46L13 8.293V4.707L11.293 3H4.707L3 4.707v6.586L4.707 13h6.586l.853-.854.708.708L11.707 14H4.293L2 11.707V4.293zM9 9.293v-1.08l-2.741.735-.259.26v.585l.207.207h2.086z"
        }
      )
    }
  );
}
const W1 = /* @__PURE__ */ i(T1);
function G1(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4 8a4 4 0 0 0 2.685 3.779 1.5 1.5 0 1 1-.159 1 5.001 5.001 0 1 1 6.431-5.443l.69-.69.707.708L12 9.707V8a4 4 0 1 0-8 0"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4" })
      ]
    }
  );
}
const E1 = /* @__PURE__ */ i(G1);
function N1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-4.631-4.63a2 2 0 0 1-2.74-2.74L4.84 5.547a4.002 4.002 0 0 0 1.844 6.232 1.5 1.5 0 1 1-.158 1 5.002 5.002 0 0 1-2.397-7.943L1.646 2.354zM8 4c-.358 0-.706.047-1.036.136l-.791-.792a5 5 0 0 1 6.784 3.992l.69-.69.707.708L12 9.707V8a4 4 0 0 0-4-4"
        }
      )
    }
  );
}
const j1 = /* @__PURE__ */ i(N1);
function U1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 .258 1.19 1.305 1.681-.536.378 1.725 1.724.377-.535 1.682L13.743 6l-1.305 1.189.535 1.682-.973.213v5.655l-4-1.6-4 1.6V9.084l-.973-.213.536-1.682L2.258 6l1.305-1.189-.536-1.682 1.725-.377.377-1.725 1.682.536zM5 10.384v2.877l3-1.2 3 1.2v-2.877l-.129.589-1.682-.536L8 11.742l-1.189-1.305-1.682.536zM8 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
        }
      )
    }
  );
}
const I1 = /* @__PURE__ */ i(U1);
function Q1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.934 2h8.132l-.25 2h2.336l-1.34 5h-1.62l-.25 2h-1.79l.535 2H11v1H5v-1h1.312l.536-2h-1.79l-.25-2h-1.62l-1.34-5h2.336zm.375 3H3.15l.804 3h.729zm3.574 6-.535 2h1.304l-.536-2zm3.433-3h.729l.803-3h-1.157zM9.5 4h-3v1h3z"
        }
      )
    }
  );
}
const K1 = /* @__PURE__ */ i(Q1);
function J1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 4c0-.508.34-.999.956-1.39a4 4 0 0 1 1.19-.5A6.002 6.002 0 0 1 8 14 6 6 0 0 1 6.983 2.086C6.423 2.56 6 3.205 6 4a2 2 0 0 0 2.517 1.932l-.258-.966A1.002 1.002 0 0 1 7 4M5 7a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-1 4a4 4 0 0 0 2.828-1.172l-.707-.707a3 3 0 0 1-4.244 0l-.707.707A4 4 0 0 0 8 11"
        }
      )
    }
  );
}
const X1 = /* @__PURE__ */ i(J1);
function Y1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.81 3H14v10H3.81L.922 8zm2.836 3.354L8.293 8 6.646 9.646l.708.708L9 8.707l1.646 1.647.708-.708L9.707 8l1.647-1.646-.707-.708L9 7.293 7.354 5.646z"
        }
      )
    }
  );
}
const Z1 = /* @__PURE__ */ i(Y1);
function _1(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5.793 15.207 4.5 4.5 15.207.793 11.5zM10.293 8 9.5 7.207 8.707 8l.793.793zm-1.5 1.5L8 8.707l-.793.793.793.793zM5.707 8l.793.793L7.293 8 6.5 7.207zm1.5-1.5L8 7.293l.793-.793L8 5.707z"
        }
      )
    }
  );
}
const n0 = /* @__PURE__ */ i(_1);
function l0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 6h-2v5h1v2h1v1H2v-1h1v-2h1V6H2V4.66l6-2.373 6 2.373zm-3 0h-1v5h1zM7 6v5h2V6zM6 6H5v5h1z"
        }
      )
    }
  );
}
const t0 = /* @__PURE__ */ i(l0);
function i0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 13V3h1v10zM4 3h2v10H4zm5 0h2v10H9zM7 13V3h1v10zm6 0V3h1v10z"
        }
      )
    }
  );
}
const e0 = /* @__PURE__ */ i(i0);
function o0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 7h1v2h-1v2H2V5h11z" })
    }
  );
}
const r0 = /* @__PURE__ */ i(o0);
function h0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708L10.293 11H2V5h2.293L1.646 2.354zM13 9v1.172L7.828 5H13v2h1v2z"
        }
      )
    }
  );
}
const a0 = /* @__PURE__ */ i(h0);
function c0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 7h1v2h-1v2H2V5h11zM4 9h1V7H4z" })
    }
  );
}
const d0 = /* @__PURE__ */ i(c0);
function w0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 7h1v2h-1v2H2V5h11zM4 9h1V7H4zm3-2H6v2h1z"
        }
      )
    }
  );
}
const v0 = /* @__PURE__ */ i(w0);
function m0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 7h1v2h-1v2H2V5h11zM4 9h1V7H4zm3-2H6v2h1zm1 2h1V7H8z"
        }
      )
    }
  );
}
const g0 = /* @__PURE__ */ i(m0);
function s0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 7h1v2h-1v2H2V5h11zM4 9h1V7H4zm3-2H6v2h1zm1 2h1V7H8zm3-2h-1v2h1z"
        }
      )
    }
  );
}
const f0 = /* @__PURE__ */ i(s0);
function u0(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M10 6v2.133L8.001 6.979 6 8.134V6z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10 9.288v1.345L8.001 9.479 6 10.634V9.289l2.001-1.156z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.001 4.536 6-3.464 6 3.464v6.928l-6 3.464-6-3.464zM11 12.042V5H9V4H7v1H5v7.042l1 .578v-.83l2.001-1.157L10 11.788v.831z"
          }
        )
      ]
    }
  );
}
const p0 = /* @__PURE__ */ i(u0);
function H0(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M10.85 7 7 13.93V9H5.15L9 2.07V7z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3.45 10H6v1H2V5h4.229zm9.1-4H10V5h3v2h1v2h-1v2H9.771z"
          }
        )
      ]
    }
  );
}
const M0 = /* @__PURE__ */ i(H0);
function x0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.619 2H10v3.928l3 5.196V14H3v-2.876l3-5.196V2h-.5V1h5.119zM9 6.196V2H7v4.196L6.536 7h2.928zM8 10v1h1v-1zm-2 1v1h1v-1z"
        }
      )
    }
  );
}
const z0 = /* @__PURE__ */ i(x0);
function V0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 3h1v2.165h2.315L6 5.616V7h6.7l1.3.348V6h1v7h-1v-2H2v2H1zm1 4h3v-.616l-.817-.22H2z"
        }
      )
    }
  );
}
const C0 = /* @__PURE__ */ i(V0);
function L0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.925 2.384A5 5 0 0 1 13 7v3.382L14.309 13h-4.308a2 2 0 1 1-4 0h-4.31L3 10.382V7a5 5 0 0 1 3.075-4.616L6.46 1h3.08z"
        }
      )
    }
  );
}
const $0 = /* @__PURE__ */ i(L0);
function S0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.498 2.67q.28-.162.577-.286L6.461 1H9.54l.385 1.384A5 5 0 0 1 13 7v3.172zM10 13a2 2 0 1 1-4 0H1.691L3 10.382V7a5 5 0 0 1 .715-2.578L1.646 2.354l.708-.708 12 12-.707.708L12.293 13z"
        }
      )
    }
  );
}
const k0 = /* @__PURE__ */ i(S0);
function y0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 5v1H5.955l-.338 1.263A2.5 2.5 0 0 1 6.95 9h.357l-.281-.842.949-.316L8.36 9h.689a2.5 2.5 0 0 1 2.601-1.995L11.921 6H11V5h3v1h-1.045l-.339 1.263A2.5 2.5 0 1 1 9.05 10h-.356l.28.842-.948.316L7.64 10h-.69a2.5 2.5 0 1 1-2.3-2.996L5.189 5z"
        }
      )
    }
  );
}
const b0 = /* @__PURE__ */ i(y0);
function R0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v8h-2V8H8v2H2zm6 2H4v1h4zM4 7h3V6H4zm-3 6v-2h14v2z"
        }
      )
    }
  );
}
const B0 = /* @__PURE__ */ i(R0);
function F0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 .793 11.207 5l-3 3 3 3L7 15.207v-6l-2.646 2.647-.708-.707L6.793 8 3.646 4.854l.708-.707L7 6.793zm1 12L9.793 11 8 9.207zM9.793 5 8 3.207v3.586z"
        }
      )
    }
  );
}
const A0 = /* @__PURE__ */ i(F0);
function q0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.207 5-1.69 1.69-.706-.708L9.793 5 8 3.207v1.965l-1-1V.793zM7 15.207v-6l-2.646 2.647-.707-.708L6.793 8 1.146 2.354l.708-.707 12 12-.708.707-2.646-2.647zm1-2.414L9.793 11 8 9.207z"
        }
      )
    }
  );
}
const O0 = /* @__PURE__ */ i(q0);
function D0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 3h3.5a2.5 2.5 0 0 1 1.76 4.276A3 3 0 0 1 8 13H4zm1 5v4h3a2 2 0 1 0 0-4zm0-1h2.5a1.5 1.5 0 1 0 0-3H5z"
        }
      )
    }
  );
}
const P0 = /* @__PURE__ */ i(D0);
function T0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 2v12H3.5A1.5 1.5 0 0 1 2 12.5v-9A1.5 1.5 0 0 1 3.5 2zm-1 10H3.5a.5.5 0 0 0 0 1H13zM4 5h7.5V4H4zm0 2h7.5V6H4zm0 2h4V8H4z"
        }
      )
    }
  );
}
const W0 = /* @__PURE__ */ i(T0);
function G0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "m13 15.35-5-2.778-5 2.778V1h10z" })
    }
  );
}
const E0 = /* @__PURE__ */ i(G0);
function N0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 14 14-.707.708L13 13.707v1.643l-5-2.778-5 2.778V3.707L.646 1.354zM13 1v9.172L3.828 1z"
        }
      )
    }
  );
}
const j0 = /* @__PURE__ */ i(N0);
function U0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m9.5 5.793 2.03 2.03-1.096 7.677H5.566L4.47 7.823l2.03-2.03V.5h3z"
        }
      )
    }
  );
}
const I0 = /* @__PURE__ */ i(U0);
function Q0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h3v1h6V2h3v3h-1v6h1v3h-3v-1H5v1H2v-3h1V5H2zm2 3v6h1v1h6v-1h1V5h-1V4H5v1z"
        }
      )
    }
  );
}
const K0 = /* @__PURE__ */ i(Q0);
function J0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2M5 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m8 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2M5 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m5-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-8 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0m8-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
        }
      )
    }
  );
}
const X0 = /* @__PURE__ */ i(J0);
function Y0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.884 4H14v9H2V4h3.116l.536-2h4.696zM9.848 4 9.58 3H6.42l-.268 1z"
        }
      )
    }
  );
}
const Z0 = /* @__PURE__ */ i(Y0);
function _0(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a7 7 0 1 1 13.062 3.502L13.197 11a6 6 0 1 0-10.394 0l-.865.5A6.97 6.97 0 0 1 1 8m3 0a4 4 0 1 1 7.464 2.002l-.866-.501a3 3 0 1 0-5.197 0l-.865.5A4 4 0 0 1 4 8m3 0a1 1 0 1 1 1.706.708l1.517 5.663-.966.258-.302-1.129H7.043l-.303 1.13-.966-.26 1.518-5.664A1 1 0 0 1 7 8m.999 1.932L7.311 12.5h1.376z"
        }
      )
    }
  );
}
const nn = /* @__PURE__ */ i(_0);
function ln(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 11.25c0 1.544-1.104 2.558-2.43 2.745-.6.085-1.296.089-1.927-.078-.634-.167-1.255-.523-1.59-1.193l-.258-.516.547-.182c.47-.157.755-.603 1.145-1.274l.016-.027c.209-.36.457-.784.787-1.112A2 2 0 0 1 4.75 9h.042L7 11.208zm1.646-2.397-1.293 1.293-1.5-1.5 1.293-1.293zM12.25 2.25l1.5 1.5-4.397 4.396-1.5-1.5z"
        }
      )
    }
  );
}
const tn = /* @__PURE__ */ i(ln);
function en(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.847 4.14 5.792 8.078l.966.259L8.357 2.37l.966.258-.843 3.144 3.02 3.02v.689l-1.741.466-3.259 3.26L1.793 8.5 6.5 3.793zm4.737 6.708c.26-.39.576-.733.916-1.055q.517.477.916 1.055c.267.4.584 1.002.584 1.652a1.5 1.5 0 1 1-3 0c0-.65.317-1.252.584-1.652"
        }
      )
    }
  );
}
const on = /* @__PURE__ */ i(en);
function rn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.985 3.778-.576-2.149.966-.258.496 1.849a3 3 0 0 1 2.258 0l.496-1.85.966.26-.576 2.148C10.62 4.326 11 5.118 11 6h1.616l.548-2.044.966.259L13.383 7H11v1.5h3v1h-3V11h2.383l.747 2.785-.966.26L12.616 12H10.83a3 3 0 0 1-5.658 0H3.383l-.547 2.044-.966-.259L2.616 11H5V9.5H2v-1h3V7H2.616L1.87 4.215l.966-.26L3.383 6H5c0-.882.38-1.674.985-2.222M7.5 6.5v5h1v-5z"
        }
      )
    }
  );
}
const hn = /* @__PURE__ */ i(rn);
function an(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 9.5h-1.67l-1-1H14zM11 7v1.172L5.758 2.929l-.349-1.3.966-.258.496 1.849a3 3 0 0 1 2.258 0l.496-1.85.966.26-.576 2.148C10.62 4.326 11 5.118 11 6h1.616l.548-2.044.966.259L13.383 7zm-.171 5a3 3 0 0 1-5.658 0H3.383l-.547 2.045-.966-.26L2.616 11H5V9.5H2v-1h3V7H2.616L1.87 4.215l.966-.259L3.384 6H5q0-.14.013-.28L1.646 2.354l.708-.708 12 12-.707.708L11.293 12zM8.5 9.207l-1-1V11.5h1z"
        }
      )
    }
  );
}
const cn = /* @__PURE__ */ i(an);
function dn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12.5 3c.348 0 .62.199.806.399a3.1 3.1 0 0 1 .508.783c.292.608.532 1.421.682 2.296.16.91.209 1.836.144 2.757-.071.909-.281 1.806-.711 2.522l-.146.243H3.5a2.5 2.5 0 0 1-.865-4.846 3.001 3.001 0 0 1 5.26 1.057A2 2 0 0 1 8.732 11h1.985a6.8 6.8 0 0 1-.357-1.765 11.3 11.3 0 0 1 .144-2.757c.15-.875.39-1.688.682-2.296a3.1 3.1 0 0 1 .507-.783C11.88 3.2 12.152 3 12.5 3"
        }
      )
    }
  );
}
const wn = /* @__PURE__ */ i(dn);
function vn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 2h7v3h6v9H5.5v-2h-2v2H1zm3 2H3v1h1zm5 4h1V7H9zM6 4H5v1h1zm5 4h1V7h-1zM4 6H3v1h1zm5 4h1V9H9zM4 8H3v1h1zm1-1h1V6H5zm7 2h-1v1h1zM5 9h1V8H5zm7 2h-1v1h1zm-3 1h1v-1H9z"
        }
      )
    }
  );
}
const mn = /* @__PURE__ */ i(vn);
function gn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.5 2h9v12h-9zm1 1v2h7V3zm2 4h-1v1h1zm-1 3h1V9h-1zm1 1h-1v1h1zm1-3h1V7h-1zm1 1h-1v1h1zm-1 3h1v-1h-1zm3-5h-1v1h1zm-1 3h1V9h-1zm1 1h-1v1h1z"
        }
      )
    }
  );
}
const sn = /* @__PURE__ */ i(gn);
function fn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 3V2h1v1h4V2h1v1h3v11H2V3zm0 1H3v2h10V4h-2v1h-1V4H6v1H5z"
        }
      )
    }
  );
}
const un = /* @__PURE__ */ i(fn);
function pn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 2v1h4V2h1v1h3v11H2V3h3V2zM3 6h10V4h-2v1h-1V4H6v1H5V4H3zm5 1.87-.641 1.3-1.433.207 1.037 1.011-.245 1.428L8 11.142l1.282.674-.245-1.428 1.037-1.01-1.433-.209z"
        }
      )
    }
  );
}
const Hn = /* @__PURE__ */ i(pn);
function Mn(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.191 2h3.618l1 2H14v9H2V4h3.191zM8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
          }
        )
      ]
    }
  );
}
const xn = /* @__PURE__ */ i(Mn);
function zn(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.191 2h3.618l1 2H14v5h-3.17a3 3 0 1 0-5.66 0H3v3h1v1H2V4h3.191z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10 8c0 .364-.097.706-.268 1H6.268A2 2 0 1 1 10 8m-4 2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4v-1h2v-1H5v-1h1v-1H4v-1zm5 0v1.01h-1V11H9v1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm-1 4v-1H9v1zm4-4a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm-1 4h1v-3h-1z"
          }
        )
      ]
    }
  );
}
const Vn = /* @__PURE__ */ i(zn);
function Cn(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.191 2h3.618l1 2H14v3.758a4.48 4.48 0 0 0-3.155-.71 3.001 3.001 0 1 0-3.798 3.797A4.54 4.54 0 0 0 7.257 13H2V4h3.191z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 6a2 2 0 0 1 1.875 1.302 4.5 4.5 0 0 0-2.573 2.573A2 2 0 0 1 8 6m3 8.5V12H8.5v-1H11V8.5h1V11h2.5v1H12v2.5z"
          }
        )
      ]
    }
  );
}
const Ln = /* @__PURE__ */ i(Cn);
function $n(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 4a3 3 0 0 0-3-3V0a4 4 0 0 1 4 4z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12 4a1 1 0 0 0-1-1V2a2 2 0 0 1 2 2zM6 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.191 3h3.618l1 2H14v9H2V5h3.191zM8 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
          }
        )
      ]
    }
  );
}
const Sn = /* @__PURE__ */ i($n);
function kn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 13V4h1.293L1.646 2.354l.708-.708 12 12-.707.708L12.293 13zm7.738-2.555-.722-.722a2 2 0 0 1-2.74-2.74l-.721-.721a3 3 0 0 0 4.184 4.184M14 4v7.172l-3.005-3.005Q11.001 8.085 11 8a3 3 0 0 0-3.167-2.995L5.737 2.908 6.19 2h3.618l1 2z"
        }
      )
    }
  );
}
const yn = /* @__PURE__ */ i(kn);
function bn(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.191 2h3.618l1 2H14v5h-3v4H2V4h3.191zM8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M15 10v1.01h-1V11h-1v1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2v-1.01h1V14h1v-1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z"
          }
        )
      ]
    }
  );
}
const Rn = /* @__PURE__ */ i(bn);
function Bn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.418 4.126a6 6 0 0 0 8.456 8.456zm.708-.708 8.455 8.456a6 6 0 0 0-8.456-8.456M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8"
        }
      )
    }
  );
}
const Fn = /* @__PURE__ */ i(Bn);
function An(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13.515 5.5h.845l.834 2.5H14v1.562L13.391 12h-.581l-.5 1h-1.618l-.5-1H5.81l-.5 1H3.69l-.5-1h-.58L2 9.562V8H.806l.833-2.5h.846L3.11 3h9.78zM12.86 7l-.75-3H8.5v.5H9v1H7v-1h.5V4H3.89l-.75 3H8.5c0-.495.301-.883.662-1.123C9.526 5.634 10 5.5 10.5 5.5s.974.134 1.338.377c.36.24.662.628.662 1.123zM11.5 7c0-.057-.035-.17-.217-.291A1.44 1.44 0 0 0 10.5 6.5c-.33 0-.605.09-.783.209-.182.121-.217.234-.217.291zM6 9H4v1h2zm6 0h-2v1h2z"
        }
      )
    }
  );
}
const qn = /* @__PURE__ */ i(An);
function On(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4 2h8v1H4zm10 2v8H2V4zm-2 10H4v-1h8z" })
    }
  );
}
const Dn = /* @__PURE__ */ i(On);
function Pn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M12 14H4V2h8zm2-10v8h-1V4zM2 4h1v8H2z" })
    }
  );
}
const Tn = /* @__PURE__ */ i(Pn);
function Wn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 1H10v2H8.5v3H9V5h1v1h1V5h1v2h-1v1h1V7h1v1h1V7h1v2h-1v5H9v-3H7v3H2V9H1V7h1v1h1V7h1v1h1V7H4V5h1v1h1V5h1v1h.5z"
        }
      )
    }
  );
}
const Gn = /* @__PURE__ */ i(Wn);
function En(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.854 4.854 9.5 10.207l-3-3-4.646 4.647-.708-.707L6.5 5.792l3 3 4.647-4.647z"
        }
      )
    }
  );
}
const Nn = /* @__PURE__ */ i(En);
function jn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 10h3v4H2zm4-4h3v8H6zm4-4h3v12h-3z" })
    }
  );
}
const Un = /* @__PURE__ */ i(jn);
function In(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m3.5 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2M4 9.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5.5-2a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
        }
      )
    }
  );
}
const Qn = /* @__PURE__ */ i(In);
function Kn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 7H5v2.05A2.5 2.5 0 0 1 6.95 11h2.343L12 8.293l3.207 3.207L12 14.707 9.293 12H6.95A2.5 2.5 0 1 1 4 9.05V7H2V2h5z"
        }
      )
    }
  );
}
const Jn = /* @__PURE__ */ i(Kn);
function Xn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 5H8.5v2.5h5V11H15v4h-4v-4h1.5V8.5h-4V11H10v4H6v-4h1.5V8.5h-4V11H5v4H1v-4h1.5V7.5h5V5H6V1h4z"
        }
      )
    }
  );
}
const Yn = /* @__PURE__ */ i(Xn);
function Zn(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 2h3v3H7V3.707L3.354 7.354l-.708-.708L6.293 3H5zm-3 8h3v4H2zm4-2h3v6H6zm4-2h3v8h-3z"
        }
      )
    }
  );
}
const _n = /* @__PURE__ */ i(Zn);
function n2(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 2a6 6 0 0 1 5.982 6.472l-.047.6-5.527-1.48-1.481-5.527.6-.047Q7.763 2 8 2"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m13.677 10.039-.259.542a6 6 0 1 1-8-7.998l.544-.26 1.63 6.085z"
          }
        )
      ]
    }
  );
}
const l2 = /* @__PURE__ */ i(n2);
function t2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12.5 2.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-3 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-3 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-2 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-1 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m1-1a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const i2 = /* @__PURE__ */ i(t2);
function e2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 5H4.5v3H8V7h3v3H8V9H4.5v3H8v-1h3v3H8v-1H3.5V5H2V2h12z"
        }
      )
    }
  );
}
const o2 = /* @__PURE__ */ i(e2);
function r2(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.61 7h2.78l.5 2H13v2.5h1V11h1v2h-1v-.5h-1V15H3v-2.5H2v.5H1v-2h1v.5h1V9h3.11zM5 12.5h6v-1H5z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M15 6h-1.294L11.23 8.48 10.61 6H7V1h8z" })
      ]
    }
  );
}
const h2 = /* @__PURE__ */ i(r2);
function a2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v10H7.71l-2.467 2.467L4.582 12H2zm9 3H5v1h6zm0 3H5v1h6z"
        }
      )
    }
  );
}
const c2 = /* @__PURE__ */ i(a2);
function d2(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M15 10h-1.582l-.661 2.467L10.29 10H4V2h11z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 7H2v5h1.349l.412 1.536L5.296 12H8v-1h1v2H5.71l-2.467 2.467L2.582 13H1V6h2z"
          }
        )
      ]
    }
  );
}
const w2 = /* @__PURE__ */ i(d2);
function v2(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14.002 7.758a4.5 4.5 0 0 0-6.87 4.822l-1.888 1.887L4.584 12H2.002V2h12z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11.002 14.5V12h-2.5v-1h2.5V8.5h1V11h2.5v1h-2.5v2.5z"
          }
        )
      ]
    }
  );
}
const m2 = /* @__PURE__ */ i(v2);
function g2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 12H7.71l-2.467 2.467L4.582 12H2V2h12z" })
    }
  );
}
const s2 = /* @__PURE__ */ i(g2);
function f2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.354 4.354 6 12.707 1.646 8.354l.708-.708L6 11.293l7.647-7.647z"
        }
      )
    }
  );
}
const u2 = /* @__PURE__ */ i(f2);
function p2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m6 2.707 4.854-4.853-.707-.708L7 9.293 4.854 7.146l-.708.708z"
        }
      )
    }
  );
}
const H2 = /* @__PURE__ */ i(p2);
function M2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 .258 1.603 1.76 2.268-.723.509 2.325 2.325.509-.722 2.268L15.743 8l-1.76 1.603.722 2.268-2.325.509-.509 2.325-2.268-.722L8 15.743l-1.603-1.76-2.268.722-.509-2.325-2.325-.509.722-2.268L.257 8l1.76-1.603-.722-2.268L3.62 3.62l.509-2.325 2.268.722zm-1 10.45 4.854-4.854-.707-.708L7 9.293 4.854 7.146l-.708.708z"
        }
      )
    }
  );
}
const x2 = /* @__PURE__ */ i(M2);
function z2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7.354.354 2.5-2.5-.708-.708-2.5 2.5zm-2-.708-.708.708L8.5 11.207l4.854-4.853-.708-.708L8.5 9.793zm-3.708.708L5.5 11.207l.707-.707-2.853-2.854z"
        }
      )
    }
  );
}
const V2 = /* @__PURE__ */ i(z2);
function C2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.647 3.646.707.708L8 8.707 3.646 4.354l.708-.708L8 7.293zm0 4 .707.708L8 12.707 3.646 8.354l.708-.708L8 11.293z"
        }
      )
    }
  );
}
const L2 = /* @__PURE__ */ i(C2);
function $2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m7.647 3.646.707.708L4.707 8l3.647 3.646-.707.707L3.293 8zm4 0 .707.708L8.707 8l3.647 3.646-.707.707L7.292 8z"
        }
      )
    }
  );
}
const S2 = /* @__PURE__ */ i($2);
function k2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.354 3.646 8.707 8l-4.353 4.354-.708-.707L7.293 8 3.646 4.354zm4 0L12.707 8l-4.353 4.354-.708-.707L11.293 8 7.646 4.354z"
        }
      )
    }
  );
}
const y2 = /* @__PURE__ */ i(k2);
function b2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 3.293 4.354 4.353-.707.708L8 4.707 4.354 8.354l-.708-.708zm0 4 4.354 4.353-.707.708L8 8.707l-3.646 3.647-.708-.707z"
        }
      )
    }
  );
}
const R2 = /* @__PURE__ */ i(b2);
function B2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.647 5.646.707.708L8 10.707 3.646 6.354l.708-.708L8 9.293z"
        }
      )
    }
  );
}
const F2 = /* @__PURE__ */ i(B2);
function A2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12.036 3.964H8.293v-1h4.743v4.743h-1zM2.965 8.293h1v3.743h3.742v1H2.965z"
        }
      )
    }
  );
}
const q2 = /* @__PURE__ */ i(A2);
function O2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.707 8 3.647 3.646-.707.708L5.293 8l4.354-4.354.707.708z"
        }
      )
    }
  );
}
const D2 = /* @__PURE__ */ i(O2);
function P2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.647 4.646.707.708L3.707 8l2.647 2.646-.707.708L2.293 8zM12.293 8 9.647 5.354l.707-.708L13.707 8l-3.353 3.354-.707-.707z"
        }
      )
    }
  );
}
const T2 = /* @__PURE__ */ i(P2);
function W2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.293 8 5.646 4.354l.708-.708L10.707 8l-4.353 4.354-.708-.708z"
        }
      )
    }
  );
}
const G2 = /* @__PURE__ */ i(W2);
function E2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 6.707-3.646 3.647-.708-.708L8 5.293l4.354 4.353-.707.708z"
        }
      )
    }
  );
}
const N2 = /* @__PURE__ */ i(E2);
function j2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 2.293 3.354 3.353-.707.708L8 3.707 5.354 6.354l-.708-.708zm2.647 7.353.707.708L8 13.707l-3.354-3.353.708-.708L8 12.293z"
        }
      )
    }
  );
}
const U2 = /* @__PURE__ */ i(j2);
function I2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.964 2.964h4.743v1H3.964v3.743h-1zm9.072 9.072V8.293h1v4.743H8.293v-1z"
        }
      )
    }
  );
}
const Q2 = /* @__PURE__ */ i(I2);
function K2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 0 1 6 6z" })
    }
  );
}
const J2 = /* @__PURE__ */ i(K2);
function X2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 1 1 0 12v-1a5 5 0 0 0 5-5"
        }
      )
    }
  );
}
const Y2 = /* @__PURE__ */ i(X2);
function Z2(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 1 1-6 6h1a5 5 0 0 0 10 0"
        }
      )
    }
  );
}
const _2 = /* @__PURE__ */ i(Z2);
function nl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 5V2h1v3zM5.525 6.232 3.404 4.111l.707-.707 2.121 2.121zm7.071-2.121-2.121 2.121-.707-.707 2.121-2.121zM5 8.5H2v-1h3zm9 0h-3v-1h3zm-7.768 1.975-2.121 2.121-.707-.707 2.121-2.121zm5.657 2.121L9.812 10.52l.707-.707 2.077 2.077zM7.5 14v-3h1v3z"
        }
      )
    }
  );
}
const ll = /* @__PURE__ */ i(nl);
function tl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.116 3 .268 1H9v1h2v2.58l2 .536V13h1v1H2v-1h1V7h2V4h.616l.268-1H6.5V1h1v2z"
        }
      )
    }
  );
}
const il = /* @__PURE__ */ i(tl);
function el(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 14H2V3h12zM5.252 6h1.964l.536-2H5.788zm3.536-2-.536 2h1.964l.536-2zm3 0-.536 2H13V4zM4.752 4H3v2h1.216z"
        }
      )
    }
  );
}
const ol = /* @__PURE__ */ i(el);
function rl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.348 2h5.304l-.268 1H13v11H3V3h2.616zm4 1H6.652l.268 1h2.16zM11 7H5v1h6zm0 3H5v1h6z"
        }
      )
    }
  );
}
const hl = /* @__PURE__ */ i(rl);
function al(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m6.5-4v4.384l4.235 1.134.26-.965L8.5 7.616V4z"
        }
      )
    }
  );
}
const cl = /* @__PURE__ */ i(al);
function dl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.293 8 2.646 3.354l.708-.708L8 7.293l4.647-4.647.707.708L8.707 8l4.647 4.647-.707.707L8 8.707l-4.646 4.647-.708-.707z"
        }
      )
    }
  );
}
const wl = /* @__PURE__ */ i(dl);
function vl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m3.646-2.646L7.293 8l-2.647 2.646.708.708L8 8.707l2.646 2.647.708-.708L8.707 8l2.647-2.646-.707-.708L8 7.293 5.354 4.646z"
        }
      )
    }
  );
}
const ml = /* @__PURE__ */ i(vl);
function gl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M15 13H1V2h14zM9 9a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-.5h-1V9h-1V6h1v.5h1V6a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1zM5 5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-.5H6V9H5V6h1v.5h1V6a1 1 0 0 0-1-1z"
        }
      )
    }
  );
}
const sl = /* @__PURE__ */ i(gl);
function fl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a1 1 0 0 0-1 1H6a2 2 0 1 1 3.49 1.333l-.018.021-.623.558L14 7.886V9h-3v6.239l-3-1.2-3 1.2V9H2V7.887l5.706-3.294 1.056-.945A1 1 0 0 0 8 2m4.197 6L8 5.577 3.805 8z"
        }
      )
    }
  );
}
const ul = /* @__PURE__ */ i(fl);
function pl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a4.5 4.5 0 0 1 4.14 2.732A4.25 4.25 0 0 1 10.75 13H4.5a3.501 3.501 0 0 1-.986-6.86A4.5 4.5 0 0 1 8 2"
        }
      )
    }
  );
}
const Hl = /* @__PURE__ */ i(pl);
function Ml(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.708-1.565-1.566A4.3 4.3 0 0 1 10.75 13H4.5a3.5 3.5 0 0 1-.986-6.86c.043-.54.18-1.052.397-1.522L1.646 2.354zM15 8.75c0 .962-.32 1.85-.86 2.563l-8.588-8.59a4.5 4.5 0 0 1 6.587 2.009A4.25 4.25 0 0 1 15 8.75"
        }
      )
    }
  );
}
const xl = /* @__PURE__ */ i(Ml);
function zl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.026 12.342 3-9 .948.316-3 9zm-1.38-7.696.708.708L2.707 8l2.647 2.646-.707.708L1.293 8zM13.294 8l-2.646-2.646.707-.708L14.707 8l-3.353 3.354-.707-.708z"
        }
      )
    }
  );
}
const Vl = /* @__PURE__ */ i(zl);
function Cl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.817 2.117a6 6 0 0 1 2.366 0l.372.074.125 1.633c.396.16.765.374 1.095.633l1.477-.707.25.284a6 6 0 0 1 1.185 2.05l.121.358-1.352.926c.06.42.06.845 0 1.264l1.352.926-.12.359a6 6 0 0 1-1.186 2.05l-.25.283-1.477-.707c-.33.259-.699.473-1.095.633l-.125 1.633-.372.074a6 6 0 0 1-2.366 0l-.372-.074-.125-1.633a4.5 4.5 0 0 1-1.095-.633l-1.477.707-.25-.284a6 6 0 0 1-1.185-2.05l-.121-.358 1.352-.926a4.5 4.5 0 0 1 0-1.264l-1.352-.926.12-.359a6 6 0 0 1 1.186-2.05l.25-.283 1.477.707c.33-.259.699-.473 1.095-.633l.125-1.633zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
      )
    }
  );
}
const Ll = /* @__PURE__ */ i(Cl);
function $l(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-2.756-2.756-.116-.055c-.33.259-.699.473-1.095.633l-.125 1.633-.372.074a6 6 0 0 1-2.366 0l-.372-.074-.125-1.633a4.5 4.5 0 0 1-1.095-.633l-1.477.707-.25-.284a6 6 0 0 1-1.185-2.05l-.121-.358 1.352-.926a4.5 4.5 0 0 1 0-1.264l-1.352-.926.12-.359a6 6 0 0 1 1.106-1.957L1.646 2.354zm3.923 5.338a2 2 0 0 0 2.74 2.74zm.066-3.469.102-1.324.372-.074a6 6 0 0 1 2.366 0l.372.074.125 1.633a4.5 4.5 0 0 1 1.095.633l1.477-.707.25.283a6 6 0 0 1 1.186 2.05l.12.359-1.352.926c.06.42.06.845 0 1.264l1.351.926-.12.359a6 6 0 0 1-.272.67z"
        }
      )
    }
  );
}
const Sl = /* @__PURE__ */ i($l);
function kl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 3h1v2.293l2.646-2.647.707.708L10.707 6H13v1H9zM7 13H6v-2.293l-2.646 2.647-.708-.708L5.293 10H3V9h4z"
        }
      )
    }
  );
}
const yl = /* @__PURE__ */ i(kl);
function bl(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.773 4.455a1.318 1.318 0 1 1 0 2.636 1.318 1.318 0 0 1 0-2.636"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12 12H2V2h10zM5.8 8.828l2.85-1.645L11 8.54V3H3v4.211z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 4v10H4v-1h9V4z" })
      ]
    }
  );
}
const Rl = /* @__PURE__ */ i(bl);
function Bl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8.5 5H11v6H8.5v3h-1v-3H5V5h2.5V2h1z" })
    }
  );
}
const Fl = /* @__PURE__ */ i(Bl);
function Al(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7.5 1.208L6.797 7.504l-2.329 4.033zm3.036-4.745L7.5 6.793 9.206 8.5z"
        }
      )
    }
  );
}
const ql = /* @__PURE__ */ i(Al);
function Ol(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 2h5v5H5v4h4V9h5v5H9v-2H4V7H2z" })
    }
  );
}
const Dl = /* @__PURE__ */ i(Ol);
function Pl(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M11 4.293V12H3V2h5.707zM8 2.707V5h2.293z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6 14v-1h6V5h1v9z" })
      ]
    }
  );
}
const Tl = /* @__PURE__ */ i(Pl);
function Wl(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M12 12H2V2h10z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 4v10H4v-1h9V4z" })
      ]
    }
  );
}
const Gl = /* @__PURE__ */ i(Wl);
function El(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7 9V7h2v2z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.5 2h1v1h1V2h1v1h1V2h1v1H13v2.5h1v1h-1v1h1v1h-1v1h1v1h-1V13h-2.5v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1H3v-2.5H2v-1h1v-1H2v-1h1v-1H2v-1h1V3h2.5zM6 6v4h4V6z"
          }
        )
      ]
    }
  );
}
const Nl = /* @__PURE__ */ i(El);
function jl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 1.793 14.207 4.5l-5.804 5.804.375 1.398-6.927 1.856L.793 12.5zM5.845 8.862 2.307 12.4l5.246-1.405-.156-.581z"
        }
      )
    }
  );
}
const Ul = /* @__PURE__ */ i(jl);
function Il(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 4V2h1v9h9v1h-2v2h-1v-2H4V5H2V4zm7 1H6V4h6v6h-1z"
        }
      )
    }
  );
}
const Ql = /* @__PURE__ */ i(Il);
function Kl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 2.02V1h1v1.02a6 6 0 0 1 5.48 5.48H15v1h-1.02a6 6 0 0 1-5.48 5.48V15h-1v-1.02A6 6 0 0 1 2.02 8.5H1v-1h1.02A6 6 0 0 1 7.5 2.02m0 1.005A5 5 0 0 0 3.025 7.5H4v1h-.975A5 5 0 0 0 7.5 12.975V12h1v.975A5 5 0 0 0 12.975 8.5H12v-1h.975A5 5 0 0 0 8.5 3.025V4h-1zM8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      )
    }
  );
}
const Jl = /* @__PURE__ */ i(Kl);
function Xl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 4a2 2 0 1 1 3.26 1.553l1.598 1.598 2.157-.98a1 1 0 1 1 .871.822L12.276 13H3.724l-1.61-6.006a1 1 0 1 1 .87-.823l2.156.98 1.6-1.598A2 2 0 0 1 6 4m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    }
  );
}
const Yl = /* @__PURE__ */ i(Xl);
function Zl(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.501 4.247 5.5-3.175 5.5 3.175-5.5 3.176zm5 4.043v6.349l-5.5-3.175V5.113zm1-.001 5.5-3.175v6.35l-5.5 3.176z"
        }
      )
    }
  );
}
const _l = /* @__PURE__ */ i(Zl);
function nt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 5.541v2.598L4.75 6.552V3.954zM7 9.005l-2.25 1.299L2 8.717l2.25-1.299zM4.25 11.17v3.176L1.5 12.758V9.583zm1 .002 2.25-1.3v3.174l-2.25 1.3zM8.5 9.871l2.25 1.299v3.176L8.5 13.047zm3.25 1.299 2.75-1.587v3.175l-2.75 1.588zm-.5-.864L9 9.006l2.75-1.589 2.25 1.3zM8.5 8.14v-2.6l2.75-1.586v2.598zM8 4.675 5.25 3.088 8 1.5l2.75 1.588z"
        }
      )
    }
  );
}
const lt = /* @__PURE__ */ i(nt);
function tt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M12 7h-1V2h1zm-8 7V9h1v5zm7.5-5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
        }
      )
    }
  );
}
const it = /* @__PURE__ */ i(tt);
function et(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M11.5 6.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9.76 5H14v9H6v-3H4v3H2V7h1.116l.224-.837.966.259L4.151 7h.965l.224-.837.966.259L6.151 7h.965l.224-.837.966.259L8.151 7h1.073zm-1.108 8H13V6h-2.473z"
          }
        )
      ]
    }
  );
}
const ot = /* @__PURE__ */ i(et);
function rt(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 4.72C2 4 2.973 3.2 3.904 2.777 4.978 2.289 6.427 2 8 2s3.022.289 4.096.777C13.027 3.2 14 4 14 4.72 14 6 11.136 7 8 7 4.865 7 2 6 2 4.72m10.627 5.97c.51-.211.984-.475 1.373-.797V11c0 1.007-.875 1.755-1.904 2.223C11.022 13.71 9.573 14 8 14s-3.022-.289-4.096-.777C2.875 12.755 2 12.007 2 11V9.893c.39.322.863.585 1.373.798 1.235.514 2.871.809 4.627.809s3.393-.295 4.627-.81"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 8c1.756 0 3.393-.295 4.627-.81.51-.212.984-.475 1.373-.797v2.5c-.389.322-.863.585-1.373.798-1.234.514-2.871.809-4.627.809s-3.392-.295-4.627-.81c-.51-.212-.984-.475-1.373-.797v-2.5c.39.322.863.585 1.373.798C4.608 7.705 6.244 8 8 8"
          }
        )
      ]
    }
  );
}
const ht = /* @__PURE__ */ i(rt);
function at(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 4h7v4h1V5h3.08L14 8.434V10h-1.085a1.5 1.5 0 1 1-2.83 0h-4.17a1.5 1.5 0 1 1-2.83 0H2z"
        }
      )
    }
  );
}
const ct = /* @__PURE__ */ i(at);
function dt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a7 7 0 0 1 7-7v14a7 7 0 0 1-7-7m9-7a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-1 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m2-1a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const wt = /* @__PURE__ */ i(dt);
function vt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8 15.5.5 8 8 .5 15.5 8z" })
    }
  );
}
const mt = /* @__PURE__ */ i(vt);
function gt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m15.5 8-2.336 2.336-7.5-7.5L8 .5zM8 15.5.5 8l3.396-3.396-3.25-3.25.708-.708 14 14-.708.708-3.25-3.25z"
        }
      )
    }
  );
}
const st = /* @__PURE__ */ i(gt);
function ft(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.354 1.646 1 1-.708.708-1-1zM11.5 3.559l-1.099.55L9.293 3 10.4 1.892l1.1.549zm-6 3-1.099.55L3.293 6 4.4 4.892l1.1.549zm8.5.998-1.987.497-1.085-1.086.51-1.53 1.53-.51L14 5.96zm-7 6-1.987.497-1.085-1.086.51-1.53 1.53-.51L7 11.96zm-.6-3.449L5.293 9l1.108-1.109 1.099.55v1.118zm5.1 1.451-1.099.55L9.293 11 10.4 9.892l1.1.549zM7.646 7.354l.708-.708 1 1-.708.708zm2.708.292 1 1-.708.708-1-1zM4.146 9.354l-1-1 .708-.708 1 1zm2.208-5.708 1 1-.708.708-1-1zm2.792 1.208-1-1 .708-.708 1 1zm-2.292.792 1 1-.708.708-1-1zm.792 7.708.708-.707 1 1-.708.707zm-.292-3.207 1 1-.708.707-1-1zm.792 1.707.708-.707 1 1-.708.707zM3.354 9.353l-1 1-.708-.707 1-1zM1.646 7.646l1-1 .708.708-1 1zm6.708-4.792-1 1-.708-.708 1-1zm-.708 2.792 1-1 .708.708-1 1zm3.708-.292-1 1-.707-.708 1-1zM4.646 7.646l1-1 .708.708-1 1zm5.208 1.707-1 1-.708-.707 1-1zm1.793.293 1-1 .707.708-1 1zm-7.293 1.707-.708-.707 1-1 .708.708z"
        }
      )
    }
  );
}
const ut = /* @__PURE__ */ i(ft);
function pt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 11H8.902l.268 1H11v1H5v-1h1.831l.269-1H2V3h12zm-5.866 1L8 11.5l-.133.5z"
        }
      )
    }
  );
}
const Ht = /* @__PURE__ */ i(pt);
function Mt(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 3H2v7H1V2h12z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 4h12v8H9.902l.268 1H12v1H6v-1h1.831l.268-1H3zm6 8.5-.133.5h.267z"
          }
        )
      ]
    }
  );
}
const xt = /* @__PURE__ */ i(Mt);
function zt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 6H8.902l.268 1H8.134L8 6l-.134 1H6.83l.27-1H4.5V1h7zm0 7H8.902l.268 1H10v1H6v-1h.831l.269-1H4.5V8h7zm-3.366 1L8 13.5l-.133.5z"
        }
      )
    }
  );
}
const Vt = /* @__PURE__ */ i(zt);
function Ct(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 13 13-.707.708L10.293 11H8.902l.268 1H11v1H5v-1h1.831l.268-1H2V3h.293L.646 1.354zM8.134 12 8 11.5l-.133.5zM14 11h-.172l-8-8H14z"
        }
      )
    }
  );
}
const Lt = /* @__PURE__ */ i(Ct);
function $t(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 10H5.902l.268 1H7v1H3v-1h.831l.269-1H1V5h6.5zm-2.5.5-.133.5h.267zM8.5 5H15v5h-3.098l.268 1H13v1H9v-1h.831l.269-1H8.5zm2.5 5.5-.133.5h.267z"
        }
      )
    }
  );
}
const St = /* @__PURE__ */ i($t);
function kt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 .293 2.354 2.353-.708.708L8.5 2.207V7h-1V2.207L6.354 3.354l-.708-.708zM2 4h3v1H3v6h10V5h-2V4h3v8H8.902l.268 1H11v1H5v-1h1.831l.268-1H2zm6 8.5-.134.5h.268z"
        }
      )
    }
  );
}
const yt = /* @__PURE__ */ i(kt);
function bt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.25 3.567C3.215 4.123 5.407 5 8 5s4.785-.877 5.75-1.433l.116-.067H15v9h-1.134l-.116-.067C12.785 11.877 10.593 11 8 11s-4.785.877-5.75 1.433l-.116.067H1v-9h1.134z"
        }
      )
    }
  );
}
const Rt = /* @__PURE__ */ i(bt);
function Bt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-4.5 5v-1h9v1zm4.5 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
        }
      )
    }
  );
}
const Ft = /* @__PURE__ */ i(Bt);
function At(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M3 2h6.707L13 5.293V14H3zm6 1v3h3z" })
    }
  );
}
const qt = /* @__PURE__ */ i(At);
function Ot(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 2h6.707L13 5.293v1.963A4.5 4.5 0 0 0 7.758 14H3zm6 1v3h3z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m8.146 11.854.708-.707 1.646 1.646 4.147-4.147.707.708-4.854 4.853z"
          }
        )
      ]
    }
  );
}
const Dt = /* @__PURE__ */ i(Ot);
function Pt(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 5.293v1.963A4.5 4.5 0 0 0 7.758 14H3V2h6.707zM12 6 9 3v3z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11 11V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z"
          }
        )
      ]
    }
  );
}
const Tt = /* @__PURE__ */ i(Pt);
function Wt(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6.5 8.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 2h7.134L13 4.751V14H3zm9.116 3.6L9.25 2.849V5.6zM7.5 6.5a2 2 0 1 0 1.016 3.723l1.63 1.63.707-.707-1.63-1.63A2 2 0 0 0 7.5 6.5"
          }
        )
      ]
    }
  );
}
const Gt = /* @__PURE__ */ i(Wt);
function Et(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1.875 10.3 3.6l-.6.8-1.2-.9v8.915l2.674-2.298.652.758L8 14.164l-3.826-3.29.652-.758 2.674 2.3V3.5l-1.2.9-.6-.8z"
        }
      )
    }
  );
}
const Nt = /* @__PURE__ */ i(Et);
function jt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 2v7.793l3.146-3.147.707.708L8 11.707 3.646 7.354l.708-.708L7.5 9.793V2zm4.117 11 .57-2.13.966.26-.769 2.87H2.617l-.77-2.87.966-.26.571 2.13z"
        }
      )
    }
  );
}
const Ut = /* @__PURE__ */ i(jt);
function It(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10.5 8.5c.64 0 1.29.261 1.759.646.319.262.61.634.703 1.069.365.086.695.282.945.561.357.388.593.931.593 1.474 0 1.277-1.103 2.25-2.385 2.25h-3.5c-1.132 0-2.115-.861-2.115-2 0-.515.232-1.028.592-1.387a1.74 1.74 0 0 1 .859-.477c.028-.517.276-.984.623-1.336a2.75 2.75 0 0 1 1.926-.8"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M15 9h-1.517a3.4 3.4 0 0 0-.589-.626c-.63-.518-1.5-.874-2.394-.874a3.75 3.75 0 0 0-2.637 1.098A3 3 0 0 0 7.524 9H1V4h14zM3 7h1V6H3z"
          }
        )
      ]
    }
  );
}
const Qt = /* @__PURE__ */ i(It);
function Kt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 13 13-.708.707-1.223-1.222c-.38.234-.831.369-1.308.369h-3.5c-1.132 0-2.115-.861-2.115-2 0-.515.232-1.028.592-1.387a1.74 1.74 0 0 1 .86-.477c.027-.517.275-.984.622-1.336l.01-.01-.707-.706-.014.014q-.18.183-.34.402H1V4h2.293L1.646 2.354zM3 7h1V6H3zm7.5.5-.168.004L6.828 4H15v5h-1.517a3.4 3.4 0 0 0-.59-.627c-.629-.517-1.499-.873-2.393-.873"
        }
      )
    }
  );
}
const Jt = /* @__PURE__ */ i(Kt);
function Xt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 4h14v5H8.5v3H10v1h4v1h-4v1H6v-1H2v-1h4v-1h1.5V9H1zm3 2H3v1h1z"
        }
      )
    }
  );
}
const Yt = /* @__PURE__ */ i(Xt);
function Zt(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 13 13-.708.707L13.293 14H10v1H6v-1H2v-1h4v-1h1.5V9H1V4h2.293L1.646 2.354zM8.5 9.207V12H10v1h2.293zM4 6H3v1h1zm11 3h-3.172l-5-5H15z"
        }
      )
    }
  );
}
const _t = /* @__PURE__ */ i(Zt);
function ni(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M1 5h14v5H1zm2 3h1V7H3zm10-1H6v1h7z" })
    }
  );
}
const li = /* @__PURE__ */ i(ni);
function ti(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.708L9.293 10H1V5h3.293L1.646 2.354zM6.293 7H6v1h1.293zM3 8h1V7H3zm12 2h-2.172l-2-2H13V7H9.828l-2-2H15z"
        }
      )
    }
  );
}
const ii = /* @__PURE__ */ i(ti);
function ei(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 5h1v8.214l-3 .804-3-.804V5h1V2h4zM9 5V3H7v2z"
        }
      )
    }
  );
}
const oi = /* @__PURE__ */ i(ei);
function ri(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708L11 11.707v1.507l-3 .804-3-.804V5.707L1.646 2.354zM11 5v3.172L7.828 5H9V3H7v1.172l-1-1V2h4v3z"
        }
      )
    }
  );
}
const hi = /* @__PURE__ */ i(ri);
function ai(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.646 4.646 2-2 .708.708-2 2zm8.708-2 2 2-.707.708-2-2zm-8 8 2 2-.708.708-2-2zm10 .708-2 2-.708-.708 2-2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M1 4a3 3 0 1 1 5.904.755L7.587 5h.826l.683-.245A3.004 3.004 0 0 1 12 1a3 3 0 1 1-.796 5.893 3.1 3.1 0 0 0 0 2.214A3.003 3.003 0 0 1 15 12a3 3 0 1 1-5.893-.796 3.1 3.1 0 0 0-2.214 0A3.003 3.003 0 0 1 4 15a3 3 0 1 1 .796-5.893 3.1 3.1 0 0 0 0-2.214A3.003 3.003 0 0 1 1 4m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-8 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0-.001 4A2 2 0 0 0 12 10M9 5.5H7v1a1 1 0 0 0 2 0z"
          }
        )
      ]
    }
  );
}
const ci = /* @__PURE__ */ i(ai);
function di(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7 14v-1H2V3h5V2h1v12zm0-8.707V4H3v5.293zM13 4H9V3h5v10H9V9.135l1.65-.952L13 9.539z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10.318 6.318c0 .728-.59 1.318-1.318 1.318V5c.728 0 1.318.59 1.318 1.318"
          }
        )
      ]
    }
  );
}
const wi = /* @__PURE__ */ i(di);
function vi(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M12 9H4V5h8z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 2h1.5V1h1v1H10v1h4v8h-2v1h-1.653l.636 2.37-.966.26L9.312 12H6.687l-.704 2.63-.966-.26.635-2.37H4v-1H2V3h4zm7 8V4H3v6z"
          }
        )
      ]
    }
  );
}
const mi = /* @__PURE__ */ i(vi);
function gi(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.377 9 8 2.753 13.623 9zM13.5 11v1h-11v-1z"
        }
      )
    }
  );
}
const si = /* @__PURE__ */ i(gi);
function fi(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8.32 3.828A3.44 3.44 0 0 1 13.954 7H12v1h1.627a3.4 3.4 0 0 1-.455.68l-.012.014L8 13.866 2.84 8.694l-.012-.014A3.4 3.4 0 0 1 2.373 8h2.834l1.034-1.034.973 3.632L9.244 8H11V7H8.756L7.661 8.402 6.76 5.034 4.793 7H2.046A3.44 3.44 0 0 1 7.68 3.828l.012.01.308.303.308-.302z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13.627 8a3.4 3.4 0 0 0 .327-1H15v1zM2.046 7c.056.345.165.682.327 1H1V7z"
          }
        )
      ]
    }
  );
}
const ui = /* @__PURE__ */ i(fi);
function pi(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 1H15v14H8.5zm1.146 7.354 1.854 1.853 1.854-1.853-.708-.708-.646.647V6h-1v2.293l-.646-.647zM7.5 15H1V1h6.5zM4 10h1V7.707l.646.647.708-.708L4.5 5.793 2.646 7.646l.708.708L4 7.707z"
        }
      )
    }
  );
}
const Hi = /* @__PURE__ */ i(pi);
function Mi(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0-4a5.97 5.97 0 0 0-3 .803l-.5-.866A6.97 6.97 0 0 1 8 1a6.97 6.97 0 0 1 3.501.937l-.5.866A5.97 5.97 0 0 0 8 2m0 2a4 4 0 0 0-2 .535l-.5-.866a5 5 0 0 1 5 .001l-.5.865A4 4 0 0 0 8 4M2.803 5A5.97 5.97 0 0 0 2 8a5.97 5.97 0 0 0 .803 3l-.866.5A6.97 6.97 0 0 1 1 8c0-1.274.341-2.47.937-3.501zM14 8a5.97 5.97 0 0 0-.803-3l.866-.501A6.97 6.97 0 0 1 15 8a6.97 6.97 0 0 1-.937 3.501l-.866-.5A5.97 5.97 0 0 0 14 8M4.535 6a4 4 0 0 0 0 4l-.866.5a5 5 0 0 1 .001-5zM12 8a4 4 0 0 0-.535-2l.866-.5a5 5 0 0 1-.001 5l-.865-.5A4 4 0 0 0 12 8m-6 3.465a4 4 0 0 0 4 0l.5.866a5 5 0 0 1-5-.001zm-1 1.732A5.97 5.97 0 0 0 8 14a5.97 5.97 0 0 0 3-.803l.501.866A6.97 6.97 0 0 1 8 15a6.97 6.97 0 0 1-3.501-.937z"
        }
      )
    }
  );
}
const xi = /* @__PURE__ */ i(Mi);
function zi(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 3h3v1H9v1h2.707L13 6.293V7h1v3.049l-1-.032v.69L11.707 12H7.293l-1-1h-1L4 9.708v-1.2l-1 .017v1.008H2V6.5h1v1.024l1-.016V6.293L5.293 5H8V4H7z"
        }
      )
    }
  );
}
const Vi = /* @__PURE__ */ i(zi);
function Ci(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6 2h8v12H6v-2h1v1h6V3H7v1H6z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m8.354 10.854-.708-.708L9.293 8.5H1v-1h8.293L7.646 5.854l.708-.708L11.207 8z"
          }
        )
      ]
    }
  );
}
const Li = /* @__PURE__ */ i(Ci);
function $i(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 3h12v1.59L8 8.406 2 4.59z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "m8 9.593 6-3.819V13H2V5.774z" })
      ]
    }
  );
}
const Si = /* @__PURE__ */ i($i);
function ki(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 13 13-.708.708L12.293 13H2V5.774l6 3.819.541-.345-1.365-1.365L2 4.589V3h.293L.646 1.354zM14 5.774v5.398l-3.298-3.299zm0-1.184L9.977 7.148 5.828 3H14z"
        }
      )
    }
  );
}
const yi = /* @__PURE__ */ i(ki);
function bi(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M12.5 6.5h-9v-1h9zm0 4h-9v-1h9z" })
    }
  );
}
const Ri = /* @__PURE__ */ i(bi);
function Bi(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 4H6V3h4zm0 2H6V5h4zm0 2H6V7h4zm5 0h-4V7h4zM5 10H1V9h4zm5 0H6V9h4zm5 0h-4V9h4zM5 12H1v-1h4zm5 0H6v-1h4zm5 0h-4v-1h4zM5 14H1v-1h4zm5 0H6v-1h4zm5 0h-4v-1h4z"
        }
      )
    }
  );
}
const Fi = /* @__PURE__ */ i(Bi);
function Ai(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 2.293 14.207 6.5l-3 3L7 5.293zm.5 7.914L7.707 13H5.293l-3-3 4-4zM14 13h-4v-1h4z"
        }
      )
    }
  );
}
const qi = /* @__PURE__ */ i(Ai);
function Oi(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 .5 15.5 8 8 15.5.5 8zm-.5 5V9h1V5.5zm0 4.5v1h1v-1z"
        }
      )
    }
  );
}
const Di = /* @__PURE__ */ i(Oi);
function Pi(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.5 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M7 5.293v1.086l-3 3V5.293l.793-.793h1.414z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M15 8h-2.793l-7 7H1v-4h2.793l7-7H15z" })
      ]
    }
  );
}
const Ti = /* @__PURE__ */ i(Pi);
function Wi(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.5 10V7h1V6h3v1h1v3h-1V8h-1v2h-1V8h-1v2z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 2h12v12H2zm8.5 3h-5v1h-1v5h7V6h-1z" })
      ]
    }
  );
}
const Gi = /* @__PURE__ */ i(Wi);
function Ei(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h8v2H9V3H3v10h6v-1h1v2H2zm11.293 5.5-1.647-1.646.708-.708L15.207 8l-2.853 2.854-.708-.708L13.293 8.5H5v-1z"
        }
      )
    }
  );
}
const Ni = /* @__PURE__ */ i(Ei);
function ji(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 7h-1V4.707L9.354 7.354l-.707-.708L11.293 4H9V3h4zM3 9h1v2.293l2.646-2.647.708.708L4.707 12H7v1H3z"
        }
      )
    }
  );
}
const Ui = /* @__PURE__ */ i(ji);
function Ii(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 .423 5.5 3.175-2.815 1.625 1.315.76v1.481l3-1.732v6.35l-5.5 3.176v-3.214L8 12.91l-1.5-.866v3.214L1 12.083v-6.35l3 1.731V5.982l1.315-.759L2.5 3.598zM6.315 5.8l-.815.47L8 7.715l2.5-1.443-.815-.47L8 6.773zM11 7.137 8.5 8.58v2.887l1-.578V8.908l1.5-.866zm-3.5 4.33V8.58L5 7.137v.904l1.5.866v1.983z"
        }
      )
    }
  );
}
const Qi = /* @__PURE__ */ i(Ii);
function Ki(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 1.293 2.354 2.353-.708.708L8.5 3.207V9h-1V3.207L6.354 4.354l-.708-.708zM3 5h2v1H4v6h8V6h-1V5h2v8H3z"
        }
      )
    }
  );
}
const Ji = /* @__PURE__ */ i(Ki);
function Xi(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.348 2h5.304l-.268 1H13v11H3v-2h1v1h8V4h-1.884l-.268 1H6.152l-.268-1H4v3H3V3h2.616z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7.293 9 5.646 7.354l.708-.708L9.208 9.5l-2.854 2.854-.708-.708L7.293 10H2V9z"
          }
        )
      ]
    }
  );
}
const Yi = /* @__PURE__ */ i(Xi);
function Zi(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.52 5.455C4.734 4.674 6.31 4 8 4s3.267.674 4.48 1.455c1.2.773 2.117 1.701 2.455 2.299l.14.246-.14.246c-.338.598-1.256 1.526-2.456 2.3C11.267 11.325 9.69 12 8 12s-3.267-.674-4.48-1.455c-1.2-.773-2.117-1.701-2.455-2.299L.925 8l.14-.246c.338-.598 1.256-1.526 2.456-2.3M8 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6 8a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
        }
      )
    }
  );
}
const _i = /* @__PURE__ */ i(Zi);
function ne(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.589 10.204 8.543 5.25l-.897-.896.708-.708.646.647 1.146-1.147a1.914 1.914 0 0 1 2.707 2.708L11.708 7l.646.646-.707.708-.896-.897-4.954 4.954-2.395 1.197-1.01-1.01zm.822.592-.793 1.586 1.585-.792 4.84-4.84-.793-.793z"
        }
      )
    }
  );
}
const le = /* @__PURE__ */ i(ne);
function te(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.708-2.907-2.908C9.894 11.78 8.965 12 8 12c-1.69 0-3.267-.674-4.48-1.455-1.2-.773-2.117-1.701-2.455-2.299L.925 8l.14-.246c.338-.598 1.256-1.526 2.456-2.3q.365-.235.773-.453L1.646 2.354zm3.923 5.338a2 2 0 0 0 2.74 2.74l-.758-.758a1 1 0 0 1-1.225-1.225zm8.658 1.262c-.286.506-.988 1.25-1.925 1.935L6.918 4.09A7 7 0 0 1 8 4c1.69 0 3.267.674 4.48 1.455 1.2.773 2.117 1.701 2.455 2.299l.14.246z"
        }
      )
    }
  );
}
const ie = /* @__PURE__ */ i(te);
function ee(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 7h2v7h-3v-4H8v4H1V7h1.384l.536-2H5v2h.384l.536-2H8v2h2V2h3zM3 10h1V9H3zm3-1H5v1h1zm-3 3h1v-1H3zm3-1H5v1h1z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M11 12H9v-1h2z" })
      ]
    }
  );
}
const oe = /* @__PURE__ */ i(ee);
function re(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 5h2V1h1v4h2v3H5v2H4V8H2zm10-4v2h2v3h-2v4h-1V6H9V3h2V1zM4.5 12a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m7 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
        }
      )
    }
  );
}
const he = /* @__PURE__ */ i(re);
function ae(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 2.25A2.25 2.25 0 0 1 9.75 4.5c0 .605-.221 1.268-.489 1.852.29-.247.607-.485.933-.677.414-.244.866-.425 1.306-.425h2.25V7.5a2.25 2.25 0 0 1-2.25 2.25c-.605 0-1.268-.221-1.852-.489a7 7 0 0 1 .677.933c.244.414.425.866.425 1.306v2.25H8.5a2.25 2.25 0 0 1-2.25-2.25c0-.605.221-1.268.489-1.852-.29.247-.607.485-.933.677-.414.244-.866.425-1.306.425H2.25V8.5A2.25 2.25 0 0 1 4.5 6.25c.605 0 1.268.22 1.852.489a7 7 0 0 1-.677-.933C5.431 5.392 5.25 4.94 5.25 4.5V2.25z"
        }
      )
    }
  );
}
const ce = /* @__PURE__ */ i(ae);
function de(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 9V5h1v4zm2 2V3h1v8zM5.5 3c1.023 0 1.853.83 1.853 1.853 0 .285-.125.608-.278.905q-.103.197-.22.387.189-.117.387-.22c.297-.153.62-.278.905-.278H10V7.5c0 1.023-.83 1.853-1.853 1.853-.285 0-.608-.125-.905-.278a6 6 0 0 1-.387-.22q.117.189.22.387c.153.297.278.62.278.905V12H5.5a1.853 1.853 0 0 1-1.853-1.853c0-.285.125-.608.278-.905q.103-.196.22-.387a6 6 0 0 1-.387.22c-.297.153-.62.278-.905.278H1V7.5c0-1.023.83-1.853 1.853-1.853.285 0 .608.125.905.278q.196.103.387.22a6 6 0 0 1-.22-.387c-.153-.297-.278-.62-.278-.905V3z"
        }
      )
    }
  );
}
const we = /* @__PURE__ */ i(de);
function ve(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.647 3H6.5c1.023 0 1.853.83 1.853 1.853 0 .285-.125.608-.278.905q-.103.197-.22.387.189-.117.387-.22c.297-.153.62-.278.905-.278H11V7.5c0 1.023-.83 1.853-1.853 1.853-.285 0-.608-.125-.905-.278a6 6 0 0 1-.387-.22q.12.194.22.387c.153.297.278.62.278.905V12H6.5a1.853 1.853 0 0 1-1.853-1.853c0-.285.125-.608.278-.905q.103-.196.22-.387a6 6 0 0 1-.387.22c-.297.153-.62.278-.905.278H2V7.5c0-1.023.83-1.853 1.853-1.853.285 0 .608.125.905.278q.197.103.387.22a6 6 0 0 1-.22-.387c-.153-.297-.278-.62-.278-.905zM13 5v4h-1V5z"
        }
      )
    }
  );
}
const me = /* @__PURE__ */ i(ve);
function ge(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 4.5a2.5 2.5 0 0 1 5 0v1.258l2-.625V4.5h1v.634l3.108.97.892 3.33V14h-2V9H7v5H2zM3 5v8h2V9.435l.892-3.33L6 6.071V5zm7.5 1.5h-2v2h2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 12.293v-1.586l.793.793zm1.5-.086.793.793H8.707zm1.5.086-.793-.793.793-.793zM8.707 10h1.586l-.793.793z"
          }
        )
      ]
    }
  );
}
const se = /* @__PURE__ */ i(ge);
function fe(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 12.37v-3.5l-6 3.5V3.63l6 3.49V3.63L15.492 8z"
        }
      )
    }
  );
}
const ue = /* @__PURE__ */ i(fe);
function pe(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 3.63v8.74l-6-3.5v3.5L.508 8 8 3.63v3.49z"
        }
      )
    }
  );
}
const He = /* @__PURE__ */ i(pe);
function Me(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v10H7.71l-2.467 2.467L4.582 12H2zm5.5 2.5v3h1v-3zm0 4v1h1v-1z"
        }
      )
    }
  );
}
const xe = /* @__PURE__ */ i(Me);
function ze(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m4-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.171 9.828a4 4 0 0 0 5.657 0l-.707-.707a3 3 0 0 1-4.243 0z"
        }
      )
    }
  );
}
const Ve = /* @__PURE__ */ i(ze);
function Ce(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m4-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5 9v1h6V9z"
        }
      )
    }
  );
}
const Le = /* @__PURE__ */ i(Ce);
function $e(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m4-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-4.122 5.879a3 3 0 0 1 4.243 0l.707-.707a4 4 0 0 0-5.657 0z"
        }
      )
    }
  );
}
const Se = /* @__PURE__ */ i($e);
function ke(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2m1 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0M6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M4.039 8.57a4 4 0 0 0 7.92 0l.011-.07H4.03z"
        }
      )
    }
  );
}
const ye = /* @__PURE__ */ i(ke);
function be(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3.164-.758 1.931-.518-.258-.966-1.932.518zm3.74-.518 1.933.518.258-.966-1.931-.518zM6 11a2 2 0 1 1 4 0h1a3 3 0 0 0-6 0z"
        }
      )
    }
  );
}
const Re = /* @__PURE__ */ i(be);
function Be(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1.248 5.919a1 1 0 0 0 1.618-1.175 1 1 0 0 0-1.618 1.176m1.13-4.193a1 1 0 1 0 1.902-.619 1 1 0 0 0-1.902.619m-5.244 3.016a1 1 0 1 0 1.617 1.177 1 1 0 0 0-1.617-1.177m.488-3.016a1 1 0 1 0-1.902-.619 1 1 0 0 0 1.902.619"
        }
      )
    }
  );
}
const Fe = /* @__PURE__ */ i(Be);
function Ae(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 14H2V1h12zM4 3V2H3v1zM3 8v1h1V8zm1 5v-1H3v1zm0-3H3v1h1zM3 7h1V6H3zm2 1v5h6V8zm6-6H5v5h6zm1 10v1h1v-1zm0-1h1v-1h-1zm0-2h1V8h-1zm1-3h-1v1h1zM3 5h1V4H3zm9-1v1h1V4zm0-2v1h1V2z"
        }
      )
    }
  );
}
const qe = /* @__PURE__ */ i(Ae);
function Oe(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 1h12v6h-1V6h-1v1h-1V2H5v5h4v1H5v5h2v1H2zm2 12v-1H3v1zm-1-2h1v-1H3zm0-2h1V8H3zm0-2h1V6H3zm0-2h1V4H3zm0-2h1V2H3zm9-1v1h1V2zm1 2h-1v1h1z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11 11V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z"
          }
        )
      ]
    }
  );
}
const De = /* @__PURE__ */ i(Oe);
function Pe(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12 12H2V3h10zm-1-1v-1h-1v1zm-2 0V8H5v3zm-5 0v-1H3v1zM3 9h1V8H3zm0-2h1V6H3zm0-2h1V4H3zm2-1v3h4V4zm5 0v1h1V4zm1 2h-1v1h1zm0 2h-1v1h1z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 5h1v9H4v-1h9z" })
      ]
    }
  );
}
const Te = /* @__PURE__ */ i(Pe);
function We(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 6H3V5h10zm-2 3H5V8h6zm-2 3H7v-1h2z" })
    }
  );
}
const Ge = /* @__PURE__ */ i(We);
function Ee(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.502 3a5.5 5.5 0 0 0-4.764 2.75l-.866-.5a6.502 6.502 0 1 1 10.972 6.961l-.82-.57c.618-.89.98-1.972.98-3.139A5.5 5.5 0 0 0 7.503 3M3.001 8.502a4.502 4.502 0 1 1 9.003 0A9.46 9.46 0 0 1 10.254 14l-.816-.579a8.46 8.46 0 0 0 1.566-4.919 3.502 3.502 0 0 0-7.003 0 1.5 1.5 0 0 1-1.5 1.5H2v-1h.5a.5.5 0 0 0 .5-.5m4.501-1.5a1.5 1.5 0 0 0-1.5 1.5c0 1.7-1.211 3.116-2.817 3.435l-.195-.981a2.5 2.5 0 0 0 2.012-2.454 2.5 2.5 0 1 1 5.001 0 7.49 7.49 0 0 1-2.733 5.793l-.636-.772a6.49 6.49 0 0 0 2.37-5.02 1.5 1.5 0 0 0-1.502-1.501m.5 1.5a5.5 5.5 0 0 1-3.097 4.95l-.437-.899a4.5 4.5 0 0 0 2.534-4.05z"
        }
      )
    }
  );
}
const Ne = /* @__PURE__ */ i(Ee);
function je(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.741 2.061c1.36.749 2.009 1.769 2.009 2.83 0 1.033-.619 1.955-1.473 2.525-.666.444-.777.808-.777 1.021 0 .249.148.503.354.709.135.135.37.229.646.229s.511-.094.646-.229c.32-.318.349-.596.402-1.098l.018-.166c.033-.298.086-.65.246-1.035.16-.387.418-.784.834-1.201l.255-.254.323.161c.647.324 1.088.943 1.364 1.614.278.678.412 1.462.412 2.208C13 11.97 10.72 14 8 14s-5-2.031-5-4.625c0-1.064.277-1.883.703-2.555.418-.66.968-1.158 1.471-1.59l.156-.134C6.3 4.267 7 3.667 7 2.5v-.846z"
        }
      )
    }
  );
}
const Ue = /* @__PURE__ */ i(je);
function Ie(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 1.5v1h-1v-1zm.647 1.146 1-1 .707.708-1 1zM11.207 7.5 4.5 14.207 1.793 11.5 8.5 4.793l1 1 2.147-2.147.707.708L10.207 6.5zM13.5 4h1v1h-1z"
        }
      )
    }
  );
}
const Qe = /* @__PURE__ */ i(Ie);
function Ke(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5 3h1V2h4v1h1V2h3v2H2V2h3zM2 7V5h5.5v2zm0 3V8h3v2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7.5 10H6V8h4v2H8.5v2H10v1h4v1h-4v1H6v-1H2v-1h4v-1h1.5z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 10h-3V8h3zm0-5v2H8.5V5z" })
      ]
    }
  );
}
const Je = /* @__PURE__ */ i(Ke);
function Xe(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ a("g", { fill: "currentColor", children: [
        /* @__PURE__ */ l("path", { d: "m1.354.646 14 14-.707.708L13.293 14H10v1H6v-1H2v-1h4v-1h1.5v-2H6V8h1.293l-1-1H2V5h2.293l-1-1H2V2.707L.646 1.354zM9.293 10H8.5v2H10v1h2.293z" }),
        /* @__PURE__ */ l("path", { d: "M14 10h-1.172l-2-2H14zm0-3H9.828L8.5 5.672V5H14zm0-3H6.828L6 3.172V2h4v1h1V2h3zM5 8v2H2V8z" })
      ] })
    }
  );
}
const Ye = /* @__PURE__ */ i(Xe);
function Ze(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 14v-1h1v1zm0-2v-1h1v1zM3 11v-1h1v1zm4.5-1V9h1v1zm0-2V7h1v1zm-1 0h-1V7h1zM11 2h-1V1h1zm-.5 6h-1V7h1zm2 0h-1V7h1zm-5-2V5h1v1zm-5-2h-1V3h1zm2.354 1.06-.708-.706.708-.708.707.708zm1.5 1.5-.708-.706.707-.708.707.708zm2.585-.706.707-.708.707.708-.707.707zM11 4h1v1h-1zm2 0h1v1h-1zM3.44 8.354l.706-.708.707.708-.707.707zm4.206-5.208.707-.707.708.707-.708.708zm6.207 6.915-.707-.707.707-.708.707.708z"
        }
      )
    }
  );
}
const _e = /* @__PURE__ */ i(Ze);
function n5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v12H2zm1 1v10h10V3zm9.002 1v3h-1V5.706l-5.291 5.29 1.292.001v1H4.002v-3h1v1.294L10.295 5H9V4z"
        }
      )
    }
  );
}
const l5 = /* @__PURE__ */ i(n5);
function t5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 4.751V14H3V2h7.134zM9.25 2.849V5.6h2.866zM10.002 10V7H7v1h1.295L6 10.291V8.997H5v3h3.001v-1H6.712l2.291-2.29V10z"
        }
      )
    }
  );
}
const i5 = /* @__PURE__ */ i(t5);
function e5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 3h5.384l.536 2H14v7H9.152l-.536-2H4v4H3V2h1z"
        }
      )
    }
  );
}
const o5 = /* @__PURE__ */ i(e5);
function r5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m10.148 7.034-.644 2.61.839.225a2 2 0 0 1 2.975.797l1.682.451v1.59L13.707 14H2.293L1 12.707v-1.591L7.033 9.5h.175l.496-1.984-1.44-.72-.83-2.906-1.592-.53V2.162L7.04.882l2.591 1.496z"
        }
      )
    }
  );
}
const h5 = /* @__PURE__ */ i(r5);
function a5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4.312V14H2V2h9.977zM5 6h5V3H5zm6 3H5v4h6z"
        }
      )
    }
  );
}
const c5 = /* @__PURE__ */ i(a5);
function d5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 4a2 2 0 1 1 4 0c0 .183-.043.396-.096.598l-.058.204q.076-.08.148-.151a2.5 2.5 0 0 1 .47-.383 2 2 0 1 1 2 3.464c-.159.092-.365.16-.567.216L11.691 8l.206.052c.202.055.408.124.567.216a2 2 0 0 1-2 3.464 2.5 2.5 0 0 1-.47-.383l-.148-.152.058.205c.053.202.096.415.096.598a2 2 0 1 1-4 0c0-.183.044-.396.097-.598l.057-.204q-.075.08-.148.151a2.5 2.5 0 0 1-.47.383 2 2 0 0 1-2-3.464c.159-.092.365-.16.567-.216L4.309 8l-.206-.052a2.5 2.5 0 0 1-.567-.216 2 2 0 1 1 2-3.464c.159.091.322.236.47.383q.073.07.148.152l-.057-.205A2.5 2.5 0 0 1 6 4m2 5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
        }
      )
    }
  );
}
const w5 = /* @__PURE__ */ i(d5);
function v5(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 1a4.5 4.5 0 0 1 4.14 2.732A4.25 4.25 0 0 1 15 7.75v.76l-3.556.711a4.5 4.5 0 0 1-2.895-.388l-1.545-.772a3.5 3.5 0 0 0-2.252-.302l-3.833.767.154-.74A3.5 3.5 0 0 1 3.514 5.14 4.5 4.5 0 0 1 8 1m-.996 11.561a3.5 3.5 0 0 0-2.252-.302l-3.654.731-.196-.98 3.654-.731a4.5 4.5 0 0 1 2.895.387l1.545.773a3.5 3.5 0 0 0 2.252.302l3.654-.731.196.98-3.654.731a4.5 4.5 0 0 1-2.895-.388z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m1.098 10.99-.196-.981 3.654-.73a4.5 4.5 0 0 1 2.895.388l1.545.772a3.5 3.5 0 0 0 2.252.301l3.654-.73.196.981-3.654.73a4.5 4.5 0 0 1-2.895-.388l-1.545-.772a3.5 3.5 0 0 0-2.252-.301z"
          }
        )
      ]
    }
  );
}
const m5 = /* @__PURE__ */ i(v5);
function g5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 13H2V3h4.884l.536 2H14z" })
    }
  );
}
const s5 = /* @__PURE__ */ i(g5);
function f5(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6.42 5H13v2H3.161l-2.16 5.398L1 3h4.884z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M3.839 8h11l-2.002 5h-11z" })
      ]
    }
  );
}
const u5 = /* @__PURE__ */ i(f5);
function p5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13.689 2.13 12.652 6h3.107l-1.875 7h-3.768L8.241 6h3.375l1.107-4.13zM7.884 10H2.116l.536-2h4.696zm-.536 3H2.652l-.536-2h5.768z"
        }
      )
    }
  );
}
const H5 = /* @__PURE__ */ i(p5);
function M5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.999 2H8c.277 0 .784 0 1.352.406.547.39 1.093 1.114 1.611 2.408.555 1.386.41 2.38.144 3.377q-.07.257-.143.512c-.194.682-.395 1.383-.45 2.297h-5.03c-.056-.914-.256-1.615-.45-2.297q-.075-.255-.143-.512c-.266-.997-.41-1.991.144-3.377.517-1.294 1.064-2.018 1.61-2.408C7.216 2 7.723 2 8 2m2.482 10c-.066.841-.297 1.532-.67 2.044-.453.622-1.1.956-1.812.956s-1.359-.334-1.812-.956c-.373-.512-.605-1.203-.67-2.044z"
        }
      )
    }
  );
}
const x5 = /* @__PURE__ */ i(M5);
function z5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.5 7.116 1 .268V2h1v5.384l1-.268V2h1v5.884l-2 .536V14h-1V8.42l-2-.536V2h1z"
        }
      )
    }
  );
}
const V5 = /* @__PURE__ */ i(z5);
function C5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.353 2.646 13.207 5.5l-2.854 2.854-.707-.708L11.293 6H3.982l1.707 6.37-.966.26L2.678 5h8.615L9.646 3.354z"
        }
      )
    }
  );
}
const L5 = /* @__PURE__ */ i(C5);
function $5(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12 8a5 5 0 1 0-5 5v1a6 6 0 1 1 5.898-7.105l1.248-1.249.708.708L12 9.207z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4 5h1.01v1.125H5v3.75h.01V11H4zm2 1.125C6 5.422 6.649 5 7.25 5h1.5C9.351 5 10 5.422 10 6.125v3.75C10 10.578 9.351 11 8.75 11h-1.5C6.649 11 6 10.578 6 9.875zm1.04-.058C7 6.1 7 6.123 7 6.125v3.75c0 .002 0 .025.04.058a.33.33 0 0 0 .21.067h1.5a.33.33 0 0 0 .21-.067C9 9.9 9 9.877 9 9.875v-3.75c0-.002 0-.025-.04-.058A.33.33 0 0 0 8.75 6h-1.5a.33.33 0 0 0-.21.067"
          }
        )
      ]
    }
  );
}
const S5 = /* @__PURE__ */ i($5);
function k5(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m8 9.732-1.5-.866V7.134L8 6.268l1.5.866v1.732z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.001 4.536 6-3.464 6 3.464v6.928l-6 3.464-6-3.464zM8 5.113 5.5 6.557v2.886L8 10.887l2.5-1.444V6.557z"
          }
        )
      ]
    }
  );
}
const y5 = /* @__PURE__ */ i(k5);
function b5(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.001 4.535 6-3.464 6 3.465-3.5 2.02L8 5.114 5.5 6.557v2.887l-3.499 2.02z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.5 7.134 8 6.268l1.5.866-3 1.733zm-1 6.351-1-.578 9.501-5.485v1.155zm8.501-2.021-6 3.464-1-.577 7-4.042z"
          }
        )
      ]
    }
  );
}
const R5 = /* @__PURE__ */ i(b5);
function B5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.001 4.535 6-3.464 6 3.465-12 6.928zm3.499 8.95-1-.578 9.501-5.485v1.155zm8.501-2.021-6 3.464-1-.577 7-4.042z"
        }
      )
    }
  );
}
const F5 = /* @__PURE__ */ i(B5);
function A5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.002 1.072 6 3.464v3.253L4.818 13.09l-2.817-1.626V4.536zm5.999 10.392-6 3.464-1-.577 7-4.041z"
        }
      )
    }
  );
}
const q5 = /* @__PURE__ */ i(A5);
function O5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v8H8.902l.268 1H11v1H5v-1h1.831l.268-1H2zm6 8.5-.134.5h.268zM7 9h1V8a1.5 1.5 0 1 0 0-3H7zm1-3a.5.5 0 0 1 0 1zM4 9h1V7.5h1v-1H5V6h1.5V5H4zm7.114-2.903c.067-.036.263-.1.662.1l.448-.894c-.601-.301-1.155-.319-1.588-.083A1.2 1.2 0 0 0 10 6.25c0 .629.437.954.671 1.129l.029.021c.276.207.3.255.3.35 0 .022-.024.103-.114.153-.067.036-.263.1-.662-.1l-.448.894c.601.301 1.155.319 1.588.083A1.2 1.2 0 0 0 12 7.75c0-.629-.437-.954-.671-1.129L11.3 6.6c-.276-.207-.3-.255-.3-.35 0-.022.024-.103.114-.152"
        }
      )
    }
  );
}
const D5 = /* @__PURE__ */ i(O5);
function P5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m12.736 5.53.006.005-.707.707c-.528-.528-1.482-1.482-2.388-2.215-.456-.37-.874-.661-1.202-.818a1.4 1.4 0 0 0-.27-.102q.007.03.02.071.088.285.443.794c.472.67 1.202 1.482 1.966 2.322l.104.115c.716.79 1.45 1.598 1.95 2.28.26.354.483.71.6 1.035.11.306.185.768-.161 1.114-.317.317-.738.304-1.054.226-.322-.08-.671-.257-1.014-.468-.693-.424-1.503-1.077-2.273-1.715l-.475-.395c-.608-.506-1.175-.98-1.65-1.326a7 7 0 0 0-.377-.26q.042.083.096.179c.272.48.696 1.075 1.143 1.701l.012.017c.433.606.887 1.242 1.188 1.773.15.266.28.539.344.79.058.224.102.607-.183.893-.245.244-.567.275-.811.254a2.8 2.8 0 0 1-.77-.21c-.513-.208-1.106-.549-1.656-.883l-.619-.382-.355-.22.192.257.01.014c.258.343.534.711.723 1.018.094.153.185.32.237.481.026.08.052.188.048.306a.63.63 0 0 1-.182.426.72.72 0 0 1-.56.201 1.3 1.3 0 0 1-.414-.104 5.5 5.5 0 0 1-.677-.364L4 13.035q-.18-.11-.367-.214.03.135.083.29.117.345.276.674l.005.01v.002l-.446.223-.448.224v-.002l-.003-.004-.007-.014a7 7 0 0 1-.326-.797 3.2 3.2 0 0 1-.162-.704c-.018-.203-.02-.565.239-.824a.72.72 0 0 1 .56-.202c.154.009.3.057.414.104.167.069.347.17.514.267l-.297-.399-.011-.014c-.257-.343-.533-.711-.722-1.018a2.4 2.4 0 0 1-.238-.481.9.9 0 0 1-.048-.306.63.63 0 0 1 .181-.426.63.63 0 0 1 .501-.17c.115.009.225.043.312.076.18.068.39.179.606.301.272.156.598.358.936.568.194.12.391.243.585.36.55.335 1.081.637 1.511.812q.238.095.385.124a3 3 0 0 0-.211-.433c-.271-.48-.695-1.074-1.143-1.7l-.012-.018c-.433-.606-.887-1.242-1.187-1.773-.15-.265-.282-.538-.345-.789-.057-.225-.102-.608.183-.893a.73.73 0 0 1 .57-.203c.162.01.317.064.449.122.266.117.571.316.884.544.503.368 1.105.87 1.715 1.378l.458.381c.777.644 1.535 1.25 2.158 1.633.314.193.559.306.732.349l.047.01-.014-.04q-.099-.28-.466-.783c-.467-.639-1.17-1.412-1.904-2.221l-.084-.092c-.75-.827-1.528-1.689-2.043-2.42-.254-.362-.471-.729-.579-1.068-.104-.332-.143-.784.199-1.126a.93.93 0 0 1 .75-.254c.235.02.471.104.688.208.436.209.926.56 1.398.943.95.768 1.936 1.755 2.46 2.28"
        }
      )
    }
  );
}
const T5 = /* @__PURE__ */ i(P5);
function W5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m14.13 2.947-1.871.501-.552.552.5.5-1 1 .793.793V13H4V4.293L5.293 3h3.414l.793.793 1-1 .5.5.741-.741 2.13-.57zm-3.631 1.846.293-.293-.293-.293-.293.293zM5 5h3V4H5.707L5 4.707zm1.646 4.647-1 1 .708.707 1-1zm-1-2.293 1 1 .708-.708-1-1zm4.708 3.292-1-1-.708.707 1 1zm-1-2.292 1-1-.708-.708-1 1z"
        }
      )
    }
  );
}
const G5 = /* @__PURE__ */ i(W5);
function E5(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 5h3v1H5z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10 11h2.293l.707-.707V7h-1V4.707l-.854-.853.708-.708L14 5.293v5.414L12.707 12H10v2H3V3h7zM9 7V4H4v3z"
          }
        )
      ]
    }
  );
}
const N5 = /* @__PURE__ */ i(E5);
function j5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 2v1H3.707l3.647 3.646-.708.708L3 3.707V6H2V2zm6.293 1H10V2h4v4h-1V3.707L9.354 7.354l-.708-.708zM6.646 8.646l.708.708L3.707 13H6v1H2v-4h1v2.293zm2.708 0L13 12.293V10h1v4h-4v-1h2.293L8.646 9.354z"
        }
      )
    }
  );
}
const U5 = /* @__PURE__ */ i(j5);
function I5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1.354.646 5 4.293V2h1v4H2V5h2.293L.646 1.354zM10 2h1v2.293L14.646.646l.708.708L11.707 5H14v1h-4zm-8 8h4v4H5v-2.293l-3.646 3.647-.708-.707L4.293 11H2zm8 0h4v1h-2.293l3.647 3.646-.707.708L11 11.707V14h-1z"
        }
      )
    }
  );
}
const Q5 = /* @__PURE__ */ i(I5);
function K5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.66 7h.84v1H7.393l-.997 3.719A1.728 1.728 0 0 1 3 11.272h1a.727.727 0 0 0 1.43.188L6.357 8H5.5V7h1.125l.729-2.72a1.728 1.728 0 0 1 3.396.447h-1a.727.727 0 0 0-1.43-.188zm2.633 4L8.646 9.354l.708-.708L11 10.293l1.646-1.647.707.708L11.708 11l1.647 1.646-.707.708L11 11.707l-1.646 1.647-.708-.707z"
        }
      )
    }
  );
}
const J5 = /* @__PURE__ */ i(K5);
function X5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 10H4V2h8zm-9 4H1v-2h2zm3 0H4v-2h2zm3 0H7v-2h2zm3 0h-2v-2h2zm3 0h-2v-2h2z"
        }
      )
    }
  );
}
const Y5 = /* @__PURE__ */ i(X5);
function Z5(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6 3.313 1.566.42h.869L10 3.312l2.894.775 1.938 6.162-.638 2.38-1.626.664-1.441-.386-.536-2L8 10.214l-2.592.694-.536 2-1.441.386-1.626-.664-.638-2.38 1.938-6.162zM5 6v1H4v1h1v1h1V8h1V7H6V6zm5.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
        }
      )
    }
  );
}
const _5 = /* @__PURE__ */ i(Z5);
function n3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.707-1.064-1.064-.013.005-1.441-.386-.393-1.466-.677-.677L8 10.214l-2.592.694-.536 2-1.441.386-1.626-.664-.638-2.38 1.938-6.162.218-.058-1.677-1.676zM5.293 6H5v1H4v1h1v1h1V8h1v-.293L6.293 7H6v-.293zm9.54 4.25-.37 1.384-2.991-2.991a1.5 1.5 0 1 0-2.114-2.114L6.192 3.364l1.373.368h.869L10 3.312l2.894.776z"
        }
      )
    }
  );
}
const l3 = /* @__PURE__ */ i(n3);
function t3(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m5.998 2.313 1.566.419h.869l1.565-.42 2.894.776 1.937 6.16-.241.9L10.84 7.96A1.5 1.5 0 1 0 9 6.5v2.98l-1.002-.268-2.59.694-.537 2-1.44.386-1.626-.664-.638-2.38 1.938-6.16zM4 6v1h1v1h1V7h1V6H6V5H5v1z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10.5 6a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-.499 8.37V8.63l4.92 2.87z"
          }
        )
      ]
    }
  );
}
const i3 = /* @__PURE__ */ i(t3);
function e3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.268 4A2 2 0 0 1 6 1c.513 0 1.165.157 1.681.727A2.5 2.5 0 0 1 8 2.169a2.5 2.5 0 0 1 .319-.442C8.835 1.157 9.487 1 10 1a2 2 0 0 1 1.732 3H14.5v2h-5V5h-3v1h-5V4zM6 2a1 1 0 0 0 0 2h1.482c-.066-.858-.302-1.337-.542-1.602A1.23 1.23 0 0 0 6 2m5 1a1 1 0 0 0-1-1c-.315 0-.663.093-.94.398-.24.265-.476.744-.542 1.602H10a1 1 0 0 0 1-1M6.5 7v3.5l1.5-1 1.5 1V7H14v7H2V7z"
        }
      )
    }
  );
}
const o3 = /* @__PURE__ */ i(e3);
function r3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 3H8.5v1.031A4 4 0 0 1 12 8v3h1v2h1v1H2v-1h1v-2h1V8a4 4 0 0 1 3.5-3.969V1H10zm1 5.5h-.75V11H11zm-1.75 0H8.5V11h.75zm-1.75 0h-.75V11h.75zm-1.75 0H5V11h.75z"
        }
      )
    }
  );
}
const h3 = /* @__PURE__ */ i(r3);
function a3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1.5 1.5h5V2h3v-.5h5v5H14v3h.5v5h-5V14h-3v.5h-5v-5H2v-3h-.5zM4 4v2h2V4zm3 0v2h2V4zm3 0v2h2V4zM4 7v2h2V7zm3 0v2h2V7zm3 0v2h2V7zm-6 3v2h2v-2zm3 0v2h2v-2zm3 0v2h2v-2z"
        }
      )
    }
  );
}
const c3 = /* @__PURE__ */ i(a3);
function d3(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M10.5 8a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 5H1V4h2v1h11v6H9v1H4v-1H3v1H2zm9 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
          }
        )
      ]
    }
  );
}
const w3 = /* @__PURE__ */ i(d3);
function v3(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M10 5.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 2h2v1h11v6H8v1H3V9H2v1H1V3H0zm8.5 4a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M10 11v1H5v-1h4v-1h5V5.5h1V11z" })
      ]
    }
  );
}
const m3 = /* @__PURE__ */ i(v3);
function g3(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 12 12-.708.708L10.293 11H9v1H4v-1H3v1H2V5H1V4h2v1h1.293L1.646 2.354zM14 11h-.172l-1.857-1.857a1.5 1.5 0 1 0-2.114-2.114L7.828 5H14z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11.5 8a.5.5 0 0 1-.243.429l-.686-.686A.5.5 0 0 1 11.5 8"
          }
        )
      ]
    }
  );
}
const s3 = /* @__PURE__ */ i(g3);
function f3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m.854.146 15 15-.707.707-1.354-1.353H9.5V14h-3v.5h-5v-5H2v-3h-.5V2.207L.146.854zM4 4.707V6h1.293zm3 3V9h1.293zm3 3V12h1.293zM4 7v2h2V7zm0 3v2h2v-2zm3 0v2h2v-2zm7.5-.5v2.172l-2.5-2.5V7H9.828L9 6.172V4H6.828l-2.5-2.5H6.5V2h3v-.5h5v5H14v3zM10 4v2h2V4z"
        }
      )
    }
  );
}
const u3 = /* @__PURE__ */ i(f3);
function p3(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 6.051V12h-1V6.524L8 8.889 1.354 5.746 8 2.423l6.646 3.323z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4 10V8.103l4 1.892 4-1.892V10c0 .894-.508 1.656-1.235 2.175C10.039 12.695 9.06 13 8 13s-2.038-.306-2.765-.825C4.508 11.655 4 10.894 4 10"
          }
        )
      ]
    }
  );
}
const H3 = /* @__PURE__ */ i(p3);
function M3(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 5.05a2.5 2.5 0 1 0 0 4.9V13H3V9h.5a1.5 1.5 0 1 0 0-3H3V3h10z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
          }
        )
      ]
    }
  );
}
const x3 = /* @__PURE__ */ i(M3);
function z3(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 3h5v2.05a2.5 2.5 0 1 0 0 4.9V13H2z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.5 6a1.5 1.5 0 0 1 1.415 1h5.378l-1.647-1.646.708-.708L15.207 7.5l-2.853 2.854-.708-.708L13.293 8H7.915A1.5 1.5 0 1 1 6.5 6"
          }
        )
      ]
    }
  );
}
const V3 = /* @__PURE__ */ i(z3);
function C3(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 3h5v2.05a2.5 2.5 0 1 0 0 4.9V13H2z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.5 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m3.646 3.146L11.793 7.5l-1.646-1.646.707-.708L12.5 6.793l1.646-1.647.707.708L13.207 7.5l1.647 1.646-.708.708L12.5 8.207l-1.646 1.647z"
          }
        )
      ]
    }
  );
}
const L3 = /* @__PURE__ */ i(C3);
function $3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.97 10.108c-.203.56-.421 1.477-.463 2.892h1.026c.129-.978.619-1.783 1.079-2.348a6.6 6.6 0 0 1 .745-.774c.114-.1.354-.286.354-.286l.577.817s-.183.143-.27.22a5.6 5.6 0 0 0-.63.654c-.373.459-.722 1.045-.843 1.717H14v1H2v-1h2.384c-.142-.318-.403-.629-.717-.91a5.5 5.5 0 0 0-.89-.642c.043-.086.464-.886.464-.886s.233.137.346.211a6.5 6.5 0 0 1 .746.572c.425.379.932.949 1.106 1.655h1.016c-.121-.672-.469-1.258-.843-1.717a5.5 5.5 0 0 0-.899-.874l.576-.817q.184.135.354.286a6.6 6.6 0 0 1 .744.774c.461.565.95 1.37 1.08 2.348h1.04c.042-1.52.276-2.553.524-3.233.136-.376.276-.643.39-.823.066-.105.225-.297.225-.297l.714.7-.093.131a3.3 3.3 0 0 0-.297.63"
        }
      )
    }
  );
}
const S3 = /* @__PURE__ */ i($3);
function k3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.354 2.354-1 1-.708-.708 1-1zM11.191 2h1.618l.8 1.599L12 5.207 10.392 3.6zM5.635 3.928 7 5.293V7.39l-2.653.664-1.419-1.419.677-2.03zM12.89 8l.664 2.653-1.419 1.419-2.03-.677-.677-2.03L10.793 8zm-6.989.892 1.6.799v1.618l-1.6.8L4.293 10.5zm2.745-.538-1-1 .708-.708 1 1zm-.292 4.293 1 1-.708.707-1-1zM1.646 9.646l1-1 .708.708-1 1zm8.708-4.792-1 1-.708-.708 1-1z"
        }
      )
    }
  );
}
const y3 = /* @__PURE__ */ i(k3);
function b3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 5V2h1v3h4V2h1v3h3v1h-3v4h3v1h-3v3h-1v-3H6v3H5v-3H2v-1h3V6H2V5zm1 1v4h4V6z"
        }
      )
    }
  );
}
const R3 = /* @__PURE__ */ i(b3);
function B3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.353 1.646 12 12-.707.708L11 11.707V14h-1v-3H6v3H5v-3H2v-1h3V6H2V5h2.293L1.646 2.354zM6 6.707V10h3.293zM11 6v2.172l-1-1V6H8.828l-1-1H10V2h1v3h3v1z"
        }
      )
    }
  );
}
const F3 = /* @__PURE__ */ i(B3);
function A3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.5 2.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-9 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-9 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-9 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
        }
      )
    }
  );
}
const q3 = /* @__PURE__ */ i(A3);
function O3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-6 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const D3 = /* @__PURE__ */ i(O3);
function P3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.5 5.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-9 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
        }
      )
    }
  );
}
const T3 = /* @__PURE__ */ i(P3);
function W3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 2.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
        }
      )
    }
  );
}
const G3 = /* @__PURE__ */ i(W3);
function E3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 5.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
        }
      )
    }
  );
}
const N3 = /* @__PURE__ */ i(E3);
function j3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 2H2v3H1V1h4zm6-1h4v4h-1V2h-3zM5 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4m6 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4M8 9a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-6 2v3h3v1H1v-4zm12 3v-3h1v4h-4v-1z"
        }
      )
    }
  );
}
const U3 = /* @__PURE__ */ i(j3);
function I3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 4V2h1v2H13v3H8.5v1H11v3H8.5v3h-1v-3H5V8h2.5V7H3V4z"
        }
      )
    }
  );
}
const Q3 = /* @__PURE__ */ i(I3);
function K3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4 2v12H3V2zm1 2h9v3H5zm0 4h6v3H5z" })
    }
  );
}
const J3 = /* @__PURE__ */ i(K3);
function X3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 2v12h-1V2zm-2 5H2V4h9zm0 4H5V8h6z" })
    }
  );
}
const Y3 = /* @__PURE__ */ i(X3);
function Z3(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.5 5a1.5 1.5 0 0 1 1.264.693A1.5 1.5 0 0 1 14 7v4.5a3.5 3.5 0 0 1-3.5 3.5H6.427l-2.695-2.694A2.5 2.5 0 0 1 3 10.538V9.5a2.5 2.5 0 0 1 2-2.45V6.5a1.5 1.5 0 0 1 2.236-1.308 1.5 1.5 0 0 1 2.528 0C9.982 5.07 10.233 5 10.5 5"
        }
      )
    }
  );
}
const _3 = /* @__PURE__ */ i(Z3);
function no(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 1a1.5 1.5 0 0 1 1.448 1.105A1.5 1.5 0 0 1 12 3.5v.085A1.5 1.5 0 0 1 14 5v6.5a3.5 3.5 0 0 1-3.5 3.5H6.409l-.687-.776-1.214-1.37c-.897-1.015-1.849-2.092-2.046-2.32-.535-.622-.574-1.495.026-2.095.613-.613 1.393-.479 1.988-.203.082.038.269.132.524.263V4a1.5 1.5 0 0 1 2-1.415V2.5A1.5 1.5 0 0 1 8.5 1"
        }
      )
    }
  );
}
const lo = /* @__PURE__ */ i(no);
function to(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 4H7V2.707L2.707 7H4v1H1V5h1v1.293L6.293 2H5V1h3zm0 1.5a1.5 1.5 0 1 1 3 0v1.616l2.147.576A2.5 2.5 0 0 1 15 10.106V12.5a2.5 2.5 0 0 1-2.5 2.5H8.523l-.15-.168a882 882 0 0 1-2.911-3.299c-.535-.62-.575-1.494.025-2.094.614-.613 1.394-.48 1.988-.203.083.038.27.132.525.263z"
        }
      )
    }
  );
}
const io = /* @__PURE__ */ i(to);
function eo(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3.5v1.085q.236-.084.5-.085c.531 0 .998.276 1.264.692a1.5 1.5 0 0 1 2 .5A1.5 1.5 0 0 1 14 7v4.5a3.5 3.5 0 0 1-3.5 3.5H6.427l-2.695-2.694A2.5 2.5 0 0 1 3 10.538V9.5a2.5 2.5 0 0 1 2-2.45V3.5a1.5 1.5 0 1 1 3 0"
        }
      )
    }
  );
}
const oo = /* @__PURE__ */ i(eo);
function ro(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 7a5.5 5.5 0 0 1 10.88-1.145l1.781 4.452-1.717.572-.52 3.121H8.366l-.577-1h-4.79v-2.838A5.5 5.5 0 0 1 2 7"
        }
      )
    }
  );
}
const ho = /* @__PURE__ */ i(ro);
function ao(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 3h1v4h4V3h1v9h-1V8H6v4H5z" })
    }
  );
}
const co = /* @__PURE__ */ i(ao);
function wo(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.066 7c.18-1.34.728-2.486 1.588-3.346C4.722 2.586 6.23 2 8 2s3.278.586 4.346 1.654c.861.86 1.409 2.007 1.589 3.346h.425l.667 2-.667 2H14v3H9v.5H7v-2h2v.5h4v-2h-1V7h.924c-.171-1.086-.624-1.978-1.284-2.64C10.786 3.507 9.545 3 8 3s-2.786.508-3.639 1.36C3.7 5.022 3.247 5.914 3.076 7H4v4H1.64L.973 9l.667-2z"
        }
      )
    }
  );
}
const vo = /* @__PURE__ */ i(wo);
function mo(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M10 6h3v4h-3v3H6v-3H3V6h3V3h4z" })
    }
  );
}
const go = /* @__PURE__ */ i(mo);
function so(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12.992 4.008a3.44 3.44 0 0 1 .18 4.672l-.012.014L8 13.866 2.84 8.694l-.012-.014A3.44 3.44 0 0 1 7.68 3.829l.012.011.308.302.308-.304.012-.01a3.44 3.44 0 0 1 4.672.18"
        }
      )
    }
  );
}
const fo = /* @__PURE__ */ i(so);
function uo(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-3.07-3.07L8 13.865 2.84 8.694l-.012-.014a3.44 3.44 0 0 1 .33-4.814L1.647 2.354zM13.16 8.694l-.818.82-6.489-6.49a3.43 3.43 0 0 1 1.827.804l.012.01.308.303.308-.302.013-.011a3.44 3.44 0 0 1 4.851 4.852z"
        }
      )
    }
  );
}
const po = /* @__PURE__ */ i(uo);
function Ho(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 4h12v1H8.5v1.742q1.848.496 3.685 1.035a1.5 1.5 0 1 1-.028 1.393c-.964.248-1.784.74-2.671 1.272l-.18.107c-.958.573-1.996 1.164-3.306 1.373V13h4v1H2.793l-1.147-1.146.708-.708.853.854H5v-1a3 3 0 0 1-3-3c0-1.64 1.208-3 3-3 .295 0 .777.085 1.33.205q.585.13 1.17.278V5H2zm11.035 4.683a.5.5 0 1 0 .045-.453z"
        }
      )
    }
  );
}
const Mo = /* @__PURE__ */ i(Ho);
function xo(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m6-2a1 1 0 0 1 2 0c0 .284-.069.473-.16.62-.096.155-.232.285-.41.433l-.093.077c-.15.122-.338.274-.482.443-.2.232-.355.53-.355.927V10h1V8.5c0-.104.032-.18.114-.276.08-.094.179-.175.32-.29l.136-.112c.197-.164.436-.378.62-.676.191-.307.31-.68.31-1.146a2 2 0 1 0-4 0zm.5 5v1h1v-1z"
        }
      )
    }
  );
}
const zo = /* @__PURE__ */ i(xo);
function Vo(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 1.793 14.207 4.5l-7.5 7.5h-1l-1 1H3.293l-1-1L4 10.293v-1zm-7 9.414L3.707 12h.586l.5-.5z"
        }
      )
    }
  );
}
const Co = /* @__PURE__ */ i(Vo);
function Lo(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M0 2h16v11H0zm4 8V8h2v2h1V5H6v2H4V5H3v5zm6.5-4a1.5 1.5 0 0 1 1.354 2.146l-.5-.5-.707.708.5.5A1.5 1.5 0 1 1 10.5 6m2.086 2.879a2.5 2.5 0 1 0-.707.707l.767.768.708-.708z"
        }
      )
    }
  );
}
const $o = /* @__PURE__ */ i(Lo);
function So(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.542 11h-3.42L7.267 7.146l-.06-.06 1.15-1.15a1.5 1.5 0 0 1 2.232.124zM6.498 7.795l.063.059L9.707 11H1.293l3.146-3.146a1.5 1.5 0 0 1 2.06-.06"
        }
      )
    }
  );
}
const ko = /* @__PURE__ */ i(So);
function yo(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 4a4 4 0 0 0-4 4v1.293l1.146-1.147.708.708L3.5 11.207 1.146 8.854l.708-.708L3 9.293V8a5 5 0 1 1 3.706 4.83l.258-.965A4.004 4.004 0 0 0 12 8a4 4 0 0 0-4-4m.5 1v2.616l2.528.678-.259.966L7.5 8.384V5z"
        }
      )
    }
  );
}
const bo = /* @__PURE__ */ i(yo);
function Ro(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.146 8.854 13 7.707V14H9v-4H7v4H3V7.707L1.854 8.854l-.708-.708L8 1.293l6.854 6.853z"
        }
      )
    }
  );
}
const Bo = /* @__PURE__ */ i(Ro);
function Fo(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.06 3.233 8 1.293l6.854 6.853-.708.708L13 7.707v2.465zM13 14H9v-4H7v4H3V7.707L1.854 8.854l-.708-.708L4.293 5 1.646 2.354l.708-.708 12 12-.708.707-.646-.646z"
        }
      )
    }
  );
}
const Ao = /* @__PURE__ */ i(Fo);
function qo(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 1c-.771 0-1.347.533-1.703 1.296-.356.762-.547 1.844-.547 3.204 0 1.416.34 2.34.666 3.096q.062.145.122.277C6.808 9.484 7 9.92 7 10.5v.5H6v-.5c0-.002-.002-.047-.062-.15a2.5 2.5 0 0 0-.283-.374c-.131-.15-.286-.312-.463-.494l-.056-.058q-.255-.261-.504-.528C3.873 8.072 3 6.947 3 5.5c0-1.389.568-2.529 1.495-3.314C5.414 1.409 6.66 1 8 1m1 10v-.5c0-.58.192-1.016.462-1.627l.122-.277c.327-.756.666-1.68.666-3.096 0-1.36-.191-2.442-.547-3.204C9.347 1.533 8.771 1 8 1c1.34 0 2.586.409 3.505 1.186C12.432 2.971 13 4.111 13 5.5c0 1.447-.873 2.572-1.632 3.396q-.249.267-.504.528l-.056.058c-.176.182-.332.344-.463.494a2.5 2.5 0 0 0-.283.374c-.06.103-.062.148-.062.15v.5zm-3.5 2v-1h5v1H10v2H6v-2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.75 5.5c0-1.287.184-2.205.453-2.781C7.472 2.144 7.771 2 8 2s.528.144.797.719c.27.576.453 1.494.453 2.781 0 1.23-.286 2.013-.584 2.698l-.114.258C8.285 9.056 8 9.693 8 10.5c0-.807-.285-1.445-.552-2.044l-.114-.258C7.036 7.513 6.75 6.73 6.75 5.5"
          }
        )
      ]
    }
  );
}
const Oo = /* @__PURE__ */ i(qo);
function Do(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 3H3V1h10zM5.52 8 3.212 4h9.578l-2.31 4 2.31 4H3.21zm5.537-3H4.943l1.732 3-1.732 3h6.114L9.325 8zM3 15v-2h10v2z"
        }
      )
    }
  );
}
const Po = /* @__PURE__ */ i(Do);
function To(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 3H3V1h10zM5.52 8 3.212 4h9.578l-2.31 4 2.31 4H3.21zm-.577-3 1.732 3h2.65l1.732-3zM3 15v-2h10v2z"
        }
      )
    }
  );
}
const Wo = /* @__PURE__ */ i(To);
function Go(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 3H3V1h10zM5.52 8 3.212 4h9.578l-2.31 4 2.31 4H3.21zm.289-1.5h4.382l.866-1.5H4.943zm4.382 3H5.809L4.943 11h6.114zM3 15v-2h10v2z"
        }
      )
    }
  );
}
const Eo = /* @__PURE__ */ i(Go);
function No(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 3H3V1h10zM5.52 8 3.212 4h9.578l-2.31 4 2.31 4H3.21zm1.155 0-1.732 3h6.114L9.325 8zM3 15v-2h10v2z"
        }
      )
    }
  );
}
const jo = /* @__PURE__ */ i(No);
function Uo(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v8H8.902l.268 1H11v1H5v-1h1.831l.268-1H2zm6 8.5-.134.5h.268zM12 5h-1v1h1zM7.51 8H4.5v1h3.01zM10 8H9v1h1zm2 0h-1v1h1z"
        }
      )
    }
  );
}
const Io = /* @__PURE__ */ i(Uo);
function Qo(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7.5 8.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8.5 2.541A3 3 0 0 1 10.959 5h.541v1H11v1h2v1h.5v1H13v1h-2v3h1v1H4v-1h1v-3H3V9h-.5V8H3V7h2V6h-.5V5h.541A3 3 0 0 1 7.5 2.541V2h1zM10.5 5h-5v1h5zM8 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
          }
        )
      ]
    }
  );
}
const Ko = /* @__PURE__ */ i(Qo);
function Jo(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-.08 3h4.16l1.072 4H4.849z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5 0v1h6V0h1v1h2v14H2V1h2V0zm0 2v1H4V2H3v12h10V2h-1v1h-1V2z"
          }
        )
      ]
    }
  );
}
const Xo = /* @__PURE__ */ i(Jo);
function Yo(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.5 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 14H2V2h12zm-7.466-3.753 3.483-2.007L13 9.959V3H3v5.211z"
          }
        )
      ]
    }
  );
}
const Zo = /* @__PURE__ */ i(Yo);
function _o(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11.947 4.276 12.31 5H15v2.5h-1V6H9v1.5H8V5h3.19l-.137-.276z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m13.416 7.277-.001.002-.003.005-.01.014-.037.053q-.047.07-.134.188a11 11 0 0 1-.476.599c-.234.272-.53.589-.862.862H15v1h-3.5v.5A1.5 1.5 0 0 1 10 12h-.5v-1h.5a.5.5 0 0 0 .5-.5V10H8V9h2.5v-.309l.276-.138c.24-.12.494-.32.737-.553H9.5V7h2.586a.5.5 0 0 0 .353-.146l.207-.208zM6.511 9.819l-.933.362-.644-1.665H3.108l-.642 1.664-.933-.36L3.585 4.5h.866zM4.019 6.154l-.525 1.362h1.053z"
          }
        )
      ]
    }
  );
}
const n6 = /* @__PURE__ */ i(_o);
function l6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 8.793V3h1v5.793l1.146-1.147.708.708L8 10.707 5.646 8.354l.708-.708zM3 5h2v1H4v6h8V6h-1V5h2v8H3z"
        }
      )
    }
  );
}
const t6 = /* @__PURE__ */ i(l6);
function i6(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10.354 3.354 8 5.707 5.646 3.354l.708-.708L7.5 3.793V1h1v2.793l1.146-1.147z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 5h2v1H4v3.211l2.8 1.617 2.85-1.645L12 10.54V6h-1V5h2v9H3z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.454 7.773a1.318 1.318 0 1 1 2.637 0 1.318 1.318 0 0 1-2.637 0"
          }
        )
      ]
    }
  );
}
const e6 = /* @__PURE__ */ i(i6);
function o6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.295 5H5.71l2.293 2.293L10.295 5h3.414l1.293 1.293v3.414L13.71 11h-3.414L8.002 8.707 5.71 11H2.295L1.002 9.707V6.293zm5 3-2-2H2.71l-.707.707v2.586L2.71 10h2.586zM8.71 8l2 2h2.586l.707-.707V6.707L13.295 6H10.71z"
        }
      )
    }
  );
}
const r6 = /* @__PURE__ */ i(o6);
function h6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7.5-3V4h-1v1zm0 7V6h-1v6z"
        }
      )
    }
  );
}
const a6 = /* @__PURE__ */ i(h6);
function c6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2.173 9.938 3.29l-.5.866L8 3.327l-1.437.83-.5-.866zM4 6.214v1.083H3V5.059l1.938-1.118.5.866-.938.541.938.541-.5.866zm7.5-.866-.937-.541.5-.866L13 5.059v2.238h-1V6.214l-.937.541-.5-.866zM8 7.368l1.438-.83.5.867-1.438.83v1.66h-1v-1.66l-1.437-.83.5-.866zm-2.562 3.717-.5.866L3 10.833V8.595h1v1.66zm6.562-.83v-1.66h1v2.238l-1.937 1.118-.5-.866zm-4.5.938h1v1.082l.938-.541.5.866L8 13.72l-1.937-1.119.5-.866.937.541z"
        }
      )
    }
  );
}
const d6 = /* @__PURE__ */ i(c6);
function w6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a5 5 0 0 1 .5 9.975V12H10v1h4v1h-4v1H6v-1H2v-1h4v-1h1.5v-1.025A5 5 0 0 1 8 1M4.126 5a4 4 0 0 0 0 2h1.91a14 14 0 0 1 0-2zm2.023 3H4.535a4 4 0 0 0 2.088 1.757 5 5 0 0 1-.158-.417A8.4 8.4 0 0 1 6.149 8M8 10l.008-.002.033-.016a.6.6 0 0 0 .15-.145c.13-.165.27-.435.395-.813.099-.296.184-.64.25-1.024H7.164c.067.383.152.728.25 1.024.127.378.266.648.396.813a.6.6 0 0 0 .15.145.1.1 0 0 0 .033.016zm-.961-3H8.96a13 13 0 0 0 0-2H7.04a13 13 0 0 0 0 2M4.535 4H6.15c.079-.495.185-.948.316-1.34q.07-.218.158-.417A4 4 0 0 0 4.535 4m3.458-1.998-.033.016a.6.6 0 0 0-.15.145c-.13.165-.269.435-.396.813A7 7 0 0 0 7.164 4h1.672a7 7 0 0 0-.25-1.024c-.125-.378-.265-.648-.395-.813a.6.6 0 0 0-.15-.145l-.033-.016L8 2zM9.964 5a14 14 0 0 1 0 2h1.91a4 4 0 0 0 0-2zm1.5-1a4 4 0 0 0-2.087-1.757q.086.2.158.417c.13.392.237.845.316 1.34zm0 4H9.852a8.4 8.4 0 0 1-.316 1.34q-.072.218-.158.417A4 4 0 0 0 11.465 8"
        }
      )
    }
  );
}
const v6 = /* @__PURE__ */ i(w6);
function m6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 14 14-.708.708L13.293 14H10v1H6v-1H2v-1h4v-1h1.5v-1.025a5 5 0 0 1-4.12-6.889L.645 1.354zM4.293 5h-.167a4 4 0 0 0 0 2h1.91q-.01-.135-.017-.274zm3 3h-.13L8 10l.008-.002.033-.016a.6.6 0 0 0 .15-.145 2.4 2.4 0 0 0 .324-.615zm2.62 2.62a5 5 0 0 1-1.413.355V12H10v1h2.293zM6.466 9.34A8.5 8.5 0 0 1 6.15 8H4.535a4 4 0 0 0 2.089 1.757 5 5 0 0 1-.158-.417M13 6c0 1.17-.402 2.245-1.075 3.097l-.713-.713q.137-.184.253-.384h-.637l-1.83-1.83q.009-.585-.036-1.17H7.828L6.256 3.428q.09-.414.209-.768.07-.218.158-.417a4 4 0 0 0-1.007.545l-.713-.714A5 5 0 0 1 13 6M8.008 2.002 8 2l-.008.002-.033.016a.6.6 0 0 0-.15.145c-.13.165-.27.435-.395.813-.099.296-.184.64-.25 1.024h1.673a7 7 0 0 0-.25-1.024c-.127-.378-.266-.648-.396-.813a.6.6 0 0 0-.15-.145zM10 6q0 .514-.036 1h1.91a4 4 0 0 0 0-2h-1.91Q10 5.486 10 6m-.624-3.757q.09.206.158.417A8.4 8.4 0 0 1 9.85 4h1.615a4 4 0 0 0-2.088-1.757"
        }
      )
    }
  );
}
const g6 = /* @__PURE__ */ i(m6);
function s6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.55 4H7.2V3h4v1H9.585l-2.143 8H8.79v1h-4v-1h1.616z"
        }
      )
    }
  );
}
const f6 = /* @__PURE__ */ i(s6);
function u6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m15.207 6.5-2.853 2.854-.708-.708L13.293 7H7a2 2 0 1 0 1.932 1.482l.966-.258A3 3 0 1 1 7 6h6.293l-1.647-1.646.708-.708zM1 6h3v1H1z"
        }
      )
    }
  );
}
const p6 = /* @__PURE__ */ i(u6);
function H6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 2h3v1.5h-3zm3 2.5V9h-3V4.5zm1.647 4.352 2.965.794-.308 1.15 1.196.32v1.591L13.707 14H2.293L1 12.707v-1.59l5.934-1.59h2.132l1.772.474z"
        }
      )
    }
  );
}
const M6 = /* @__PURE__ */ i(H6);
function x6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 5a3 3 0 1 1 1.262 2.445L6.707 9l1.647 1.646-.708.708L6 9.707l-.793.793 1.647 1.646-.708.708L4.5 11.207l-1.146 1.147-.708-.708 4.909-4.908A3 3 0 0 1 7 5m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
        }
      )
    }
  );
}
const z6 = /* @__PURE__ */ i(x6);
function V6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 3h14v9H1zm3 2H3v1h1zm1.5 0h-1v1h1zM6 6h1V5H6zm2.5-1h-1v1h1zM9 6h1V5H9zm2.5-1h-1v1h1zm.5 1h1V5h-1zM4 7H3v1h1zm.5 1h1V7h-1zM7 7H6v1h1zm.5 1h1V7h-1zM10 7H9v1h1zm.5 1h1V7h-1zM13 7h-1v1h1zM3 10h1V9H3zm8-1H5v1h6zm1 1h1V9h-1z"
        }
      )
    }
  );
}
const C6 = /* @__PURE__ */ i(V6);
function L6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8 13.707 2.293 8 8 2.293 13.707 8z" })
    }
  );
}
const $6 = /* @__PURE__ */ i(L6);
function S6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M9 9h-.5v5h-1V9H6V4.753L7.878 1.5H9z" })
    }
  );
}
const k6 = /* @__PURE__ */ i(S6);
function y6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.724 1.5h6.66l1.876 7H11V11h-1V8.5H8.5V14H10v1H6v-1h1.5V8.5H2.849z"
        }
      )
    }
  );
}
const b6 = /* @__PURE__ */ i(y6);
function R6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 10H3V3h10zM2 11h12v1H2z" })
    }
  );
}
const B6 = /* @__PURE__ */ i(R6);
function F6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.779 3.843a5 5 0 0 0-1.802-.748l.195-.981a6 6 0 0 1 2.162.897zm-3.754-.747a5 5 0 0 0-1.803.746l-.555-.832a6 6 0 0 1 2.163-.895zM3.844 5.222a5 5 0 0 0-.748 1.802l-.981-.195c.15-.752.446-1.487.897-2.162zm-.747 3.753c.127.64.378 1.254.746 1.804l-.832.555a6 6 0 0 1-.895-2.164zm2.126 3.182a5 5 0 0 0 1.802.748l-.195.981a6 6 0 0 1-2.162-.897zM12.5 7.793 14.207 9.5l-4.5 4.5H8v-1.707z"
        }
      )
    }
  );
}
const A6 = /* @__PURE__ */ i(F6);
function q6(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8 9.079 1.008 5 8 .921 14.992 5z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m1.238 7.926.524-.852L8 10.913l6.238-3.839.524.852L8 12.087z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m1.238 10.926.524-.852L8 13.913l6.238-3.839.524.852L8 15.087z"
          }
        )
      ]
    }
  );
}
const O6 = /* @__PURE__ */ i(q6);
function D6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m14.762 10.926-.624.384-.727-.727.827-.509zm0-3-2.481 1.527-.727-.727 2.684-1.652zm-5.397 2.147-1.13-1.131L8 9.079 1.008 5l2.075-1.21-1.437-1.436.708-.708 12 12-.708.708-1.697-1.697L8 15.087l-6.762-4.161.524-.852L8 13.913l3.223-1.983-1.13-1.13L8 12.087 1.238 7.926l.524-.852L8 10.913zM14.992 5l-4.524 2.64-5.152-5.153L8 .921z"
        }
      )
    }
  );
}
const P6 = /* @__PURE__ */ i(D6);
function T6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.333 14H6.667V2h2.666zm1-12H13v12h-2.667zM3 2h2.667v12H3z"
        }
      )
    }
  );
}
const W6 = /* @__PURE__ */ i(T6);
function G6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h4v12H2zm12 6.5V14H7V8.5zm-7-1V2h7v5.5z"
        }
      )
    }
  );
}
const E6 = /* @__PURE__ */ i(G6);
function N6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 3h3v4.5h-3zM2 7.5V3h3.5v4.5zm0 1h3.5V13H2zm4.5 0h3V13h-3zm7.5 0V13h-3.5V8.5zm-3.5-1V3H14v4.5z"
        }
      )
    }
  );
}
const j6 = /* @__PURE__ */ i(N6);
function U6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 5H2V2h3zm1-2h8v1H6zM5 9H2V6h3zm1-2h8v1H6zm-1 6H2v-3h3zm1-2h8v1H6z"
        }
      )
    }
  );
}
const I6 = /* @__PURE__ */ i(U6);
function Q6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 5.667H2V3h12zM2 9.333V6.667h12v2.666zm12 1V13H2v-2.667z"
        }
      )
    }
  );
}
const K6 = /* @__PURE__ */ i(Q6);
function J6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 13h-2V3h2zM5 13H3V5h2zm3-9h2v1.053l1.785-.479 2.12 7.911-1.932.518L10 5.639V13H8z"
        }
      )
    }
  );
}
const X6 = /* @__PURE__ */ i(J6);
function Y6(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 2h3v1h2v1.053l1.786-.479 2.07 7.728-2.898.776L10.464 6.5H10V4H9v2.5H8V3H7v3.5H6V5H5v1.5H4V4h2zm7.631 8.595-1.553-5.796-.965.259 1.552 5.796z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m5.232 7.313 1.017.272h.502l1.017-.272 1.979.53 1.274 4.052-.442 1.647-1.171.479-1.075-.288-.34-1.268-1.493-.4-1.493.4-.34 1.268-1.075.288-1.171-.479-.442-1.647 1.275-4.052z"
          }
        )
      ]
    }
  );
}
const Z6 = /* @__PURE__ */ i(Y6);
function _6(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 2h14v12H1zm3 4a2 2 0 1 0 4 0 2 2 0 0 0-4 0m7-1.5h-1v1h1zM10 8h3V7h-3zM4.14 9l-1 3h5.72l-1-3zM10 10h3V9h-3zm3 1h-3v1h3z"
        }
      )
    }
  );
}
const nr = /* @__PURE__ */ i(_6);
function lr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0m-4 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0m2.33-2.5a5 5 0 0 0-1.83-1.831L9.5 5.4c.455.264.835.643 1.099 1.099zM5.5 3.67A5 5 0 0 0 3.669 5.5l1.733 1A3 3 0 0 1 6.5 5.4zM3.67 10.5a5 5 0 0 0 1.83 1.83l1-1.733A3 3 0 0 1 5.402 9.5zm6.928-1A3 3 0 0 1 9.5 10.597l1 1.733a5 5 0 0 0 1.83-1.83z"
        }
      )
    }
  );
}
const tr = /* @__PURE__ */ i(lr);
function ir(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a4 4 0 0 0-4 4c0 1.038.627 1.914 1.368 2.718q.132.145.265.282h1.715l-.903-3.37.966-.26L8 8.569l.589-2.197.966.258L8.652 10h1.715q.132-.136.265-.282C11.373 8.914 12 8.038 12 7a4 4 0 0 0-4-4m1.44 8H8.383l-.268 1H9c0-.248.092-.47.196-.65q.105-.18.243-.35M9 13H7v.293l.707.707h.586L9 13.293zm-2-1h.884l-.268-1H6.561c.09.114.174.231.243.35.104.18.196.402.196.65M3 7a5 5 0 0 1 10 0c0 1.447-.873 2.572-1.632 3.396-.173.187-.345.365-.504.528l-.056.058c-.176.182-.332.344-.463.494a2.5 2.5 0 0 0-.283.374c-.06.103-.062.148-.062.15v1.707L8.707 15H7.293L6 13.707V12c0-.002-.002-.047-.062-.15a2.5 2.5 0 0 0-.283-.374c-.131-.15-.286-.312-.463-.494l-.056-.057a28 28 0 0 1-.504-.53C3.873 9.573 3 8.448 3 7"
        }
      )
    }
  );
}
const er = /* @__PURE__ */ i(ir);
function or(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.079 6h3.283L7 15.383V10H3.972l2.144-8h4.035z"
        }
      )
    }
  );
}
const rr = /* @__PURE__ */ i(or);
function hr(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7.224 7.053 8 7.44l.776-.388.448.894L8 8.56l-1.224-.612z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 2h12v12H2zm6 2a3 3 0 0 0-3 3c0 .895.54 1.575.966 2.037q.118.129.228.24h3.612q.11-.111.229-.24C10.46 8.575 11 7.895 11 7a3 3 0 0 0-3-3m-.485 7.667h.97l.848-.849v-.54H6.667v.54z"
          }
        )
      ]
    }
  );
}
const ar = /* @__PURE__ */ i(hr);
function cr(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 0 1 6 6v.293l.647-.647.707.708-1.854 1.853-1.853-1.853.707-.708.646.647zM2.5 5.793l1.854 1.853-.707.708L3 7.707V8a5 5 0 0 0 5 5v1a6 6 0 0 1-6-6v-.293l-.646.647-.707-.708z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 4.375a2.5 2.5 0 0 1 2.5 2.5c0 .758-.457 1.326-.798 1.698-.08.085-.16.167-.23.24l-.025.025a7 7 0 0 0-.196.209 1 1 0 0 0-.084.107v1.484l-.738.737h-.858l-.738-.737V9.154a1 1 0 0 0-.084-.106 6 6 0 0 0-.196-.21l-.025-.026a13 13 0 0 1-.229-.24c-.342-.371-.799-.94-.799-1.697a2.5 2.5 0 0 1 2.5-2.5"
          }
        )
      ]
    }
  );
}
const dr = /* @__PURE__ */ i(cr);
function wr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 2a2 2 0 1 1-1.017 3.723l-5.26 5.26a2 2 0 1 1-.707-.707l5.261-5.26A2 2 0 0 1 12 2"
        }
      )
    }
  );
}
const vr = /* @__PURE__ */ i(wr);
function mr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 6h5v2h2V6h5v5H9V9H7v2H2zm4 1H3v3h3V9H4.5V8H6zm4 2v1h3V7h-3v1h1.5v1z"
        }
      )
    }
  );
}
const gr = /* @__PURE__ */ i(mr);
function sr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 2.5V5h-1V2.5zM5.854 3.646l1.5 1.5-.708.708-1.5-1.5zm5 .708-1.5 1.5-.708-.708 1.5-1.5zM5.268 5.438l.507 1.892 1.088-.31.274.96-1.103.316.528 1.972-4.83 1.294-1.294-4.83zm-.707 1.225-2.898.776.777 2.898 2.897-.776-.265-.99-1.435.41-.274-.962 1.45-.414zm6.172-1.225 4.829 1.294-1.294 4.83-4.83-1.294.529-1.972-1.104-.315.274-.962 1.088.311zm-.07 4.123 2.898.776.776-2.898-2.898-.776-.252.942 1.45.414-.274.962-1.435-.41z"
        }
      )
    }
  );
}
const fr = /* @__PURE__ */ i(sr);
function ur(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M9 4h5v1H9zM4.5 9a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M9 11h5v1H9z"
        }
      )
    }
  );
}
const pr = /* @__PURE__ */ i(ur);
function Hr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 5H9V4h5zm0 7H9v-1h5zM7.354 2.354 3.5 6.207 1.646 4.354l.708-.708L3.5 4.793l3.146-3.147zm0 7L3.5 13.207l-1.854-1.854.708-.707L3.5 11.793l3.146-3.147z"
        }
      )
    }
  );
}
const Mr = /* @__PURE__ */ i(Hr);
function xr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 2h1.01v1H4v3h.01v1H3zm11 3H7V4h7zM2 9h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3v1h1v-.01h1V14H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-1H3v.01H2zm12 3H7v-1h7z"
        }
      )
    }
  );
}
const zr = /* @__PURE__ */ i(xr);
function Vr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.358 12.197C4.217 10.757 3 8.742 3 6.647 3 4.227 5.264 2 8 2s5 2.227 5 4.648c0 2.094-1.217 4.108-2.358 5.55-.782.993-1.667 1.9-2.642 2.704l-.07-.054c-.11-.081-.302-.222-.982-.89a19 19 0 0 1-1.59-1.76M8 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
        }
      )
    }
  );
}
const Cr = /* @__PURE__ */ i(Vr);
function Lr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-2.638-2.638q-.183.25-.367.482a19 19 0 0 1-1.59 1.76c-.338.333-.689.64-1.052.944-.117-.098-.209-.117-1.053-.943a19 19 0 0 1-1.589-1.761C4.217 10.756 3 8.742 3 6.648c0-.8.247-1.58.677-2.264l-2.03-2.03zM13 6.647c0 .985-.27 1.953-.673 2.851L5.493 2.664A5.1 5.1 0 0 1 8 2c2.736 0 5 2.227 5 4.647"
        }
      )
    }
  );
}
const $r = /* @__PURE__ */ i(Lr);
function Sr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a3 3 0 0 1 3 3v2h1v7H4V7h1V5a3 3 0 0 1 3-3M6 5v2h4V5a2 2 0 1 0-4 0"
        }
      )
    }
  );
}
const kr = /* @__PURE__ */ i(Sr);
function yr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 2a3 3 0 0 1 2.94 2.4l.01.05V7h-1V4.553A2 2 0 0 0 9 5v2h1v7H2V7h6V5a3 3 0 0 1 3-3"
        }
      )
    }
  );
}
const br = /* @__PURE__ */ i(yr);
function Rr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a4 4 0 0 1 4-4h6a4 4 0 1 1 0 8v-1a3 3 0 0 0 0-6H5a3 3 0 0 0 0 6h2.293L6.146 9.854l.708-.708L9.207 11.5l-2.353 2.354-.708-.708L7.293 12H5a4 4 0 0 1-4-4"
        }
      )
    }
  );
}
const Br = /* @__PURE__ */ i(Rr);
function Fr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.708-9.285-9.286A3.001 3.001 0 0 0 5 11h2.293L6.146 9.854l.708-.708L9.207 11.5l-2.353 2.354-.708-.708L7.293 12H5a4 4 0 0 1-1.44-7.733L1.646 2.354zM15 8a4 4 0 0 1-1.259 2.913l-.707-.708A3 3 0 0 0 11 5H7.828l-1-1H11a4 4 0 0 1 4 4"
        }
      )
    }
  );
}
const Ar = /* @__PURE__ */ i(Fr);
function qr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v5H2zm12 6v2H9.902l.268 1H11v1H5v-1h.831l.269-1H2V9zm-6.866 2-.268 1h2.268l-.268-1z"
        }
      )
    }
  );
}
const Or = /* @__PURE__ */ i(qr);
function Dr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 13 13-.707.707L10.293 11h-.391l.268 1H11v1H5v-1h.831l.268-1H2V9h6.293l-1-1H2V3h.293L.646 1.354zM7.134 11l-.268 1h2.268l-.268-1zM14 11h-.172l-2-2H14zm0-3h-3.172l-5-5H14z"
        }
      )
    }
  );
}
const Pr = /* @__PURE__ */ i(Dr);
function Tr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8.354a6 6 0 1 1 12 0v6h-4v-6a2 2 0 1 0-4 0v6H2zm3 5v-1H3v1zm8 0v-1h-2v1z"
        }
      )
    }
  );
}
const Wr = /* @__PURE__ */ i(Tr);
function Gr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6.5a4.5 4.5 0 1 1 8.016 2.809l4.338 4.338-.707.707-4.338-4.338A4.5 4.5 0 0 1 2 6.5"
        }
      )
    }
  );
}
const Er = /* @__PURE__ */ i(Gr);
function Nr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6.5a4.5 4.5 0 1 1 8.016 2.809l4.338 4.337-.707.707-4.338-4.337A4.5 4.5 0 0 1 2 6.5M9 7H4V6h5z"
        }
      )
    }
  );
}
const jr = /* @__PURE__ */ i(Nr);
function Ur(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6.5a4.5 4.5 0 1 1 8.016 2.809l4.338 4.337-.707.707-4.338-4.337A4.5 4.5 0 0 1 2 6.5M6 6V4h1v2h2v1H7v2H6V7H4V6z"
        }
      )
    }
  );
}
const Ir = /* @__PURE__ */ i(Ur);
function Qr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4M6 15v-4H5V6h6v5h-1v4H9v-4H7v4z"
        }
      )
    }
  );
}
const Kr = /* @__PURE__ */ i(Qr);
function Jr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4m7 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4m3.739 11H13v3h-1v-3h-2v3H9v-3H7.262l2.4-6h2.677zM7 11H6v4H5v-4H3v4H2v-4H1V6h6z"
        }
      )
    }
  );
}
const Xr = /* @__PURE__ */ i(Jr);
function Yr(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m9.5 13.89-3-.75V2.154l3 1.125zm1-10.611 4-1.5v10.568l-4 1.5zm-9-.169 4-1v11.03l-4 1z"
        }
      )
    }
  );
}
const Zr = /* @__PURE__ */ i(Yr);
function _r(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 14 14-.707.708-2.227-2.227-1.92.72v-2.64l-1-1v3.683l-3-.75V7.208l-1-1v6.934l-4 1V3.11l.722-.18L.646 1.353zM14.5 1.779v9.893l-4-4V3.279zm-5 1.5v3.393l-3-3V2.154z"
        }
      )
    }
  );
}
const nh = /* @__PURE__ */ i(_r);
function lh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.711 5H9v6H8V6h-.711L5.5 9.098 3.711 6H3v5H2V5h2.289L5.5 7.098zm7.936 2.646.707.708-2.854 2.853-2.854-2.853.708-.708L12 9.293V5h1v4.293z"
        }
      )
    }
  );
}
const th = /* @__PURE__ */ i(lh);
function ih(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8.997 3.497a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9.497 1.997a1.5 1.5 0 0 0-1.353 2.147l-1 1 .707.707 1-1a1.5 1.5 0 0 0 2-2l1.497-1.497.646.645L14 2v3.113L8.5 8.29V14H11v1H5v-1h2.5V8.289L2 5.113V2z"
          }
        )
      ]
    }
  );
}
const eh = /* @__PURE__ */ i(ih);
function oh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 0 1 .588.028l-.097.996a5 5 0 0 0-.982 0l-.097-.996Q7.703 2 8 2m2.357 1.589a5 5 0 0 0-.905-.375l.29-.957a6 6 0 0 1 1.088.451zm-3.809-.375a5 5 0 0 0-.905.375l-.472-.882a6 6 0 0 1 1.087-.45zm5.317 1.614a5 5 0 0 0-.693-.693l.635-.773a6 6 0 0 1 .831.831zm-7.037-.693q-.38.314-.693.693l-.773-.635q.375-.455.831-.831zm7.958 2.413a5 5 0 0 0-.375-.905l.882-.472a6 6 0 0 1 .45 1.087zm-9.197-.905a5 5 0 0 0-.375.905l-.957-.29a6 6 0 0 1 .451-1.088zM14 8q0 .297-.029.588l-.995-.097a5 5 0 0 0 0-.982l.996-.097Q14 7.703 14 8M3.024 7.509a5 5 0 0 0 0 .982l-.996.097a6 6 0 0 1 0-1.176zm.19 1.943a5 5 0 0 0 .375.905l-.882.472a6 6 0 0 1-.45-1.087zm9.197.905a5 5 0 0 0 .375-.905l.957.29q-.174.57-.451 1.088zm-8.276.815a5 5 0 0 0 .693.693l-.635.773a6 6 0 0 1-.831-.831zm7.037.693a5 5 0 0 0 .693-.693l.773.635q-.375.455-.831.831zm-5.529.546a5 5 0 0 0 .905.375l-.29.957a6 6 0 0 1-1.088-.451zm3.809.375q.475-.144.905-.375l.472.882a6 6 0 0 1-1.087.45zM8 14q-.297 0-.588-.029l.097-.995a5 5 0 0 0 .982 0l.097.996Q8.297 14 8 14m0-2a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
        }
      )
    }
  );
}
const rh = /* @__PURE__ */ i(oh);
function hh(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 4a4 4 0 0 1 .522.034l-.13.991a3 3 0 0 0-.784 0l-.13-.991A4 4 0 0 1 8 4m1.826 1.62a3 3 0 0 0-.678-.393l.383-.923a4 4 0 0 1 .904.523zm-2.974-.393q-.367.153-.678.393l-.609-.793a4 4 0 0 1 .904-.523zm-1.232.947q-.24.31-.393.678l-.923-.383a4 4 0 0 1 .523-.904zm5.153.678a3 3 0 0 0-.393-.678l.793-.609a4 4 0 0 1 .523.904zM12 8q0 .265-.034.522l-.991-.13a3 3 0 0 0 0-.784l.991-.13Q12 7.734 12 8m-6.975-.392a3 3 0 0 0 0 .784l-.991.13a4 4 0 0 1 0-1.044zm5.355 2.218a3 3 0 0 0 .393-.678l.923.383q-.203.49-.523.904zm-5.153-.678a3 3 0 0 0 .393.678l-.793.609a4 4 0 0 1-.523-.904zm.947 1.232a3 3 0 0 0 .678.393l-.383.923a4 4 0 0 1-.904-.523zm2.974.393a3 3 0 0 0 .678-.393l.609.793a4 4 0 0 1-.904.523zM8 12a4 4 0 0 1-.522-.034l.13-.991a3 3 0 0 0 .784 0l.13.991A4 4 0 0 1 8 12"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M1 1h14v14H1zm12 7A5 5 0 1 0 3 8a5 5 0 0 0 10 0"
          }
        )
      ]
    }
  );
}
const ah = /* @__PURE__ */ i(hh);
function ch(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2m0 10a4 4 0 0 0 4-4h-1a3 3 0 0 1-3 3zm-2.286-.717a4 4 0 0 0 1.143.552l.36-.93-1-.482zm.699-4.368c.586-.586.744-1.378.354-1.768-.391-.39-1.182-.232-1.768.354-.586.585-.744 1.377-.354 1.767.391.391 1.182.233 1.769-.353"
        }
      )
    }
  );
}
const dh = /* @__PURE__ */ i(ch);
function wh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 1.73v2.5h2.5v1H5v2.5H4v-2.5H1.5v-1H4v-2.5zM1.647 13.876l12-12 .707.707-12 12zM8.5 11.23h6v1h-6z"
        }
      )
    }
  );
}
const vh = /* @__PURE__ */ i(wh);
function mh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1.5a6.5 6.5 0 1 1-.002 13A6.5 6.5 0 0 1 8 1.5M9.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M3.236 5.25l2.599 1.5a2.5 2.5 0 0 1 1.518-1.165l-.777-2.899a5.5 5.5 0 0 0-3.34 2.563"
        }
      )
    }
  );
}
const gh = /* @__PURE__ */ i(mh);
function sh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.999 3.052a3.5 3.5 0 0 1 4.95 4.95l-4.947 4.945a3.5 3.5 0 0 1-4.95-4.95zM10.5 3c-.702 0-1.335.288-1.79.753l-.003.005-2.122 2.12 3.536 3.536 2.125-2.125A2.5 2.5 0 0 0 10.5 3"
        }
      )
    }
  );
}
const fh = /* @__PURE__ */ i(sh);
function uh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 8.415v2.824L7.404 9H6v4H3V9H2V5h1V4h3v1h1.404L13 2.761v2.824a1.5 1.5 0 0 1 0 2.83"
        }
      )
    }
  );
}
const ph = /* @__PURE__ */ i(uh);
function Hh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 4H3V3h10zm0 4H3V7h10zm0 4H3v-1h10z" })
    }
  );
}
const Mh = /* @__PURE__ */ i(Hh);
function xh(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 1a3 3 0 0 1 3 3v4a3 3 0 0 1-6 0V4a3 3 0 0 1 3-3"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 12a4 4 0 0 0 4-4h1a5 5 0 0 1-3.448 4.755L10.151 15H5.848l.602-2.245A5 5 0 0 1 3 8h1a4 4 0 0 0 4 4"
          }
        )
      ]
    }
  );
}
const zh = /* @__PURE__ */ i(xh);
function Vh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 8c0 .645-.122 1.261-.344 1.827l-.792-.79Q12 8.538 12 8zm-2 0q0 .084-.005.167l-5.62-5.62A3 3 0 0 1 11 4zm-1.262 2.445A3 3 0 0 1 5 8V5.707L1.646 2.354l.707-.708 12 12-.707.708-2.482-2.483a5 5 0 0 1-1.612.884L10.151 15H5.848l.602-2.245A5 5 0 0 1 3 8h1a4 4 0 0 0 6.453 3.16z"
        }
      )
    }
  );
}
const Ch = /* @__PURE__ */ i(Vh);
function Lh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 1h2v1h1v7h-1.117l-.267 1H9.384l-.268-1H8V5.915q-.183.065-.383.08L6.007 12h7.877l.803 3H1.313l.803-3h.857l2.143-8h.97A1.5 1.5 0 0 1 8 3.085V2h1zM7.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
        }
      )
    }
  );
}
const $h = /* @__PURE__ */ i(Lh);
function Sh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 2h1v12h-1zM2 12.707V3.293L6.707 8zm12-9.414v9.414L9.293 8z"
        }
      )
    }
  );
}
const kh = /* @__PURE__ */ i(Sh);
function yh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.293 2h9.414L8 6.707zM2 8.5v-1h12v1zM3.293 14 8 9.293 12.707 14z"
        }
      )
    }
  );
}
const bh = /* @__PURE__ */ i(yh);
function Rh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 1h4v1H2v3H1zm13 1h-3V1h4v4h-1zm1 9v4h-4v-1h3v-3zM5 14v1H1v-4h1v3zM8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
        }
      )
    }
  );
}
const Bh = /* @__PURE__ */ i(Rh);
function Fh(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.5 8c-.866 0-1.672-.116-2.28-.32A4 4 0 0 1 3 7.6v.857a.4.4 0 0 0 .045.04 1.7 1.7 0 0 0 .492.236C4.016 8.893 4.71 9 5.5 9q.405 0 .769-.035-.18.488-.239 1.02Q5.77 10 5.5 10c-.867 0-1.673-.116-2.28-.319a4 4 0 0 1-.22-.08v.855a.4.4 0 0 0 .045.04 1.7 1.7 0 0 0 .492.237c.479.16 1.173.267 1.963.267q.27 0 .526-.016a4.5 4.5 0 0 0 .22.986Q5.884 12 5.5 12c-.867 0-1.673-.116-2.279-.318-.301-.1-.58-.231-.795-.4C2.217 11.117 2 10.857 2 10.5v-6c0-.357.217-.617.426-.782.214-.169.494-.299.794-.399C3.827 3.116 4.633 3 5.5 3s1.673.117 2.279.318a2.7 2.7 0 0 1 .795.4c.209.165.426.425.426.782v1.756a4.5 4.5 0 0 0-2.176 1.648A9 9 0 0 1 5.5 8M3.05 4.5c.09.07.248.153.487.233C4.017 4.893 4.71 5 5.5 5s1.484-.107 1.963-.267A1.7 1.7 0 0 0 7.95 4.5a1.7 1.7 0 0 0-.487-.233C6.983 4.107 6.29 4 5.5 4s-1.484.107-1.963.267a1.7 1.7 0 0 0-.487.233M8 5.6a4 4 0 0 1-.22.081C7.172 5.884 6.366 6 5.5 6s-1.673-.116-2.28-.319a4 4 0 0 1-.22-.08v.855q.013.015.045.04c.09.07.25.156.492.237C4.017 6.893 4.71 7 5.5 7s1.484-.107 1.963-.267c.243-.081.403-.166.492-.236A.4.4 0 0 0 8 6.457z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7 10.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
          }
        )
      ]
    }
  );
}
const Ah = /* @__PURE__ */ i(Fh);
function qh(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.94 6.94c.271-.273.646-.44 1.06-.44s.789.167 1.06.44c.273.271.44.646.44 1.06s-.167.789-.44 1.06c-.271.273-.646.44-1.06.44s-.789-.167-1.06-.44a1.5 1.5 0 0 1 0-2.12"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3.146-2.146.768.767a2.5 2.5 0 0 0 0 2.758l-.768.768.708.707.767-.768a2.5 2.5 0 0 0 2.758 0l.768.768.707-.707-.768-.768a2.5 2.5 0 0 0 0-2.758l.768-.767-.707-.708-.768.768a2.5 2.5 0 0 0-2.758 0l-.767-.768z"
          }
        )
      ]
    }
  );
}
const Oh = /* @__PURE__ */ i(qh);
function Dh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 4h14v8H1zm5 4a2 2 0 1 0 4 0 2 2 0 0 0-4 0M2 7h2V5H2zm2 2H2v2h2zm8 2h2V9h-2zm2-6h-2v2h2z"
        }
      )
    }
  );
}
const Ph = /* @__PURE__ */ i(Dh);
function Th(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.315 3.009a5 5 0 1 1-4.48 7.76l-.556-.839 1.004.063a4 4 0 0 0 3.584-6.208l-.556-.839z"
        }
      )
    }
  );
}
const Wh = /* @__PURE__ */ i(Th);
function Gh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-2.482-2.482a5 5 0 0 1-7.33-1.103L3.28 9.93l1.004.063a4 4 0 0 0 3.435-1.568L1.646 2.354zM10.5 3.67a5 5 0 0 1 2.155 6.157l-4.13-4.13a4 4 0 0 0-.658-1.912l-.556-.839 1.004.063a5 5 0 0 1 2.185.661"
        }
      )
    }
  );
}
const Eh = /* @__PURE__ */ i(Gh);
function Nh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4m5 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4m5 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
        }
      )
    }
  );
}
const jh = /* @__PURE__ */ i(Nh);
function Uh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 5a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 5a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
        }
      )
    }
  );
}
const Ih = /* @__PURE__ */ i(Uh);
function Qh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 1.86 5.562 3h4.876L15 1.86v12.28L10.438 13H5.562L1 14.14zM6 12h4v-2H6zm0-3h4V7H6zm0-3h4V4H6zM5 3.89l-3-.75v2.42l3 .375zm0 3.051-3-.375v2.868l3-.375zm0 3.125-3 .375v2.419l3-.75zm6-6.176v2.044l3-.375V3.14zm3 2.676-3 .375V9.06l3 .375zm0 3.875-3-.375v2.044l3 .75z"
        }
      )
    }
  );
}
const Kh = /* @__PURE__ */ i(Qh);
function Jh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1.456 14.842 14H1.158zm.326 5.011 1.385.214L8 3.544 6.325 6.616l1.111.74z"
        }
      )
    }
  );
}
const Xh = /* @__PURE__ */ i(Jh);
function Yh(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 5.5H3V1h4.5zm1 0V1H13v4.5zm4.5 1V10a5 5 0 0 1-10 0V6.5z"
        }
      )
    }
  );
}
const Zh = /* @__PURE__ */ i(Yh);
function _h(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11 3.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8.5 1H13v4.5H8.5zm2.25 1a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M3 1h4.5v4.5H3zm10 9a5 5 0 0 1-10 0V6.5h10z"
          }
        )
      ]
    }
  );
}
const n4 = /* @__PURE__ */ i(_h);
function l4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.667 5.5H3V1h2.667zM3 10V6.5h10V10a5 5 0 0 1-10 0m3.667-9h2.666v4.5H6.667zM13 5.5h-2.667V1H13z"
        }
      )
    }
  );
}
const t4 = /* @__PURE__ */ i(l4);
function i4(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 1h4.5v2.585A1.5 1.5 0 0 0 6.5 5v.5H3zm3.5 6a1.5 1.5 0 1 0 3 0v-.5H13V10a5 5 0 0 1-10 0V6.5h3.5zm3-2a1.5 1.5 0 0 0-1-1.415V1H13v4.5H9.5z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7.5 5a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0z" })
      ]
    }
  );
}
const e4 = /* @__PURE__ */ i(i4);
function o4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h4.5v2.585A1.5 1.5 0 0 0 6.5 5v.5H3zm3.5 6a1.5 1.5 0 1 0 3 0v-.5H13V10a5 5 0 0 1-10 0V6.5h3.5zm3-2a1.5 1.5 0 0 0-1-1.415V1H13v4.5H9.5z"
        }
      )
    }
  );
}
const r4 = /* @__PURE__ */ i(o4);
function h4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 1.293 2.354 2.353-.708.708L8.5 3.207V7.5h4.293l-1.147-1.146.707-.708L14.708 8l-2.354 2.354-.707-.708L12.793 8.5H8.5v4.293l1.146-1.147.707.707L8 14.708l-2.354-2.354.708-.707L7.5 12.793V8.5H3.207l1.147 1.146-.708.707L1.293 8l2.353-2.354.708.708L3.207 7.5H7.5V3.207L6.354 4.354l-.708-.708z"
        }
      )
    }
  );
}
const a4 = /* @__PURE__ */ i(h4);
function c4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 .918 2.354 2.353-.708.708L8.5 2.832V4.5h-1V2.832L6.354 3.98l-.708-.708zM8 5.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m2.354 7.229L8 15.082l-2.354-2.354.708-.707L7.5 13.168V11.5h1v1.668l1.146-1.147zm2.373-2.375-.707-.708L13.168 8.5H11.5v-1h1.668l-1.147-1.146.707-.708L15.082 8zm-8.747-4L2.832 7.5H4.5v1H2.832l1.147 1.146-.708.708L.918 8l2.353-2.354z"
        }
      )
    }
  );
}
const d4 = /* @__PURE__ */ i(c4);
function w4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 2.382.447.894c.13.258.312.539.519.856q.178.27.37.58c.166.269.327.552.449.83.118.274.215.58.215.887a2 2 0 1 1-4 0c0-.307.097-.613.216-.886.12-.279.283-.562.448-.83q.193-.31.37-.58c.207-.318.39-.599.519-.857zm-.689 10.801a1.2 1.2 0 0 0-.487-.454c-.443-.24-1.083-.322-1.803-.292a11 11 0 0 0-1.969.292c-.271.064-.497.126-.655.172l-.18.055-.046.014-.01.004h-.003l-.003-.011L2 12.5l-.158-.475h.002l.004-.001.015-.005.055-.018q.448-.138.905-.245a12 12 0 0 1 2.156-.319c.514-.02 1.062.005 1.572.13a5 5 0 0 0-.834-.718 6.5 6.5 0 0 0-1.694-.822l-.112-.033-.027-.008-.005-.001L4 9.5l.123-.484h.005l.012.004a7.5 7.5 0 0 1 2.143 1.005c.633.435 1.285 1.048 1.717 1.878.432-.83 1.085-1.443 1.717-1.877a7.5 7.5 0 0 1 2.144-1.006l.012-.004.003-.001h.002L12 9.5l.122.485-.006.001-.026.008a6.5 6.5 0 0 0-1.807.856 4.8 4.8 0 0 0-.834.717c.509-.125 1.058-.151 1.572-.129a12 12 0 0 1 2.157.318c.291.068.534.135.704.185l.2.06.055.018.015.005.005.001c.001 0 .001.001-.157.475l-.158.474h-.003l-.01-.004-.046-.014a13 13 0 0 0-.835-.227 11 11 0 0 0-1.969-.292c-.719-.03-1.36.052-1.803.292a1.2 1.2 0 0 0-.486.454c-.112.191-.19.452-.19.817h-1c0-.365-.077-.626-.19-.817"
        }
      )
    }
  );
}
const v4 = /* @__PURE__ */ i(w4);
function m4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 1v3h-1V1zM4 2v2H3V2zm5 0v2H8V2zm3.786 10H11v.566L10.616 14H2.384L2 12.566V5h9v1h3.393zm.304-5H11v4h1.018z"
        }
      )
    }
  );
}
const g4 = /* @__PURE__ */ i(m4);
function s4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 1a2.5 2.5 0 0 1 2.112 1.162 2.49 2.49 0 0 1 2.214.219A2 2 0 1 1 11 5.732V6h3v7h-3v.566L10.616 15H2.384L2 13.565v-7.65a1.5 1.5 0 0 1 .036-2.842A2.5 2.5 0 0 1 4.5 1M3 4h-.5a.5.5 0 0 0-.5.5.498.498 0 0 0 .9.3l.3-.4.4.3a1.5 1.5 0 0 0 1.734.047l.536-.36.214.61a1.5 1.5 0 0 0 .666.803l.25.144V8.5a.5.5 0 0 0 1 0V5.944l.25-.144c.268-.155.483-.391.613-.673l.218-.473.464.237a1 1 0 1 0-.308-1.538l-.337.398-.383-.354a1.5 1.5 0 0 0-1.851-.144l-.536.36-.214-.61A1.5 1.5 0 0 0 3 3.5zm10 3h-2v5h2zm-8 6V8H4v5zm2 0v-2H6v2zm2 0v-2H8v2z"
        }
      )
    }
  );
}
const f4 = /* @__PURE__ */ i(s4);
function u4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M15 7H1V3h14zM3.5 4.5h-1v1h1zM15 12H1V8h14zM3.5 9.5h-1v1h1z"
        }
      )
    }
  );
}
const p4 = /* @__PURE__ */ i(u4);
function H4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a2 2 0 0 1 .501 3.937v1.626a2 2 0 0 1 1.212.902l1.29-.388a2 2 0 1 1 .287.958L10 8.422a2 2 0 0 1-.51 1.412l.852 1.277a2 2 0 1 1-.832.555l-.852-1.277a2 2 0 0 1-1.316 0l-.852 1.277a2 2 0 1 1-.832-.555l.852-1.277A2 2 0 0 1 6 8.5l.001-.078-1.29-.387A2 2 0 1 1 5 7l-.001.078 1.29.387A2 2 0 0 1 7.5 6.563V4.937A2 2 0 0 1 8 1"
        }
      )
    }
  );
}
const M4 = /* @__PURE__ */ i(H4);
function x4(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.207 8 2.647 2.647-.707.707L.793 8l3.354-3.354.707.708zm9.647-3.354L15.207 8l-3.353 3.354-.707-.708L13.793 8l-2.646-2.646z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
          }
        )
      ]
    }
  );
}
const z4 = /* @__PURE__ */ i(x4);
function V4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 5H6V2h4zM6 6h4v1H6zm3.87 5.483L8 10.982l-1.87.501-.26-.966 1.63-.437V7.964h1v2.116l1.63.437zM5 12H1V9h4zm10 0h-4V9h4zM1 13h4v1H1zm10 0h4v1h-4z"
        }
      )
    }
  );
}
const C4 = /* @__PURE__ */ i(V4);
function L4(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3.464 4.464a5 5 0 0 0 0 7.072l-.707.707a6 6 0 0 1 0-8.486zM15 8a5.98 5.98 0 0 1-1.757 4.243l-.707-.707a5 5 0 0 0 0-7.072l.707-.707A5.98 5.98 0 0 1 15 8"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4.879 5.879a3 3 0 0 0 0 4.242l-.707.707a4 4 0 0 1 0-5.656zM13 8a4 4 0 0 1-1.172 2.828l-.707-.707a3 3 0 0 0 0-4.242l.707-.707A4 4 0 0 1 13 8M8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
          }
        )
      ]
    }
  );
}
const $4 = /* @__PURE__ */ i(L4);
function S4(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 12 12-.708.708-4.63-4.63a2 2 0 0 1-2.74-2.74l-4.63-4.63zm.594 3.424A4.97 4.97 0 0 0 2 8a4.98 4.98 0 0 0 1.464 3.536l-.707.707a6 6 0 0 1-.523-7.888z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4.393 6.514a3 3 0 0 0 .486 3.607l-.707.707a4 4 0 0 1-.505-5.04zM15 8a5.97 5.97 0 0 1-.942 3.23l-.728-.728c.426-.736.67-1.59.67-2.502 0-1.38-.56-2.63-1.464-3.536l.707-.707A5.98 5.98 0 0 1 15 8"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 8c0 .633-.147 1.231-.409 1.763l-.762-.762C11.94 8.688 12 8.35 12 8c0-.829-.335-1.578-.879-2.121l.707-.707A4 4 0 0 1 13 8"
          }
        )
      ]
    }
  );
}
const k4 = /* @__PURE__ */ i(S4);
function y4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.873 4.01a1.5 1.5 0 1 1 .802 2.455L11.715 8l.96 1.536a1.5 1.5 0 1 1-.802 2.454l-2.374.95A1.5 1.5 0 1 1 6.5 13l.002-.061-2.374-.949a1.5 1.5 0 1 1-.802-2.454L4.286 8l-.961-1.535a1.5 1.5 0 1 1 .802-2.454l2.374-.95A1.5 1.5 0 1 1 9.5 3l-.001.06zm-3.547 7.526L9.579 9.53l-.624-.375c-.554.46-1.356.46-1.91 0l-.624.374 1.253 2.005a1.5 1.5 0 0 1 .652 0m2.111-5.581 1.093-.656a1.6 1.6 0 0 1-.029-.36L9.236 4.03zm1.036.547-.507.304.158.254zM8.325 4.465a1.5 1.5 0 0 1-.652 0L6.42 6.47l.625.374a1.5 1.5 0 0 1 1.911 0l.623-.374zm1.782 2.855-.637.38c.04.197.04.4 0 .598l.64.383.426-.682zM6.5 8q0-.153.03-.299l-.639-.383L5.465 8l.426.682.639-.383A1.5 1.5 0 0 1 6.5 8M4.499 4.94a1.5 1.5 0 0 1-.029.36l1.094.655 1.201-1.923zm.535 1.863L4.527 6.5l.348.558zm-.507 2.698.507-.304-.159-.254zm-.028 1.56 2.266.906-1.201-1.922-1.094.656q.03.146.03.299zm7.002 0a1.5 1.5 0 0 1 .029-.36l-1.093-.656-1.202 1.922zm-.534-1.864.507.304-.349-.558z"
        }
      )
    }
  );
}
const b4 = /* @__PURE__ */ i(y4);
function R4(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 6V5h2v1z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 2h12v12h-1.185l-.753-.646-1.312.716-1.375-.75L8 14.07l-1.375-.75-1.365.744-1.411-.706-.642.642H2zm6 2H4v3h4zm1 1h3V4H9zm0 2h3V6H9zM4 8v1h8V8zm8 3v-1H4v1z"
          }
        )
      ]
    }
  );
}
const B4 = /* @__PURE__ */ i(R4);
function F4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 3.5v9h-1V8.287L4 12.37V3.629l7 4.084V3.5z"
        }
      )
    }
  );
}
const A4 = /* @__PURE__ */ i(F4);
function q4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708L9.793 10.5H3.5v-1h5.293l-3-3H3.5v-1h1.293L1.646 2.354zM8.328 5.5H12.5v1H9.328z"
        }
      )
    }
  );
}
const O4 = /* @__PURE__ */ i(q4);
function D4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 12a2 2 0 1 1-2-2h1V6H6v6a2 2 0 1 1-2-2h1V3h8z"
        }
      )
    }
  );
}
const P4 = /* @__PURE__ */ i(D4);
function T4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 1.5h1v5h-1zm1 7a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1v1h2v1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-1h-2v-1zm3-3h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2v-1h2v-1h-1v-1h1v-1h-2z"
        }
      )
    }
  );
}
const W4 = /* @__PURE__ */ i(T4);
function G4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m4.99 6.947 5.478 2.95L9.12 12H1.774zm6.358 3.423L14.374 12H10.31zm.538-.845L15 4.607v6.594zm-.9-.485L1.626 4h12.568zM4.107 6.472 1 11.354V4.799z"
        }
      )
    }
  );
}
const E4 = /* @__PURE__ */ i(G4);
function N4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.607 1h6.594L9.525 4.114zm5.763 3.651L12 1.625V5.69zm-1.33.362L6.577 9.589l-.423-.269L4 11.166v-9.36zM12 6.88v6.16l-4.578-2.913 2.475-4.595zM2.5 15v-1.23l3.742-3.208L12 14.226V15zm3.831-3.197L3.768 14h6.015z"
        }
      )
    }
  );
}
const j4 = /* @__PURE__ */ i(N4);
function U4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 2h5v5h-1V3.707L7.354 9.354l-.708-.708L12.293 3H9zM2 3h5v1H3v9h9V9h1v5H2z"
        }
      )
    }
  );
}
const I4 = /* @__PURE__ */ i(U4);
function Q4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4.293v7.414L11.707 14H4.293L2 11.707V4.293L4.293 2h7.414zM6 9V6H5v3zm4-3v3h1V6z"
        }
      )
    }
  );
}
const K4 = /* @__PURE__ */ i(Q4);
function J4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.293 2h7.414L14 4.293v7.414L11.707 14H4.293L2 11.707V4.293zM5 5v3h1V5zm6 3V5h-1v3zM8 9a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1"
        }
      )
    }
  );
}
const X4 = /* @__PURE__ */ i(J4);
function Y4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2M5 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0m5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    }
  );
}
const Z4 = /* @__PURE__ */ i(Y4);
function _4(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 1a1 1 0 1 0 2 0 1 1 0 0 0-2 0M8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    }
  );
}
const n7 = /* @__PURE__ */ i(_4);
function l7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m5.5-3v2h1V5zM7 9H5v1h2zm2 1h2V9H9z"
        }
      )
    }
  );
}
const t7 = /* @__PURE__ */ i(l7);
function i7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m2.646-1.146 1.5 1.5.708-.708-1.5-1.5zm5.208 1.5 1.5-1.5-.708-.708-1.5 1.5zM7.5 9.5V12h1V9.5z"
        }
      )
    }
  );
}
const e7 = /* @__PURE__ */ i(i7);
function o7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m7.146-1.146 2 2 .708-.708-2-2zm-4.292 2 2-2-.708-.708-2 2zM7.5 9.5V12h1V9.5z"
        }
      )
    }
  );
}
const r7 = /* @__PURE__ */ i(o7);
function h7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.793 4h10.414L15 5.793v4.414L13.207 12H2.793L1 10.207V5.793zM5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2-1a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    }
  );
}
const a7 = /* @__PURE__ */ i(h7);
function c7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2 3v1a1 1 0 0 0 2 0v-1zm4-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    }
  );
}
const d7 = /* @__PURE__ */ i(c7);
function w7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.793 4h10.414L15 5.793v4.414L13.207 12H2.793L1 10.207V5.793zM5 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2 1a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    }
  );
}
const v7 = /* @__PURE__ */ i(w7);
function m7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 9H2V2h7zm4.707 3.5-2.353 2.353-.708-.707L11.793 13H2v-1h9.793l-1.147-1.147.708-.707zM10 2h1v1h-1zm2 0h2v2h-1V3h-1zm2 3v1h-1V5zm0 2v2h-2V8h1V7zm-3 2h-1V8h1z"
        }
      )
    }
  );
}
const g7 = /* @__PURE__ */ i(m7);
function s7(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 5h4V2h4v12H2V2h4zm3 5h2.5V9H9zm0 1v1h2v-1zm-5.39.43 3.865 1.037L8.51 8.603 4.646 7.568z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7 2h2v2H7z" })
      ]
    }
  );
}
const f7 = /* @__PURE__ */ i(s7);
function u7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8c0-3.35 3.213-6 7-6 1.877 0 3.62.499 4.906 1.511C14.204 4.534 15 6.055 15 8c0 1.451-.77 2.457-1.851 2.88-1.055.413-2.35.253-3.426-.464-.92-.613-1.473-.653-1.972-.493a.77.77 0 0 0-.49.464c-.074.205-.073.494.155.836.341.511.521 1.019.49 1.488a1.34 1.34 0 0 1-.705 1.114c-.76.423-1.897.24-2.958-.396-1.245-.747-2.069-1.555-2.575-2.474S1 9.052 1 8m7-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m6 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M4 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    }
  );
}
const p7 = /* @__PURE__ */ i(u7);
function H7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.725 8.732a2.5 2.5 0 1 0 3.535 3.536l4.89-4.89.707.708-4.89 4.889a3.5 3.5 0 0 1-4.95-4.95l5.658-5.657a2.5 2.5 0 0 1 3.535 3.536L6.553 11.56a1.5 1.5 0 0 1-2.121-2.122l4.89-4.889.706.707-4.889 4.89a.5.5 0 1 0 .707.707l5.657-5.657a1.5 1.5 0 0 0-2.121-2.122z"
        }
      )
    }
  );
}
const M7 = /* @__PURE__ */ i(H7);
function x7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M.747 1.623 15.242 8 .747 14.377 2.322 8.5H8v-1H2.322z"
        }
      )
    }
  );
}
const z7 = /* @__PURE__ */ i(x7);
function V7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 13H9V4H7v9H6V8h-.5a2.5 2.5 0 0 1 0-5H12v1h-2zM5.5 4a1.5 1.5 0 1 0 0 3H6V4z"
        }
      )
    }
  );
}
const C7 = /* @__PURE__ */ i(V7);
function L7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 1a3.5 3.5 0 0 1 3.355 4.5A3.5 3.5 0 0 1 12 9.965V13h1.5v1H2v-1h.882l2-1-2-1H2.5v-1h7v1h-.382l-2 1 2 1H11V9.965A3.5 3.5 0 0 1 8.145 5.5 3.5 3.5 0 0 1 11.5 1M5.118 13h1.764L6 12.559zm0-2 .882.441.882-.441z"
        }
      )
    }
  );
}
const $7 = /* @__PURE__ */ i(L7);
function S7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 12V4h1v8zm5 0V4h1v8z" })
    }
  );
}
const k7 = /* @__PURE__ */ i(S7);
function y7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M3.5 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m2.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M8 7c.648 0 1.266.11 1.873.639.569.499 1.087 1.334 1.671 2.659.316.716.412 1.35.273 1.9-.142.563-.507.954-.943 1.215C10.042 13.912 8.856 14 8 14c-.898 0-2.074-.193-2.894-.74-.421-.281-.78-.676-.922-1.215s-.043-1.136.284-1.774c.583-1.133 1.096-1.944 1.64-2.473C6.68 7.243 7.285 7 8 7"
        }
      )
    }
  );
}
const b7 = /* @__PURE__ */ i(y7);
function R7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M15 5H1V3h14zm0 8H1V7h14zM3 10h6V9H3zm10-1h-2v1h2z"
        }
      )
    }
  );
}
const B7 = /* @__PURE__ */ i(R7);
function F7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 1.793 14.207 4.5l-2 2L9.5 3.793zm0 5.414L4.707 14H2v-2.707L8.793 4.5z"
        }
      )
    }
  );
}
const A7 = /* @__PURE__ */ i(F7);
function q7(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 8a6 6 0 0 0 2.787 5.068l-.536.844a7 7 0 1 1 7.498 0l-.536-.844A6 6 0 1 0 2 8"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 6.5a1.5 1.5 0 0 1 1.496 1.383l2.982.799-.26.966-2.981-.799A1.5 1.5 0 1 1 8 6.5"
          }
        )
      ]
    }
  );
}
const O7 = /* @__PURE__ */ i(q7);
function D7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 0 0-3.213 11.068l-.536.845a7 7 0 1 1 7.498 0l-.536-.845A6 6 0 0 0 8 2M6.504 7.883a1.5 1.5 0 1 1 .26.966l-2.982.799-.26-.966z"
        }
      )
    }
  );
}
const P7 = /* @__PURE__ */ i(D7);
function T7(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 8a6 6 0 0 0 2.787 5.068l-.536.844a7 7 0 1 1 7.498 0l-.536-.844A6 6 0 1 0 2 8"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 6.5q.14 0 .273.025L9.817 3.85l.866.5-1.544 2.674A1.5 1.5 0 1 1 8 6.5"
          }
        )
      ]
    }
  );
}
const W7 = /* @__PURE__ */ i(T7);
function G7(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4 2h10v7H8V5H4zm11 9H8v-1h7z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 6h2v1h1V6h2v5H2zm5 6v2H2v-2z" })
      ]
    }
  );
}
const E7 = /* @__PURE__ */ i(G7);
function N7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M1 3h14v10H1zm11.5 2.5h-5v3h5z" })
    }
  );
}
const j7 = /* @__PURE__ */ i(N7);
function U7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 5H2V2h12zm0 3H2V7h12zm0 3H2v-1h12zM2 13h12v1H2z"
        }
      )
    }
  );
}
const I7 = /* @__PURE__ */ i(U7);
function Q7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 1h7v1h-.954l.422 4.84L12 7.116V10H8.5v5h-1v-5H4V7.116l1.032-.276L5.454 2H4.5z"
        }
      )
    }
  );
}
const K7 = /* @__PURE__ */ i(Q7);
function J7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 7.116v2.056L5.404 2.576 5.454 2h-.626L4.5 1.672V1h7v1h-.954l.422 4.84zM8.5 10v5h-1v-5H4V7.116l1.032-.276.089-1.012-3.475-3.474.708-.708 12 12-.707.708L9.293 10z"
        }
      )
    }
  );
}
const X7 = /* @__PURE__ */ i(J7);
function Y7(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3.5 2a12.5 12.5 0 0 1 10.827 6.249l.251.433-1.733 1-.25-.433A10.5 10.5 0 0 0 3.5 4H3V2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 15.366V5h.5a9.5 9.5 0 0 1 8.229 4.75l.25.432zM9.5 8.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-3 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1-5a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
          }
        )
      ]
    }
  );
}
const Z7 = /* @__PURE__ */ i(Y7);
function _7(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-9 5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M2 6v5H1V6zm12 5V6h1v5zm-1-5v5h-1V6z"
        }
      )
    }
  );
}
const n8 = /* @__PURE__ */ i(_7);
function l8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 12.37V3.63L12.492 8z" })
    }
  );
}
const t8 = /* @__PURE__ */ i(l8);
function i8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 1v3h2V1h1v3h3v1h-1v2.365L11.294 10H8.5v1.5A2.5 2.5 0 0 1 6 14H3v-1h3a1.5 1.5 0 0 0 1.5-1.5V10H4.706L4 7.365V5H3V4h3V1z"
        }
      )
    }
  );
}
const e8 = /* @__PURE__ */ i(i8);
function o8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.099 2.392.901.9 1.646-1.646.708.708L12.707 4l.901.901-1.197 2.395-.704.704.647.646-.707.708-5-5 .707-.708.646.647.704-.704zM7.854 6.853 6.207 8.5 7.5 9.793l1.646-1.647.708.707L8.207 10.5l1.147 1.147-.708.707L8 11.708l-.704.704-2.395 1.197L4 12.708l-1.646 1.645-.708-.707 1.646-1.647-.9-.9 1.197-2.395L4.293 8l-.647-.647.708-.707L5.5 7.793l1.646-1.647z"
        }
      )
    }
  );
}
const r8 = /* @__PURE__ */ i(o8);
function h8(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7 3v2H6V3zm3 0v2H9V3z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12 8h1v3.678l-3 .804V15H6v-2.518l-3-.804V8h1V1h8zM5 8h6V2H5zm4 6v-1.25l-1 .268-1-.268V14z"
          }
        )
      ]
    }
  );
}
const a8 = /* @__PURE__ */ i(h8);
function c8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 3h2.152l-1.34 5H8.5v5H10v1H6v-1h1.5V8H4.188l-1.34-5H5V2h6z"
        }
      )
    }
  );
}
const d8 = /* @__PURE__ */ i(c8);
function w8(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8.5 1v7h-1V1z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11.002 2.803a6 6 0 1 1-6.002 0l.5.866a5 5 0 1 0 5 0z"
          }
        )
      ]
    }
  );
}
const v8 = /* @__PURE__ */ i(w8);
function m8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 15v-1h.529l.483-8.22L6.5 1.294l1.5 1.5 1.5-1.5 4.488 4.488.483 8.219H15v1zm5-4.5V8.35l.49-.85H7.5v4.361L6.217 14h3.566L8.5 11.861V7.5h1.01l.49.85v2.15h1V8.082L8 2.886 5 8.082V10.5z"
        }
      )
    }
  );
}
const g8 = /* @__PURE__ */ i(m8);
function s8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 3.5v4.212l7-4.082v8.74L5 8.287V12.5H4v-9z"
        }
      )
    }
  );
}
const f8 = /* @__PURE__ */ i(s8);
function u8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.152 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6M3 14l1.608-6h7.087l1.608 6z"
        }
      )
    }
  );
}
const p8 = /* @__PURE__ */ i(u8);
function H8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6M.85 14l1.606-6h7.088l1.608 6zm10.23-4-.268-1h2.2l1.34 5h-2.2l-.268-1h1.165l-.804-3zm.42-5a1.5 1.5 0 0 0-1.594-1.497l-.062-.998a2.5 2.5 0 0 1 .557 4.963l-.26-.974A1.5 1.5 0 0 0 11.5 5"
        }
      )
    }
  );
}
const M8 = /* @__PURE__ */ i(H8);
function x8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m14.354 13.646-.708.708-12-12 .708-.708 2.661 2.662a3 3 0 1 1 2.676 2.676L8.707 8h2.837l1.038 3.875zM4.456 8h.716l6 6H2.848z"
        }
      )
    }
  );
}
const z8 = /* @__PURE__ */ i(x8);
function V8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M15 4H1V2h14zm-1 7h-3.92l.903 3.37-.966.26L9.58 13H6.419l-.436 1.63-.966-.26L5.92 11H2V5h12zm-4.688 1-.267-1h-2.09l-.268 1z"
        }
      )
    }
  );
}
const C8 = /* @__PURE__ */ i(V8);
function L8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.552 1.263 2.436 9.09 2.588-7L11.554 7H15v1h-4.214l-.362-1.352-2.589 7-2.387-8.91L4.36 8H1V7h2.64z"
        }
      )
    }
  );
}
const $8 = /* @__PURE__ */ i(L8);
function S8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a2 2 0 0 1 2 2h3v3h-1a1 1 0 0 0 0 2h1v4H9v-1a1 1 0 0 0-2 0v1H4v-3a2 2 0 1 1 0-4V4h2a2 2 0 0 1 2-2"
        }
      )
    }
  );
}
const k8 = /* @__PURE__ */ i(S8);
function y8(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2.5 2.5h2v2h-2z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 6H1V1h5zM5 5V2H2v3zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M2 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2m6 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2M7 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m7-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-4 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-8.5-1.5h2v2h-2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 15H1v-5h5zm-1-1v-3H2v3zm6.5-11.5h2v2h-2z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M15 6h-5V1h5zm-1-1V2h-3v3z" })
      ]
    }
  );
}
const b8 = /* @__PURE__ */ i(y8);
function R8(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7.694 2.008a6 6 0 1 0 5.344 9.253l.838.544A7 7 0 1 1 7.644 1.009z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.982 5.177a3.001 3.001 0 1 0 2.952 5.116l.645.764a4 4 0 1 1-3.937-6.82z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9.813 1.237a7.003 7.003 0 0 1 4.951 8.575l-.13.483-7.246-1.941 1.941-7.247.483.13"
          }
        )
      ]
    }
  );
}
const B8 = /* @__PURE__ */ i(R8);
function F8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a6.97 6.97 0 0 1 3.501.937l.432.25-2.25 3.897-.433-.25a2.5 2.5 0 0 0-2.5.001l-.433.25-2.25-3.898.433-.25A6.97 6.97 0 0 1 8 1M5.5 8a2.5 2.5 0 0 0 1.25 2.166l.432.25-2.25 3.897-.432-.25A7 7 0 0 1 1 8v-.5h4.5zm9.5-.5V8a7 7 0 0 1-3.5 6.063l-.432.25-2.25-3.897.432-.25A2.5 2.5 0 0 0 10.5 8v-.5zM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
        }
      )
    }
  );
}
const A8 = /* @__PURE__ */ i(F8);
function q8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 5h1.5V3h1v2h1V3h1v2h1V3h1v2h1V3h1v2h1V3h1v2H14v6h-1.5v2h-1v-2h-1v2h-1v-2h-1v2h-1v-2h-1v2h-1v-2h-1v2h-1v-2H2z"
        }
      )
    }
  );
}
const O8 = /* @__PURE__ */ i(q8);
function D8(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M10 7h1v1h-1z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14.001 4.536v6.928l-6 3.464-6-3.464V4.536l6-3.464zM9 6v4h1V9h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM5.5 6h-1v1.44l.7.56-.7.56V10h1v-.96l.5-.4.5.4V10h1V8.56L6.8 8l.7-.56V6h-1v.96l-.5.4-.5-.4z"
          }
        )
      ]
    }
  );
}
const P8 = /* @__PURE__ */ i(D8);
function T8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 8a5 5 0 1 1 10 0A5 5 0 0 1 3 8m5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
        }
      )
    }
  );
}
const W8 = /* @__PURE__ */ i(T8);
function G8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8 8H3V2h5zm0 6H2V9h6zm6-2H9V4h5z" })
    }
  );
}
const E8 = /* @__PURE__ */ i(G8);
function N8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.647 5.354c-1.59-1.59-3.936-1.718-5.472-.182a4 4 0 0 0 0 5.656l-.707.708a5 5 0 0 1 0-7.072c1.98-1.98 4.961-1.742 6.886.182l1.645 1.646L13 4h1l-.002 3.998L10 8V7l2.292-.001z"
        }
      )
    }
  );
}
const j8 = /* @__PURE__ */ i(N8);
function U8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 2.173 8.938 3.29l-.5.866L7 3.327l-1.437.83-.5-.866zM3 6.214v1.083H2V5.059l1.938-1.118.5.866-.938.541.938.541-.5.866zm2.563.325L7.5 7.657v2.238h-1v-1.66l-1.437-.83zm-1.125 4.546-.5.866L2 10.833V8.596h1v1.66zM11 10.256v-1.66h1v2.237l-1.937 1.118-.5-.866zm-4.5.937h1v1.082l.938-.541.5.866L7 13.72l-1.937-1.119.5-.866.937.541zM11 2h4v4h-1V3.707l-3.646 3.647-.708-.708L13.293 3H11z"
        }
      )
    }
  );
}
const I8 = /* @__PURE__ */ i(U8);
function Q8(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 8a5 5 0 0 1 10 0v1.293l1.646-1.647.708.708-2.854 2.853-2.854-2.853.708-.708L12 9.293V8a4 4 0 1 0-2.964 3.865l.258.966A5.005 5.005 0 0 1 3 8"
        }
      )
    }
  );
}
const K8 = /* @__PURE__ */ i(Q8);
function J8(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4.749 1.37a6.5 6.5 0 0 1 6.501 0l-.5.866a5.5 5.5 0 0 0-5.5 0zM5.75 3.103a4.5 4.5 0 0 1 4.5 0l-.5.865a3.5 3.5 0 0 0-3.5 0zM7.5 8a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11 15H5V5h6zM8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-1.25 5h1v-1h-1zm2.5-1h-1v1h1zM6.75 13h1v-1h-1zm2.5-1h-1v1h1z"
          }
        )
      ]
    }
  );
}
const X8 = /* @__PURE__ */ i(J8);
function Y8(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.455 6.773a1.318 1.318 0 1 1 2.636 0 1.318 1.318 0 0 1-2.636 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4 3h10v10H4zm1 1v4.211l2.8 1.617 2.85-1.645L13 9.54V4zM3 4v8H2V4z"
          }
        )
      ]
    }
  );
}
const Z8 = /* @__PURE__ */ i(Y8);
function _8(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4 8c0 1.432.751 2.688 1.884 3.395l-.53.848a5.001 5.001 0 0 1 1.983-9.2l-.69-.69.707-.707L9.707 4H8a4 4 0 0 0-4 4"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10.646 3.757a5.001 5.001 0 0 1-1.982 9.2l.69.69-.708.707L6.293 12H8a4 4 0 0 0 2.116-7.395z"
          }
        )
      ]
    }
  );
}
const na = /* @__PURE__ */ i(_8);
function la(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.707-2.483-2.482c-.7.573-1.559.96-2.5 1.085l.69.69-.708.707L6.293 12H8c.924 0 1.775-.314 2.453-.84L9.016 9.723a2 2 0 0 1-2.74-2.74L4.84 5.548a3.997 3.997 0 0 0 1.044 5.848l-.53.848a4.997 4.997 0 0 1-1.225-7.407L1.646 2.354zM13 8c0 .874-.224 1.696-.619 2.41l-.658-.945a4 4 0 0 0-1.607-4.86l.53-.848A5 5 0 0 1 13 8M8 4c-.358 0-.706.047-1.036.136l-.791-.791a5 5 0 0 1 1.164-.301l-.69-.69.707-.708L9.707 4z"
        }
      )
    }
  );
}
const ta = /* @__PURE__ */ i(la);
function ia(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m4.707 6 1.647 1.646-.708.708L2.793 5.5l2.853-2.854.708.708L4.707 5h8.615l-2.045 7.63-.966-.26L12.018 6z"
        }
      )
    }
  );
}
const ea = /* @__PURE__ */ i(ia);
function oa(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 4a4 4 0 0 0-4 4v1.293l1.146-1.147.708.708L3.5 11.207 1.146 8.854l.708-.708L3 9.293V8a5 5 0 1 1 3.706 4.83l.258-.965A4.004 4.004 0 0 0 12 8a4 4 0 0 0-4-4"
        }
      )
    }
  );
}
const ra = /* @__PURE__ */ i(oa);
function ha(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.354.646 11.207 3.5 8.354 6.354l-.708-.708L9.293 4H8a4 4 0 1 0 4 4h1a5 5 0 1 1-5-5h1.293L7.646 1.354z"
        }
      )
    }
  );
}
const aa = /* @__PURE__ */ i(ha);
function ca(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m4.707 6 1.647 1.646-.707.708L2.793 5.5l2.854-2.854.707.708L4.707 5h8.615l-2.144 8H3v-1h7.41l1.608-6z"
        }
      )
    }
  );
}
const da = /* @__PURE__ */ i(ca);
function wa(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4 9.207 1.146 6.354l.708-.708 1.248 1.249A6 6 0 1 1 9 14v-1a5 5 0 1 0-5-5z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 5h1.01v1.125H7v3.75h.01V11H6zm2 1.125C8 5.422 8.649 5 9.25 5h1.5c.601 0 1.25.422 1.25 1.125v3.75c0 .703-.649 1.125-1.25 1.125h-1.5C8.649 11 8 10.578 8 9.875zm1.04-.058C9 6.1 9 6.123 9 6.125v3.75c0 .002 0 .025.04.058a.33.33 0 0 0 .21.067h1.5a.33.33 0 0 0 .21-.067c.04-.033.04-.056.04-.058v-3.75c0-.002 0-.025-.04-.058A.33.33 0 0 0 10.75 6h-1.5a.33.33 0 0 0-.21.067"
          }
        )
      ]
    }
  );
}
const va = /* @__PURE__ */ i(wa);
function ma(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.5 5c0 .306.142.536.402.709C3.177 5.892 3.574 6 4 6s.823-.108 1.098-.291c.259-.173.402-.403.402-.709h1c0 .306.142.536.402.709C7.177 5.892 7.574 6 8 6s.823-.108 1.098-.291c.259-.173.402-.403.402-.709h1c0 .306.142.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.259-.173.402-.403.402-.709h1c0 .694-.358 1.214-.848 1.541C13.177 6.858 12.574 7 12 7s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29 2 2 0 0 1-.348.29C9.177 6.858 8.574 7 8 7s-1.177-.142-1.652-.459A2 2 0 0 1 6 6.251a2 2 0 0 1-.348.29C5.177 6.858 4.574 7 4 7s-1.177-.142-1.652-.459C1.857 6.214 1.5 5.694 1.5 5zm0 4c0 .306.142.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.259-.173.402-.403.402-.709h1c0 .306.142.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.259-.173.402-.403.402-.709h1c0 .306.142.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.259-.173.402-.403.402-.709h1c0 .694-.358 1.214-.848 1.541-.475.317-1.078.459-1.652.459s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29 2 2 0 0 1-.348.29C9.177 10.858 8.574 11 8 11s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29 2 2 0 0 1-.348.29C5.177 10.858 4.574 11 4 11s-1.177-.142-1.652-.459C1.857 10.214 1.5 9.694 1.5 9z"
        }
      )
    }
  );
}
const ga = /* @__PURE__ */ i(ma);
function sa(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.982 4.743a2 2 0 0 1-1.998-.02L5.586 6.121a2.49 2.49 0 0 1 .302 2.12L9.646 12h4.238l.804 3H1.313l.804-3h3.287L3.402 9.998a2.5 2.5 0 1 1 1.477-4.584l1.398-1.398a2 2 0 1 1 3.426.033l1.793 1.748.297-.297h1.914l1.646 1.646-.707.708L13.293 6.5h-1.086l-.707.707v1.086l1.354 1.353-.708.707L10.5 8.708V6.793l.289-.289zM9 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0M3.535 9A1.5 1.5 0 1 0 3.5 9z"
        }
      )
    }
  );
}
const fa = /* @__PURE__ */ i(sa);
function ua(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14.018 12.778 11 14.521v-3.642l-2.69-2.69-2.373-.791 1.15-4.288L10.6 1.94l2.885 2.308z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4.461 7.96 7.77 9.063l2.23 2.23v2.475l-1.874 1.249-4.856-.54-1.806-1.805.585-3.505z"
          }
        )
      ]
    }
  );
}
const pa = /* @__PURE__ */ i(ua);
function Ha(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.486 8.192a8 8 0 0 1-.39.419L8 11.707v2l-1.5 1.5L4.793 13.5l1-1L5 11.707l-1.146 1.147-.707-.708L4.293 11l-.793-.793-1 1L.793 9.5l1.5-1.5h2l3.096-3.096a8 8 0 0 1 .419-.389zM8.612 3.905c1.216-.808 2.731-1.318 4.046-.88l.237.08.079.237c.439 1.315-.071 2.83-.878 4.047z"
        }
      )
    }
  );
}
const Ma = /* @__PURE__ */ i(Ha);
function xa(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.613 5.833C2.474 6.359 2 6.984 2 7.5s.474 1.142 1.613 1.667C4.71 9.674 6.261 10 8 10h.293l-.647-.646.708-.708 1.853 1.854-1.853 1.854-.708-.708.647-.646H8c-1.85 0-3.55-.345-4.806-.925C1.981 9.515 1 8.641 1 7.5s.981-2.015 2.194-2.575C4.45 4.345 6.15 4 8 4s3.55.345 4.806.925C14.019 5.485 15 6.359 15 7.5c0 .663-.34 1.24-.84 1.704-.499.462-1.19.842-1.99 1.131l-.34-.94c.721-.26 1.28-.582 1.651-.925.37-.342.519-.672.519-.97 0-.516-.474-1.141-1.613-1.667C11.29 5.326 9.739 5 8 5c-1.74 0-3.29.326-4.387.833"
        }
      )
    }
  );
}
const za = /* @__PURE__ */ i(xa);
function Va(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.08 12.503C10.63 11.401 11 9.81 11 8c0-.98-.108-1.897-.295-2.705A12 12 0 0 0 8 5c-.579 0-1.135.038-1.66.107a11.6 11.6 0 0 0-.32 2.166l.626-.627.708.708L5.5 9.207 3.646 7.354l.708-.708.663.664c.034-.706.121-1.38.253-2.01a8 8 0 0 0-1.773.62C2.337 6.5 2 7.116 2 7.5s.337 1 1.497 1.58C4.598 9.63 6.19 10 8 10q.146 0 .29-.003l-.644-.643.708-.708 1.853 1.854-1.853 1.854-.708-.708.65-.65Q8.149 11 8 11c-3.866 0-7-1.567-7-3.5 0-1.503 1.894-2.784 4.554-3.28C6.176 2.283 7.264 1 8.5 1c1.29 0 2.418 1.397 3.025 3.475C13.603 5.082 15 6.21 15 7.5c0 .988-.82 1.881-2.137 2.518q.082-.589.115-1.205C13.758 8.317 14 7.825 14 7.5c0-.384-.337-1-1.498-1.58a7 7 0 0 0-.71-.305C11.927 6.359 12 7.162 12 8c0 3.866-1.567 7-3.5 7-1.233 0-2.317-1.275-2.94-3.203q.54.093 1.111.144.117.3.249.561C7.5 13.664 8.116 14 8.5 14s1-.337 1.58-1.498m.305-8.295a7 7 0 0 0-.305-.71C9.5 2.336 8.884 2 8.5 2s-1 .337-1.58 1.497a7 7 0 0 0-.25.566 14 14 0 0 1 3.715.145"
        }
      )
    }
  );
}
const Ca = /* @__PURE__ */ i(Va);
function La(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.646 5.646 7.793 4.5H6.5A2.5 2.5 0 0 0 4 7H3a3.5 3.5 0 0 1 3.5-3.5h1.293L6.646 2.354l.708-.708L9.707 4 7.354 6.354zM5 7h6v6H5z"
        }
      )
    }
  );
}
const $a = /* @__PURE__ */ i(La);
function Sa(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.646 6.354 6.293 4l2.353-2.354.708.708L8.207 3.5H9.5A3.5 3.5 0 0 1 13 7h-1a2.5 2.5 0 0 0-2.5-2.5H8.207l1.147 1.146zM5 7h6v6H5z"
        }
      )
    }
  );
}
const ka = /* @__PURE__ */ i(Sa);
function ya(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 0 1 6 6v.293l.647-.647.707.708-1.854 1.853-1.853-1.853.707-.708.646.647V8a5 5 0 0 0-5-5zM3.647 8.354 3 7.707V8a5 5 0 0 0 5 5v1a6 6 0 0 1-6-6v-.293l-.646.647-.707-.708L2.5 5.793l1.854 1.853zM5.5 8a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
        }
      )
    }
  );
}
const ba = /* @__PURE__ */ i(ya);
function Ra(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.03 14.024 6 13.016 1.5 14.14v-3.433l2.5-2.5 2 2L7.207 9H8V8H6.793L6 8.793l-2-2-2.5 2.5V3.11l4.53-1.133L10 3.466l4.5-1.687v10.568zm1.612-4.085c.391-.494.858-1.24.858-2.057 0-1.007-.921-1.882-2-1.882s-2 .875-2 1.882c0 .816.467 1.563.858 2.057.337.426.728.783 1.142 1.13.414-.347.805-.704 1.142-1.13"
        }
      )
    }
  );
}
const Ba = /* @__PURE__ */ i(Ra);
function Fa(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 1.293 14.707 5l-1.5 1.5-1.353-1.354-.707.708L12.5 7.207 11.707 8 9.354 5.646l-.707.708L11 8.707l-.793.793-1.353-1.354-.707.708L9.5 10.207 8.707 11 6.354 8.646l-.707.708L8 11.707l-.793.793-1.353-1.354-.707.708L6.5 13.207l-1.5 1.5L1.293 11z"
        }
      )
    }
  );
}
const Aa = /* @__PURE__ */ i(Fa);
function qa(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10 3.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m14.379 4.647.707.708-2.504 2.503-3-1.732-1.768 1.768 3 1.732-3.46 3.461-.708-.707 2.54-2.54-2.104-1.216-5.228 5.23-.708-.707 7.54-7.54-2.104-1.214-1.96 1.961-.707-.708 2.503-2.503 6 3.464z"
          }
        )
      ]
    }
  );
}
const Oa = /* @__PURE__ */ i(qa);
function Da(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1v.866L11.541 8H8v1h6v4H4.293L1.5 10.207V9H7V1z"
        }
      )
    }
  );
}
const Pa = /* @__PURE__ */ i(Da);
function Ta(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12.5 9a.5.5 0 0 0 .5-.5V6h1v2.5a1.5 1.5 0 0 1-1.5 1.5H12v1.092Q13.5 11 15 11v1q-2.589 0-5.163.28a44.5 44.5 0 0 0-5.978 1.053q-1.035.26-2.051.589l-.105.037-.025.008-.007.003-.525-.824L6.5 7.793l3.467 3.467q.505-.051 1.033-.096V8h-.5A1.5 1.5 0 0 1 9 6.5V4h1v2.5a.5.5 0 0 0 .5.5h.5V2h1v7z"
        }
      )
    }
  );
}
const Wa = /* @__PURE__ */ i(Ta);
function Ga(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.519 4.606v3.998l5.718-3.53.526.851-7.244 4.471V6.393L1.762 9.926l-.523-.852z"
        }
      )
    }
  );
}
const Ea = /* @__PURE__ */ i(Ga);
function Na(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8 14H2V8h6z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 14h-4v-1h3V3H3v3H2V2h12z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9 5V4h3.003v3h-1V5.705l-1.65 1.648-.707-.708L10.294 5z"
          }
        )
      ]
    }
  );
}
const ja = /* @__PURE__ */ i(Na);
function Ua(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 3v1H15v1h-2v2h2.152l-.804 3h-3.696l-.804-3H12V5H8.5v7H10v1H6v-1h1.5V5H4v2h2.152l-.804 3H1.652L.848 7H3V5H1V4h6.5V3z"
        }
      )
    }
  );
}
const Ia = /* @__PURE__ */ i(Ua);
function Qa(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 1v2.793l1.146-1.147.708.708L8 5.707 5.646 3.354l.708-.708L7.5 3.793V1zM14 6.5v1H2v-1zm-12 3v-1h12v1zm6 .793 2.354 2.353-.708.708L8.5 12.207V15h-1v-2.793l-1.146 1.147-.708-.708z"
        }
      )
    }
  );
}
const Ka = /* @__PURE__ */ i(Qa);
function Ja(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M15 13.5h-5v-1H9v1H1v-6h1v-1H1V3h14zm-12-6h1v-1H3zm2 0h1v-1H5zm3-1H7v1h1zm1 2v1h1v-1zm1 3v-1H9v1zm-1-4h1v-1H9z"
        }
      )
    }
  );
}
const Xa = /* @__PURE__ */ i(Ja);
function Ya(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 14 14-.707.708-1.854-1.854H10v-1H9v1H1v-6h1v-1H1V3h1.293L.646 1.354zM5.793 6.5H5v1h1v-.793zm4 4H9v1h1v-.793zM3 7.5h1v-1H3zM15 3v9.172L5.828 3z"
        }
      )
    }
  );
}
const Za = /* @__PURE__ */ i(Ya);
function _a(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 3H2V2h12zM4 8a4 4 0 1 1 4 4v-1a3 3 0 1 0-3-3v.293l.646-.647.708.708L4.5 10.207 2.646 8.354l.708-.708.646.647zm10 5v1H2v-1z"
        }
      )
    }
  );
}
const nc = /* @__PURE__ */ i(_a);
function lc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 3H2V2h12zm-6 .293 2.354 2.353-.708.708L8.5 5.207v5.586l1.146-1.147.708.708L8 12.707l-2.354-2.353.708-.708L7.5 10.793V5.207L6.354 6.354l-.708-.708zM14 13v1H2v-1z"
        }
      )
    }
  );
}
const tc = /* @__PURE__ */ i(lc);
function ic(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 4H8.5v.26l2.5 2V14H9v-3H7v3H5V6.26l2.5-2V2H10zM8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7 1v4h-3v-4zM1 10h3v4H1z"
        }
      )
    }
  );
}
const ec = /* @__PURE__ */ i(ic);
function oc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 4.5a2.5 2.5 0 1 1 4.45 1.564l2.354 1.359 4.946-2.856.5.866L9.804 8l4.446 2.567-.5.866-4.946-2.856-2.354 1.36a2.5 2.5 0 1 1-.834-.673L7.804 8 5.617 6.737A2.5 2.5 0 0 1 2 4.5M4.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
        }
      )
    }
  );
}
const rc = /* @__PURE__ */ i(oc);
function hc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h4v4H4.5v4H6v.268l5.5-3.175V6H10V2h4v4h-1.5v1.67L6 11.423V14H2v-4h1.5V6H2z"
        }
      )
    }
  );
}
const ac = /* @__PURE__ */ i(hc);
function cc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.646 6.354 7.293 4l2.353-2.354.707.708L9.207 3.5H12.5V10H14v4h-4v-4h1.5V4.5H9.207l1.147 1.146zM6 6H4.5v5.5h2.293l-1.147-1.146.708-.708L8.707 12l-2.353 2.354-.708-.708L6.793 12.5H3.5V6H2V2h4z"
        }
      )
    }
  );
}
const dc = /* @__PURE__ */ i(cc);
function wc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 6h-.946l.535 2h4.822l.536-2H10V2h4v4h-2.018l-.804 3H8.5v1H10v4H6v-4h1.5V9H4.822l-.804-3H2V2h4z"
        }
      )
    }
  );
}
const vc = /* @__PURE__ */ i(wc);
function mc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 10h1.5V6H2V2h4v2.577l6.5 3.753V10H14v4h-4v-4h1.5V8.907L6 5.732V6H4.5v4H6v4H2z"
        }
      )
    }
  );
}
const gc = /* @__PURE__ */ i(mc);
function sc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m9.207 4.5 1.147 1.146-.707.708L7.293 4l2.354-2.354.707.708L9.207 3.5H12.5V10H14v4h-4v-4h1.5V4.5zM6 6H4.5v4H6v4H2v-4h1.5V6H2V2h4z"
        }
      )
    }
  );
}
const fc = /* @__PURE__ */ i(sc);
function uc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.354 1.646 12 3.293l1.647-1.647.707.708L12.707 4l1.647 1.646-.708.708L12 4.707l-1.646 1.647-.708-.708L11.293 4 9.646 2.354zM2 2h4v4H4.5v4H6v4H2v-4h1.5V6H2zm9.5 5h1v3H14v4h-4v-4h1.5z"
        }
      )
    }
  );
}
const pc = /* @__PURE__ */ i(uc);
function Hc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 6H4.5v4H6v4H2v-4h1.5V6H2V2h4zm8 8h-4v-4h4zm-1-6h-2V6h2zm0-3h-2V3h2z"
        }
      )
    }
  );
}
const Mc = /* @__PURE__ */ i(Hc);
function xc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.793 2H13v3h-.5v1h.5v8H3V3.793zM6 4.5H5V7h1zM7 7h1V4H7zm3-3H9v3h1z"
        }
      )
    }
  );
}
const zc = /* @__PURE__ */ i(xc);
function Vc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.348 4.541C1.858 4.214 1.5 3.694 1.5 3h1c0 .306.143.536.402.709C3.177 3.892 3.574 4 4 4s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709C7.177 3.892 7.574 4 8 4s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541C13.177 4.858 12.574 5 12 5s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29 2 2 0 0 1-.348.29C9.177 4.858 8.574 5 8 5s-1.177-.142-1.652-.459A2 2 0 0 1 6 4.251a2 2 0 0 1-.348.29C5.177 4.858 4.574 5 4 5s-1.177-.142-1.652-.459m0 4C1.858 8.214 1.5 7.694 1.5 7h1c0 .306.143.536.402.709C3.177 7.892 3.574 8 4 8s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709C7.177 7.892 7.574 8 8 8s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541C13.177 8.858 12.574 9 12 9s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29 2 2 0 0 1-.348.29C9.177 8.858 8.574 9 8 9s-1.177-.142-1.652-.459A2 2 0 0 1 6 8.251a2 2 0 0 1-.348.29C5.177 8.858 4.574 9 4 9s-1.177-.142-1.652-.459M2.5 11c0 .306.142.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.259-.173.402-.403.402-.709h1c0 .306.142.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.259-.173.402-.403.402-.709h1c0 .306.142.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.259-.173.402-.403.402-.709h1c0 .694-.358 1.214-.848 1.541-.475.317-1.078.459-1.652.459s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29 2 2 0 0 1-.348.29C9.177 12.858 8.574 13 8 13s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29q-.158.164-.348.29C5.177 12.858 4.574 13 4 13s-1.177-.142-1.652-.459C1.857 12.214 1.5 11.694 1.5 11z"
        }
      )
    }
  );
}
const Cc = /* @__PURE__ */ i(Vc);
function Lc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.642 14.87.325-1.204A6 6 0 0 1 9.062 2.115L9.393.87l.967.258L6.608 15.13zm4.891-1.411A6 6 0 0 1 8.52 14l-.086-.998a5 5 0 0 0 1.676-.45zm2.904-2.903a6 6 0 0 1-1.196 1.708l-.706-.708a5 5 0 0 0 .995-1.422zm.357-4.089a6 6 0 0 1 .182 2.077l-.997-.088a5 5 0 0 0-.15-1.73zM11.44 3.104a6 6 0 0 1 1.474 1.475l-.82.574a5 5 0 0 0-1.227-1.23z"
        }
      )
    }
  );
}
const $c = /* @__PURE__ */ i(Lc);
function Sc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 0 1 5.98 5.498l1.268-.001v1H.753l.002-1L2.02 7.5A6 6 0 0 1 8 2M3.32 9.711a5 5 0 0 0 .87 1.503l-.766.643a6 6 0 0 1-1.044-1.804zm8.53 1.503a5 5 0 0 0 .87-1.503l.94.342a6 6 0 0 1-1.044 1.804zm-6.329 1.117a5 5 0 0 0 1.63.594l-.172.985a6 6 0 0 1-1.959-.713zm3.368.594a5 5 0 0 0 1.631-.594l.501.866a6 6 0 0 1-1.96.713z"
        }
      )
    }
  );
}
const kc = /* @__PURE__ */ i(Sc);
function yc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.061 2.087a6 6 0 0 1 1.959.713l-.501.866a5 5 0 0 0-1.63-.594zM5.02 2.8a6 6 0 0 1 1.958-.713l.172.985a5 5 0 0 0-1.63.594zm7.596 1.34a6 6 0 0 1 1.044 1.804l-.94.342a5 5 0 0 0-.87-1.503zM2.38 5.944A6 6 0 0 1 3.424 4.14l.766.643c-.373.443-.669.95-.87 1.503zm12.867 1.555-.001 1-1.267-.001a6 6 0 0 1-11.959 0l-1.267.001-.001-1L2.5 7.497h11z"
        }
      )
    }
  );
}
const bc = /* @__PURE__ */ i(yc);
function Rc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 2.009 5.978 1.601.021.36-.5.03.5-.03v.01l.002.02.003.078q.005.102.006.286c.002.245-.002.594-.027 1.016a16 16 0 0 1-.5 3.188c-.645 2.384-2.102 5.102-5.362 5.917l-.121.03-.121-.03c-3.26-.815-4.717-3.533-5.362-5.917a16 16 0 0 1-.5-3.188q-.04-.69-.019-1.38L2 3.98v-.008L2.5 4 2 3.97l.022-.36zm-.476 8.222 3.852-4.402-.752-.658-3.148 3.597-1.622-1.622-.708.707z"
        }
      )
    }
  );
}
const Bc = /* @__PURE__ */ i(Rc);
function Fc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m9.353 1.354-.853.853v1.246l4.632 1.241L14.018 8H1.982l.886-3.306L7.5 3.453v-1.66L8.646.646zm2.033 11.734L8 15.043l-3.387-1.955L3.518 9h8.964z"
        }
      )
    }
  );
}
const Ac = /* @__PURE__ */ i(Fc);
function qc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h10v10H2zm9 1H9.707l-2.5 2.5L11 10.293zM3 4v5.293L8.293 4zm11 0v8h-1V4z"
        }
      )
    }
  );
}
const Oc = /* @__PURE__ */ i(qc);
function Dc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m7 1.226 5.5 3.176-5 2.887v5.773L2 9.887V4.113zm0 5.197 3.5-2.021L7 2.382l-3.5 2.02zM3 5.268v4.041l3.5 2.021V7.289zm12 .268v6.35l-5.5 3.176v-6.35z"
        }
      )
    }
  );
}
const Pc = /* @__PURE__ */ i(Dc);
function Tc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m12.353 5.146-1.5-1.5L13 1.5 14.5 3zm-.707.707-1.293 1.293-1.5-1.5 1.293-1.293zM10 8.25c0 1.544-1.104 2.558-2.43 2.745-.6.085-1.296.089-1.927-.078-.634-.167-1.255-.523-1.59-1.193l-.258-.516.547-.182c.47-.157.755-.603 1.145-1.274l.016-.027c.209-.36.457-.784.787-1.112A2 2 0 0 1 7.75 6h.042L10 8.208zm-6.224.352a4 4 0 0 0-.505.392l-.677-.737a5 5 0 0 1 .63-.489zm8.953.392a4 4 0 0 0-.505-.392l.552-.835a5 5 0 0 1 .63.49zM2.594 9.96c-.145.408-.12.857.068 1.247l-.907.422A2.62 2.62 0 0 1 1.65 9.63zm11.906.54c0 .396-.091.775-.255 1.129l-.907-.422a1.62 1.62 0 0 0 .068-1.247l.944-.33q.148.418.15.87M3.754 12.384a6.1 6.1 0 0 0 1.586.732l-.295.956a7.1 7.1 0 0 1-1.847-.857zm6.906.732a6.1 6.1 0 0 0 1.586-.733l.556.832a7.1 7.1 0 0 1-1.847.857zm-3.562.343a10 10 0 0 0 1.804 0l.092.996a11 11 0 0 1-1.988 0z"
        }
      )
    }
  );
}
const Wc = /* @__PURE__ */ i(Tc);
function Gc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.024 3.095a5 5 0 0 0-1.802.748l-.555-.832a6 6 0 0 1 2.162-.897zm3.755.747a5 5 0 0 0-1.803-.746l.195-.98a6 6 0 0 1 2.163.894zm-6.937 1.38a5 5 0 0 0-.746 1.802l-.98-.195a6 6 0 0 1 .894-2.163zm9.063 1.802a5 5 0 0 0-.748-1.802l.832-.555c.451.675.748 1.41.897 2.162zm-.747 3.755c.367-.55.619-1.164.746-1.804l.98.195a6 6 0 0 1-.894 2.164zM3.095 8.976c.124.625.37 1.237.748 1.802l-.832.555a6 6 0 0 1-.897-2.162zm5.88 3.93a5 5 0 0 0 1.803-.749l.555.832a6 6 0 0 1-2.162.897zm-3.754-.748c.55.368 1.164.619 1.804.746l-.195.98a6 6 0 0 1-2.164-.894z"
        }
      )
    }
  );
}
const Ec = /* @__PURE__ */ i(Gc);
function Nc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h2v1H3v1H2zm4.5 0h3v1h-3zM2 9.5v-3h1v3zM2 12h1v1h1v1H2zm7.5 2h-3v-1h3zM12 2h2.207l-1.853 1.854-.708-.708.354-.353zM9.146 5.646l1.5-1.5.708.708-1.5 1.5zm-1 1 .708.708L8.207 8l.647.646-.708.708L6.793 8zm2.5 5.208-1.5-1.5.708-.708 1.5 1.5zM12 13.207l-.354-.353.708-.708L14.207 14H12z"
        }
      )
    }
  );
}
const jc = /* @__PURE__ */ i(Nc);
function Uc(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h2v1H3v1H2zm4.5 0h3v1h-3zM12 2h2v2h-1V3h-1zM2 9.5v-3h1v3zm12-3v3h-1v-3zM2 12h1v1h1v1H2zm12 0v2h-2v-1h1v-1zm-4.5 2h-3v-1h3z"
        }
      )
    }
  );
}
const Ic = /* @__PURE__ */ i(Uc);
function Qc(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9.646 4.354 8.5 3.207V6h-1V3.207L6.354 4.354l-.708-.708L8 1.293l2.354 2.353z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 5h2v1H4v3.211l2.8 1.617 2.85-1.645L12 10.54V6h-1V5h2v9H3z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.454 7.773a1.318 1.318 0 1 1 2.637 0 1.318 1.318 0 0 1-2.637 0"
          }
        )
      ]
    }
  );
}
const Kc = /* @__PURE__ */ i(Qc);
function Jc(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M9 2a5 5 0 0 0 5 5v1a6 6 0 0 1-6-6z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 6a4 4 0 0 1-4-4h1a3 3 0 0 0 3 3z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 4a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1zm-9.06.111a3.5 3.5 0 0 0-.636 4.079 3.57 3.57 0 0 0 1.527 1.515c.237.121.484.214.733.277A3.5 3.5 0 0 0 9.89 9.06l.707.707a4.5 4.5 0 0 1-4.26 1.188l.815 3.04H1.848l1.48-5.525a4.5 4.5 0 0 1 .904-5.067z"
          }
        )
      ]
    }
  );
}
const Xc = /* @__PURE__ */ i(Jc);
function Yc(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 8a6 6 0 0 1 11.995-.246 4.5 4.5 0 0 0-6.24 6.24A6 6 0 0 1 2 8.001m2.645-.732c.39.39 1.182.233 1.768-.353s.744-1.377.354-1.768c-.39-.39-1.182-.232-1.768.354-.586.585-.744 1.377-.354 1.767"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11.001 8h1v1.05a2.5 2.5 0 0 1 1.37.792l.91-.525.5.866-.91.525a2.5 2.5 0 0 1 0 1.584l.91.525-.5.866-.91-.525A2.5 2.5 0 0 1 12 13.95V15h-1v-1.05a2.5 2.5 0 0 1-1.371-.792l-.91.525-.5-.866.91-.525a2.5 2.5 0 0 1 0-1.584l-.91-.525.5-.866.91.525A2.5 2.5 0 0 1 11 9.05zm.499 2a1.5 1.5 0 1 0-.001 3 1.5 1.5 0 0 0 .001-3"
          }
        )
      ]
    }
  );
}
const Zc = /* @__PURE__ */ i(Yc);
function _c(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a5.5 5.5 0 0 1 3.783 9.493 5 5 0 0 1 .811.33 2.2 2.2 0 0 1 .613.459c.183.195.288.45.293.718v1c0 .449-.302.777-.604.992-.315.223-.738.404-1.216.548-.964.289-2.265.46-3.68.46s-2.716-.171-3.679-.46c-.479-.144-.902-.325-1.217-.548-.302-.215-.604-.542-.604-.992v-1a1.08 1.08 0 0 1 .293-.718c.163-.183.378-.334.614-.459a5 5 0 0 1 .81-.331A5.5 5.5 0 0 1 8 1M3.876 11.706a1.2 1.2 0 0 0-.334.239.2.2 0 0 0-.042.06v.988c.004.013.032.076.182.183.191.136.5.278.926.406C5.455 13.836 6.654 14 8 14s2.545-.164 3.392-.418c.426-.128.735-.271.926-.406.15-.107.178-.171.182-.183v-.987a.2.2 0 0 0-.042-.06 1.2 1.2 0 0 0-.334-.24c-.314-.167-.778-.324-1.365-.446A5.5 5.5 0 0 1 8 12a5.5 5.5 0 0 1-2.759-.741c-.587.123-1.051.28-1.365.447m-.377.303v-.002zM6.913 5.74c.586-.586.744-1.378.354-1.768-.391-.391-1.182-.232-1.768.353-.586.586-.744 1.378-.354 1.768.391.391 1.182.232 1.768-.354M11 6.326a3 3 0 0 1-3 3v1a4 4 0 0 0 4-4zm-3.43 2.97a3 3 0 0 1-.855-.259l-.43.904c.356.168.74.287 1.144.344z"
        }
      )
    }
  );
}
const nd = /* @__PURE__ */ i(_c);
function ld(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8" })
    }
  );
}
const td = /* @__PURE__ */ i(ld);
function id(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.707-1.773-1.771a6 6 0 0 1-8.456-8.456L1.647 2.354zM14 8c0 .926-.21 1.804-.585 2.587L5.413 2.585A6 6 0 0 1 14 8"
        }
      )
    }
  );
}
const ed = /* @__PURE__ */ i(id);
function od(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2 4.536 6-3.464 6 3.464v6.928l-6 3.464-6-3.464z"
        }
      )
    }
  );
}
const rd = /* @__PURE__ */ i(od);
function hd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.515 2h4.97L14 5.515v4.97L10.485 14h-4.97L2 10.485v-4.97z"
        }
      )
    }
  );
}
const ad = /* @__PURE__ */ i(hd);
function cd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1.638 7 4.5 1.992 7.362 7zM14 5h-1V3.707l-2.646 2.647-.708-.708L12.293 3H11V2h3zM4.5 9a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m9.5 5H9V9h5z"
        }
      )
    }
  );
}
const dd = /* @__PURE__ */ i(cd);
function wd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 2h12v12H2z" })
    }
  );
}
const vd = /* @__PURE__ */ i(wd);
function md(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 14 14-.707.707L13.293 14H2V2.707L.646 1.354zM14 2v9.172L4.828 2z"
        }
      )
    }
  );
}
const gd = /* @__PURE__ */ i(md);
function sd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "m8 1.24 7.366 12.758H.634z" })
    }
  );
}
const fd = /* @__PURE__ */ i(sd);
function ud(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 1a2.5 2.5 0 1 1-1.813 4.222l-2.53 1.582-.53-.849 2.53-1.58A2.5 2.5 0 0 1 11.5 1m-8 5a2.504 2.504 0 0 1 2.415 3.148l2.23 1.116-.447.894-2.231-1.115A2.5 2.5 0 1 1 3.5 6M9 12.5a2.5 2.5 0 0 1 2-2.45V7.5h1v2.55a2.5 2.5 0 1 1-3 2.45"
        }
      )
    }
  );
}
const pd = /* @__PURE__ */ i(ud);
function Hd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 3.97v.01l.002.02q.02.69-.019 1.38a16 16 0 0 1-.5 3.188c-.645 2.384-2.102 5.102-5.362 5.917l-.121.03-.121-.03c-3.26-.815-4.717-3.533-5.362-5.917A16 16 0 0 1 2 4v-.028s0-.002.5.028l-.499-.03.021-.36L8 2.01l5.978 1.6zm0 0-.5.03z"
        }
      )
    }
  );
}
const Md = /* @__PURE__ */ i(Hd);
function xd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 13 13-.707.708-2.033-2.033a6.58 6.58 0 0 1-3.493 2.164l-.121.03-.121-.03c-3.26-.815-4.717-3.533-5.362-5.917a16 16 0 0 1-.5-3.188q-.03-.507-.027-1.016c.002-.252.017-.502.032-.754l.695-.186-2.07-2.07zm12.129 7.922c-.138.51-.313 1.034-.534 1.552L5.506 2.677 8 2.01l5.978 1.601c.015.252.03.502.032.754.002.245-.002.594-.026 1.016a16 16 0 0 1-.501 3.188"
        }
      )
    }
  );
}
const zd = /* @__PURE__ */ i(xd);
function Vd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.616 4H13v3h1v2H4.19l1-2h4.622zm.768 1-.536 2H12V5zM15 10v3H3.217L1.5 10.139V10z"
        }
      )
    }
  );
}
const Cd = /* @__PURE__ */ i(Vd);
function Ld(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 1v1.021a5.97 5.97 0 0 1 3.374 1.397l.722-.721.707.707-.722.722A5.97 5.97 0 0 1 13.98 7.5H15v1h-1.02a5.97 5.97 0 0 1-1.399 3.375l.722.722-.707.707-.722-.721A5.97 5.97 0 0 1 8.5 13.98V15h-1v-1.02a5.97 5.97 0 0 1-3.374-1.399l-.722.722-.707-.707.721-.722A5.97 5.97 0 0 1 2.02 8.5H1v-1h1.021a5.97 5.97 0 0 1 1.397-3.374l-.721-.722.707-.707.722.721A5.97 5.97 0 0 1 7.5 2.02V1zM6.984 6.277a2 2 0 0 1 .516-.214V3.025a5 5 0 0 0-2.664 1.104zm4.18-2.148A4.97 4.97 0 0 0 8.5 3.025v3.038a2 2 0 0 1 .516.214zM9.723 6.984a2 2 0 0 1 .214.516h3.039a5 5 0 0 0-1.105-2.664zM9.938 8.5q-.072.276-.214.516l2.147 2.148A5 5 0 0 0 12.975 8.5zm-.921 1.223q-.24.142-.516.214v3.039a5 5 0 0 0 2.665-1.105zM7.5 9.937a2 2 0 0 1-.516-.214l-2.148 2.148A5 5 0 0 0 7.5 12.975zm-1.223-.921a2 2 0 0 1-.214-.516H3.025a5 5 0 0 0 1.104 2.664zM6.063 7.5q.072-.276.214-.516L4.129 4.836A5 5 0 0 0 3.025 7.5z"
        }
      )
    }
  );
}
const $d = /* @__PURE__ */ i(Ld);
function Sd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 4a3 3 0 0 1 6 0h2v10H3V4zm5 0a2 2 0 1 0-4 0zM5 6a3 3 0 0 0 6 0h-1a2 2 0 1 1-4 0z"
        }
      )
    }
  );
}
const kd = /* @__PURE__ */ i(Sd);
function yd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.91 2.97 5.83 7h4.34L9.09 2.971l.966-.26L11.205 7h2.948l-1.608 6H3.457L1.849 7h2.946l1.15-4.289z"
        }
      )
    }
  );
}
const bd = /* @__PURE__ */ i(yd);
function Rd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 2h2.643l.269 1h9.21l-1.306 5H5.255l.268 1H11v1H4.757l-1.88-7H1zm4.5 9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
        }
      )
    }
  );
}
const Bd = /* @__PURE__ */ i(Rd);
function Fd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.877 3H1V2h2.643l1.343 5h6.058l1.078-4.126.967.252L11.816 8H5.255l.268 1H11v1H4.757zM5.5 12a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
        }
      )
    }
  );
}
const Ad = /* @__PURE__ */ i(Fd);
function qd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.707 12H2v-1.707l6.5-6.5L10.207 5.5zM6 11h8v1H6z"
        }
      )
    }
  );
}
const Od = /* @__PURE__ */ i(qd);
function Dd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.707 4 2.5 2.5-2.5 2.5H8v5H7V9H3V4h4V2h1v2z"
        }
      )
    }
  );
}
const Pd = /* @__PURE__ */ i(Dd);
function Td(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.297 6.322C2.927 5.612 3.74 5 5 5c1.75 0 2.64 1.185 3.364 2.152L8.4 7.2C9.17 8.226 9.78 9 11 9c.868 0 1.43-.395 1.955-.986.22-.249.423-.519.64-.808l.152-.202c.27-.355.565-.73.912-1.055l.682.731c-.279.26-.53.576-.796.927l-.14.187c-.218.29-.451.601-.702.884C13.073 9.388 12.26 10 11 10c-1.751 0-2.64-1.185-3.364-2.152L7.6 7.8C6.83 6.774 6.22 6 5 6c-.869 0-1.43.395-1.955.986-.221.249-.423.519-.64.808l-.152.202c-.27.355-.565.73-.912 1.055L.66 8.32c.279-.26.53-.576.796-.927l.14-.187c.218-.29.451-.601.702-.884"
        }
      )
    }
  );
}
const Wd = /* @__PURE__ */ i(Td);
function Gd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m3.548 2.146 3 3-.708.708-3-3zm-3.39.708-3 3-.707-.708 3-3zM7.499 10V5h1v5zm-.64.13-1.34 5-.966-.26 1.34-5zm3.246-.26 1.34 5-.966.26-1.339-5z"
        }
      )
    }
  );
}
const Ed = /* @__PURE__ */ i(Gd);
function Nd(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 3a5 5 0 0 1 5 5v.293l.646-.647.708.708-1.854 1.853-1.854-1.853.708-.708.646.647V8a4 4 0 1 0-8 0v1H3V8a5 5 0 0 1 5-5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
          }
        )
      ]
    }
  );
}
const jd = /* @__PURE__ */ i(Nd);
function Ud(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.82 2.23a1.8 1.8 0 0 1 1.22-.732c.738-.112 1.583.161 2.343.83l-.66.751c-.594-.522-1.152-.65-1.532-.592-.37.056-.609.284-.676.61l-.2.98-.664-.749c-.22-.249-.541-.326-.89-.19-.358.14-.777.53-1.03 1.278l-.948-.32c.325-.959.919-1.618 1.615-1.889a1.8 1.8 0 0 1 1.422.023M5 12a3 3 0 1 1 5.83 1H14v1H2v-1h3.17c-.11-.313-.17-.65-.17-1m4.96-7.502a1.8 1.8 0 0 1 1.22.732c.44-.203.947-.21 1.423-.024.696.272 1.29.93 1.614 1.89l-.947.32c-.253-.748-.672-1.138-1.031-1.278-.348-.136-.669-.059-.89.19l-.663.749-.2-.98c-.067-.326-.306-.554-.676-.61-.38-.058-.938.07-1.532.592l-.66-.751c.76-.669 1.604-.942 2.343-.83"
        }
      )
    }
  );
}
const Id = /* @__PURE__ */ i(Ud);
function Qd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 4h6v1H8v2H5V5H2V4h3V2h3zm3 6h3v1h-3v2H8v-2H2v-1h6V8h3z"
        }
      )
    }
  );
}
const Kd = /* @__PURE__ */ i(Qd);
function Jd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 2.5A1.5 1.5 0 0 1 5.5 1h5A1.5 1.5 0 0 1 12 2.5V11H4zM9 2H7v1h2zM4 12h8v1.5a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 13.5zm4.5 1h-1v1h1z"
        }
      )
    }
  );
}
const Xd = /* @__PURE__ */ i(Jd);
function Yd(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 2.5v6.672L4.357 1.529A1.5 1.5 0 0 1 5.5 1h5A1.5 1.5 0 0 1 12 2.5M9 2H7v1h2zm-7.354.354.708-.708 12 12-.708.708L12 12.707v.793a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 13.5V12h7.293l-1-1H4V4.707zM8.5 13h-1v1h1z"
        }
      )
    }
  );
}
const Zd = /* @__PURE__ */ i(Yd);
function _d(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 3.793V2h1v1.793l.646-.647.708.708L8.5 5.207v1.927l1.669-.963.495-1.85.966.26-.237.882 1.553-.896.5.866-1.553.896.883.237-.258.966-1.85-.495L9 8l1.669.963 1.849-.495.258.966-.883.237 1.553.896-.5.866-1.553-.896.237.883-.966.258-.495-1.849L8.5 8.866v1.927l1.354 1.353-.708.708-.646-.647V14h-1v-1.793l-.646.647-.708-.708L7.5 10.793V8.866l-1.669.963-.495 1.85-.966-.26.236-.882-1.552.896-.5-.866 1.552-.896-.883-.237.26-.966 1.848.495L7 8l-1.67-.963-1.849.495-.259-.966.883-.237-1.552-.896.5-.866 1.552.896-.236-.883.966-.258.495 1.849 1.669.963V5.207L6.146 3.854l.708-.708z"
        }
      )
    }
  );
}
const nw = /* @__PURE__ */ i(_d);
function lw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 6H3V5h10zM9 9H3V8h6zm-3 3H3v-1h3z" })
    }
  );
}
const tw = /* @__PURE__ */ i(lw);
function iw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 13H3v-1h10zm-4-3H3V9h6zM6 7H3V6h3zm6-4.707 2.854 2.854-.708.707L12.5 4.207V9h-1V4.207L9.854 5.854l-.708-.707z"
        }
      )
    }
  );
}
const ew = /* @__PURE__ */ i(iw);
function ow(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v1H3zm0 3h6v1H3zm0 3h3v1H3zm11.854 1.854L12 13.707l-2.854-2.854.708-.707 1.646 1.647V7h1v4.793l1.646-1.647z"
        }
      )
    }
  );
}
const rw = /* @__PURE__ */ i(ow);
function hw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 13V3h1v10zm-2-2V5h1v6zm4 0V5h1v6zm4 0V5h1v6zm-2-1V6h1v4zM2 9V7h1v2z"
        }
      )
    }
  );
}
const aw = /* @__PURE__ */ i(hw);
function cw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 5.5V4.366l-.982.567-.5-.866L9.5 3.5l-.982-.567.5-.866.982.567V1.5h1v1.134l.982-.567.5.866-.982.567.982.567-.5.866L11 4.366V5.5zm1 10v-3.134l-2.714 1.567-.5-.866L10.5 11.5 7.786 9.933l.5-.866L11 10.634V7.5h1v3.134l2.714-1.567.5.866L12.5 11.5l2.714 1.567-.5.866L12 12.366V15.5zm-7.5-8L1.652 6.433l.5-.866L4 6.634V4.5h1v2.134l1.848-1.067.5.866L5.5 7.5l1.848 1.067-.5.866L5 8.366V10.5H4V8.366L2.152 9.433l-.5-.866z"
        }
      )
    }
  );
}
const dw = /* @__PURE__ */ i(cw);
function ww(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6.815 10H5V6h1.815L11 2.413v11.174z" })
    }
  );
}
const vw = /* @__PURE__ */ i(ww);
function mw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.815 10H2V6h1.815L8 2.413v11.174zM14 4v8h-1V4zm-2 1v6h-1V5zm-2 1v4H9V6z"
        }
      )
    }
  );
}
const gw = /* @__PURE__ */ i(mw);
function sw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.815 10H4V6h1.815L10 2.413v11.174zM12 6v4h-1V6z"
        }
      )
    }
  );
}
const fw = /* @__PURE__ */ i(sw);
function uw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.815 10H3V6h1.815L9 2.413v11.174zM13 5v6h-1V5zm-2 1v4h-1V6z"
        }
      )
    }
  );
}
const pw = /* @__PURE__ */ i(uw);
function Hw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.815 10H2V6h1.815L8 2.413v11.174zm6.039-3.854L11.5 7.793l1.646-1.647.708.708L12.207 8.5l1.647 1.647-.708.707L11.5 9.208l-1.646 1.645-.708-.707L10.793 8.5 9.146 6.854z"
        }
      )
    }
  );
}
const Mw = /* @__PURE__ */ i(Hw);
function xw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.708L10 10.707v2.88L5.815 10H4V6h1.293L1.646 2.354zM10 2.413v4.759L7.438 4.609z"
        }
      )
    }
  );
}
const zw = /* @__PURE__ */ i(xw);
function Vw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.766 9.065c-.227.257-.266.384-.266.435V14h-1V9.5c0-.05-.039-.178-.266-.435a9 9 0 0 0-.492-.499 26 26 0 0 1-.346-.337C5.766 7.599 5 6.719 5 5.5 5 3.656 6.262 2 8 2s3 1.656 3 3.5c0 1.22-.766 2.098-1.396 2.729l-.346.337q-.256.24-.492.5"
        }
      )
    }
  );
}
const Cw = /* @__PURE__ */ i(Vw);
function Lw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 5h6.5v4H13V5h1v5H7.5V6H3v4H2z" })
    }
  );
}
const $w = /* @__PURE__ */ i(Lw);
function Sw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 13H6V3h8zM4 4h1v8H4zm-1 7H2V5h1z" })
    }
  );
}
const kw = /* @__PURE__ */ i(Sw);
function yw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 2h3v1h-2v3H9v3H6v3H3v2H2v-3h3V8h3V5h3z"
        }
      )
    }
  );
}
const bw = /* @__PURE__ */ i(yw);
function Rw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m15.074 6.51-3.537 3.448.835 4.869L8 12.528l-4.372 2.299.835-4.869L.926 6.51l4.888-.71L8 1.37l2.186 4.43z"
        }
      )
    }
  );
}
const Bw = /* @__PURE__ */ i(Rw);
function Fw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m1.031-.562 4.97-1.331 4.968 1.331a5 5 0 0 0-9.938 0m9.7 2.188-2.998.803-.658 2.455a5.01 5.01 0 0 0 3.655-3.258m-5.806 3.258-.658-2.455-2.997-.803a5.01 5.01 0 0 0 3.655 3.258M8 7.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    }
  );
}
const Aw = /* @__PURE__ */ i(Fw);
function qw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4 3.5v9H3v-9zm2 8.87V3.63L13.492 8z" })
    }
  );
}
const Ow = /* @__PURE__ */ i(qw);
function Dw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M12 3.5h1v9h-1zm-2 .13v8.74L2.508 8z" })
    }
  );
}
const Pw = /* @__PURE__ */ i(Dw);
function Tw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v12H6.293L2 9.707zm4 8H3.707L6 12.293z"
        }
      )
    }
  );
}
const Ww = /* @__PURE__ */ i(Tw);
function Gw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 14H5.586L2 10.414V2h12zm-1-4.041L10.017 8.24 7.75 9.546l.5.866 1.767-1.018L13 11.113zM6 13v-3H3zM5 6.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
        }
      )
    }
  );
}
const Ew = /* @__PURE__ */ i(Gw);
function Nw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v12H5.586L2 10.414zm1 8 3 3v-3zm3.741-4.079-2.815.41 1.725 1.681.698-.716-.274-.267 1.33-.194L8 5.63l.595 1.205 1.331.194-.963.938.227 1.325-.457-.24-.465.885 2.25 1.183-.481-2.804 2.038-1.985-2.815-.41L8 3.37z"
        }
      )
    }
  );
}
const jw = /* @__PURE__ */ i(Nw);
function Uw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 14H5.586L2 10.414V2h12zm-6-3h1V6h2V5H6v1h2zm-2 2v-3H3z"
        }
      )
    }
  );
}
const Iw = /* @__PURE__ */ i(Uw);
function Qw(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8.5 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 14H5.586L2 10.414V2h12zm-8-1v-3H3zm0-6.5a2.5 2.5 0 0 0 3.879 2.086l1.768 1.768.707-.707-1.768-1.768A2.5 2.5 0 1 0 6 6.5"
          }
        )
      ]
    }
  );
}
const Kw = /* @__PURE__ */ i(Qw);
function Jw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.848 4H11v8h.848l.804 3H3.348l.804-3H5V4h-.848l-.804-3h9.304zm-3.223 8H9.75V4H8.625zm-1.25-8H6.25v8h1.125z"
        }
      )
    }
  );
}
const Xw = /* @__PURE__ */ i(Jw);
function Yw(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M12 12H4V4h8z" })
    }
  );
}
const Zw = /* @__PURE__ */ i(Yw);
function _w(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m12.03 1.83.94.34q-.043.12-.082.238c-.053.158-.13.392-.223.692-.184.6-.431 1.465-.678 2.515-.467 1.983-.931 4.618-.982 7.385H14v1H2v-1h1.992c-.066-2.035-.517-4.147-.974-5.805a35 35 0 0 0-.9-2.795l-.082-.214.928-.371.09.233q.526 1.422.928 2.882c.469 1.7.944 3.91 1.01 6.07h1.003c-.05-2.767-.515-5.402-.982-7.385A39 39 0 0 0 4.335 3.1a27 27 0 0 0-.305-.93l.94-.34.09.258q.534 1.63.927 3.298c.477 2.03.957 4.745 1.008 7.614h1.008a47.5 47.5 0 0 1 .502-6.386q.147-1.005.349-2.003.075-.368.16-.732l.971.242-.04.173q-.04.175-.111.517-.196.97-.34 1.95A46.5 46.5 0 0 0 9.004 13h1.002c.05-2.869.53-5.585 1.008-7.615.253-1.075.506-1.96.697-2.579q.15-.49.32-.977"
        }
      )
    }
  );
}
const n9 = /* @__PURE__ */ i(_w);
function l9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 4c-1.299 0-2 .846-2 1.5 0 .596.21.917.514 1.15.348.265.836.43 1.45.623l.072.023c.198.063.408.129.62.204H14v1h-3.671c.324.357.564.817.664 1.418.152.911-.16 1.702-.746 2.251C9.673 12.71 8.858 13 8 13c-1.683 0-3-1.035-3-2.5h1c0 .744.683 1.5 2 1.5.642 0 1.2-.219 1.563-.56.351-.33.538-.79.444-1.358-.1-.598-.386-.952-.777-1.213a3.7 3.7 0 0 0-.752-.369H2v-1h3.983l-.076-.056C5.353 7.021 5 6.404 5 5.5 5 4.154 6.299 3 8 3c1.683 0 3 1.035 3 2.5h-1C10 4.756 9.317 4 8 4"
        }
      )
    }
  );
}
const t9 = /* @__PURE__ */ i(l9);
function i9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 3h12v1H2zm12 5H2V5h12zm0 5H2V9h12z" })
    }
  );
}
const e9 = /* @__PURE__ */ i(i9);
function o9(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M12.5 5 11 3.5l3-3L15.5 2z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8 4H2v8h12V6h1v7H1V3h7z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.49 6.75C6.94 5.97 7.51 5 8.75 5l-.01-.01c.218 0 .436.044.647.123l.903-.903 1.5 1.5-.912.912c.072.202.112.41.112.618 0 1.44-.98 2.55-2.43 2.75-.28.04-.56.06-.82.06-1.28 0-2.26-.47-2.69-1.33l-.26-.52.55-.18c.507-.159.816-.693 1.144-1.26z"
          }
        )
      ]
    }
  );
}
const r9 = /* @__PURE__ */ i(o9);
function h9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M3.5 7.5h9v1h-9z" })
    }
  );
}
const a9 = /* @__PURE__ */ i(h9);
function c9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m11-.5H4v1h8z"
        }
      )
    }
  );
}
const d9 = /* @__PURE__ */ i(c9);
function w9(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "m7.383 11-.268-1h1.77l-.269 1z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.5 2H5V1h6v1H9.5v2.5H12V14h-1.5v1h-1v-1h-3v1h-1v-1H4V4.5h2.5zm1 0v2.5h1V2zM7 7.5h2v-1H7zM10.188 9H5.812l.804 3h2.768z"
          }
        )
      ]
    }
  );
}
const v9 = /* @__PURE__ */ i(w9);
function m9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a3 3 0 0 1 2.827 4.005 3 3 0 1 1-1.08 5.722L10.356 14H5.642l.611-2.273a3 3 0 1 1-1.08-5.722A3 3 0 0 1 8 2"
        }
      )
    }
  );
}
const g9 = /* @__PURE__ */ i(m9);
function s9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m12.252 8-3.464 6H7.211L3.747 8l3.464-6h1.577z"
        }
      )
    }
  );
}
const f9 = /* @__PURE__ */ i(s9);
function u9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.435 2.252c.804 1.408 1.685 2.388 2.471 3.266q.243.27.47.528C12.26 7.056 13 8.053 13 9.5a2.5 2.5 0 0 1-3.205 2.399l.563 2.1H5.643l.563-2.1A2.5 2.5 0 0 1 3 9.5c0-1.447.74-2.444 1.623-3.454q.23-.26.47-.528c.789-.878 1.669-1.859 2.473-3.266L8 1.492z"
        }
      )
    }
  );
}
const p9 = /* @__PURE__ */ i(u9);
function H9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 2v2h-1V2zM4.111 3.404l1.414 1.414-.707.707L3.404 4.11zm7.778 0 .707.707-1.414 1.414-.707-.707zM8 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6M2 7.5h2v1H2zm10 0h2v1h-2zm-7.182 2.975.707.707-1.414 1.414-.707-.706zm6.364 0 1.414 1.414-.707.707-1.414-1.414zM7.5 14v-2h1v2z"
        }
      )
    }
  );
}
const M9 = /* @__PURE__ */ i(H9);
function x9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 3v1h-1V3zM4.818 4.111l.707.707-.707.707-.708-.707zm7.071.707-.707.707-.707-.707.707-.708zM8 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6M3 7.5h1v1H3zm9 0h1v1h-1zm-6.475 3.682-.707.707-.707-.707.707-.707zm5.657-.707.707.707-.707.707-.707-.707zM7.5 13v-1h1v1z"
        }
      )
    }
  );
}
const z9 = /* @__PURE__ */ i(x9);
function V9(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 12 12-.707.707-3.909-3.908a3 3 0 0 1-4.184-4.184L1.647 2.355zM11 8q0 .084-.005.167L7.834 5.005A3 3 0 0 1 11 8M7.5 4V2h1v2zm4.389-.596.707.707-1.414 1.414-.707-.707zM2 7.5h2v1H2zm12 1h-2v-1h2zm-9.182 1.975.707.707-1.414 1.414-.707-.706z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7.5 14v-2h1v2z" })
      ]
    }
  );
}
const C9 = /* @__PURE__ */ i(V9);
function L9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 3h2.725l-2.432 9.073-.293.079zm-1 9.42-.303.081-2.07-7.728L4 4.137zM8.976 2.194l5.797 1.554-2.588 9.66-5.797-1.554z"
        }
      )
    }
  );
}
const $9 = /* @__PURE__ */ i(L9);
function S9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.354.646 2.857 2.86-2.858 2.848-.706-.708 1.647-1.641h-1.29A4 4 0 0 0 4.139 9.04l-.966.258a5.006 5.006 0 0 1 4.83-6.294h1.294l-1.65-1.652zm4.48 6.055a5.006 5.006 0 0 1-4.83 6.295H6.707l1.646 1.651-.708.706-2.85-2.858 2.85-2.849.707.708-1.642 1.641h1.292a4 4 0 0 0 3.865-5.036z"
        }
      )
    }
  );
}
const k9 = /* @__PURE__ */ i(S9);
function y9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.005 4.005a4 4 0 0 0-1.036.134l-.791-.79a5 5 0 0 1 1.827-.344h1.291l-1.65-1.652.708-.707 2.856 2.859L8.767 5.94l-.707-.707 1.234-1.228zm4.998 3.99c0 .648-.123 1.266-.346 1.833l-.79-.79a4 4 0 0 0 .001-2.079l.966-.258c.11.414.17.848.17 1.294m-1.841 3.875a4.98 4.98 0 0 1-3.16 1.126H6.708l1.646 1.651-.708.706-2.85-2.858 2.85-2.849.707.708-1.642 1.641h1.292c.923 0 1.772-.312 2.449-.836L4.844 5.55a4 4 0 0 0-.705 3.49l-.966.258a5 5 0 0 1 .96-4.46L1.646 2.355l.707-.708 12 12-.707.708z"
        }
      )
    }
  );
}
const b9 = /* @__PURE__ */ i(y9);
function R9(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8.005 4.005A4 4 0 0 0 4.14 9.041l-.966.258a5 5 0 0 1 4.831-6.294h1.292l-1.65-1.652.708-.707 3.355 3.359z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "m5.404 10 2.598-4.5L10.6 10z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13.004 7.995a5 5 0 0 1-5 5H6.709l1.646 1.652-.708.706L4.3 11.996h3.703a4.005 4.005 0 0 0 3.865-5.037l.966-.258q.168.623.169 1.294"
          }
        )
      ]
    }
  );
}
const B9 = /* @__PURE__ */ i(R9);
function F9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 1A1.5 1.5 0 0 1 13 2.5V11H3V2.5A1.5 1.5 0 0 1 4.5 1zM3 13.5V12h10v1.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5m5.5-.5h-1v1h1z"
        }
      )
    }
  );
}
const A9 = /* @__PURE__ */ i(F9);
function q9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 2.5v7.672L3.937 1.109C4.111 1.039 4.301 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5M11.293 12l-1-1H3V3.707L1.646 2.354l.708-.708 13 13-.707.708-1.66-1.66A1.5 1.5 0 0 1 11.5 15h-7A1.5 1.5 0 0 1 3 13.5V12zM8.5 13h-1v1h1z"
        }
      )
    }
  );
}
const O9 = /* @__PURE__ */ i(q9);
function D9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.293 2h3.414L14 4.293v3.414l-6.5 6.5L1.793 8.5zM10.5 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
        }
      )
    }
  );
}
const P9 = /* @__PURE__ */ i(D9);
function T9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.293 2h3.414L14 4.293v3.414l-6.5 6.5L1.793 8.5zm-1.44 5.146-.706.708 2 2 .707-.708zm.294 3.708.707-.708-2-2-.707.708zM10.5 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
        }
      )
    }
  );
}
const W9 = /* @__PURE__ */ i(T9);
function G9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 4.5h2V5h1.91l.804 3h.403l.803-3h1.58v1h-.812l-.804 3h-.902l.518 1.934V11c0 .424-.332.685-.56.82-.262.154-.607.276-.99.372-.774.194-1.817.308-2.95.308s-2.176-.114-2.95-.308c-.383-.096-.729-.218-.99-.372-.229-.135-.56-.396-.56-.82v-.066L3.75 10H1.848L2.92 6h1.902l.268-1H7zM3.688 7l-.536 2h.866l.536-2z"
        }
      )
    }
  );
}
const E9 = /* @__PURE__ */ i(G9);
function N9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13.726 5.498c-.127 1.436-.778 3.366-2.837 5.406-2.057 2.04-3.987 2.691-5.417 2.822-.86.078-1.687-.005-2.47-.32l-.587-2.19 3.237-1.87 1.739 1.002a5.3 5.3 0 0 0 1.808-1.2 5.4 5.4 0 0 0 1.168-1.692L9.332 5.665l1.87-3.237 2.19.587c.317.778.408 1.629.334 2.482"
        }
      )
    }
  );
}
const j9 = /* @__PURE__ */ i(N9);
function U9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-3.112-3.112c-1.924 1.774-3.715 2.36-5.063 2.483-.86.078-1.687-.005-2.47-.32l-.587-2.19 3.237-1.87 1.739 1.004a5.2 5.2 0 0 0 1.41-.84L1.646 2.354zm9.848 7.728-1.86-1.86.025-.058-1.034-1.791 1.869-3.237 2.19.587c.317.778.409 1.63.334 2.482-.094 1.07-.48 2.416-1.524 3.877"
        }
      )
    }
  );
}
const I9 = /* @__PURE__ */ i(U9);
function Q9(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4m1.19 12H6.811L4.848 5.675h6.304z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.329 11.2a11 11 0 0 0-1.943.474c-.57.204-.961.423-1.19.616a.8.8 0 0 0-.19.21.8.8 0 0 0 .189.209c.23.194.621.413 1.192.617C4.52 13.73 6.15 14 8 14c1.848 0 3.48-.269 4.614-.674.57-.204.961-.423 1.19-.616a.8.8 0 0 0 .19-.21.8.8 0 0 0-.189-.209c-.23-.194-.621-.413-1.192-.617-.542-.194-1.2-.357-1.942-.474l.26-.97C13.333 10.625 15 11.493 15 12.5c0 1.38-3.134 2.5-7 2.5s-7-1.12-7-2.5c0-1.008 1.667-1.876 4.069-2.27z"
          }
        )
      ]
    }
  );
}
const K9 = /* @__PURE__ */ i(Q9);
function J9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.858 6.834-2.118.567 1.74 6.492-.966.259-.634-2.368a4.5 4.5 0 0 1-2.765-.001l-.635 2.37-.966-.26 1.548-5.774-1.069.286-.99-3.698 5.864-1.571zm-3.083.826-.598.16-.803 2.995a3.5 3.5 0 0 0 2.247.002zm2.875-5.466 1.366-.366 1.357 5.064-1.366.366zM3.078 8.455l.074.272-.966.26-.777-2.898.966-.259.079.293L4.22 5.65l.625 2.33z"
        }
      )
    }
  );
}
const X9 = /* @__PURE__ */ i(J9);
function Y9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M15 12h-1.5v1h-1v-1h-9v1h-1v-1H1V3h14zm-1-1v-1H2v1z"
        }
      )
    }
  );
}
const Z9 = /* @__PURE__ */ i(Y9);
function _9(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.045.87 7.884 4h.233L8.955.87l.966.26L9.151 4h.928l.268 1H14v9H2V5h3.652l.268-1h.928L6.08 1.13zM12 7H6v5h6zM3.5 8.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0M5 12v-1H4v1z"
        }
      )
    }
  );
}
const nv = /* @__PURE__ */ i(_9);
function lv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7.5 4H4V3h8v1H8.5v9h-1z" })
    }
  );
}
const tv = /* @__PURE__ */ i(lv);
function iv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4H2V3h12zm-2 3H4V6h8zm1 3H3V9h10zm-2 3H5v-1h6z"
        }
      )
    }
  );
}
const ev = /* @__PURE__ */ i(iv);
function ov(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4H2V3h12zm0 3H2V6h12zm0 3H2V9h12zm-6 3H2v-1h6z"
        }
      )
    }
  );
}
const rv = /* @__PURE__ */ i(ov);
function hv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4H2V3h12zm-4 3H2V6h8zm2 3H2V9h10zm-4 3H2v-1h6z"
        }
      )
    }
  );
}
const av = /* @__PURE__ */ i(hv);
function cv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4H2V3h12zm0 3H6V6h8zm0 3H4V9h10zm0 3H8v-1h6z"
        }
      )
    }
  );
}
const dv = /* @__PURE__ */ i(cv);
function wv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 2h12v12H2zm5.5 9h1V6H11V5H5v1h2.5z" })
    }
  );
}
const vv = /* @__PURE__ */ i(wv);
function mv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 14H2V2h12zM3.293 3H3v.293zM3 4.707v1.586L6.293 3H4.707zM7.707 3 3 7.707v1.586L9.293 3zm3 0L3 10.707v1.586L12.293 3zM13 3.707 3.707 13h1.586L13 5.293zm0 3L6.707 13h1.586L13 8.293zm0 3L9.707 13h1.586L13 11.293zm0 3-.293.293H13z"
        }
      )
    }
  );
}
const gv = /* @__PURE__ */ i(mv);
function sv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 1h4v2H8.5v1H10v1H8.5v1H10v1H8.5v1H10v1.764a3 3 0 1 1-4 0z"
        }
      )
    }
  );
}
const fv = /* @__PURE__ */ i(sv);
function uv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 3H14v8h-2.5zm-1 8.5-1.607 2.781A1.437 1.437 0 0 1 6.26 13.19L6.847 11H2.481L1.72 8.152 3.1 3h5.6l1.8.482z"
        }
      )
    }
  );
}
const pv = /* @__PURE__ */ i(uv);
function Hv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 13H2V5h2.5zm1-8.5 1.606-2.781A1.437 1.437 0 0 1 9.739 2.81L9.152 5h4.367l.761 2.848L12.9 13H7.3l-1.8-.482z"
        }
      )
    }
  );
}
const Mv = /* @__PURE__ */ i(Hv);
function xv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M15 6.5h-1a1.5 1.5 0 1 0 0 3h1V13H1V9.5h1a1.5 1.5 0 1 0 0-3H1V3h14zm-7.641.669-1.433.209 1.037 1.01-.245 1.428L8 9.142l1.282.674-.245-1.428 1.038-1.011-1.434-.208L8 5.87z"
        }
      )
    }
  );
}
const zv = /* @__PURE__ */ i(xv);
function Vv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 3H6V2h4v1H9v1.1A5.002 5.002 0 0 1 8 14a5 5 0 0 1-1-9.9zm0 6a1 1 0 1 0 1.259-.966l-.553-2.062-.966.259.553 2.062A1 1 0 0 0 7 9"
        }
      )
    }
  );
}
const Cv = /* @__PURE__ */ i(Vv);
function Lv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 2h6v2h3v3h-4V6H6v1H2V4h3zm1 1v1h4V3zm0 5v1h4V8h4v5H2V8zm3 0H7V7h2z"
        }
      )
    }
  );
}
const $v = /* @__PURE__ */ i(Lv);
function Sv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.614 3h2.768l2.411 9h2.205v1h-12v-1h2.205l.402-1.5H9v-1H4.873l.268-1H8v-1H5.408z"
        }
      )
    }
  );
}
const kv = /* @__PURE__ */ i(Sv);
function yv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.146 1.15.708.707-2.147 2.147H12v1H4.707L6.854 7.15l-.708.707-3.353-3.353zm5.147 9.854L9.146 8.857l.708-.707 3.353 3.354-3.353 3.353-.708-.707 2.147-2.146H4v-1z"
        }
      )
    }
  );
}
const bv = /* @__PURE__ */ i(yv);
function Rv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.146 9.857.708-.707L4 11.296V4.004h1v7.292L7.146 9.15l.708.707L4.5 13.211zM11 4.711 8.854 6.857l-.708-.707L11.5 2.796l3.354 3.354-.707.707L12 4.711v7.293h-1z"
        }
      )
    }
  );
}
const Bv = /* @__PURE__ */ i(Rv);
function Fv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a7 7 0 0 1 0 14h-.5V1zM3.5 2.639A7 7 0 0 1 5.605 1.42l.342.94a6 6 0 0 0-1.804 1.044zM1.105 6.785A7 7 0 0 1 1.937 4.5l.866.5a6 6 0 0 0-.713 1.957zm.832 4.716a7 7 0 0 1-.832-2.286l.985-.172A6 6 0 0 0 2.803 11zm3.668 3.078A7 7 0 0 1 3.5 13.362l.643-.766a6 6 0 0 0 1.804 1.044z"
        }
      )
    }
  );
}
const Av = /* @__PURE__ */ i(Fv);
function qv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M10 3h3v1H3V3h3V1h4zm2 12H4V5h8z" })
    }
  );
}
const Ov = /* @__PURE__ */ i(qv);
function Dv(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10 3h3v1H3V3h3V1h4zm1.889 3.014A5.5 5.5 0 0 0 7.257 15H4V5h7.89z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10.793 11.5 8.646 9.354l.708-.708 2.146 2.147 2.146-2.147.707.708-2.146 2.146 2.146 2.146-.707.708-2.146-2.147-2.146 2.146-.708-.707z"
          }
        )
      ]
    }
  );
}
const Pv = /* @__PURE__ */ i(Dv);
function Tv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.473 2.037a2.5 2.5 0 0 1 4.505 1.126 3 3 0 0 1 .75 5.29A4 4 0 0 1 8.5 10.969V13H13v1H3v-1h4.5v-2.031a4 4 0 0 1-2.15-.973A2.5 2.5 0 0 1 3.3 6.31a3 3 0 0 1 3.172-4.273"
        }
      )
    }
  );
}
const Wv = /* @__PURE__ */ i(Tv);
function Gv(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10.371 7.696H8.866l3 5.196H7V15H6v-2.108H1.134l3-5.196H2.639L6.505 1zM10 15v-1.108h1V15z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12.103 8.696 9.082 3.464 10.505 1l3.866 6.696h-1.505l3 5.196h-2.845l-2.423-4.196z"
          }
        )
      ]
    }
  );
}
const Ev = /* @__PURE__ */ i(Gv);
function Nv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 1v6.977c.518-.048 1.054-.175 1.453-.408q.384-.225.529-.542c.094-.207.136-.495.033-.906a93 93 0 0 0-.744-2.794l-.04-.138-.01-.033-.002-.008-.454-1.492 2.54 1.947-.61.794-.115-.089q.173.643.405 1.57c.147.59.112 1.115-.094 1.564-.203.445-.55.765-.933.99-.59.345-1.319.498-1.958.548V14h-1V8.98c-.64-.05-1.369-.203-1.958-.549-.384-.224-.73-.544-.933-.989-.205-.45-.241-.974-.094-1.563q.233-.928.405-1.57l-.116.088-.608-.794 2.539-1.947-.453 1.49v.002l-.003.008-.01.033-.04.138q-.054.184-.158.556-.307 1.116-.586 2.238c-.103.411-.061.699.034.906q.144.314.529.542c.398.233.934.36 1.452.408V1z"
        }
      )
    }
  );
}
const jv = /* @__PURE__ */ i(Nv);
function Uv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.667 4.842 4.666 4 4.342-3.722.65.76-4.992 4.279-4.666-4-4.342 3.72-.65-.759z"
        }
      )
    }
  );
}
const Iv = /* @__PURE__ */ i(Uv);
function Qv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.794 12.129-.876-3.272H3.082l-.877 3.273-.965-.26L3.616 3h1.767l2.377 8.87zM4.616 4h-.232L3.35 7.858h2.3zM14 6.793v3.641l.385 1.437-.966.258-.178-.663-.534.534H9.793L9 11.207V9.792l.741-.74L13 8.179v-.972L12.793 7h-2.586l-.353.354-.708-.708L9.793 6h3.414zm-4 3.414v.586l.207.207h2.086l.707-.707V9.214l-2.74.734z"
        }
      )
    }
  );
}
const Kv = /* @__PURE__ */ i(Qv);
function Jv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 3v6.5a2.5 2.5 0 0 0 5 0V3h1v6.5a3.5 3.5 0 1 1-7 0V3zM14 14v1H2v-1z"
        }
      )
    }
  );
}
const Xv = /* @__PURE__ */ i(Jv);
function Yv(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.647 4.646c1.924-1.924 4.905-2.161 6.885-.182a5 5 0 0 1 0 7.072l-.707-.708a4 4 0 0 0 0-5.656c-1.536-1.536-3.881-1.409-5.471.182L3.708 6.999 6 7v1l-3.998-.002L2 4h1l.001 2.292z"
        }
      )
    }
  );
}
const Zv = /* @__PURE__ */ i(Yv);
function _v(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m3.384 3-.571 2.13-.966-.26.77-2.87h10.767l.769 2.87-.966.26-.57-2.13zM8 4.293l4.354 4.353-.708.708L8.5 6.207V14h-1V6.207L4.354 9.354l-.708-.708z"
        }
      )
    }
  );
}
const nm = /* @__PURE__ */ i(_v);
function lm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.146 3.354 8.5 2.708v5.64l2.5-.67V7h-1V4h3v3h-1v1.447l-3.5.938v1.68a2 2 0 1 1-1 0v-.18L4 9.946v-2.03a1.5 1.5 0 1 1 1 0v1.262l2.5.67V2.707l-.646.647-.708-.707L8 .793l1.854 1.854z"
        }
      )
    }
  );
}
const tm = /* @__PURE__ */ i(lm);
function im(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 13H2v-1h12zM7 2v9H4V2zm4 3v6H8V5z" })
    }
  );
}
const em = /* @__PURE__ */ i(im);
function om(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8.5v-1h2V3h3v4.5h1V5h3v2.5h3v1h-3V11H8V8.5H7V13H4V8.5z"
        }
      )
    }
  );
}
const rm = /* @__PURE__ */ i(om);
function hm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 3h12v1H2zm5 2v9H4V5zm4 0v6H8V5z" })
    }
  );
}
const am = /* @__PURE__ */ i(hm);
function cm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "m12 5.691 3-1.5v7.618l-3-1.5V12H1V4h11z" })
    }
  );
}
const dm = /* @__PURE__ */ i(cm);
function wm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.708L11.293 12H1V4h2.293L1.646 2.354zM15 11.809l-.725-.363L6.828 4H12v1.691l3-1.5z"
        }
      )
    }
  );
}
const vm = /* @__PURE__ */ i(wm);
function mm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 3h4v1H6zm6.383 8.995h-3.5L8.616 11H7.384l-.266.995H3.617L2.68 8.497 3.616 5h8.769l.935 3.498zM1.715 8.498l.636 2.374-.966.258L.68 8.498l.703-2.628.966.26zm12.902-2.627.704 2.627-.705 2.631-.966-.258.636-2.373-.635-2.368z"
        }
      )
    }
  );
}
const gm = /* @__PURE__ */ i(mm);
function sm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m9.059.557.518 1.932-.966.259L8.093.815zm5.183 1.907-1.415 1.415-.707-.707 1.416-1.415zM4.815 4.093l1.933.518-.259.966-1.932-.517zm10.369 3.814-1.932-.518.259-.966 1.932.517zm-4.243 3.536-.518-1.932.966-.259.518 1.932zM8.646 8.854 3.5 14 2 12.5l5.146-5.146zm-.792-2.208L10 4.5 11.5 6 9.354 8.146z"
        }
      )
    }
  );
}
const fm = /* @__PURE__ */ i(sm);
function um(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 .984 7.357 13.014H.643zM7.5 6.5V10h1V6.5zm0 4.5v1h1v-1z"
        }
      )
    }
  );
}
const pm = /* @__PURE__ */ i(um);
function Hm(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M11 2.803a6 6 0 0 0-6 0V1h6z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11 12a5 5 0 1 1 1.9-5h.6v2h-.6a5 5 0 0 1-1.9 3M6.87 5.714l.722 2.694 2.694.722.259-.966-2.137-.572-.572-2.137z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 13.197a6 6 0 0 0 6 0V15H5z" })
      ]
    }
  );
}
const Mm = /* @__PURE__ */ i(Hm);
function xm(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M15 10h-1V2H2v8H1V1h14z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7 3.254 9.992 5 7 6.745zm1 1.75L8.008 5 8 4.995zM4.5 7.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m7 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-5 2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m.11 2h2.78l.75 3H5.86zm3.561-1h2.72l.75 3h-2.72zm-5.092 3h-2.72l.75-3h2.72z"
          }
        )
      ]
    }
  );
}
const zm = /* @__PURE__ */ i(xm);
function Vm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.447 3.276c.317.633.779 1.344 1.278 2.11q.42.642.826 1.293c.379.616.737 1.246 1.001 1.853.262.601.448 1.219.448 1.801a4 4 0 1 1-8 0c0-.582.186-1.199.448-1.801.264-.607.621-1.237 1.001-1.853.275-.445.556-.877.826-1.293.499-.766.961-1.477 1.278-2.11L8 2.382z"
        }
      )
    }
  );
}
const Cm = /* @__PURE__ */ i(Vm);
function Lm(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4.5 6a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11.5 3a3.5 3.5 0 1 1 0 7H9.902l.268 1H11v1H5v-1h.831l.269-1H4.5a3.5 3.5 0 1 1 0-7zm-2.366 8-.268-1H7.134l-.268 1zM3 6.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m9-.5h-1v1h1z"
          }
        )
      ]
    }
  );
}
const $m = /* @__PURE__ */ i(Lm);
function Sm(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4.5 6a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 12 12-.708.707L11 11.708V12H5v-1h.831l.268-1H4.5a3.5 3.5 0 0 1-1.743-6.536l-1.11-1.11zm1.951 3.366a1.5 1.5 0 1 0 1.682 1.683zM9.134 11l-.268-1H7.134l-.268 1zM15 6.5a3.5 3.5 0 0 1-2.361 3.31L5.829 3H11.5A3.5 3.5 0 0 1 15 6.5M12 6h-1v1h1z"
          }
        )
      ]
    }
  );
}
const km = /* @__PURE__ */ i(Sm);
function ym(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4.5 6a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11.5 3a3.5 3.5 0 0 1 3.243 4.819A5 5 0 0 0 7.416 10h-.282l-.535 2H5v-1h.831l.269-1H4.5a3.5 3.5 0 1 1 0-7zM3 6.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M11 5v1h1V5z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9.629 9.842a2.5 2.5 0 0 1 1.37-.792V8h1v1.05a2.5 2.5 0 0 1 1.372.792l.91-.525.5.866-.91.525a2.5 2.5 0 0 1 0 1.584l.91.525-.5.866-.91-.525A2.5 2.5 0 0 1 12 13.95V15h-1v-1.05a2.5 2.5 0 0 1-1.371-.792l-.91.525-.5-.866.91-.525a2.5 2.5 0 0 1 0-1.584l-.91-.525.5-.866zm.571.908a1.5 1.5 0 1 0 2.638 1.429A1.5 1.5 0 0 0 10.2 10.75"
          }
        )
      ]
    }
  );
}
const bm = /* @__PURE__ */ i(ym);
function Rm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 4c0 .364-.097.706-.268 1h2.276l2.144 8H1.848l2.144-8h2.276A2 2 0 1 1 10 4M8 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 7v3h1V7zm3 0v3h1V7z"
        }
      )
    }
  );
}
const Bm = /* @__PURE__ */ i(Rm);
function Fm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 4h1v3.5h6V4h1v8h-1V8.5H5V12H4zM2 7.5V5h1v6H2V8.5H1v-1zM13 5h1v2.5h1v1h-1V11h-1z"
        }
      )
    }
  );
}
const Am = /* @__PURE__ */ i(Fm);
function qm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.203 6.447a6.002 6.002 0 0 1 11.594 0 6 6 0 1 1-11.594 0m4.979.296a1.5 1.5 0 0 1 .722-.24L8 6.5a1.51 1.51 0 0 1 1.237.651l3.441-.922a5.002 5.002 0 0 0-9.355 0l3.44.922a1.5 1.5 0 0 1 .419-.408m2.313 1.374A1.5 1.5 0 0 1 8.5 9.415v3.56a5 5 0 0 0 4.436-5.78zM7.5 9.415a1.5 1.5 0 0 1-.996-1.298l-3.44-.922a5 5 0 0 0 4.436 5.78z"
        }
      )
    }
  );
}
const Om = /* @__PURE__ */ i(qm);
function Dm(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.5 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0M8 6v1h2v1H8v2h3.289l1.587 2.75-.866.5L10.711 11H7V6z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7.5 15A4.5 4.5 0 0 1 6 6.256V12h4.134l.808 1.4A4.5 4.5 0 0 1 7.5 15"
          }
        )
      ]
    }
  );
}
const Pm = /* @__PURE__ */ i(Dm);
function Tm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.001 4.536 6-3.464 6 3.464v6.928l-6 3.464-6-3.464zm4.352 1.11c0 .254.111.54.247.804q.09.177.196.346a4 4 0 0 0-.345-.196c-.264-.137-.55-.247-.804-.247C4.737 6.353 4 7.09 4 8v1.647h1.647c.254 0 .54-.111.804-.247a5 5 0 0 0 .345-.196 5 5 0 0 0-.196.345c-.137.264-.247.55-.247.804C6.353 11.263 7.09 12 8 12h1.647v-1.647c0-.254-.111-.54-.247-.804a5 5 0 0 0-.196-.345 5 5 0 0 0 .345.196c.264.137.55.247.804.247C11.263 9.647 12 8.91 12 8V6.353h-1.647c-.254 0-.54.111-.804.247-.115.058-.23.126-.345.196a5 5 0 0 0 .196-.345c.137-.264.247-.55.247-.804C9.647 4.737 8.91 4 8 4H6.353z"
        }
      )
    }
  );
}
const Wm = /* @__PURE__ */ i(Tm);
function Gm(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M.929 5.929A9.97 9.97 0 0 1 8 3a9.97 9.97 0 0 1 7.071 2.929l-.707.707A8.97 8.97 0 0 0 8 4a8.97 8.97 0 0 0-6.364 2.636z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3.05 8.05A6.98 6.98 0 0 1 8 6a6.98 6.98 0 0 1 4.95 2.05l-.707.707A5.98 5.98 0 0 0 8 7a5.98 5.98 0 0 0-4.243 1.757zM8 9a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
          }
        )
      ]
    }
  );
}
const Em = /* @__PURE__ */ i(Gm);
function Nm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.707-3.672-3.671q.024.156.025.318a2 2 0 1 1-1.682-1.975L6.486 7.193a6 6 0 0 0-2.729 1.564L3.05 8.05a7 7 0 0 1 2.635-1.658L4.154 4.861a9 9 0 0 0-2.518 1.775L.93 5.929a10 10 0 0 1 2.479-1.814L1.646 2.354zm9.889 7.111a6 6 0 0 0-1.969-1.311l-1.39-1.39A6.97 6.97 0 0 1 12.95 8.05zM8 4a9 9 0 0 0-1.104.067l-.872-.872Q6.984 3.001 8 3a9.97 9.97 0 0 1 7.071 2.929l-.707.707A8.97 8.97 0 0 0 8 4"
        }
      )
    }
  );
}
const jm = /* @__PURE__ */ i(Nm);
function Um(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 3h12v2H2zm12 3v7H2V6z" })
    }
  );
}
const Im = /* @__PURE__ */ i(Um);
function Qm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 5H2V3h12zm0 8H2V6h12zm-6.192-1.842 1.334-4-.95-.316-1.332 4zM3.793 9l1.854 1.854.707-.708L5.207 9l1.146-1.146-.707-.708zm5.854 1.146.707.708L12.207 9l-1.853-1.854-.707.708L10.793 9z"
        }
      )
    }
  );
}
const Km = /* @__PURE__ */ i(Qm);
function Jm(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 3H1V1h6zM1 7V4h6v3zm8 0V4h6v3zm6-6v2H9V1zM7 11H1V9h6zm0 4H1v-3h6zm2-3h6v3H9zm6-1H9V9h6z"
        }
      )
    }
  );
}
const Xm = /* @__PURE__ */ i(Jm);
function Ym(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 3h10v2H2zm10 3v5H2V6z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 12V5h1v8H3v-1z" })
      ]
    }
  );
}
const Zm = /* @__PURE__ */ i(Ym);
function _m(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 5H2V3h12zm0 8H2V6h12zm-9.854-2.853.708.707L6.707 9 4.854 7.146l-.708.708L5.293 9zM10 10H7v1h3z"
        }
      )
    }
  );
}
const ng = /* @__PURE__ */ i(_m);
function lg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.54 2h4.92l.564 6.831L8.5 10.29V14H11v1H5v-1h2.5v-3.71L4.976 8.83z"
        }
      )
    }
  );
}
const tg = /* @__PURE__ */ i(lg);
function ig(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4 5a4 4 0 0 0 .535 2l-.865.5a5 5 0 0 1-.001-5l.866.5A4 4 0 0 0 4 5m8.33-2.5a5 5 0 0 1 .001 5l-.866-.5a4 4 0 0 0 0-4zM6.267 4a2 2 0 0 0 0 2l-.865.5a3 3 0 0 1 0-3zm4.331-.5a3 3 0 0 1 0 3L9.733 6a2 2 0 0 0 0-2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7 5a1 1 0 1 1 1.5.866V9H14v5H2V9h5.5V5.866A1 1 0 0 1 7 5m1 7v-1H7v1zm1 0h1v-1H9zm3-1h-1v1h1z"
          }
        )
      ]
    }
  );
}
const eg = /* @__PURE__ */ i(ig);
function og(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 13 13-.707.708L13.293 14H2V9h5.5v-.793l-1.85-1.85-.248.144a3 3 0 0 1-.288-.68L4.01 4.717A4 4 0 0 0 4.535 7l-.865.501a5 5 0 0 1-.535-3.659L1.646 2.354zM8 12v-1H7v1zm1 0h1v-1H9zm5-3v2.172L11.829 9zM9 5c0 .32-.15.605-.384.788L7.212 4.384A1 1 0 0 1 9 5m3 0a4 4 0 0 0-.535-2l.866-.5a5 5 0 0 1-.001 5.001l-.865-.5A4 4 0 0 0 12 5m-2 0a2 2 0 0 0-.267-1l.865-.5a3 3 0 0 1 0 3L9.733 6A2 2 0 0 0 10 5"
        }
      )
    }
  );
}
const rg = /* @__PURE__ */ i(og);
function hg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4M6.662 6h2.677l2.4 6H10v3H9v-3H7v3H6v-3H4.261z"
        }
      )
    }
  );
}
const ag = /* @__PURE__ */ i(hg);
function cg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 7H2V3h12zM2 13V8h4v5zm5-5h7v5H7z" })
    }
  );
}
const dg = /* @__PURE__ */ i(cg);
function wg(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M12 6H2V3h10zm-7 5H2V7h3zm1 0V7h6v4z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 12V5h1v8H3v-1z" })
      ]
    }
  );
}
const vg = /* @__PURE__ */ i(wg);
function mg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 2h8v12H4zm6 4H6v1h4zM6 9h4V8H6zm4-5H9v1h1z"
        }
      )
    }
  );
}
const gg = /* @__PURE__ */ i(mg);
function sg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708L12 12.707V14H4V4.707L1.646 2.354zM7.293 8H6v1h2.293zM12 2v7.172L9.828 7H10V6H8.828l-4-4zm-2 2H9v1h1z"
        }
      )
    }
  );
}
const fg = /* @__PURE__ */ i(sg);
function ug(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7 2h8v12h-5v-1h2V9h2V8h-2V7h2V6h-2V4H7zm6 3h1V4h-1z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M1 5h10v7H6.902l.268 1H9v1H3v-1h1.831l.268-1H1zm5 7.5-.134.5h.268z"
          }
        )
      ]
    }
  );
}
const pg = /* @__PURE__ */ i(ug);
function Hg(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 13 13-.708.708L13.293 14H10v-1h2v-.293l-1-1V12H6.902l.268 1H9v1H3v-1h1.831l.268-1H1V5h3.293L1.646 2.354zM6 12.5l-.134.5h.268zM15 2v10.172l-3-3V9h2V8h-2V7h2V6h-2V4H7V2zm-2 3h1V4h-1z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M11 5v3.172L7.828 5z" })
      ]
    }
  );
}
const Mg = /* @__PURE__ */ i(Hg);
function xg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.1 7a5 5 0 0 0 0 2h1.94a12.6 12.6 0 0 1 0-2zm.316-1h1.747a8.6 8.6 0 0 1 .614-2.096 6 6 0 0 1 .26-.504A5.02 5.02 0 0 0 3.417 6M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2m0 1c-.374 0-.875.356-1.313 1.318A7.4 7.4 0 0 0 6.18 6h3.64a7.4 7.4 0 0 0-.508-1.682C8.875 3.356 8.373 3 8 3m4.583 3a5.02 5.02 0 0 0-2.62-2.6 6 6 0 0 1 .26.504A8.6 8.6 0 0 1 10.837 6zM9.957 7H6.043a11.5 11.5 0 0 0 0 2h3.914a11.5 11.5 0 0 0 0-2M12.9 9a5 5 0 0 0 0-2h-1.94a12.5 12.5 0 0 1 0 2zm-3.079 1H6.18c.12.642.295 1.213.508 1.682C7.125 12.644 7.627 13 8 13s.875-.356 1.313-1.318c.213-.47.388-1.04.508-1.682m.141 2.6a5.02 5.02 0 0 0 2.622-2.6h-1.747c-.133.786-.343 1.499-.615 2.096a5 5 0 0 1-.26.504m-3.924 0a6 6 0 0 1-.261-.504A8.6 8.6 0 0 1 5.163 10H3.416a5.02 5.02 0 0 0 2.622 2.6"
        }
      )
    }
  );
}
const zg = /* @__PURE__ */ i(xg);
function Vg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-1.773-1.772a6 6 0 0 1-8.456-8.456L1.647 2.354zm1.775 3.19A5 5 0 0 0 3.416 6h1.747l.02-.11zM6.293 7h-.25a11.5 11.5 0 0 0 0 2h2.25zm-.113 3a7.4 7.4 0 0 0 .507 1.682C7.125 12.644 7.626 13 8 13c.373 0 .875-.356 1.313-1.318a7 7 0 0 0 .416-1.246L9.293 10zm4.363 1.25a7 7 0 0 1-.32.846 5 5 0 0 1-.261.505 5 5 0 0 0 1.202-.73zM3.1 7a5 5 0 0 0 0 2h1.94a12.6 12.6 0 0 1 0-2zm2.938 5.6a6 6 0 0 1-.26-.504A8.6 8.6 0 0 1 5.162 10H3.416a5.02 5.02 0 0 0 2.622 2.6M14 8c0 .926-.21 1.804-.585 2.587L11.828 9H12.9a5 5 0 0 0 0-2h-1.94A13 13 0 0 1 11 8.17L9.97 7.14 9.956 7h-.129l-1-1h.993a7.4 7.4 0 0 0-.508-1.682C8.875 3.356 8.373 3 8 3c-.33 0-.762.28-1.16 1.011L5.413 2.585A6 6 0 0 1 14 8m-1.417-2a5.02 5.02 0 0 0-2.62-2.6 5 5 0 0 1 .26.504A8.6 8.6 0 0 1 10.837 6z"
        }
      )
    }
  );
}
const Cg = /* @__PURE__ */ i(Vg);
function Lg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 2a4 4 0 0 1 3.615 2.285l.102.215H10L9.25 6 10 7.5h3.716l-.1.214A4 4 0 0 1 8.87 9.837l-5.37 5.37L.793 12.5l5.369-5.37A4 4 0 0 1 10 2"
        }
      )
    }
  );
}
const $g = /* @__PURE__ */ i(Lg);
function Sg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 9h1.348l-.635-2.37.966-.26.972 3.63H12v.446l-4 1.072-4-1.072v-.445H1.348l.973-3.63.966.259L2.651 9H4V6h8zM6 9h4V8H6z"
        }
      )
    }
  );
}
const kg = /* @__PURE__ */ i(Sg);
function yg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h10v9a5 5 0 0 1-10 0zm1 1v3.5h3.5V2zm4.5 0v3.5H12V2zM12 6.5H4V10a4 4 0 1 0 8 0zm-6.25-3a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5m-1.25.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0"
        }
      )
    }
  );
}
const bg = /* @__PURE__ */ i(yg);
function Rg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.647 5.354 8.501 4.207v4.505l3.9 2.252-.42-1.566.966-.258.862 3.215-3.215.861-.259-.966 1.566-.42L8 9.578l-3.901 2.251 1.567.42-.26.966-3.215-.861.862-3.215.966.258-.419 1.566 3.9-2.252V4.207L6.354 5.354l-.707-.708L8 2.293l2.354 2.353z"
        }
      )
    }
  );
}
const Bg = /* @__PURE__ */ i(Rg);
function Fg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 7H2V2h5zM6 6V3H3v3zm6 8h-1v-2H9v-1h2V9h1v2h2v1h-2zM2 9h5v5H2zm1 1v3h3v-3zm11-3H9V2h5zm-1-1V3h-3v3z"
        }
      )
    }
  );
}
const Ag = /* @__PURE__ */ i(Fg);
function qg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 7H2V2h5zM6 6V3H3v3zm1 8H2V9h5zm-1-1v-3H3v3zm3-4h5v5H9zm1 1v3h3v-3zm4-3H9V2h5zm-1-1V3h-3v3z"
        }
      )
    }
  );
}
const Og = /* @__PURE__ */ i(qg);
function Dg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6M6 4a2 2 0 1 0 4 0 2 2 0 0 0-4 0m3 4v1H5.222L4.15 13h3.027v1H2.848l1.608-6zm2 3V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z"
        }
      )
    }
  );
}
const Pg = /* @__PURE__ */ i(Dg);
function Tg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-.544 4h6.704v1H5.223l-1.072 4h2.813v1H2.848zm10.897 1.354L10.5 14.207l-2.354-2.353.707-.708 1.647 1.647 4.146-4.147z"
        }
      )
    }
  );
}
const Wg = /* @__PURE__ */ i(Tg);
function Gg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-.544 4H7v1H5.223l-1.072 4H6.5v1H2.848zM7.5 11.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m2.5 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m2.5 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const Eg = /* @__PURE__ */ i(Gg);
function Ng(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-.544 4h6.704v1H5.223l-1.072 4h3.026v1H2.848zM14.5 12h-6v-1h6z"
        }
      )
    }
  );
}
const jg = /* @__PURE__ */ i(Ng);
function Ug(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7.5 7.5V2h1v5.5H14v1H8.5V14h-1V8.5H2v-1z" })
    }
  );
}
const Ig = /* @__PURE__ */ i(Ug);
function Qg(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7.5 12V8.5H4v-1h3.5V4h1v3.5H12v1H8.5V12z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1M2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8"
          }
        )
      ]
    }
  );
}
const Kg = /* @__PURE__ */ i(Qg);
function Jg(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9.2 4.1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-.5 1.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0m2.951 5.3H6.748l.804-3h3.295zm-1.303-1-.268-1H8.319l-.268 1z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 2h11v12H3v-3H2v-1h1V8.5H2v-1h1V6H2V5h1zm10 11V3H4v2h1v1H4v1.5h1v1H4V10h1v1H4v2z"
          }
        )
      ]
    }
  );
}
const Xg = /* @__PURE__ */ i(Jg);
function Yg(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 2h2.384l1.072 4H13a2 2 0 1 1 0 4h-2.544l-1.072 4H7v-4H4.384l-.268 1H1.179l.804-3-.804-3h2.937l.268 1H7zm1 4h1.42l-.804-3H8zM2.884 8.5 2.482 10h.866l.268-1H13a1 1 0 0 0 0-2H3.616l-.268-1h-.866l.402 1.5H5v1zM8 10v3h.616l.804-3z"
        }
      )
    }
  );
}
const Zg = /* @__PURE__ */ i(Yg);
function _g(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 10h1v1H5zm2 0h1v1H7z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 2.293v2.414l-1 1V8h2v1h-2v4h2v1H2v-1h1V9H2V8h7V5.707l-1-1V2.293L9.293 1h2.414zM4 13h5V9H4zm7-7h-1v7h1zm.293-1L12 4.293V4H9v.293L9.707 5zM9 3h3v-.293L11.293 2H9.707L9 2.707z"
          }
        )
      ]
    }
  );
}
const ns = /* @__PURE__ */ i(_g);
function ls(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.354 2.354-2 2-.708-.708 2-2zm6-.708 2 2-.707.708-2-2zM8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M3 8a5 5 0 1 1 8.504 3.567l.483 1.804-.966.258-.372-1.388a5 5 0 0 1-5.295.002l-.371 1.386-.966-.258.482-1.8A5 5 0 0 1 3 8m8.028.294-.259.966-3.177-.852-.852-3.177.966-.259.702 2.62z"
        }
      )
    }
  );
}
const ts = /* @__PURE__ */ i(ls);
function is(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a2 2 0 0 1 .5 3.937V7H10v1H8.5v5.42q.266-.168.544-.315c.239-.127.491-.25.739-.371l.093-.046q.423-.202.835-.426c.976-.536 1.833-1.199 2.248-2.382l-1.129-.41.341-.94 1.987.721-.102.433c-.44 1.856-1.669 2.798-2.863 3.454-.297.163-.595.31-.877.449l-.093.045c-.251.123-.487.238-.709.356-.507.269-.883.524-1.124.824L8 15.3l-.39-.488c-.241-.301-.617-.554-1.123-.824-.223-.118-.459-.233-.71-.356l-.093-.045c-.282-.139-.58-.286-.877-.449-1.193-.656-2.423-1.598-2.863-3.454l-.102-.434 1.988-.72.34.94-1.128.409c.414 1.184 1.271 1.847 2.247 2.383q.412.223.835.426l.092.046c.25.121.501.244.74.371q.278.147.544.315V8H6V7h1.5V4.937A2 2 0 0 1 8 1M7 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
        }
      )
    }
  );
}
const es = /* @__PURE__ */ i(is);
function os(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v10H3zm1 1v8h8V4zm2 2h4v4H6zm1 1v2h2V7z"
        }
      )
    }
  );
}
const rs = /* @__PURE__ */ i(os);
function hs(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v10H3zm9 6V7h-2v2zm0-5H4v8h8v-2H9V6h3zM7 7H6V6h1zm0 3H6V9h1z"
        }
      )
    }
  );
}
const as = /* @__PURE__ */ i(hs);
function cs(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v10H3zm6 1H7v2h2zM4 4v8h8V4h-2v3H6V4zm3 5v1H6V9zm3 0v1H9V9z"
        }
      )
    }
  );
}
const ds = /* @__PURE__ */ i(cs);
function ws(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v10H3zm9 3V4h-2v2zM4 4v8h8V7H9V4zm3 3H6V6h1zm0 3H6V9h1zm3-1v1H9V9z"
        }
      )
    }
  );
}
const vs = /* @__PURE__ */ i(ws);
function ms(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v10H3zm1 4v5h8V4H7v3zm2-3H4v2h2zm4 3H9V6h1zM7 9v1H6V9zm3 1H9V9h1z"
        }
      )
    }
  );
}
const gs = /* @__PURE__ */ i(ms);
function ss(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v10H3zm4 9h2v-2H7zm5 0V4H4v8h2V9h4v3zM7 7H6V6h1zm3 0H9V6h1z"
        }
      )
    }
  );
}
const fs = /* @__PURE__ */ i(ss);
function us(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v10H3zm7 9h2v-2h-2zm2-8H4v8h5V9h3zM7 7H6V6h1zm3 0H9V6h1zm-3 3H6V9h1z"
        }
      )
    }
  );
}
const ps = /* @__PURE__ */ i(us);
function Hs(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v10H3zm1 7v2h2v-2zm8 2V4H4v5h3v3zM7 7H6V6h1zm3 0H9V6h1zm0 3H9V9h1z"
        }
      )
    }
  );
}
const Ms = /* @__PURE__ */ i(Hs);
function xs(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v10H3zm1 4v2h2V7zm0 5h8V4H4v2h3v4H4zm6-5H9V6h1zm0 3H9V9h1z"
        }
      )
    }
  );
}
const zs = /* @__PURE__ */ i(xs);
function Vs(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.5 8.482 3 .804 2.871-.769.259.966-3.13.838-3-.803-2.87.769-.259-.966zm0-3 3 .804 2.871-.769.259.966-3.13.839-3-.804-2.87.769-.259-.966z"
        }
      )
    }
  );
}
const Cs = /* @__PURE__ */ i(Vs);
function Ls(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h3v3H2zm1 1v1h1V3zm3.5-1h3v3h-3zm1 1v1h1V3zM11 2h3v3h-3zm1 1v1h1V3zM2 6.5h3v3H2zm1 1v1h1v-1zm3.5-1h3v3h-3zm1 1v1h1v-1zm3.5-1h3v3h-3zm1 1v1h1v-1zM2 11h3v3H2zm1 1v1h1v-1zm3.5-1h3v3h-3zm1 1v1h1v-1zm3.5-1h3v3h-3zm1 1v1h1v-1z"
        }
      )
    }
  );
}
const $s = /* @__PURE__ */ i(Ls);
function Ss(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v3h-1v7H3V6H2zm11 2V4H3v1zM4 6v6h8V6zm6 2H6V7h4z"
        }
      )
    }
  );
}
const ks = /* @__PURE__ */ i(Ss);
function ys(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1.75 1.75 15 7.5l-3.5 2 3 3-2 2-3-3-2 3.5zm1.926 1.926 3.946 9.094 1.66-2.903 3.218 3.219.586-.586-3.219-3.219 2.903-1.659z"
        }
      )
    }
  );
}
const bs = /* @__PURE__ */ i(ys);
function Rs(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.647 7.646.707.708L8 12.707 3.646 8.354l.708-.708L7.5 10.793V3h1v7.793z"
        }
      )
    }
  );
}
const Bs = /* @__PURE__ */ i(Rs);
function Fs(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 11v1H4V6h1v4.293l5.647-5.647.707.708L5.707 11z"
        }
      )
    }
  );
}
const As = /* @__PURE__ */ i(Fs);
function qs(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.647 6.646.707.708L8 11.707 3.646 7.354l.708-.708L7.5 9.793V2h1v7.793zM3 12h10v1H3z"
        }
      )
    }
  );
}
const Os = /* @__PURE__ */ i(qs);
function Ds(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 6h1v6H6v-1h4.293L4.646 5.354l.708-.708L11 10.293z"
        }
      )
    }
  );
}
const Ps = /* @__PURE__ */ i(Ds);
function Ts(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.207 7.5H13v1H5.207l3.147 3.147-.707.707L3.293 8l4.354-4.354.707.708z"
        }
      )
    }
  );
}
const Ws = /* @__PURE__ */ i(Ts);
function Gs(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 3v10H3V3zm5.354 8.646-.707.708L4.293 8l4.354-4.354.707.708L6.207 7.5H14v1H6.207z"
        }
      )
    }
  );
}
const Es = /* @__PURE__ */ i(Gs);
function Ns(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m3.207 8.5 2.147 2.146-.707.708L1.293 8l3.354-3.354.707.708L3.207 7.5h9.586l-2.146-2.146.707-.708L14.707 8l-3.353 3.354-.707-.707L12.793 8.5z"
        }
      )
    }
  );
}
const js = /* @__PURE__ */ i(Ns);
function Us(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.793 8.5H3v-1h7.793L7.646 4.354l.708-.708L12.707 8l-4.353 4.354-.708-.707z"
        }
      )
    }
  );
}
const Is = /* @__PURE__ */ i(Us);
function Qs(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 3v10h-1V3zM6.646 4.354l.708-.708L11.707 8l-4.353 4.353-.708-.707L9.793 8.5H2v-1h7.793z"
        }
      )
    }
  );
}
const Ks = /* @__PURE__ */ i(Qs);
function Js(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.646 8.354 8.5 5.207V13h-1V5.207L4.354 8.354l-.708-.708L8 3.293l4.354 4.353z"
        }
      )
    }
  );
}
const Xs = /* @__PURE__ */ i(Js);
function Ys(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 1.293 3.354 3.353-.707.708L8.5 3.207v9.586l2.146-2.147.708.707L8 14.708l-3.354-3.354.708-.707L7.5 12.793V3.207L5.354 5.354l-.708-.708z"
        }
      )
    }
  );
}
const Zs = /* @__PURE__ */ i(Ys);
function _s(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 5H5.707l5.647 5.647-.707.707L5 5.707V10H4V4h6z"
        }
      )
    }
  );
}
const nf = /* @__PURE__ */ i(_s);
function lf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v1H3zm1.354 6.354-.708-.708L8 4.293l4.354 4.353-.708.708L8.5 6.207V14h-1V6.207z"
        }
      )
    }
  );
}
const tf = /* @__PURE__ */ i(lf);
function ef(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 10V5.707l-5.646 5.647-.708-.707L10.293 5H6V4h6v6z"
        }
      )
    }
  );
}
const of = /* @__PURE__ */ i(ef);
function rf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.293 2h7.414L14 4.293v4.414l-1.985 1.985-2.366-.634-.942.942H5.793L5 10.207V8.793l.741-.741L9 7.179v-.972L8.793 6H6.207l-.353.354-.708-.708L5.793 5h3.414l.793.793v3.323l1.717.46L13 8.293V4.707L11.293 3H4.707L3 4.707v6.586L4.707 13h6.586l.853-.854.708.708L11.707 14H4.293L2 11.707V4.293zM9 9.293v-1.08l-2.741.735-.259.26v.585l.207.207h2.086z"
        }
      )
    }
  );
}
const hf = /* @__PURE__ */ i(rf);
function af(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 4a4 4 0 0 0-1.315 7.779 1.5 1.5 0 1 1-.16 1A5.002 5.002 0 0 1 8 3a5 5 0 0 1 4.956 4.337l.69-.69.707.707L12 9.707V8a4 4 0 0 0-4-4m0 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1"
        }
      )
    }
  );
}
const cf = /* @__PURE__ */ i(af);
function df(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.707-4.63-4.63a2 2 0 0 1-2.74-2.74L4.84 5.548a4.002 4.002 0 0 0 1.844 6.232 1.5 1.5 0 1 1-.158 1 5.002 5.002 0 0 1-2.397-7.943L1.646 2.354zm4.68 6.095a1 1 0 0 0 1.225 1.225zM8 12a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m0-8q-.54.002-1.036.135l-.791-.79a5 5 0 0 1 6.784 3.992l.69-.69.707.707L12 9.707V8a4 4 0 0 0-4-4"
        }
      )
    }
  );
}
const wf = /* @__PURE__ */ i(df);
function vf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 .258 1.19 1.305 1.681-.536.378 1.725 1.724.377-.535 1.682L13.743 6l-1.305 1.189.535 1.682-.973.213v5.655l-4-1.6-4 1.6V9.084l-.973-.213.536-1.682L2.258 6l1.305-1.189-.536-1.682 1.725-.377.377-1.725 1.682.536zM5 10.384v2.877l3-1.2 3 1.2v-2.877l-.129.589-1.682-.536L8 11.742l-1.189-1.305-1.682.536zm3-8.642-.881.968-1.248-.397-.28 1.279-1.278.28.397 1.246L3.743 6l.967.882-.397 1.247 1.279.28.28 1.278 1.247-.397.881.968.882-.968 1.247.397.28-1.279 1.278-.28-.397-1.246.968-.882-.968-.882.397-1.247-1.278-.28-.28-1.278-1.247.397zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      )
    }
  );
}
const mf = /* @__PURE__ */ i(vf);
function gf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.934 2h8.132l-.25 2h2.336l-1.34 5h-1.62l-.25 2h-1.79l.535 2H11v1H5v-1h1.312l.536-2h-1.79l-.25-2h-1.62l-1.34-5h2.336zm.375 3H3.15l.804 3h.729zm3.574 6-.535 2h1.304l-.536-2zm3.05-8H5.067l.875 7h4.118zm.383 5h.729l.803-3h-1.157zM9.5 5h-3V4h3z"
        }
      )
    }
  );
}
const sf = /* @__PURE__ */ i(gf);
function ff(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.1 3.374A5.002 5.002 0 0 0 8 13 5 5 0 0 0 8 3a1 1 0 1 0 .26 1.966l.257.966A2.002 2.002 0 0 1 6.1 3.374M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2M5 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-1 4a4 4 0 0 1-2.83-1.172l.707-.707a3 3 0 0 0 4.244 0l.707.707A4 4 0 0 1 8 11"
        }
      )
    }
  );
}
const uf = /* @__PURE__ */ i(ff);
function pf(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7.354 5.646 9 7.293l1.647-1.647.707.708L9.707 8l1.647 1.646-.708.708L9 8.707l-1.646 1.647-.708-.708L8.293 8 6.646 6.354z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 13H3.808L.922 8 3.81 3H14zm-9.613-1H13V4H4.387l-2.31 4z"
          }
        )
      ]
    }
  );
}
const Hf = /* @__PURE__ */ i(pf);
function Mf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5.793 15.207 4.5 4.5 15.207.793 11.5zM8.707 5 11 7.293 13.793 4.5 11.5 2.207zm1.586 3L9.5 7.207 8.707 8l.793.793zm-1.5 1.5L8 8.707l-.793.793.793.793zm-1.5 1.5L5 8.707 2.207 11.5 4.5 13.793zM5.707 8l.793.793L7.293 8 6.5 7.207zm1.5-1.5L8 7.293l.793-.793L8 5.707z"
        }
      )
    }
  );
}
const xf = /* @__PURE__ */ i(Mf);
function zf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 2.287 6 2.373V6h-2v5h1v2h1v1H2v-1h1v-2h1V6H2V4.66zM11 11V6h-1v5zm-4 0h2V6H7zm-1 0V6H5v5zm2-7.638L3.86 5h8.282zM12 12H4v1h8z"
        }
      )
    }
  );
}
const Vf = /* @__PURE__ */ i(zf);
function Cf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 3h2v10H4zm5 0h2v10H9zM7 13V3h1v10zm6 0V3h1v10zM2 13V3h1v10z"
        }
      )
    }
  );
}
const Lf = /* @__PURE__ */ i(Cf);
function $f(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 7h1v2h-1v2H2V5h11zm-1 3V6H3v4z" })
    }
  );
}
const Sf = /* @__PURE__ */ i($f);
function kf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708L10.293 11H2V5h2.293L1.646 2.354zM5.293 6H3v4h6.293zM13 9v1.172l-1-1V6H8.828l-1-1H13v2h1v2z"
        }
      )
    }
  );
}
const yf = /* @__PURE__ */ i(kf);
function bf(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4 9V7h1v2z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 7h1v2h-1v2H2V5h11zm-1 3V6H3v4z" })
      ]
    }
  );
}
const Rf = /* @__PURE__ */ i(bf);
function Bf(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 7v2H4V7zm1 2V7h1v2z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 7h1v2h-1v2H2V5h11zm-1 3V6H3v4z" })
      ]
    }
  );
}
const Ff = /* @__PURE__ */ i(Bf);
function Af(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4 9V7h1v2zm3-2v2H6V7zm1 2V7h1v2z" }),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 7h1v2h-1v2H2V5h11zm-1 3V6H3v4z" })
      ]
    }
  );
}
const qf = /* @__PURE__ */ i(Af);
function Of(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5 7v2H4V7zm1 2V7h1v2zm3-2v2H8V7zm1 2V7h1v2z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 7h1v2h-1v2H2V5h11zm-1 3V6H3v4z" })
      ]
    }
  );
}
const Df = /* @__PURE__ */ i(Of);
function Pf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.001 10.887 5 12.04V5h2V4h2v1h2v7.042l2.001-1.155V5.113l-5-2.886-5 2.886zM10 12.619v-.831l-1.999-1.155L6 11.79v.83l2.001 1.155zm-4-1.985 2.001-1.155L10 10.633V9.288L8.001 8.133 6 9.29zm0-2.5 2.001-1.155L10 8.133V6H6zM2.001 4.536l6-3.464 6 3.464v6.928l-6 3.464-6-3.464z"
        }
      )
    }
  );
}
const Tf = /* @__PURE__ */ i(Pf);
function Wf(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10.85 7 7 13.93V9H5.15L9 2.07V7zM8 5.93 6.85 8H8zm0 4.14L9.15 8H8z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 9h-1v2h-2v-1h1V6h-2V5h3v2h1zM5 6H3v4h3v1H2V5h3z"
          }
        )
      ]
    }
  );
}
const Gf = /* @__PURE__ */ i(Wf);
function Ef(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 2h5.119v1H10v2.928l3 5.196V14H3v-2.876l3-5.196V3h-.5zM7 3v3.196L6.536 7h2.928L9 6.196V3zm3.042 5H5.959L4 11.392V13h8v-1.608zM8 11v-1h1v1zm-2 1v-1h1v1z"
        }
      )
    }
  );
}
const Nf = /* @__PURE__ */ i(Ef);
function jf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 3h1v2.165h2.315L6 5.616V7h6.7l1.3.348V6h1v7h-1v-2H2v2H1zm1 7h12V8.384L12.568 8H2zm0-3h3v-.616l-.817-.22H2z"
        }
      )
    }
  );
}
const Uf = /* @__PURE__ */ i(jf);
function If(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.46 1h3.08l.385 1.384A5 5 0 0 1 13 7v3.382L14.31 13H10a2 2 0 1 1-4 0H1.691l1.31-2.618V7a5 5 0 0 1 3.073-4.616zM7 13a1 1 0 0 0 2 0zm.22-11L6.9 3.144l-.244.087A4 4 0 0 0 4 7v3.618L3.31 12h9.381l-.69-1.382V7a4 4 0 0 0-2.658-3.769L9.1 3.144 8.78 2z"
        }
      )
    }
  );
}
const Qf = /* @__PURE__ */ i(If);
function Kf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 7v3.172l-1-1V7a4 4 0 0 0-2.657-3.769L9.1 3.144 8.78 2H7.22L6.9 3.144l-.243.087q-.216.076-.42.177l-.739-.738q.28-.162.577-.286L6.46 1h3.078l.386 1.384A5 5 0 0 1 13 7m-3 6a2 2 0 1 1-4 0H1.691L3 10.382V7a5 5 0 0 1 .715-2.578L1.646 2.354l.707-.708 12 12-.707.708L12.293 13zM4.449 5.156A4 4 0 0 0 4 7v3.618L3.309 12h7.984zM7 13a1 1 0 0 0 2 0z"
        }
      )
    }
  );
}
const Jf = /* @__PURE__ */ i(Kf);
function Xf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 5v1H5.955l-.338 1.263A2.5 2.5 0 0 1 6.95 9h.357l-.281-.842.949-.316L8.36 9h.689a2.5 2.5 0 0 1 2.601-1.995L11.921 6H11V5h3v1h-1.045l-.339 1.263A2.5 2.5 0 1 1 9.05 10h-.356l.28.842-.948.316L7.64 10h-.69a2.5 2.5 0 1 1-2.3-2.996L5.189 5zM4.017 9.37l.366-1.365a1.5 1.5 0 1 0 .966.258l-.366 1.366zm8.332-1.107-.366 1.366-.966-.258.366-1.367a1.5 1.5 0 1 0 .966.26"
        }
      )
    }
  );
}
const Yf = /* @__PURE__ */ i(Xf);
function Zf(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v8h1v3H1v-3h1zm1 8h5V8h4v2h1V3H3zm8 0V9H9v1zm-9 1v1h12v-1zm6-6H4V4h4zM7 7H4V6h3z"
        }
      )
    }
  );
}
const _f = /* @__PURE__ */ i(Zf);
function nu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 .793 11.207 5l-3 3 3 3L7 15.207v-6l-2.646 2.647-.708-.707L6.793 8 3.646 4.854l.708-.707L7 6.793zm1 12L9.793 11 8 9.207zM9.793 5 8 3.207v3.586z"
        }
      )
    }
  );
}
const lu = /* @__PURE__ */ i(nu);
function tu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m9.518 6.69-.707-.708L9.793 5 8 3.207v1.965l-1-1V.793L11.207 5zm.982 5.017-3.5 3.5v-6l-2.646 2.647-.707-.707L6.793 8 1.146 2.354l.708-.708 12 12-.707.708zM8 12.793 9.793 11 8 9.207z"
        }
      )
    }
  );
}
const iu = /* @__PURE__ */ i(tu);
function eu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 3h3.5a2.5 2.5 0 0 1 1.76 4.276A3 3 0 0 1 9 13H5zm1 5v4h3a2 2 0 1 0 0-4zm0-1h2.5a1.5 1.5 0 1 0 0-3H6z"
        }
      )
    }
  );
}
const ou = /* @__PURE__ */ i(eu);
function ru(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3.5A1.5 1.5 0 0 1 3.5 2H14v12H3.5A1.5 1.5 0 0 1 2 12.5zm1 7.585q.236-.084.5-.085H13V3H3.5a.5.5 0 0 0-.5.5zM13 12H3.5a.5.5 0 0 0 0 1H13zm-1.5-7H4V4h7.5zm0 2H4V6h7.5zM8 9H4V8h4z"
        }
      )
    }
  );
}
const hu = /* @__PURE__ */ i(ru);
function au(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h10v14.35l-5-2.778-5 2.778zm1 1v11.65l4-2.222 4 2.222V2z"
        }
      )
    }
  );
}
const cu = /* @__PURE__ */ i(au);
function du(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 14 14-.707.708L13 13.707v1.643l-5-2.778-5 2.778V3.707L.646 1.354zM4 4.707v8.943l4-2.222 4 2.222v-.943zm9 5.465-1-1V2H4.828l-1-1H13z"
        }
      )
    }
  );
}
const wu = /* @__PURE__ */ i(du);
function vu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5.5h3v5.293l2.03 2.03-1.096 7.677H5.566L4.47 7.823l2.03-2.03zm1 1v4.707l-1.97 1.97.904 6.323h3.132l.904-6.323-1.97-1.97V1.5z"
        }
      )
    }
  );
}
const mu = /* @__PURE__ */ i(vu);
function gu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h3v1h6V2h3v3h-1v6h1v3h-3v-1H5v1H2v-3h1V5H2zm2 3v6h1v1h6v-1h1V5h-1V4H5v1zM3 3v1h1V3zm0 9v1h1v-1zm10-8V3h-1v1zm-1 8v1h1v-1z"
        }
      )
    }
  );
}
const su = /* @__PURE__ */ i(gu);
function fu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2M5 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m8 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2M5 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m5-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-8 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0m8-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
        }
      )
    }
  );
}
const uu = /* @__PURE__ */ i(fu);
function pu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.652 2h4.696l.536 2H14v9H2V4h3.116zm.5 2h3.696L9.58 3H6.42zM3 5v7h10V5z"
        }
      )
    }
  );
}
const Hu = /* @__PURE__ */ i(pu);
function Mu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8a7 7 0 1 1 13.062 3.502L13.197 11a6 6 0 1 0-10.394 0l-.865.5A6.97 6.97 0 0 1 1 8m3 0a4 4 0 1 1 7.464 2.002l-.866-.501a3 3 0 1 0-5.197 0l-.865.5A4 4 0 0 1 4 8m3 0a1 1 0 1 1 1.706.708l1.517 5.663-.966.258-.302-1.129H7.043l-.303 1.13-.966-.26 1.518-5.664A1 1 0 0 1 7 8m.999 1.932L7.311 12.5h1.376z"
        }
      )
    }
  );
}
const xu = /* @__PURE__ */ i(Mu);
function zu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m12.25 1.543 2.207 2.207L7 11.208v.042c0 1.544-1.104 2.558-2.43 2.745-.6.085-1.296.089-1.927-.078-.634-.167-1.255-.522-1.59-1.193l-.258-.516.547-.182c.47-.157.755-.603 1.145-1.274l.016-.027c.21-.36.456-.784.786-1.112A2 2 0 0 1 4.792 9zM4.76 10h-.01c-.324 0-.55.118-.756.322-.227.226-.414.54-.642.933l-.035.06c-.25.43-.563.97-1.055 1.34q.251.195.636.295c.465.123 1.02.127 1.532.055.9-.127 1.57-.774 1.57-1.755v-.01zm1.724.31.809-.81-.793-.793-.81.81zM7.207 8 8 8.793l5.043-5.043-.793-.793z"
        }
      )
    }
  );
}
const Vu = /* @__PURE__ */ i(zu);
function Cu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m7.664 4.957.693-2.586.966.258-.843 3.144 3.02 3.02v.689l-1.741.466-3.259 3.26L1.793 8.5 6.5 3.793zm-.299 1.115L6.5 5.207 3.207 8.5 6.5 11.793l2.741-2.741.87-.233-1.93-1.93-.198.74-.966-.258zm5.489 4.074-.354.354-.354-.354.354-.353zm-.354 1.135-.084.121c-.233.35-.416.748-.416 1.098a.5.5 0 0 0 1 0c0-.35-.183-.748-.416-1.098zm.354-1.134.002.002.003.003.012.012q.3.32.545.684c.267.4.584 1.002.584 1.652a1.5 1.5 0 1 1-3 0c0-.65.317-1.252.584-1.652q.23-.34.508-.644l.038-.04.011-.012.003-.003.002-.002v-.001l.354.354z"
        }
      )
    }
  );
}
const Lu = /* @__PURE__ */ i(Cu);
function $u(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.985 3.778-.576-2.149.966-.258.496 1.849a3 3 0 0 1 2.258 0l.496-1.85.966.26-.576 2.148C10.62 4.326 11 5.118 11 6h1.616l.548-2.044.966.259L13.383 7H11v1.5h3v1h-3V11h2.383l.747 2.785-.966.26L12.616 12H10.83a3 3 0 0 1-5.658 0H3.383l-.547 2.044-.966-.259L2.616 11H5V9.5H2v-1h3V7H2.616L1.87 4.215l.966-.26L3.383 6H5c0-.882.38-1.674.985-2.222M8 4a1.997 1.997 0 0 0-2 2v5q0 .208.04.4A2 2 0 0 0 10 11V6a1.997 1.997 0 0 0-2-2m.5 7.5h-1v-5h1z"
        }
      )
    }
  );
}
const Su = /* @__PURE__ */ i($u);
function ku(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 9.5h-1.67l-1-1H14zM11 7v1.172l-1-1V6a1.997 1.997 0 0 0-2.938-1.767L5.758 2.93l-.349-1.3.966-.258.496 1.849a3 3 0 0 1 2.258 0l.496-1.85.966.26-.576 2.148C10.62 4.326 11 5.118 11 6h1.616l.548-2.044.966.259L13.383 7zm-.171 5a3 3 0 0 1-5.658 0H3.383l-.547 2.045-.966-.26L2.616 11H5V9.5H2v-1h3V7H2.616L1.87 4.215l.966-.259L3.384 6H5q0-.14.013-.28L1.646 2.354l.708-.708 12 12-.707.708L11.293 12zM7.5 8.207 6 6.707V11q0 .208.04.4A2 2 0 0 0 10 11v-.293l-1.5-1.5V11.5h-1z"
        }
      )
    }
  );
}
const yu = /* @__PURE__ */ i(ku);
function bu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.799 11H13.2c.242-.503.387-1.138.442-1.844a10.3 10.3 0 0 0-.132-2.509c-.14-.812-.358-1.53-.599-2.032a2.2 2.2 0 0 0-.334-.531 1 1 0 0 0-.078-.071.5.5 0 0 0-.078.07 2.2 2.2 0 0 0-.335.532c-.24.501-.458 1.22-.598 2.032-.14.81-.197 1.69-.133 2.509.056.706.201 1.34.443 1.844m-1.081 0a6.8 6.8 0 0 1-.357-1.765 11.3 11.3 0 0 1 .144-2.757c.15-.875.39-1.688.682-2.296a3.1 3.1 0 0 1 .507-.783C11.88 3.2 12.152 3 12.5 3s.62.199.806.399a3.1 3.1 0 0 1 .508.783c.292.608.532 1.421.682 2.296.151.877.217 1.841.144 2.757-.071.909-.281 1.806-.711 2.522l-.146.243H3.5a2.5 2.5 0 0 1-.865-4.846 3.001 3.001 0 0 1 5.26 1.057A2 2 0 0 1 8.732 11zM7 11a1 1 0 0 0 .31-1.951l-.288-.094-.051-.297a2 2 0 0 0-3.617-.795l-.101.146-.17.05A1.5 1.5 0 0 0 3.5 11z"
        }
      )
    }
  );
}
const Ru = /* @__PURE__ */ i(bu);
function Bu(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10 7v1H9V7zm0 2v1H9V9zm0 2v1H9v-1zm2-4v1h-1V7zm0 2v1h-1V9zm0 2v1h-1v-1zM3 5V4h1v1zm0 2V6h1v1zm0 2V8h1v1zm2-4V4h1v1zm0 2V6h1v1zm0 2V8h1v1z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M1 2h7v3h6v9H1zm12 11V6H8v7zM2 3v10h1v-2h3v2h1V3zm2 10h1v-1H4z"
          }
        )
      ]
    }
  );
}
const Fu = /* @__PURE__ */ i(Bu);
function Au(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.5 2h9v12h-9zm1 1v2h7V3zm7 3h-7v7h7zm-5 2h-1V7h1zm2 0h-1V7h1zm2 0h-1V7h1zm-4 2h-1V9h1zm2 0h-1V9h1zm2 0h-1V9h1zm-4 2h-1v-1h1zm2 0h-1v-1h1zm2 0h-1v-1h1z"
        }
      )
    }
  );
}
const qu = /* @__PURE__ */ i(Au);
function Ou(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 3V2h1v1h4V2h1v1h3v11H2V3zm0 1H3v2h10V4h-2v1h-1V4H6v1H5zm8 3H3v6h10z"
        }
      )
    }
  );
}
const Du = /* @__PURE__ */ i(Ou);
function Pu(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m10.074 9.378-1.037 1.01.245 1.428L8 11.142l-1.282.675.245-1.428-1.037-1.011 1.433-.208L8 7.87l.641 1.299z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 2v1h4V2h1v1h3v11H2V3h3V2zM3 6h10V4h-2v1h-1V4H6v1H5V4H3zm0 7h10V7H3z"
          }
        )
      ]
    }
  );
}
const Tu = /* @__PURE__ */ i(Pu);
function Wu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.191 2h3.618l1 2H14v9H2V4h3.191zm.618 1-1 2H3v7h10V5h-2.809l-1-2zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
        }
      )
    }
  );
}
const Gu = /* @__PURE__ */ i(Wu);
function Eu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.191 2h3.618l1 2H14v5h-1V5h-2.809l-1-2H6.809l-1 2H3v7h1v1H2V4h3.191zM8 6a2 2 0 0 0-1.834 2.8l-.916.4a3 3 0 1 1 5.5 0l-.916-.4A2 2 0 0 0 8 6m-4 5v-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4v-1h2v-1H5v-1h1v-1zm4 0a1 1 0 0 1 1-1h2v1.01h-1V11H9v1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zm1 2v1h1v-1zm3-2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm2 0h-1v3h1z"
        }
      )
    }
  );
}
const Nu = /* @__PURE__ */ i(Eu);
function ju(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.191 2h3.618l1 2H14v3.177h-1V5h-2.809l-1-2H6.809l-1 2H3v7h3.563v1H2V4h3.191z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 6a2 2 0 0 0-1.042 3.707l-.522.853a3 3 0 1 1 4.125-4.125l-.854.523A2 2 0 0 0 8 6m3 5V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z"
          }
        )
      ]
    }
  );
}
const Uu = /* @__PURE__ */ i(ju);
function Iu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4a3 3 0 0 0-3-3V0a4 4 0 0 1 4 4zm-2 0a1 1 0 0 0-1-1V2a2 2 0 0 1 2 2zM6.191 3h3.618l1 2H14v9H2V5h3.191zm.618 1-1 2H3v7h10V6h-2.809l-1-2zM8 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
        }
      )
    }
  );
}
const Qu = /* @__PURE__ */ i(Iu);
function Ku(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 13V4h1.293L1.646 2.354l.708-.708 12 12-.707.708L12.293 13zm9.293-1-1.555-1.555a3 3 0 0 1-4.184-4.184L4.294 5H3v7zM6.277 6.984a2 2 0 0 0 2.74 2.74zM14 4v7.172l-1-1V5h-2.809l-1-2H6.809l-.327.654-.745-.746L6.19 2h3.618l1 2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11 8q0 .084-.005.167L7.833 5.005Q7.915 5 8 5a3 3 0 0 1 3 3"
          }
        )
      ]
    }
  );
}
const Ju = /* @__PURE__ */ i(Ku);
function Xu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.191 2h3.618l1 2H14v5h-1V5h-2.809l-1-2H6.809l-1 2H3v7h8v1H2V4h3.191zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0m7 3a1 1 0 0 1 1-1h2v1.01h-1V11h-1v1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2v-1.01h1V14h1v-1h-1a1 1 0 0 1-1-1z"
        }
      )
    }
  );
}
const Yu = /* @__PURE__ */ i(Xu);
function Zu(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.418 4.126a6 6 0 0 0 8.456 8.456zm.708-.708 8.455 8.456a6 6 0 0 0-8.456-8.456M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8"
        }
      )
    }
  );
}
const _u = /* @__PURE__ */ i(Zu);
function np(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.11 3h9.78l.625 2.5h.845l.834 2.5H14v1.562L13.39 12h-.58l-.5 1h-1.62l-.5-1H5.81l-.5 1H3.691l-.5-1H2.61L2 9.562V8H.806l.834-2.5h.845zM3 8v1.438L3.39 11h9.22L13 9.438V8zm9.86-1-.75-3H8.5v.5H9v1H7v-1h.5V4H3.89l-.75 3H8.5c0-.495.301-.883.662-1.123.364-.243.839-.377 1.338-.377s.974.134 1.338.377c.361.24.662.628.662 1.123zm-3.143-.291C9.535 6.83 9.5 6.943 9.5 7h2c0-.057-.034-.17-.217-.291A1.44 1.44 0 0 0 10.5 6.5c-.33 0-.605.09-.783.209M6 10H4V9h2zm6 0h-2V9h2z"
        }
      )
    }
  );
}
const lp = /* @__PURE__ */ i(np);
function tp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4v8H2V4zm-1 7V5H3v6zM4 2h8v1H4zm8 12H4v-1h8z"
        }
      )
    }
  );
}
const ip = /* @__PURE__ */ i(tp);
function ep(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 14H4V2h8zm-1-1V3H5v10zM3 4v8H2V4zm10 8V4h1v8z"
        }
      )
    }
  );
}
const op = /* @__PURE__ */ i(ep);
function rp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 1H10v2H8.5v3H9V5h1v1h1V5h1v2h-1v1h1V7h1v1h1V7h1v2h-1v5H2V9H1V7h1v1h1V7h1v1h1V7H4V5h1v1h1V5h1v1h.5zM6 7v6h1v-2h2v2h1V7zM3 9v4h2V9zm10 4V9h-2v4z"
        }
      )
    }
  );
}
const hp = /* @__PURE__ */ i(rp);
function ap(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.854 4.854 9.5 10.207l-3-3-4.646 4.647-.708-.707L6.5 5.792l3 3 4.647-4.647z"
        }
      )
    }
  );
}
const cp = /* @__PURE__ */ i(ap);
function dp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 2h4v12H3v-4h3V6h3zm1 11h2V3h-2zm-1 0V7H7v6zm-3 0v-2H4v2z"
        }
      )
    }
  );
}
const wp = /* @__PURE__ */ i(dp);
function vp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M3.5 6a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m5-1a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m2.5 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0M2.5 11a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m5.5-3a3 3 0 1 1 0 6 3 3 0 0 1 0-6m-2 3a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
        }
      )
    }
  );
}
const mp = /* @__PURE__ */ i(vp);
function gp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h5v5H5v2.05c.98.199 1.751.97 1.95 1.95h2.343L12 8.293l3.207 3.207L12 14.707 9.293 12H6.95A2.5 2.5 0 1 1 4 9.05V7H2zm8.207 9.5L12 13.293l1.793-1.793L12 9.707zM3 3v3h3V3zm1.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
        }
      )
    }
  );
}
const sp = /* @__PURE__ */ i(gp);
function fp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 1h4v4H8.5v2.5h5V11H15v4h-4v-4h1.5V8.5h-4V11H10v4H6v-4h1.5V8.5h-4V11H5v4H1v-4h1.5V7.5h5V5H6zm1 1v2h2V2zM2 12v2h2v-2zm5 0v2h2v-2zm5 0v2h2v-2z"
        }
      )
    }
  );
}
const up = /* @__PURE__ */ i(fp);
function pp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 5H7V3.707L3.354 7.354l-.708-.708L6.293 3H5V2h3zm5 9H3v-4h3V8h3V6h4zm-1-7h-2v6h2zm-5 6h2V9H7zm-3-2v2h2v-2z"
        }
      )
    }
  );
}
const Hp = /* @__PURE__ */ i(pp);
function Mp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.214 3.005 1.01 3.77 3.771 1.01a5 5 0 0 0-4.78-4.78m-.687-.987Q7.761 2 8 2a6 6 0 0 1 5.982 6.473l-.047.6-5.527-1.481-1.48-5.527zm-1.566.305 1.63 6.085 6.086 1.63-.26.543a6 6 0 1 1-7.999-7.999zM5.316 3.78a5 5 0 1 0 6.903 6.903L6.776 9.226z"
        }
      )
    }
  );
}
const xp = /* @__PURE__ */ i(Mp);
function zp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12.5 2.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-3 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-3 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-2 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-1 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m1-1a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const Vp = /* @__PURE__ */ i(zp);
function Cp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v3H4.5v3H8V7h3v3H8V9H4.5v3H8v-1h3v3H8v-1H3.5V5H2zm7 10v1h1v-1zm0-4v1h1V8zM3 3v1h10V3z"
        }
      )
    }
  );
}
const Lp = /* @__PURE__ */ i(Cp);
function $p(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.61 7h2.78l.5 2H13v2.5h1V11h1v2h-1v-.5h-1V15H3v-2.5H2v.5H1v-2h1v.5h1V9h3.11zm.53 2h1.72l-.25-1H7.39zM4 10v4h8v-4zm7 2.5H5v-1h6z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7 1h8v5h-1.293L11.23 8.48 10.61 6H7zm1 1v3h3.39l.381 1.523L13.293 5H14V2z"
          }
        )
      ]
    }
  );
}
const Sp = /* @__PURE__ */ i($p);
function kp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v10H7.71l-2.467 2.467L4.582 12H2zm1 1v8h2.35l.41 1.536L7.297 11H13V3zm8 3H5V5h6zm0 3H5V8h6z"
        }
      )
    }
  );
}
const yp = /* @__PURE__ */ i(kp);
function bp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 2h11v8h-1.582l-.66 2.467L10.29 10H4zm1 1v6h5.704l1.535 1.536L12.651 9H14V3zM1 6h2v1H2v5h1.35l.41 1.536L5.297 12H8v-1h1v2H5.71l-2.467 2.467L2.582 13H1z"
        }
      )
    }
  );
}
const Rp = /* @__PURE__ */ i(bp);
function Bp(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 2h12v5.5h-1V3H3v8h2.35l.41 1.536.89-.89.707.708-2.114 2.113L4.582 12H2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11 11V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z"
          }
        )
      ]
    }
  );
}
const Fp = /* @__PURE__ */ i(Bp);
function Ap(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v10H7.71l-2.467 2.467L4.582 12H2zm1 1v8h2.35l.41 1.536L7.297 11H13V3z"
        }
      )
    }
  );
}
const qp = /* @__PURE__ */ i(Ap);
function Op(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.354 4.354 6 12.707 1.646 8.354l.708-.708L6 11.293l7.647-7.647z"
        }
      )
    }
  );
}
const Dp = /* @__PURE__ */ i(Op);
function Pp(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m4.146 7.854.708-.708L7 9.293l4.147-4.147.707.708L7 10.707z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1M2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8"
          }
        )
      ]
    }
  );
}
const Tp = /* @__PURE__ */ i(Pp);
function Wp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ a("g", { fill: "currentColor", children: [
        /* @__PURE__ */ l("path", { d: "m4.146 7.854.708-.708L7 9.293l4.147-4.147.707.708L7 10.707z" }),
        /* @__PURE__ */ l("path", { d: "m11.871 1.295.509 2.325 2.325.509-.722 2.268L15.743 8l-1.76 1.603.722 2.268-2.325.509-.509 2.325-2.268-.722L8 15.743l-1.603-1.76-2.268.722-.509-2.325-2.325-.509.722-2.268L.257 8l1.76-1.603-.722-2.268L3.62 3.62l.509-2.325 2.268.722L8 .257l1.603 1.76zm-7 1.286-.41 1.88-1.88.41.583 1.833L1.742 8l1.422 1.297-.583 1.833 1.88.41.41 1.88 1.833-.583L8 14.259l1.297-1.424 1.833.584.41-1.88 1.88-.41-.583-1.833L14.259 8l-1.424-1.296.584-1.833-1.88-.41-.41-1.88-1.833.583L8 1.742 6.704 3.164z" })
      ] })
    }
  );
}
const Gp = /* @__PURE__ */ i(Wp);
function Ep(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13.354 6.353 8.5 11.207 5.646 8.353l.707-.707L8.5 9.793l4.146-4.147z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m7.646 7.646 2.5-2.5.707.707-2.5 2.5zM5.5 11.207 2.646 8.353l.707-.707L6.207 10.5z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1M2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8"
          }
        )
      ]
    }
  );
}
const Np = /* @__PURE__ */ i(Ep);
function jp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.647 3.646.707.708L8 8.707 3.646 4.354l.708-.708L8 7.293zm0 4 .707.708L8 12.707 3.646 8.354l.708-.708L8 11.293z"
        }
      )
    }
  );
}
const Up = /* @__PURE__ */ i(jp);
function Ip(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m7.647 3.646.707.708L4.707 8l3.647 3.646-.707.707L3.293 8zm4 0 .707.708L8.707 8l3.647 3.646-.707.707L7.292 8z"
        }
      )
    }
  );
}
const Qp = /* @__PURE__ */ i(Ip);
function Kp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.354 3.646 8.707 8l-4.353 4.354-.708-.707L7.293 8 3.646 4.354zm4 0L12.707 8l-4.353 4.354-.708-.707L11.293 8 7.646 4.354z"
        }
      )
    }
  );
}
const Jp = /* @__PURE__ */ i(Kp);
function Xp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 3.293 4.354 4.353-.707.708L8 4.707 4.354 8.354l-.708-.708zm0 4 4.354 4.353-.707.708L8 8.707l-3.646 3.647-.708-.707z"
        }
      )
    }
  );
}
const Yp = /* @__PURE__ */ i(Xp);
function Zp(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.647 5.646.707.708L8 10.707 3.646 6.354l.708-.708L8 9.293z"
        }
      )
    }
  );
}
const _p = /* @__PURE__ */ i(Zp);
function nH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12.036 3.964H8.293v-1h4.743v4.743h-1zM2.965 8.293h1v3.743h3.742v1H2.965z"
        }
      )
    }
  );
}
const lH = /* @__PURE__ */ i(nH);
function tH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.707 8 3.647 3.646-.708.708L5.293 8l4.353-4.354.707.708z"
        }
      )
    }
  );
}
const iH = /* @__PURE__ */ i(tH);
function eH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.647 4.646.707.708L3.707 8l2.647 2.646-.707.708L2.293 8zM12.293 8 9.647 5.354l.707-.708L13.707 8l-3.353 3.354-.707-.707z"
        }
      )
    }
  );
}
const oH = /* @__PURE__ */ i(eH);
function rH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.293 8 5.646 4.354l.708-.708L10.707 8l-4.353 4.354-.708-.708z"
        }
      )
    }
  );
}
const hH = /* @__PURE__ */ i(rH);
function aH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 6.707-3.646 3.647-.708-.708L8 5.293l4.354 4.353-.707.708z"
        }
      )
    }
  );
}
const cH = /* @__PURE__ */ i(aH);
function dH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 2.293 3.354 3.353-.707.708L8 3.707 5.354 6.354l-.708-.708zm2.647 7.353.707.708L8 13.707l-3.354-3.353.708-.708L8 12.293z"
        }
      )
    }
  );
}
const wH = /* @__PURE__ */ i(dH);
function vH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.964 2.964h4.743v1H3.964v3.743h-1zm9.072 9.072V8.293h1v4.743H8.293v-1z"
        }
      )
    }
  );
}
const mH = /* @__PURE__ */ i(vH);
function gH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 0 1 6 6z" })
    }
  );
}
const sH = /* @__PURE__ */ i(gH);
function fH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 1 1 0 12v-1a5 5 0 0 0 5-5"
        }
      )
    }
  );
}
const uH = /* @__PURE__ */ i(fH);
function pH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 1 1-6 6h1a5 5 0 0 0 10 0"
        }
      )
    }
  );
}
const HH = /* @__PURE__ */ i(pH);
function MH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 5V2h1v3zM5.525 6.232 3.404 4.111l.707-.707 2.121 2.121zm7.071-2.121-2.121 2.121-.707-.707 2.121-2.121zM5 8.5H2v-1h3zm9 0h-3v-1h3zm-7.768 1.975-2.121 2.121-.707-.707 2.121-2.121zm5.657 2.121L9.812 10.52l.707-.707 2.077 2.077zM7.5 14v-3h1v3z"
        }
      )
    }
  );
}
const xH = /* @__PURE__ */ i(MH);
function zH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.116 3 .268 1H9v1h2v2.58l2 .536V13h1v1H2v-1h1V7h2V4h.616l.268-1H6.5V1h1v2zM11 8.616V13h1V8.884zM9 6v7h1V6zM6 5v8h2V5zM4 8v5h1V8z"
        }
      )
    }
  );
}
const VH = /* @__PURE__ */ i(zH);
function CH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v11H2zm1 1v2h1.216l.536-2zm2.788 0-.536 2h1.964l.536-2zm3 0-.536 2h1.964l.536-2zm3 0-.536 2H13V3zM13 6H3v6h10z"
        }
      )
    }
  );
}
const LH = /* @__PURE__ */ i(CH);
function $H(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.348 2h5.304l-.268 1H13v11H3V3h2.616zm.536 2H4v9h8V4h-1.884l-.268 1H6.152zm3.464-1H6.652l.268 1h2.16zM11 8H5V7h6zm0 3H5v-1h6z"
        }
      )
    }
  );
}
const SH = /* @__PURE__ */ i($H);
function kH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m6.5-4h1v3.616l3.494.937-.259.965L7.5 8.385z"
        }
      )
    }
  );
}
const yH = /* @__PURE__ */ i(kH);
function bH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.293 8 2.646 3.354l.708-.708L8 7.293l4.647-4.647.707.708L8.707 8l4.647 4.647-.707.707L8 8.707l-4.646 4.647-.708-.707z"
        }
      )
    }
  );
}
const RH = /* @__PURE__ */ i(bH);
function BH(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.354 4.646 8 7.293l2.647-2.647.707.708L8.707 8l2.647 2.647-.708.707L8 8.707l-2.646 2.647-.708-.708L7.293 8 4.646 5.354z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1M2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8"
          }
        )
      ]
    }
  );
}
const FH = /* @__PURE__ */ i(BH);
function AH(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9 6a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v.5h-1V6h-1v3h1v-.5h1V9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zM6 5a1 1 0 0 1 1 1v.5H6V6H5v3h1v-.5h1V9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M1 2h14v11H1zm1 1v9h12V3z" })
      ]
    }
  );
}
const qH = /* @__PURE__ */ i(AH);
function OH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 3a2 2 0 1 1 3.491 1.334l-.019.02-.623.558L14 7.886V9h-3v6.239l-3-1.2-3 1.2V9H2V7.887l5.706-3.294 1.056-.945A1 1 0 1 0 7 3zm4 6H6v4.762l2-.8 2 .8zm2.197-1L8 5.577 3.805 8z"
        }
      )
    }
  );
}
const DH = /* @__PURE__ */ i(OH);
function PH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a3.5 3.5 0 0 0-3.5 3.5v.036l.005.428-.422.07A2.5 2.5 0 0 0 4.5 12h6.25a3.25 3.25 0 0 0 .877-6.38l-.247-.07-.088-.242A3.5 3.5 0 0 0 8 3M3.514 6.14a4.5 4.5 0 0 1 8.625-1.408A4.251 4.251 0 0 1 10.75 13H4.5a3.5 3.5 0 0 1-.986-6.86"
        }
      )
    }
  );
}
const TH = /* @__PURE__ */ i(PH);
function WH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-1.566-1.566A4.3 4.3 0 0 1 10.75 13H4.5a3.5 3.5 0 0 1-.986-6.86c.043-.54.18-1.052.397-1.522L1.646 2.354zM4.68 5.388c-.117.35-.18.723-.18 1.112v.036l.005.428-.422.07A2.5 2.5 0 0 0 4.5 12h6.25q.257 0 .504-.039zM15 8.75c0 .962-.32 1.85-.86 2.563l-.715-.716a3.252 3.252 0 0 0-1.797-4.977l-.248-.07-.088-.242A3.502 3.502 0 0 0 6.28 3.451l-.728-.727a4.5 4.5 0 0 1 6.587 2.009A4.25 4.25 0 0 1 15 8.75"
        }
      )
    }
  );
}
const GH = /* @__PURE__ */ i(WH);
function EH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.026 12.342 3-9 .948.316-3 9zm-1.38-7.696.708.708L2.707 8l2.647 2.646-.707.708L1.293 8zM13.294 8l-2.646-2.646.707-.708L14.707 8l-3.353 3.354-.707-.708z"
        }
      )
    }
  );
}
const NH = /* @__PURE__ */ i(EH);
function jH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.817 2.117a6 6 0 0 1 2.366 0l.372.074.125 1.633c.396.16.765.374 1.095.633l1.477-.707.25.284a6 6 0 0 1 1.185 2.05l.121.358-1.352.926c.06.42.06.845 0 1.264l1.352.926-.12.359a6 6 0 0 1-1.186 2.05l-.25.283-1.477-.707c-.33.259-.699.473-1.095.633l-.125 1.633-.372.074a6 6 0 0 1-2.366 0l-.372-.074-.125-1.633a4.5 4.5 0 0 1-1.095-.633l-1.477.707-.25-.284a6 6 0 0 1-1.185-2.05l-.121-.358 1.352-.926a4.5 4.5 0 0 1 0-1.264l-1.352-.926.12-.359a6 6 0 0 1 1.186-2.05l.25-.283 1.477.707c.33-.259.699-.473 1.095-.633l.125-1.633zm.566.92L7.266 4.56l-.322.102c-.49.155-.935.415-1.306.755l-.249.228-1.378-.66a5 5 0 0 0-.618 1.067l1.26.864-.071.329a3.5 3.5 0 0 0 0 1.51l.072.33-1.26.863c.161.382.37.74.617 1.067l1.378-.66.25.228c.37.34.815.6 1.305.755l.322.102.117 1.522a5 5 0 0 0 1.234 0l.117-1.522.322-.102c.49-.155.935-.415 1.306-.755l.249-.228 1.378.66q.374-.492.618-1.068l-1.26-.863.072-.329a3.5 3.5 0 0 0 0-1.51l-.073-.33 1.26-.863a5 5 0 0 0-.617-1.067l-1.378.66-.25-.228c-.37-.34-.815-.6-1.305-.755l-.322-.102-.117-1.522a5 5 0 0 0-1.234 0M8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      )
    }
  );
}
const UH = /* @__PURE__ */ i(jH);
function IH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-2.756-2.756-.116-.055c-.33.259-.698.473-1.095.633l-.125 1.633-.372.074a6 6 0 0 1-2.366 0l-.372-.074-.125-1.633a4.5 4.5 0 0 1-1.095-.633l-1.477.707-.25-.284a6 6 0 0 1-1.185-2.05l-.121-.358 1.352-.926a4.5 4.5 0 0 1 0-1.264l-1.352-.926.12-.359A6 6 0 0 1 3.42 4.126L1.646 2.354zM4.523 5.23l-.512-.245a5 5 0 0 0-.618 1.067l1.261.864-.072.329a3.5 3.5 0 0 0 0 1.51l.072.33-1.26.863c.161.382.37.74.617 1.067l1.378-.66.25.228c.37.34.815.6 1.305.755l.322.102.117 1.522a5 5 0 0 0 1.234 0l.117-1.522.322-.102a3.5 3.5 0 0 0 1.04-.535l-1.08-1.08a2 2 0 0 1-2.74-2.74zm2.51 2.511A1.001 1.001 0 0 0 8.26 8.966zm6.654 2.176q-.116.345-.272.67l-1.97-1.97a3.5 3.5 0 0 0-.027-1.372l-.072-.33 1.26-.863a5 5 0 0 0-.617-1.067l-1.378.66-.25-.228c-.37-.34-.815-.6-1.305-.755l-.322-.102-.117-1.522a5 5 0 0 0-1.234 0l-.108 1.408-.931-.93.101-1.325.372-.074a6 6 0 0 1 2.366 0l.372.074.125 1.633c.397.16.765.374 1.095.633l1.477-.707.25.284a6 6 0 0 1 1.185 2.05l.121.358-1.352.926c.06.42.06.845 0 1.264l1.352.926z"
        }
      )
    }
  );
}
const QH = /* @__PURE__ */ i(IH);
function KH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 3h1v2.293l2.646-2.647.707.708L10.707 6H13v1H9zM7 13H6v-2.293l-2.646 2.647-.708-.708L5.293 10H3V9h4z"
        }
      )
    }
  );
}
const JH = /* @__PURE__ */ i(KH);
function XH(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.773 4.455a1.318 1.318 0 1 1 0 2.636 1.318 1.318 0 0 1 0-2.636m-.319 1.318a.319.319 0 1 0 .637.036.319.319 0 0 0-.637-.036"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12 12H2V2h10zM5.8 8.828l2.85-1.645L11 8.54V3H3v4.211zm0 1.155L3 8.366V11h8V9.694L8.65 8.337z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 4v10H4v-1h9V4z" })
      ]
    }
  );
}
const YH = /* @__PURE__ */ i(XH);
function ZH(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 5v6H8.5v3h-1v-3H5V5h2.5V2h1v3zm-1 5V6H6v4z"
        }
      )
    }
  );
}
const _H = /* @__PURE__ */ i(ZH);
function nM(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m9.31 9.32-4.476 2.583-.732-.732L6.695 6.68l4.475-2.583.732.732zM7.166 7.864l-1.332 2.307 2.299-1.327zm1.672.271L10.17 5.83l-2.3 1.326z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1M2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8"
          }
        )
      ]
    }
  );
}
const lM = /* @__PURE__ */ i(nM);
function tM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h5v5H5v4h4V9h5v5H9v-2H4V7H2zm1 1v3h3V3zm7 7v3h3v-3z"
        }
      )
    }
  );
}
const iM = /* @__PURE__ */ i(tM);
function eM(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11 4.293V12H3V2h5.707zM10 11V5H8V3H4v8zm-.707-7L9 3.707V4z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6 14v-1h6V5h1v9z" })
      ]
    }
  );
}
const oM = /* @__PURE__ */ i(eM);
function rM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h10v10H2zm1 1v8h8V3zm10 10V4h1v10H4v-1z"
        }
      )
    }
  );
}
const hM = /* @__PURE__ */ i(rM);
function aM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 2h1v1h1V2h1v1h1V2h1v1H13v2.5h1v1h-1v1h1v1h-1v1h1v1h-1V13h-2.5v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1H3v-2.5H2v-1h1v-1H2v-1h1v-1H2v-1h1V3h2.5zM4 4v8h8V4zm2 2h4v4H6zm1 1v2h2V7z"
        }
      )
    }
  );
}
const cM = /* @__PURE__ */ i(aM);
function dM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 1.793 14.207 4.5l-5.804 5.804.374 1.398-6.926 1.856L.793 12.5zM7.845 9.448 12.793 4.5 11.5 3.207 6.552 8.155zm-2-.586L2.307 12.4l5.246-1.405-.156-.581z"
        }
      )
    }
  );
}
const wM = /* @__PURE__ */ i(dM);
function vM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 4V2h1v9h9v1h-2v2h-1v-2H4V5H2V4zm7 1H6V4h6v6h-1z"
        }
      )
    }
  );
}
const mM = /* @__PURE__ */ i(vM);
function gM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 2.02V1h1v1.02a6 6 0 0 1 5.48 5.48H15v1h-1.02a6 6 0 0 1-5.48 5.48V15h-1v-1.02A6 6 0 0 1 2.02 8.5H1v-1h1.02A6 6 0 0 1 7.5 2.02m0 1.005A5 5 0 0 0 3.025 7.5H4v1h-.975A5 5 0 0 0 7.5 12.975V12h1v.975A5 5 0 0 0 12.975 8.5H12v-1h.975A5 5 0 0 0 8.5 3.025V4h-1zM8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      )
    }
  );
}
const sM = /* @__PURE__ */ i(gM);
function fM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 4a2 2 0 1 1 3.26 1.553l1.598 1.598 2.157-.98a1 1 0 1 1 .871.822L12.276 13H3.724L2.115 6.993a1 1 0 1 1 .869-.822l2.156.98 1.6-1.598A2 2 0 0 1 6 4m2.545.838a1 1 0 1 0-1.09-1.677 1 1 0 0 0 1.09 1.677M3.257 7.393 4.49 12h7.019l1.235-4.607-2.101.956-2.368-2.368a2 2 0 0 1-.548 0L5.36 8.348z"
        }
      )
    }
  );
}
const uM = /* @__PURE__ */ i(fM);
function pM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.001 4.536v6.928l-6 3.464-6-3.464V4.536l6-3.464zm-6.5 3.752-4.5-2.598v5.197l4.5 2.598zm1 5.197 4.5-2.598V5.69l-4.5 2.598zm-.5-11.259-4.5 2.599 4.5 2.598 4.5-2.598z"
        }
      )
    }
  );
}
const HM = /* @__PURE__ */ i(pM);
function MM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 .923 3.75 2.165V6.84L15 8.717v4.33l-3.75 2.165L8 13.336l-3.25 1.876L1 13.047v-4.33L4.25 6.84V3.088zM4.75 7.706l-2.25 1.3 2.25 1.298L7 9.005zM7.5 9.871l-2.25 1.3v2.597L7.5 12.47zm1 2.598 2.25 1.3V11.17L8.5 9.871zM9 9.006l2.25 1.3 2.25-1.3-2.25-1.299zm1.75-2.165V4.242l-2.25 1.3v2.597zM7.5 8.14v-2.6L5.25 4.242V6.84zM5.75 3.375 8 4.676l2.25-1.3L8 2.077zM14 9.871l-2.25 1.3v2.597L14 12.47zm-9.75 3.897V11.17L2 9.871v2.598z"
        }
      )
    }
  );
}
const xM = /* @__PURE__ */ i(MM);
function zM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M11 2h1v5h-1zM5 9v5H4V9zm6.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 11.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
        }
      )
    }
  );
}
const VM = /* @__PURE__ */ i(zM);
function CM(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M10.5 7.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 14H2V7h1.116l.224-.837.966.259L4.151 7h.965l.224-.837.966.259L6.151 7h.965l.224-.837.966.259L8.151 7h1.073l.536-2H14zM3 13h1v-2h2v2h1.616l1.34-5H3zm10-7h-2.473l-1.875 7H13z"
          }
        )
      ]
    }
  );
}
const LM = /* @__PURE__ */ i(CM);
function $M(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.318 3.687C3.356 4.125 3 4.627 3 5c0 .374.356.875 1.318 1.313C5.234 6.729 6.536 7 8 7s2.766-.27 3.682-.687C12.644 5.875 13 5.373 13 5c0-.374-.356-.875-1.318-1.313C10.766 3.271 9.464 3 8 3s-2.766.27-3.682.687M13 6.698a5 5 0 0 1-.904.525C11.022 7.711 9.573 8 8 8s-3.022-.289-4.096-.777A5 5 0 0 1 3 6.698V8c0 .374.356.875 1.318 1.313C5.234 9.729 6.536 10 8 10s2.766-.27 3.682-.687C12.644 8.875 13 8.373 13 8zm0 3c-.271.202-.58.378-.904.525C11.022 10.71 9.573 11 8 11s-3.022-.289-4.096-.777A5 5 0 0 1 3 9.698V11c0 .374.356.875 1.318 1.313C5.234 12.729 6.536 13 8 13s2.766-.27 3.682-.687C12.644 11.875 13 11.373 13 11zM14 11c0 1.007-.875 1.755-1.904 2.223C11.022 13.71 9.573 14 8 14s-3.022-.289-4.096-.777C2.875 12.755 2 12.007 2 11V5c0-1.007.875-1.755 1.904-2.223C4.978 2.289 6.427 2 8 2s3.022.289 4.096.777C13.125 3.245 14 3.993 14 5z"
        }
      )
    }
  );
}
const SM = /* @__PURE__ */ i($M);
function kM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 5h3.08L14 8.434V10h-1.085a1.5 1.5 0 1 1-2.83 0h-4.17a1.5 1.5 0 1 1-2.83 0H2V4h8zM9 9V5H3v4zm-4.5 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m6.5.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0m2-1.934L12.313 6H10v3h3z"
        }
      )
    }
  );
}
const yM = /* @__PURE__ */ i(kM);
function bM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8a6 6 0 0 0 6 6v1A7 7 0 0 1 8 1v1a6 6 0 0 0-6 6m8-7a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-1 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m2-1a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const RM = /* @__PURE__ */ i(bM);
function BM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 .293 15.707 8 8 15.707.293 8zM1.707 8 8 14.293 14.293 8 8 1.707z"
        }
      )
    }
  );
}
const FM = /* @__PURE__ */ i(BM);
function AM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m13.268 10.44-.707-.708L14.293 8 8 1.707 6.268 3.44l-.707-.707L8 .292 15.706 8zM3.793 4.5.646 1.354l.708-.708 14 14-.708.708-3.146-3.147-3.5 3.5L.293 8zm.707.707L1.707 8 8 14.293l2.793-2.793z"
        }
      )
    }
  );
}
const qM = /* @__PURE__ */ i(AM);
function OM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.646 3.354-1-1 .708-.708 1 1zm4.755-1.462 1.099.549v1.118l-1.099.55L9.293 3zM6.646 3.146l1-1 .708.708-1 1zm2.5 1.708-1-1 .708-.708 1 1zm-2.5.5-1-1 .708-.708 1 1zm1.708 1-.708-.708 1-1 .708.708zM4.4 4.892l1.1.548v1.118l-1.099.55L3.293 6zm5.953 1.462-.708-.708 1-1 .708.708zm2.614-1.426L14 5.96v1.597l-1.987.497-1.085-1.086.51-1.53zm-.74 1.3-.156.47.248.248.68-.17v-.402l-.302-.302zm-4.374.418-.708.708-1-1 .708-.708zm-6.208 1 1-1 .708.708-1 1zm3 0 1-1 .708.708-1 1zm4.708 0-.708.708-1-1 .708-.708zM4.146 9.354l-1-1 .708-.708 1 1zm2.255-1.462L7.5 8.44v1.118l-1.099.55L5.293 9zm4.953.754-.707.708-1-1 .707-.708zm-9.708 1 1-1 .708.708-1 1zm7.208.707-.708-.707 1-1 .708.708zm2.793-.707 1-1 .707.708-1 1zm-8 1 1-1 .707.707-1 1zm6.754-.754 1.099.549v1.118l-1.099.55L9.293 11zm-2.755 1.962-1-1 .708-.708 1 1zm-1.678-.926L7 11.959v1.598l-1.987.497-1.085-1.086.51-1.53zm-.74 1.3-.156.47.248.248.68-.17v-.402l-.302-.302zm4.626-.082-.708.707-1-1 .708-.707zm-.5 1.5-.708.707-1-1 .708-.707z"
        }
      )
    }
  );
}
const DM = /* @__PURE__ */ i(OM);
function PM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v8H8.902l.268 1H11v1H5v-1h1.831l.268-1H2zm6 8.5-.133.5h.267zM3 4v6h10V4z"
        }
      )
    }
  );
}
const TM = /* @__PURE__ */ i(PM);
function WM(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 3H2v7H1V2h12z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M15 12H9.902l.268 1H12v1H6v-1h1.831l.269-1H3V4h12zm-5.866 1L9 12.5l-.133.5zM14 11V5H4v6z"
          }
        )
      ]
    }
  );
}
const GM = /* @__PURE__ */ i(WM);
function EM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 6H8.902l.268 1H8.134L8 6l-.134 1H6.83l.27-1H4.5V1h7zm-1-1V2h-5v3zm1 8H8.902l.268 1H10v1H6v-1h.831l.269-1H4.5V8h7zm-3.366 1L8 13.5l-.133.5zm2.366-2V9h-5v3z"
        }
      )
    }
  );
}
const NM = /* @__PURE__ */ i(EM);
function jM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 13 13-.707.708L10.293 11H8.902l.268 1H11v1H5v-1h1.831l.268-1H2V3h.293L.646 1.354zM3.293 4H3v6h6.293zM8 11.5l-.133.5h.267zm6-.5h-.172l-1-1H13V4H6.828l-1-1H14z"
        }
      )
    }
  );
}
const UM = /* @__PURE__ */ i(jM);
function IM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M15 5v5h-3.098l.268 1H13v1H9v-1h.831l.268-1H5.902l.268 1H7v1H3v-1h.831l.269-1H1V5zM7.5 6H2v3h5.5zm1 0v3H14V6zm-3.366 5L5 10.5l-.133.5zm6 0L11 10.5l-.133.5z"
        }
      )
    }
  );
}
const QM = /* @__PURE__ */ i(IM);
function KM(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9.646 3.354 8.5 2.207V7h-1V2.207L6.354 3.354l-.708-.708L8 .293l2.354 2.353z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5 5H3v6h10V5h-2V4h3v8H8.902l.268 1H11v1H5v-1h1.831l.269-1H2V4h3zm3.134 8L8 12.5l-.134.5z"
          }
        )
      ]
    }
  );
}
const JM = /* @__PURE__ */ i(KM);
function XM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 3.5h1.134l.116.067C3.215 4.123 5.407 5 8 5s4.785-.877 5.75-1.433l.116-.067H15v9h-1.134l-.116-.067C12.785 11.877 10.593 11 8 11s-4.785.877-5.75 1.433l-.116.067H1zm1 1.07v6.86C3.176 10.81 5.401 10 8 10s4.824.81 6 1.43V4.57C12.824 5.19 10.599 6 8 6s-4.824-.81-6-1.43"
        }
      )
    }
  );
}
const YM = /* @__PURE__ */ i(XM);
function ZM(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12.5 8.5h-9v-1h9zM8 4.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M6.5 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M8 10.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
        }
      )
    }
  );
}
const _M = /* @__PURE__ */ i(ZM);
function nx(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 5.293V14H3V2h6.707zM12 13V6H9V3H4v10zm-.707-8L10 3.707V5z"
        }
      )
    }
  );
}
const lx = /* @__PURE__ */ i(nx);
function tx(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 2h6.707L13 5.293V8h-1V6H9V3H4v10h3v1H3zm7 3h1.293L10 3.707z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m8.146 11.854.708-.707 1.646 1.646 4.147-4.147.707.708-4.854 4.853z"
          }
        )
      ]
    }
  );
}
const ix = /* @__PURE__ */ i(tx);
function ex(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 5.293V7h-1V6H9V3H4v10h3v1H3V2h6.707zM11.293 5 10 3.707V5z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11 11V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z"
          }
        )
      ]
    }
  );
}
const ox = /* @__PURE__ */ i(ex);
function rx(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7.5 6.5a2 2 0 0 1 1.723 3.016l1.63 1.63-.707.707-1.63-1.63A2 2 0 1 1 7.5 6.5m-1 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 5.293V14H3V2h6.707zM12 13V6H9V3H4v10zm-.707-8L10 3.707V5z"
          }
        )
      ]
    }
  );
}
const hx = /* @__PURE__ */ i(rx);
function ax(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m9.7 4.4-1.2-.9v8.916l2.674-2.3.652.758L8 14.164l-3.826-3.289.652-.758L7.5 12.415V3.5l-1.2.9-.6-.8L8 1.875 10.3 3.6z"
        }
      )
    }
  );
}
const cx = /* @__PURE__ */ i(ax);
function dx(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m11.646 6.646.708.708L8 11.707 3.646 7.354l.708-.708L7.5 9.793V2h1v7.793z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.813 10.87.57 2.13h9.233l.57-2.13.967.26-.77 2.87H2.617l-.769-2.87z"
          }
        )
      ]
    }
  );
}
const wx = /* @__PURE__ */ i(dx);
function vx(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 4h14v5h-1V5H2v3h4.654v1H1zm3 3H3V6h1zm4.615 8C7.242 15 6 13.95 6 12.5a2.5 2.5 0 0 1 .74-1.742 2.3 2.3 0 0 1 .758-.504c.108-.51.38-.96.72-1.305A3.25 3.25 0 0 1 10.5 8c.767 0 1.527.309 2.076.76.302.248.615.609.787 1.052.367.139.678.372.911.626.434.47.726 1.13.726 1.812 0 1.587-1.363 2.75-2.885 2.75zm4.64-4.128a1.07 1.07 0 0 0-.783-.174.97.97 0 0 0-.128-.703C12.024 9.437 11.234 9 10.5 9c-.815 0-1.598.476-1.91 1.127-.146.306-.188.65-.081 1.002a1.12 1.12 0 0 0-.969.251A1.5 1.5 0 0 0 7 12.5c0 .828.723 1.5 1.615 1.5h3.5C13.156 14 14 13.216 14 12.25c0-.53-.307-1.092-.746-1.378"
        }
      )
    }
  );
}
const mx = /* @__PURE__ */ i(vx);
function gx(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 13 13-.708.707-.861-.861a3 3 0 0 1-1.67.508h-3.5C7.242 15 6 13.95 6 12.5a2.5 2.5 0 0 1 .74-1.742c.207-.206.464-.385.758-.504.112-.5.366-.958.732-1.317L4.293 5H2v3h4.654v1H1V4h2.293L1.646 2.354zm6.583 7.998a1.8 1.8 0 0 0-.346.483 1.36 1.36 0 0 0-.082 1.002 1.12 1.12 0 0 0-.969.251A1.5 1.5 0 0 0 7 12.5c0 .828.723 1.5 1.615 1.5h3.5c.344 0 .666-.085.943-.235z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14.274 10.438c.417.451.703 1.08.725 1.732l-4.15-4.15a3.4 3.4 0 0 1 1.727.74c.302.248.615.609.787 1.052.367.139.678.372.911.626M14 5H7.828l-1-1H15v5h-1zM4 7H3V6h1z"
          }
        )
      ]
    }
  );
}
const sx = /* @__PURE__ */ i(gx);
function fx(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 4h14v5H8.5v3H10v1h4v1h-4v1H6v-1H2v-1h4v-1h1.5V9H1zm6 10h2v-1H7zM2 5v3h12V5zm2 2H3V6h1z"
        }
      )
    }
  );
}
const ux = /* @__PURE__ */ i(fx);
function px(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4 7H3V6h1z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 13 13-.708.707L13.293 14H10v1H6v-1H2v-1h4v-1h1.5V9H1V4h2.293L1.646 2.354zM4.293 5H2v3h5.293zM8.5 9.207V12H10v1h2.293zM7 14h2v-1H7zm4.828-5-1-1H14V5H7.828l-1-1H15v5z"
          }
        )
      ]
    }
  );
}
const Hx = /* @__PURE__ */ i(px);
function Mx(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 5h14v5H1zm1 1v3h12V6zm2 2H3V7h1zm9 0H6V7h7z"
        }
      )
    }
  );
}
const xx = /* @__PURE__ */ i(Mx);
function zx(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4 8H3V7h1z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 12 12-.708.708L9.293 10H1V5h3.293L1.646 2.354zM5.293 6H2v3h6.293l-1-1H6V7h.293zm7.535 4-1-1H14V6H8.828l-1-1H15v5z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 8h-2.172l-1-1H13z" })
      ]
    }
  );
}
const Vx = /* @__PURE__ */ i(zx);
function Cx(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 5h1v8.214l-3 .804-3-.804V5h1V2h4zM9 5V3H7v2zm-1 7.982 2-.536V6H6v6.446z"
        }
      )
    }
  );
}
const Lx = /* @__PURE__ */ i(Cx);
function $x(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708L11 11.707v1.507l-3 .804-3-.804V5.707L1.646 2.354zM6 6.707v5.74l2 .535 2-.535v-1.74zm5 1.465-1-1V6H8.828l-1-1H9V3H7v1.172l-1-1V2h4v3h1z"
        }
      )
    }
  );
}
const Sx = /* @__PURE__ */ i($x);
function kx(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.646 4.646 2-2 .708.708-2 2zm8.708-2 2 2-.707.708-2-2zM4.646 13.354l-2-2 .708-.708 2 2zm8.708-2-2 2-.708-.708 2-2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M1 4a3 3 0 1 1 5.904.755L7.587 5h.826l.683-.245A3.004 3.004 0 0 1 12 1a3 3 0 1 1-.796 5.893 3.1 3.1 0 0 0 0 2.214A3.003 3.003 0 0 1 15 12a3 3 0 1 1-5.893-.796 3.1 3.1 0 0 0-2.214 0A3.003 3.003 0 0 1 4 15a3 3 0 1 1 .796-5.893 3.1 3.1 0 0 0 0-2.214A3.003 3.003 0 0 1 1 4m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m1.704 4.47a4.1 4.1 0 0 1 0 3.06c.299.207.559.467.766.766a4.1 4.1 0 0 1 3.06 0 3 3 0 0 1 .766-.766 4.1 4.1 0 0 1 0-3.06 3 3 0 0 1-.789-.8L9 5.851V6.5a1 1 0 0 1-2 0v-.648l-.507-.183c-.21.314-.479.586-.79.8M12 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-8 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0-.001 4A2 2 0 0 0 12 10"
          }
        )
      ]
    }
  );
}
const yx = /* @__PURE__ */ i(kx);
function bx(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 3V2h1v12H7v-1H2V3zm0 1H3v5.293l4-4zm0 2.707-4 4V12h4zM13 4H9V3h5v10H9v-1h4v-1.306l-2.35-1.357-1.4.809-.5-.866 1.9-1.097L13 9.539zM9.318 6.318A.32.32 0 0 0 9 6V5a1.318 1.318 0 0 1 0 2.636v-1a.32.32 0 0 0 .318-.318"
        }
      )
    }
  );
}
const Rx = /* @__PURE__ */ i(bx);
function Bx(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 1h1v1H10v1h4v8h-2v1h-1.653l.636 2.37-.966.26L9.312 12H6.687l-.704 2.63-.966-.26.635-2.37H4v-1H2V3h4V2h1.5zM3 4v6h10V4z"
        }
      )
    }
  );
}
const Fx = /* @__PURE__ */ i(Bx);
function Ax(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2.753 13.623 9H2.377zM4.623 8h6.754L8 4.247zM2.5 12v-1h11v1z"
        }
      )
    }
  );
}
const qx = /* @__PURE__ */ i(Ax);
function Ox(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.32 3.828A3.44 3.44 0 0 1 13.954 7H15v1h-1.373q-.182.36-.455.68l-.012.014L8 13.866 2.84 8.694l-.012-.014A3.4 3.4 0 0 1 2.373 8H1V7h1.046A3.44 3.44 0 0 1 7.68 3.828l.012.01.308.303.308-.302zM3.563 8l.012.014L8 12.45l4.425-4.435.012-.015H12V7h.935a2.44 2.44 0 0 0-3.951-2.424L8 5.542l-.984-.966A2.44 2.44 0 0 0 3.065 7h1.728l1.966-1.966.902 3.368L8.756 7H11v1H9.244l-2.03 2.598-.973-3.632L5.207 8z"
        }
      )
    }
  );
}
const Dx = /* @__PURE__ */ i(Ox);
function Px(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m4 7.707-.646.647-.708-.707L4.5 5.793l1.854 1.854-.708.707L5 7.707V10H4zm6.354-.061.646.647V6h1v2.293l.646-.647.708.707-1.854 1.854-1.854-1.854z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M15 15H1V1h14zm-7.5-1V2H2v12zm1 0H14V2H8.5z"
          }
        )
      ]
    }
  );
}
const Tx = /* @__PURE__ */ i(Px);
function Wx(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a5.97 5.97 0 0 0-3 .803l-.5-.866A6.97 6.97 0 0 1 8 1a6.97 6.97 0 0 1 3.501.937l-.5.866A5.97 5.97 0 0 0 8 2m0 2a4 4 0 0 0-2 .535l-.5-.866a5 5 0 0 1 5 .001l-.5.865A4 4 0 0 0 8 4M2.803 5A5.97 5.97 0 0 0 2 8a5.97 5.97 0 0 0 .803 3l-.866.5A6.97 6.97 0 0 1 1 8c0-1.274.341-2.47.937-3.501zM14 8a5.97 5.97 0 0 0-.803-3l.866-.501A6.97 6.97 0 0 1 15 8a6.97 6.97 0 0 1-.937 3.501l-.866-.5A5.97 5.97 0 0 0 14 8M4.535 6a4 4 0 0 0 0 4l-.866.5a5 5 0 0 1 .001-5zM12 8a4 4 0 0 0-.535-2l.866-.5a5 5 0 0 1-.001 5l-.865-.5A4 4 0 0 0 12 8M8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 3.465a4 4 0 0 0 4 0l.5.866a5 5 0 0 1-5-.001zm-1 1.732A5.97 5.97 0 0 0 8 14a5.97 5.97 0 0 0 3-.803l.501.866A6.97 6.97 0 0 1 8 15a6.97 6.97 0 0 1-3.501-.937z"
        }
      )
    }
  );
}
const Gx = /* @__PURE__ */ i(Wx);
function Ex(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 4H7V3h3v1H9v1h2.707L13 6.293V7h1v3.05l-1-.033v.69L11.707 12H7.293l-1-1h-1L4 9.707V8.508l-1 .017v1.008H2V6.5h1v1.024l1-.016V6.293L5.293 5H8zM5.707 6 5 6.707v2.586l.707.707h1l1 1h3.586l.707-.707V6.707L11.293 6z"
        }
      )
    }
  );
}
const Nx = /* @__PURE__ */ i(Ex);
function jx(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6 2h8v12H6v-2h1v1h6V3H7v1H6z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m8.354 10.854-.708-.708L9.293 8.5H1v-1h8.293L7.646 5.854l.708-.708L11.207 8z"
          }
        )
      ]
    }
  );
}
const Ux = /* @__PURE__ */ i(jx);
function Ix(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v10H2zm1 1v1.226l5 3.181 5-3.181V4zm10 2.41L8 9.594 3 6.41V12h10z"
        }
      )
    }
  );
}
const Qx = /* @__PURE__ */ i(Ix);
function Kx(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 13 13-.708.708L12.293 13H2V3h.293L.646 1.354zM3.293 4H3v1.226l4.176 2.657zM8.54 9.248 8 9.593 3 6.41V12h8.293zM14 11.172l-1-1V6.41l-2.298 1.462-.725-.724L13 5.226V4H6.828l-1-1H14z"
        }
      )
    }
  );
}
const Jx = /* @__PURE__ */ i(Kx);
function Xx(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M12.5 6.5h-9v-1h9zm0 4h-9v-1h9z" })
    }
  );
}
const Yx = /* @__PURE__ */ i(Xx);
function Zx(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 4H6V3h4zm0 2H6V5h4zm0 2H6V7h4zm5 0h-4V7h4zM5 10H1V9h4zm5 0H6V9h4zm5 0h-4V9h4zM5 12H1v-1h4zm5 0H6v-1h4zm5 0h-4v-1h4zM5 14H1v-1h4zm5 0H6v-1h4zm5 0h-4v-1h4z"
        }
      )
    }
  );
}
const _x = /* @__PURE__ */ i(Zx);
function nz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 2.293 14.207 6.5l-6.5 6.5H5.293l-3-3zM3.707 10l2 2h1.586l2.5-2.5L7 6.707zm4-4L10.5 8.793 12.793 6.5 10 3.707zM14 13h-4v-1h4z"
        }
      )
    }
  );
}
const lz = /* @__PURE__ */ i(nz);
function tz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ a("g", { fill: "currentColor", children: [
        /* @__PURE__ */ l("path", { d: "M8.5 5.5V9h-1V5.5zm0 4.5v1h-1v-1z" }),
        /* @__PURE__ */ l("path", { d: "M8 15.707.293 8 8 .293 15.707 8zM14.293 8 8 1.707 1.707 8 8 14.293z" })
      ] })
    }
  );
}
const iz = /* @__PURE__ */ i(tz);
function ez(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4 2.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M5.5 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m.707 2.5L7 5.293V7H6V5.707L5.793 5.5h-.586L5 5.707V9H4V5.293l.793-.793z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M15 8h-2.793l-7 7H1v-4h2.793l7-7H15zM2 12v2h2.793l7-7H14V5h-2.793l-7 7z"
          }
        )
      ]
    }
  );
}
const oz = /* @__PURE__ */ i(ez);
function rz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v12H2zm1 1v10h10V3zm2.5 2h5v1h1v5h-7V6h1zm0 2v3h1V8h1v2h1V8h1v2h1V7h-1V6h-3v1z"
        }
      )
    }
  );
}
const hz = /* @__PURE__ */ i(rz);
function az(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M10 4H9V3H3v10h6v-1h1v2H2V2h8z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m11.647 5.854.707-.708L15.207 8l-2.853 2.854-.707-.708L13.293 8.5H5v-1h8.293z"
          }
        )
      ]
    }
  );
}
const cz = /* @__PURE__ */ i(az);
function dz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 7h-1V4.707L9.354 7.354l-.707-.708L11.293 4H9V3h4zM3 9h1v2.293l2.646-2.647.708.708L4.707 12H7v1H3z"
        }
      )
    }
  );
}
const wz = /* @__PURE__ */ i(dz);
function vz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.685 5.223 12 5.982v1.482l3-1.731v6.35l-5.5 3.175v-3.214L8 12.91l-1.5-.866v3.214L1 12.082v-6.35l3 1.732V5.983l1.315-.76L2.5 3.598 8 .423l5.5 3.175zM8 7.715l2.5-1.445-.815-.47L8 6.773l-1.685-.972-.815.47zm-3-.578v.904l1.5.866v1.983l1 .577V8.58zm3.5 4.33 1-.578V8.908l1.5-.866v-.904L8.5 8.58zm3-7.87L8 1.576 4.5 3.599 8 5.619zm-6 5.887L2 7.464v4.042l3.5 2.02zm5 4.042 3.5-2.021v-4.04l-3.5 2.02z"
        }
      )
    }
  );
}
const mz = /* @__PURE__ */ i(vz);
function gz(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8.5 9h-1V2h1zM3 5h2v1H4v6h8V6h-1V5h2v8H3z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m8 1.293 2.354 2.353-.708.708L8 2.707 6.354 4.354l-.708-.708z"
          }
        )
      ]
    }
  );
}
const sz = /* @__PURE__ */ i(gz);
function fz(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10.384 3H13v11H3v-2h1v1h8V4h-1.884l-.268 1H6.152l-.268-1H4v3H3V3h2.616l-.268-1h5.304zM9.08 4l.268-1H6.652l.268 1z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7.293 9 5.646 7.354l.708-.708L9.208 9.5l-2.854 2.854-.708-.708L7.293 10H2V9z"
          }
        )
      ]
    }
  );
}
const uz = /* @__PURE__ */ i(fz);
function pz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.103 8c.34.44 1.028 1.104 1.96 1.705C5.177 10.424 6.567 11 8 11s2.822-.576 3.938-1.295c.931-.6 1.62-1.265 1.96-1.705-.34-.44-1.028-1.104-1.96-1.705C10.822 5.576 9.432 5 8 5s-2.822.576-3.938 1.295c-.931.6-1.62 1.265-1.96 1.705M3.52 5.455C4.733 4.674 6.31 4 8 4s3.267.674 4.48 1.455c1.2.773 2.117 1.701 2.455 2.299l.14.246-.14.246c-.338.598-1.256 1.526-2.456 2.3C11.267 11.325 9.69 12 8 12s-3.267-.674-4.48-1.455c-1.2-.773-2.117-1.701-2.455-2.299L.925 8l.14-.246c.338-.598 1.256-1.526 2.456-2.3M8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      )
    }
  );
}
const Hz = /* @__PURE__ */ i(pz);
function Mz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12.146 3.854a.914.914 0 0 0-1.293 0L9.708 5 11 6.293l1.146-1.147a.914.914 0 0 0 0-1.292M10.043 6.75l-.793-.793-4.84 4.84-.792 1.585 1.586-.793zM7.646 4.354l.708-.708.646.647 1.147-1.147a1.914 1.914 0 0 1 2.707 2.708L11.708 7l.645.646-.707.708-.896-.897-4.954 4.954-2.394 1.198-1.01-1.01 1.197-2.395L8.543 5.25z"
        }
      )
    }
  );
}
const xz = /* @__PURE__ */ i(Mz);
function zz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.707-2.907-2.907C9.894 11.78 8.965 12 8 12c-1.69 0-3.267-.674-4.48-1.455-1.2-.773-2.117-1.701-2.455-2.299L.925 8l.14-.246c.338-.598 1.256-1.526 2.456-2.3.243-.156.502-.31.773-.453L1.646 2.354zm2.684 4.099q-.516.252-.976.55c-.931.6-1.62 1.265-1.96 1.705.34.44 1.029 1.104 1.96 1.705C5.178 10.424 6.568 11 8 11c.67 0 1.33-.126 1.959-.334l-.943-.943a2 2 0 0 1-2.74-2.74zM7.034 7.74a1 1 0 0 0 1.225 1.225zm7.901.506c-.286.506-.988 1.25-1.925 1.935l-.717-.716c.752-.532 1.31-1.083 1.604-1.465-.34-.44-1.027-1.104-1.96-1.705C10.823 5.576 9.433 5 8 5q-.085 0-.169.003l-.913-.914A7 7 0 0 1 8 4c1.69 0 3.267.674 4.48 1.455 1.2.773 2.117 1.701 2.455 2.299l.14.246z"
        }
      )
    }
  );
}
const Vz = /* @__PURE__ */ i(zz);
function Cz(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 10V9h1v1zm1 1v1H3v-1zm1-1V9h1v1zm1 1v1H5v-1zm5 1H9v-1h2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 7h2v7H1V7h1.384l.536-2H5v2h.384l.536-2H8v2h2V2h3zm-1-4h-1v1h1zm0 2h-1v2h1zM3.152 8H2v5h5V9h6v4h1V8H7V6h-.312l-.536 2H4V6h-.313zM8 10v3h4v-3z"
          }
        )
      ]
    }
  );
}
const Lz = /* @__PURE__ */ i(Cz);
function $z(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 1h1v4h2v3H5v2H4V8H2V5h2zm7 2V1h1v2h2v3h-2v4h-1V6H9V3zm-1 1v1h3V4zM3 6v1h3V6zm1.5 7a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m8.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
        }
      )
    }
  );
}
const Sz = /* @__PURE__ */ i($z);
function kz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 2h2.5A2.5 2.5 0 0 1 10 4.5c0 .367-.074.749-.188 1.12a6 6 0 0 1 .255-.16c.43-.254.929-.46 1.433-.46H14v2.5a2.5 2.5 0 0 1-2.5 2.5c-.367 0-.749-.074-1.12-.188q.084.126.16.255c.254.43.46.929.46 1.433V14H8.5A2.5 2.5 0 0 1 6 11.5c0-.367.074-.749.188-1.12q-.126.084-.255.16c-.43.254-.929.46-1.433.46H2V8.5A2.5 2.5 0 0 1 4.5 6c.367 0 .749.074 1.12.188a6 6 0 0 1-.16-.255C5.206 5.503 5 5.004 5 4.5zm1 1v1.5c0 .246.106.56.322.926.21.358.498.72.798 1.05.28.31.563.58.784.78.12-.186.264-.42.407-.683C8.681 5.895 9 5.116 9 4.5A1.5 1.5 0 0 0 7.5 3zm1.256 5.096a11 11 0 0 0-.683-.407C5.895 7.32 5.116 7 4.5 7A1.5 1.5 0 0 0 3 8.5V10h1.5c.246 0 .56-.106.926-.322.358-.21.72-.498 1.05-.798.31-.281.58-.564.78-.784m.84.648c-.12.186-.264.42-.407.683C7.319 10.105 7 10.884 7 11.5A1.5 1.5 0 0 0 8.5 13H10v-1.5c0-.246-.106-.56-.322-.926a6.6 6.6 0 0 0-.798-1.05c-.28-.31-.563-.58-.784-.78m.648-.84a11 11 0 0 0 .683.407C10.104 8.68 10.884 9 11.5 9A1.5 1.5 0 0 0 13 7.5V6h-1.5c-.246 0-.56.106-.926.322a6.6 6.6 0 0 0-1.05.798c-.31.281-.58.564-.78.784"
        }
      )
    }
  );
}
const yz = /* @__PURE__ */ i(kz);
function bz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.5 3h2a2 2 0 0 1 2 2c0 .213-.058.433-.14.64.207-.082.427-.14.64-.14h2v2a2 2 0 0 1-2 2c-.213 0-.433-.058-.64-.14.082.207.14.427.14.64v2h-2a2 2 0 0 1-2-2c0-.213.058-.433.14-.64-.207.082-.427.14-.64.14H1v-2a2 2 0 0 1 2-2c.213 0 .433.058.64.14A1.8 1.8 0 0 1 3.5 5zm2 3.722c.106-.134.225-.288.344-.453.18-.25.352-.515.477-.758.133-.258.179-.429.179-.511a1 1 0 0 0-1-1h-1v1c0 .082.046.253.179.511.125.243.297.507.477.758.119.165.238.32.344.453m-.344 2.009c-.18.251-.352.515-.477.758-.133.258-.179.429-.179.511a1 1 0 0 0 1 1h1v-1c0-.082-.046-.253-.179-.511a6 6 0 0 0-.477-.758 13 13 0 0 0-.344-.453c-.106.134-.225.288-.344.454M4.722 7.5q-.224-.177-.453-.344a6 6 0 0 0-.758-.477C3.253 6.546 3.082 6.5 3 6.5a1 1 0 0 0-1 1v1h1c.082 0 .253-.046.511-.179.243-.125.507-.297.758-.477.165-.119.32-.238.453-.344m2.009.344a6 6 0 0 0 .758.477c.258.133.429.179.511.179a1 1 0 0 0 1-1v-1H8c-.082 0-.253.046-.511.179a6 6 0 0 0-.758.477c-.165.119-.319.238-.453.344.134.106.288.225.454.344M14 3v8h-1V3zm-2 2v4h-1V5z"
        }
      )
    }
  );
}
const Rz = /* @__PURE__ */ i(bz);
function Bz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 3h2a2 2 0 0 1 2 2c0 .213-.058.433-.14.64.207-.082.427-.14.64-.14h2v2a2 2 0 0 1-2 2c-.213 0-.433-.058-.64-.14.082.207.14.427.14.64v2h-2a2 2 0 0 1-2-2c0-.213.058-.433.14-.64-.207.082-.427.14-.64.14H2v-2a2 2 0 0 1 2-2c.213 0 .433.058.64.14A1.8 1.8 0 0 1 4.5 5zm2 3.722c.106-.134.225-.288.344-.453.18-.25.352-.515.477-.758.133-.258.179-.429.179-.511a1 1 0 0 0-1-1h-1v1c0 .082.046.253.179.511.125.243.297.507.477.758.119.165.238.32.344.453m-.344 2.009c-.18.251-.352.515-.477.758-.133.258-.179.429-.179.511a1 1 0 0 0 1 1h1v-1c0-.082-.046-.253-.179-.511a6 6 0 0 0-.477-.758 13 13 0 0 0-.344-.453c-.106.134-.225.288-.344.454M5.722 7.5q-.224-.177-.453-.344a6 6 0 0 0-.758-.477C4.253 6.546 4.082 6.5 4 6.5a1 1 0 0 0-1 1v1h1c.082 0 .253-.046.511-.179.243-.125.507-.297.758-.477.165-.119.32-.238.453-.344m2.009.344a6 6 0 0 0 .758.477c.258.133.429.179.511.179a1 1 0 0 0 1-1v-1H9c-.082 0-.253.046-.511.179a6 6 0 0 0-.758.477c-.165.119-.319.238-.453.344.134.106.288.225.454.344M12 9V5h1v4z"
        }
      )
    }
  );
}
const Fz = /* @__PURE__ */ i(Bz);
function Az(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M10.5 8.5h-2v-2h2z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7 4.5v1.258l2-.625V4.5h1v.633l3.108.972.892 3.33V14H2V4.5a2.5 2.5 0 0 1 5 0M5.915 4a1.5 1.5 0 0 0-2.83 0zM3 5v8h2V9.435l.892-3.33L6 6.071V5zm10 8V9.566l-.716-2.67L9.5 6.023l-2.784.871L6 9.565V13h1V9h5v4zm-4.207-1.5L8 10.707v1.586zm.707.707L8.707 13h1.586zm1.5-1.5-.793.793.793.793zM8.707 10l.793.793.793-.793z"
          }
        )
      ]
    }
  );
}
const qz = /* @__PURE__ */ i(Az);
function Oz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3.63 15.492 8 8 12.37v-3.5l-6 3.5V3.63l6 3.49zm1 7L13.508 8 9 5.37zM7.515 7.996 3 5.369v5.26z"
        }
      )
    }
  );
}
const Dz = /* @__PURE__ */ i(Oz);
function Pz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3.63v3.49l6-3.49v8.74l-6-3.5v3.5L.508 8zM7 5.37 2.492 8 7 10.63zm1.485 2.626L13 10.629V5.37z"
        }
      )
    }
  );
}
const Tz = /* @__PURE__ */ i(Pz);
function Wz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v10H7.71l-2.467 2.467L4.582 12H2zm1 1v8h2.35l.41 1.536L7.297 11H13V3zm4.5 4.5v-3h1v3zm0 2v-1h1v1z"
        }
      )
    }
  );
}
const Gz = /* @__PURE__ */ i(Wz);
function Ez(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-1 5a4 4 0 0 1-2.83-1.172l.707-.707a3 3 0 0 0 4.244 0l.707.707A4 4 0 0 1 8 11"
        }
      )
    }
  );
}
const Nz = /* @__PURE__ */ i(Ez);
function jz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m2 3v1H5V9z"
        }
      )
    }
  );
}
const Uz = /* @__PURE__ */ i(jz);
function Iz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-1 4c-.829 0-1.578.335-2.122.879l-.707-.707a4 4 0 0 1 5.657 0l-.707.707A3 3 0 0 0 8 10"
        }
      )
    }
  );
}
const Qz = /* @__PURE__ */ i(Iz);
function Kz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m3-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M3.959 8h8.082l-.082.57a4 4 0 0 1-7.919 0zM5.17 9a3.002 3.002 0 0 0 5.66 0z"
        }
      )
    }
  );
}
const Jz = /* @__PURE__ */ i(Kz);
function Xz(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m5.095-1.276-1.931.518-.26-.966 1.933-.518zm3.742.518-1.932-.518.259-.966 1.931.518zM8 9a2 2 0 0 0-2 2H5a3 3 0 0 1 6 0h-1a2 2 0 0 0-2-2"
        }
      )
    }
  );
}
const Yz = /* @__PURE__ */ i(Xz);
function Zz(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-.5 1.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0m3.77 5.45a1.5 1.5 0 1 1-2.427 1.763 1.5 1.5 0 0 1 2.428-1.763m-.919 1.286a.5.5 0 1 0-.588-.809.5.5 0 0 0 .588.809m2.404-4.781a1.5 1.5 0 1 1-2.854.927 1.5 1.5 0 0 1 2.854-.927m-1.582-.012a.5.5 0 1 0 .31.951.5.5 0 0 0-.31-.951m-4.018 5.27A1.5 1.5 0 1 1 4.73 9.95a1.5 1.5 0 0 1 2.427 1.763m-1.507-.477a.5.5 0 1 0 .587-.809.5.5 0 1 0-.587.81M3.245 6.455a1.5 1.5 0 1 1 2.843.958 1.5 1.5 0 0 1-2.843-.958m1.271.939a.5.5 0 1 0-.29-.248.5.5 0 0 0 .291.249"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2"
          }
        )
      ]
    }
  );
}
const _z = /* @__PURE__ */ i(Zz);
function nV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 1h12v13H2zm1 1v1h1V2zm2 0v5h6V2zm7 0v1h1V2zm1 2h-1v1h1zm0 2h-1v1h1zm0 2h-1v1h1zm0 2h-1v1h1zm0 2h-1v1h1zm-2 1V8H5v5zm-7 0v-1H3v1zm-1-2h1v-1H3zm0-2h1V8H3zm0-2h1V6H3zm0-2h1V4H3z"
        }
      )
    }
  );
}
const lV = /* @__PURE__ */ i(nV);
function tV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 1h12v6h-1V6h-1v1h-1V2H5v5h4v1H5v5h2v1H2zm2 12v-1H3v1zm-1-2h1v-1H3zm0-2h1V8H3zm0-2h1V6H3zm0-2h1V4H3zm0-2h1V2H3zm9-1v1h1V2zm1 2h-1v1h1zm-2 7V8.5h1V11h2.5v1H12v2.5h-1V12H8.5v-1z"
        }
      )
    }
  );
}
const iV = /* @__PURE__ */ i(tV);
function eV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h10v9H2zm8 8h1v-1h-1zm0-2h1V8h-1zM5 8v3h4V8zm5-1h1V6h-1zm0-2h1V4h-1zM5 4v3h4V4zM4 4H3v1h1zm0 2H3v1h1zm0 2H3v1h1zm0 2H3v1h1zm9-5h1v9H4v-1h9z"
        }
      )
    }
  );
}
const oV = /* @__PURE__ */ i(eV);
function rV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 6H3V5h10zm-2 3H5V8h6zm-2 3H7v-1h2z" })
    }
  );
}
const hV = /* @__PURE__ */ i(rV);
function aV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.502 3a5.5 5.5 0 0 0-4.764 2.75l-.866-.5a6.502 6.502 0 1 1 10.972 6.961l-.82-.57c.618-.89.98-1.972.98-3.139A5.5 5.5 0 0 0 7.503 3M3.001 8.502a4.502 4.502 0 1 1 9.003 0A9.46 9.46 0 0 1 10.254 14l-.816-.579a8.46 8.46 0 0 0 1.566-4.919 3.502 3.502 0 0 0-7.003 0 1.5 1.5 0 0 1-1.5 1.5H2v-1h.5a.5.5 0 0 0 .5-.5m4.501-1.5a1.5 1.5 0 0 0-1.5 1.5c0 1.7-1.211 3.116-2.817 3.435l-.195-.981a2.5 2.5 0 0 0 2.012-2.454 2.5 2.5 0 1 1 5.001 0 7.49 7.49 0 0 1-2.733 5.793l-.636-.772a6.49 6.49 0 0 0 2.37-5.02 1.5 1.5 0 0 0-1.502-1.501m.5 1.5a5.5 5.5 0 0 1-3.097 4.95l-.437-.899a4.5 4.5 0 0 0 2.534-4.05z"
        }
      )
    }
  );
}
const cV = /* @__PURE__ */ i(aV);
function dV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m7 1.654.74.408C9.1 2.81 9.75 3.83 9.75 4.89c0 1.033-.619 1.956-1.473 2.525-.666.444-.777.808-.777 1.021 0 .249.147.503.353.71.135.134.371.228.647.228s.511-.094.646-.229c.32-.319.349-.596.401-1.097l.018-.167c.033-.298.087-.65.246-1.035.16-.387.419-.784.835-1.2l.255-.255.322.16c.648.325 1.089.944 1.364 1.615.279.678.413 1.462.413 2.208C13 11.969 10.72 14 8 14s-5-2.03-5-4.625c0-1.064.277-1.883.702-2.555.418-.66.969-1.158 1.472-1.59l.157-.134C6.299 4.266 7 3.666 7 2.5zm.894 1.705c-.289 1.12-1.12 1.825-1.86 2.452l-.208.178c-.497.427-.947.843-1.279 1.366C4.223 7.867 4 8.501 4 9.375 4 11.337 5.749 13 8 13s4-1.663 4-3.625c0-.635-.116-1.288-.338-1.828-.157-.383-.356-.683-.582-.889-.167.21-.273.4-.345.572a2.7 2.7 0 0 0-.176.763l-.016.162c-.048.494-.108 1.117-.69 1.698-.365.366-.879.522-1.353.522s-.989-.156-1.354-.522C6.852 9.56 6.5 9.064 6.5 8.437c0-.661.388-1.297 1.222-1.853.646-.43 1.028-1.07 1.028-1.693 0-.466-.215-1.015-.856-1.532"
        }
      )
    }
  );
}
const wV = /* @__PURE__ */ i(dV);
function vV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 1.5v1h-1v-1zm.647 1.146 1-1 .707.708-1 1zm-.293 1.708L10.207 6.5l1 1L4.5 14.207 1.793 11.5 8.5 4.793l1 1 2.146-2.147zM9.793 7.5 8.5 6.207 3.207 11.5 4.5 12.793zM13.5 4h1v1h-1z"
        }
      )
    }
  );
}
const mV = /* @__PURE__ */ i(vV);
function gV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h3v1h1V2h4v1h1V2h3v8H8.5v2H10v1h4v1h-4v1H6v-1H2v-1h4v-1h1.5v-2H2zm5 12h2v-1H7zm5-11v1H9V3H7v1H4V3H3v2h10V3zm1 3H8.5v1H13zm0 2h-2v1h2zm-3 1V8H6v1zM5 9V8H3v1zM3 7h4.5V6H3z"
        }
      )
    }
  );
}
const sV = /* @__PURE__ */ i(gV);
function fV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 14 14-.708.707L13.293 14H10v1H6v-1H2v-1h4v-1h1.5v-2H2V2.707L.646 1.354zM3 3.707V5h1.293zM5.293 6H3v1h3.293zm2 2H6v1h2.293zm2 2H8.5v2H10v1h2.293zM7 14h2v-1H7zM5 9V8H3v1zm7.828 1-1-1H13V8h-2.172l-1-1H13V6H8.828l-1-1H13V3h-1v1H9V3H7v1h-.172L6 3.172V2h4v1h1V2h3v8z"
        }
      )
    }
  );
}
const uV = /* @__PURE__ */ i(fV);
function pV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 14v-1h1v1zm0-2v-1h1v1zM3 11v-1h1v1zm4.5-1V9h1v1zm0-2V7h1v1zm-1 0h-1V7h1zM11 2h-1V1h1zm-.5 6h-1V7h1zm2 0h-1V7h1zm-5-2V5h1v1zm-5-2h-1V3h1zm2.354 1.06-.708-.706.708-.708.707.708zm1.5 1.5-.708-.706.707-.708.707.708zm2.585-.706.707-.708.707.708-.707.707zM11 4h1v1h-1zm2 0h1v1h-1zM3.44 8.354l.706-.708.707.708-.707.707zm4.206-5.208.707-.707.708.707-.708.708zm6.207 6.915-.707-.707.707-.708.707.708z"
        }
      )
    }
  );
}
const HV = /* @__PURE__ */ i(pV);
function MV(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10.295 5H9V4h3.002v3h-1V5.707l-5.291 5.29h1.292l-.001 1h-3v-3h1v1.294z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 2h12v12H2zm1 1v10h10V3z" })
      ]
    }
  );
}
const xV = /* @__PURE__ */ i(MV);
function zV(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7 8V7h3.003v3h-1L9 8.707l-2.288 2.29h1.289v1H5v-3h1v1.294L8.295 8z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 5.293V14H3V2h6.707zM12 13V6H9V3H4v10zm-.707-8L10 3.707V5z"
          }
        )
      ]
    }
  );
}
const VV = /* @__PURE__ */ i(zV);
function CV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 2h1v1h5.384l.535 2H14v7H9.152l-.536-2H4v4H3zm1 7h5.384l.535 2H13V6H9.152l-.536-2H4z"
        }
      )
    }
  );
}
const LV = /* @__PURE__ */ i(CV);
function $V(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m7.04.882 2.59 1.496.517 4.655-.644 2.61.839.226a2 2 0 0 1 2.975.797l1.682.45v1.591L13.707 14H2.293L1 12.707v-1.59l5.685-1.524.574-2.299-.995-.498-.83-2.905-1.592-.53v-1.2zm.124 9.618L2 11.884v.409l.707.707h10.586l.707-.707v-.41L8.836 10.5zm1.346-1 .625-2.533-.442-3.975-1.733-1-1.847.738 1.137.379.854 2.99 1.32.66L7.74 9.5z"
        }
      )
    }
  );
}
const SV = /* @__PURE__ */ i($V);
function kV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h9.977L14 4.312V14H2zm1 1v10h1V8h8v5h1V4.688L11.523 3H11v4H5V3zm3 0v3h4V3zm5 10V9H5v4z"
        }
      )
    }
  );
}
const yV = /* @__PURE__ */ i(kV);
function bV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 4a2 2 0 1 1 4 0c0 .183-.043.396-.096.598l-.058.204q.076-.08.148-.151a2.5 2.5 0 0 1 .47-.383 2 2 0 1 1 2 3.464c-.159.092-.365.16-.567.216L11.691 8l.206.052c.202.055.408.124.567.216a2 2 0 0 1-2 3.464 2.5 2.5 0 0 1-.47-.383l-.148-.152.058.205c.053.202.096.415.096.598a2 2 0 1 1-4 0c0-.183.044-.396.097-.598l.057-.204q-.075.08-.148.151a2.5 2.5 0 0 1-.47.383 2 2 0 0 1-2-3.464l.238.412-.238-.412c.159-.092.365-.16.567-.216L4.309 8l-.206-.052a2.5 2.5 0 0 1-.567-.216 2 2 0 1 1 2-3.464c.159.091.322.236.47.383q.073.07.148.152l-.057-.205A2.5 2.5 0 0 1 6 4m.455 2.73c-.237-.31-.485-.62-.716-.892a8 8 0 0 0-.436-.477 1.6 1.6 0 0 0-.267-.227 1 1 0 1 0-1 1.732c.043.025.147.067.33.117.174.048.39.094.632.14.35.064.743.122 1.13.173.077-.207.189-.398.327-.566M8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6.128 8.704c-.387.051-.78.109-1.13.173a8 8 0 0 0-.632.14 1.6 1.6 0 0 0-.33.117 1 1 0 0 0 1 1.732 1.6 1.6 0 0 0 .267-.227c.128-.127.276-.29.436-.477.231-.272.479-.582.716-.892a2 2 0 0 1-.328-.566m1.547 1.269c-.149.361-.295.731-.414 1.066a8 8 0 0 0-.195.617 1.6 1.6 0 0 0-.064.344 1 1 0 0 0 2 0c0-.049-.015-.16-.064-.344a7 7 0 0 0-.195-.617 22 22 0 0 0-.414-1.065 2 2 0 0 1-.654 0m1.872-.705c.238.31.485.62.716.892.16.187.308.35.437.477.135.134.223.202.266.227l-.25.433.25-.433a1 1 0 1 0 1-1.732 1.6 1.6 0 0 0-.33-.117 8 8 0 0 0-.632-.14c-.35-.064-.743-.123-1.13-.173a2 2 0 0 1-.327.566m.328-1.974c.386-.05.78-.109 1.13-.174.242-.045.457-.092.63-.14a1.6 1.6 0 0 0 .33-.116 1 1 0 0 0-1-1.732 1.6 1.6 0 0 0-.265.227c-.129.127-.277.29-.437.477-.231.271-.478.583-.716.892q.21.254.328.566M8.327 6.027c.149-.361.295-.731.414-1.066a8 8 0 0 0 .195-.617C8.985 4.16 9 4.05 9 4a1 1 0 0 0-2 0q.014.175.065.343a8 8 0 0 0 .195.617c.119.335.265.705.414 1.065a2 2 0 0 1 .654 0"
        }
      )
    }
  );
}
const RV = /* @__PURE__ */ i(bV);
function BV(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 2a3.5 3.5 0 0 0-3.5 3.5v.036l.005.428-.422.07A2.5 2.5 0 0 0 2 8.5H1a3.5 3.5 0 0 1 2.514-3.36 4.5 4.5 0 0 1 8.625-1.408A4.25 4.25 0 0 1 15 7.75h-1a3.25 3.25 0 0 0-2.373-3.13l-.247-.07-.088-.242A3.5 3.5 0 0 0 8 2m-.996 10.561a3.5 3.5 0 0 0-2.252-.302l-3.654.731-.196-.98 3.654-.731a4.5 4.5 0 0 1 2.895.387l1.545.773a3.5 3.5 0 0 0 2.252.302l3.654-.731.196.98-3.654.731a4.5 4.5 0 0 1-2.895-.388z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m1.098 10.99-.196-.981 3.654-.73a4.5 4.5 0 0 1 2.895.388l1.545.772a3.5 3.5 0 0 0 2.252.301l3.654-.73.196.981-3.654.73a4.5 4.5 0 0 1-2.895-.388l-1.545-.772a3.5 3.5 0 0 0-2.252-.301z"
          }
        )
      ]
    }
  );
}
const FV = /* @__PURE__ */ i(BV);
function AV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.884 3 .536 2H14v8H2V3zM3 4v8h10V6H6.652l-.536-2z"
        }
      )
    }
  );
}
const qV = /* @__PURE__ */ i(AV);
function OV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.884 3 .536 2H13v2h2.239l-2.402 6H1.001L1 3zM12 7V6H5.652l-.536-2H2v5.9L3.163 7zm-9.762 5h9.922l1.601-4H3.84z"
        }
      )
    }
  );
}
const DV = /* @__PURE__ */ i(OV);
function PV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.616 6 1.107-4.13.966.26L12.652 6h3.107l-1.875 7h-3.768L8.241 6zM9.544 7l1.34 5h2.232l1.34-5zM2.652 8h4.696l.67 2.5-.67 2.5H2.652l-.67-2.5zm4.196 2L6.58 9H3.419l-.267 1zm0 1H3.151l.268 1H6.58z"
        }
      )
    }
  );
}
const TV = /* @__PURE__ */ i(PV);
function WV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.228 3.22c-.328.234-.781.76-1.264 1.966-.445 1.114-.34 1.87-.106 2.748q.06.224.131.467c.202.703.439 1.529.497 2.599h3.028c.058-1.07.296-1.897.497-2.599q.07-.242.131-.467c.234-.878.34-1.634-.106-2.748C9.554 3.98 9.1 3.454 8.772 3.219 8.466 3.001 8.223 3 8 3s-.465 0-.772.22M9.478 12H6.522c.062.664.245 1.14.475 1.456.275.378.629.544 1.003.544.375 0 .728-.166 1.004-.544.23-.316.413-.792.474-1.456M8 2c.278 0 .784 0 1.352.406.547.39 1.094 1.114 1.611 2.408.555 1.386.41 2.38.144 3.377q-.07.257-.143.512c-.228.802-.465 1.63-.465 2.797 0 1.07-.243 1.934-.688 2.544-.453.622-1.1.956-1.812.956s-1.359-.334-1.812-.956c-.444-.61-.688-1.474-.688-2.544 0-1.168-.236-1.995-.465-2.797q-.075-.255-.143-.512c-.266-.997-.41-1.991.144-3.377C5.554 3.52 6.1 2.796 6.647 2.406 7.215 2 7.722 2 8 2"
        }
      )
    }
  );
}
const GV = /* @__PURE__ */ i(WV);
function EV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.5 7.116 1 .268V2h1v5.384l1-.268V2h1v5.884l-2 .536V14h-1V8.42l-2-.536V2h1z"
        }
      )
    }
  );
}
const NV = /* @__PURE__ */ i(EV);
function jV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m10.354 8.354-.707-.708L11.292 6h-7.31l1.707 6.37-.966.26L2.678 5h8.615L9.646 3.354l.707-.708L13.207 5.5z"
        }
      )
    }
  );
}
const UV = /* @__PURE__ */ i(jV);
function IV(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12 8a5 5 0 1 0-5 5v1a6 6 0 1 1 5.898-7.105l1.248-1.249.708.708L12 9.207z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4 5h1.01v1.125H5v3.75h.01V11H4zm2 1.125C6 5.422 6.649 5 7.25 5h1.5C9.351 5 10 5.422 10 6.125v3.75C10 10.578 9.351 11 8.75 11h-1.5C6.649 11 6 10.578 6 9.875zm1.04-.058C7 6.1 7 6.123 7 6.125v3.75c0 .002 0 .025.04.058a.33.33 0 0 0 .21.067h1.5a.33.33 0 0 0 .21-.067C9 9.9 9 9.877 9 9.875v-3.75c0-.002 0-.025-.04-.058A.33.33 0 0 0 8.75 6h-1.5a.33.33 0 0 0-.21.067"
          }
        )
      ]
    }
  );
}
const QV = /* @__PURE__ */ i(IV);
function KV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.001 1.072 6 3.464v6.928l-6 3.464-6-3.464V4.536zm-5 4.041v5.774l5 2.887 5-2.887V5.113l-5-2.887zm4.999 0 2.5 1.444v2.886L8 10.887 5.5 9.443V6.557zM6.5 7.134v1.732l1.5.866 1.5-.866V7.134L8 6.268z"
        }
      )
    }
  );
}
const JV = /* @__PURE__ */ i(KV);
function XV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.001 5.113v6.062h-1v-6.64l6-3.464 5.75 3.32-.5.866-5.25-3.031zM5.5 6.557 8 5.113l2.25 1.3-.5.865L8 6.268l-1.5.866v2.02h-1zm8.251 2.164-8 4.619-.5-.866 8-4.619zm-6 5.196 5.5-3.175.5.866-5.5 3.175z"
        }
      )
    }
  );
}
const YV = /* @__PURE__ */ i(XV);
function ZV(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.001 5.113v5.196l9.5-5.485-4.5-2.598zm5-4.042 6.5 3.753-12.5 7.217V4.535zm5.75 7.65-8 4.619-.5-.866 8-4.619zm-6 5.196 5.5-3.175.5.866-5.5 3.175z"
        }
      )
    }
  );
}
const _V = /* @__PURE__ */ i(ZV);
function nC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m3.001 10.887 1.817 1.049 8.183-4.725V5.113l-5-2.887-5 2.887zm-1-6.351 6-3.464 6 3.464v3.253L4.819 13.09l-2.817-1.626zm5.75 9.382 5.5-3.176.5.866-5.5 3.176z"
        }
      )
    }
  );
}
const lC = /* @__PURE__ */ i(nC);
function tC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v8H8.902l.268 1H11v1H5v-1h1.831l.268-1H2zm6 8.5-.134.5h.268zM3 4v6h10V4zm4 1h1a1.5 1.5 0 1 1 0 3v1H7zm1 2a.5.5 0 0 0 0-1zM4 5h2.5v1H5v.5h1v1H5V9H4zm7.114 1.098c-.09.049-.114.13-.114.152 0 .095.024.143.3.35l.029.021c.234.175.671.5.671 1.129a1.2 1.2 0 0 1-.636 1.03c-.433.236-.987.218-1.588-.083l.448-.894c.399.2.595.136.662.1.09-.05.114-.131.114-.153 0-.095-.024-.143-.3-.35l-.029-.021c-.234-.175-.671-.5-.671-1.129a1.2 1.2 0 0 1 .636-1.03c.433-.236.987-.218 1.588.083l-.448.894c-.399-.2-.595-.136-.662-.1"
        }
      )
    }
  );
}
const iC = /* @__PURE__ */ i(tC);
function eC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m12.736 5.53.006.005-.707.707c-.528-.528-1.482-1.482-2.388-2.215-.456-.37-.874-.661-1.202-.818a1.4 1.4 0 0 0-.27-.102q.007.03.02.071.088.285.443.794c.472.67 1.202 1.482 1.966 2.322l.104.115c.716.79 1.45 1.598 1.95 2.28.26.354.483.71.6 1.035.11.306.185.768-.161 1.114-.317.317-.738.304-1.054.226-.322-.08-.671-.257-1.014-.468-.693-.424-1.503-1.077-2.273-1.715l-.475-.395c-.608-.506-1.175-.98-1.65-1.326a7 7 0 0 0-.377-.26q.042.083.096.179c.272.48.696 1.075 1.143 1.701l.012.017c.433.606.887 1.242 1.188 1.773.15.266.28.539.344.79.058.224.102.607-.183.893-.245.244-.567.275-.811.254a2.8 2.8 0 0 1-.77-.21c-.513-.208-1.106-.549-1.656-.883l-.619-.382-.355-.22.192.257.01.014c.258.343.534.711.723 1.018.094.153.185.32.237.481.026.08.052.188.048.306a.63.63 0 0 1-.182.426.72.72 0 0 1-.56.201 1.3 1.3 0 0 1-.414-.104 5.5 5.5 0 0 1-.677-.364L4 13.035q-.18-.11-.367-.214.03.135.083.29.117.345.276.674l.005.01v.002l-.446.223-.448.224v-.002l-.003-.004-.007-.014a7 7 0 0 1-.326-.797 3.2 3.2 0 0 1-.162-.704c-.018-.203-.02-.565.239-.824a.72.72 0 0 1 .56-.202c.154.009.3.057.414.104.167.069.347.17.514.267l-.297-.399-.011-.014c-.257-.343-.533-.711-.722-1.018a2.4 2.4 0 0 1-.238-.481.9.9 0 0 1-.048-.306.63.63 0 0 1 .181-.426.63.63 0 0 1 .501-.17c.115.009.225.043.312.076.18.068.39.179.606.301.272.156.598.358.936.568.194.12.391.243.585.36.55.335 1.081.637 1.511.812q.238.095.385.124a3 3 0 0 0-.211-.433c-.271-.48-.695-1.074-1.143-1.7l-.012-.018c-.433-.606-.887-1.242-1.187-1.773-.15-.265-.282-.538-.345-.789-.057-.225-.102-.608.183-.893a.73.73 0 0 1 .57-.203c.162.01.317.064.449.122.266.117.571.316.884.544.503.368 1.105.87 1.715 1.378l.458.381c.777.644 1.535 1.25 2.158 1.633.314.193.559.306.732.349l.047.01-.014-.04q-.099-.28-.466-.783c-.467-.639-1.17-1.412-1.904-2.221l-.084-.092c-.75-.827-1.528-1.689-2.043-2.42-.254-.362-.471-.729-.579-1.068-.104-.332-.143-.784.199-1.126a.93.93 0 0 1 .75-.254c.235.02.471.104.688.208.436.209.926.56 1.398.943.95.768 1.936 1.755 2.46 2.28m-.386 4.675.001-.01zm.069-.095.007-.001zM8.08 11.68v-.009zM6.09 6.463v.008zm2.076-3.431.002-.01z"
        }
      )
    }
  );
}
const oC = /* @__PURE__ */ i(eC);
function rC(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m7.354 10.354-1 1-.708-.707 1-1zm-1-3.708 1 1-.708.708-1-1zm3.292 4.707-1-1 .708-.707 1 1zm-1-3.707 1-1 .708.708-1 1z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m11.707 4 .5.5-1 1 .793.793V13H4V4.293L5.293 3h3.414l.793.793 1-1 .5.5.741-.742 2.13-.57.258.967-1.87.5zm-1.207.208-.293.292.293.293.293-.293zM5.707 4 5 4.707V5h3V4zM9 6H5v6h6V6.707l-2-2z"
          }
        )
      ]
    }
  );
}
const hC = /* @__PURE__ */ i(rC);
function aC(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8 6H5V5h3z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 3h7v8h2.293l.707-.707V7h-1V4.707l-.854-.853.708-.708L14 5.293v5.414L12.707 12H10v2H3zm1 1v3h5V4zm5 4H4v5h5z"
          }
        )
      ]
    }
  );
}
const cC = /* @__PURE__ */ i(aC);
function dC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 2v1H3.707l3.647 3.646-.708.708L3 3.707V6H2V2zm6.293 1H10V2h4v4h-1V3.707L9.354 7.354l-.708-.708zM6.646 8.646l.708.708L3.707 13H6v1H2v-4h1v2.293zm2.708 0L13 12.293V10h1v4h-4v-1h2.293L8.646 9.354z"
        }
      )
    }
  );
}
const wC = /* @__PURE__ */ i(dC);
function vC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1.354.646 5 4.293V2h1v4H2V5h2.293L.646 1.354zM10 2h1v2.293L14.646.646l.708.708L11.707 5H14v1h-4zm-8 8h4v4H5v-2.293l-3.646 3.647-.708-.707L4.293 11H2zm8 0h4v1h-2.293l3.647 3.646-.707.708L11 11.707V14h-1z"
        }
      )
    }
  );
}
const mC = /* @__PURE__ */ i(vC);
function gC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.21 4.025a.727.727 0 0 0-.89.514L7.66 7h.84v1H7.393l-.997 3.72A1.727 1.727 0 0 1 3 11.271h1a.728.728 0 0 0 1.43.188L6.357 8H5.5V7h1.125l.73-2.72a1.727 1.727 0 0 1 3.395.447h-1a.73.73 0 0 0-.54-.702M10.294 11 8.646 9.354l.708-.708L11 10.293l1.646-1.647.708.708L11.707 11l1.647 1.646-.708.708L11 11.707l-1.646 1.647-.708-.708z"
        }
      )
    }
  );
}
const sC = /* @__PURE__ */ i(gC);
function fC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 2h8v8H4zm1 1v6h6V3zm-4 9h2v2H1zm3 0h2v2H4zm3 0h2v2H7zm3 0h2v2h-2zm3 0h2v2h-2z"
        }
      )
    }
  );
}
const uC = /* @__PURE__ */ i(fC);
function pC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6 3.313 1.566.42h.869L10 3.312l2.894.775 1.938 6.162-.638 2.38-1.626.664-1.441-.386-.536-2L8 10.214l-2.592.694-.536 2-1.441.386-1.626-.664-.638-2.38 1.938-6.162zm0 1.035-2.106.564-1.685 5.36.434 1.62.854.35.559-.15.536-2L8 9.179l3.409.913.535 2 .559.15.854-.35.434-1.62-1.685-5.36L10 4.348l-1.435.384H7.434zM5 7V6h1v1h1v1H6v1H5V8H4V7zm5.5 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M9 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
        }
      )
    }
  );
}
const HC = /* @__PURE__ */ i(pC);
function MC(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 12 12-.708.707-1.064-1.064-.013.005-1.441-.386-.393-1.466-.677-.677L8 10.214l-2.592.694-.536 2-1.441.386-1.626-.664-.638-2.38 1.938-6.162.218-.058-1.677-1.676zm1.785 3.2-.245.066-1.685 5.36.434 1.62.854.35.559-.15.536-2L8 9.179l.644.172L7 7.707V8H6v1H5V8H4V7h1V6h.293zM6 6.707V7h.293zm8.833 3.543-.37 1.384-.817-.817.145-.544-1.685-5.361L10 4.348l-1.435.384H7.56L6.193 3.364l1.373.368h.869L10 3.312l2.894.776z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12 7.5c0 .458-.205.868-.528 1.143l-.715-.714a.5.5 0 1 0-.686-.686l-.714-.714A1.5 1.5 0 0 1 12 7.5"
          }
        )
      ]
    }
  );
}
const xC = /* @__PURE__ */ i(MC);
function zC(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m8.435 2.732 1.566-.42 2.894.776 1.938 6.162-.206.768-.966-.258.13-.488-1.685-5.36-2.105-.564-1.435.384H7.434L6 3.348l-2.106.565-1.685 5.36.434 1.62.854.35.559-.15.536-2L8 8.18l1.13.301-.26.966L8 9.214l-2.592.694-.536 2-1.441.386-1.626-.664-.638-2.38 1.938-6.162L6 2.312l1.566.42z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 5v1h1v1H6v1H5V7H4V6h1V5zm4.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M10 6.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0m0 7.87V8.63l4.92 2.87zm1-4v2.26l1.936-1.13z"
          }
        )
      ]
    }
  );
}
const VC = /* @__PURE__ */ i(zC);
function CC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.268 4A2 2 0 0 1 6 1c.513 0 1.165.157 1.681.727q.177.195.319.442a2.5 2.5 0 0 1 .319-.442C8.835 1.157 9.487 1 10 1a2 2 0 0 1 1.732 3H14.5v3H14v7H2V7h-.5V4zM5 3a1 1 0 0 0 1 1h1.482c-.066-.858-.302-1.337-.542-1.602A1.23 1.23 0 0 0 6 2a1 1 0 0 0-1 1m1 2H2.5v1H6zm0 2H3v6h10V7h-3v3.934L8 9.601l-2 1.333zm4-1h3.5V5H10zm0-2a1 1 0 0 0 0-2c-.315 0-.663.093-.94.398-.24.265-.476.744-.542 1.602zM7 9.066l1-.667 1 .667V5H7z"
        }
      )
    }
  );
}
const LC = /* @__PURE__ */ i(CC);
function $C(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 1H10v2H8.5v1.03A4 4 0 0 1 12 8v3h1v2h1v1H2v-1h1v-2h1V8a4 4 0 0 1 3.5-3.969zM5 8.5V11h.75V8.5zm1.75 0V11h.75V8.5zm1.75 0V11h.75V8.5zm1.75 0V11H11V8.5zM4 12v1h8v-1zm4-7a3 3 0 0 0-2.96 2.5h5.919A3 3 0 0 0 8 5"
        }
      )
    }
  );
}
const SC = /* @__PURE__ */ i($C);
function kC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 1h14v14H1zm1 1v4h.5v4H2v4h4v-.5h4v.5h4v-4h-.5V6h.5V2h-4v.5H6V2zm2 2h2v2H4zm3 0h2v2H7zm3 0h2v2h-2zM4 7h2v2H4zm3 0h2v2H7zm3 0h2v2h-2zm-6 3h2v2H4zm3 0h2v2H7zm3 0h2v2h-2z"
        }
      )
    }
  );
}
const yC = /* @__PURE__ */ i(kC);
function bC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 5H1V4h2v1h11v6H9v1H4v-1H3v1H2zm1 1v4h2v1h3v-1h5V6zm8 1.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M9.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
        }
      )
    }
  );
}
const RC = /* @__PURE__ */ i(bC);
function BC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 3H0V2h2v1h11v6H8v1H3V9H2v1H1zm1 1v4h2v1h3V8h5V4zm8 1.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M8.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m5.5-.5h1V11h-5v1H5v-1h4v-1h5z"
        }
      )
    }
  );
}
const FC = /* @__PURE__ */ i(BC);
function AC(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 12 12-.708.707L10.293 11H9v1H4v-1H3v1H2V5H1V4h2v1h1.293L1.646 2.354zM5.293 6H3v4h2v1h3v-1h1.293zM14 11h-.172l-1-1H13V6H8.828l-1-1H14z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12.5 8c0 .458-.205.868-.529 1.143l-.714-.714a.5.5 0 1 0-.686-.686l-.714-.714A1.5 1.5 0 0 1 12.5 8"
          }
        )
      ]
    }
  );
}
const qC = /* @__PURE__ */ i(AC);
function OC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ a("g", { fill: "currentColor", children: [
        /* @__PURE__ */ l("path", { d: "M4 7h2v2H4zm0 3h2v2H4zm3 0h2v2H7z" }),
        /* @__PURE__ */ l("path", { d: "m.854.146 15 15-.707.707-.854-.853H1V1.707L.146.854zM2 2.707V6h.5v4H2v4h4v-.5h4v.5h3.293l-2-2H10v-1.293L8.293 9H7V7.707L5.293 6H4V4.707zm13 9.465-1-1V10h-.5V6h.5V2h-4v.5H6V2H4.828l-1-1H15z" }),
        /* @__PURE__ */ l("path", { d: "M12 9h-.172L10 7.172V7h2zM9 6h-.172L7 4.172V4h2zm1-2h2v2h-2z" })
      ] })
    }
  );
}
const DC = /* @__PURE__ */ i(OC);
function PC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 6.464V12h-1V7.041l-1 .578V10c0 .894-.507 1.655-1.235 2.175C10.038 12.694 9.059 13 8 13s-2.038-.305-2.766-.825C4.508 11.656 4 10.894 4 10V7.62L1.5 6.175 8 2.423l6.5 3.752zM5 10c0 .488.276.976.816 1.36.539.386 1.31.64 2.184.64s1.643-.255 2.184-.64S11 10.487 11 10V8.196L8 9.928 5 8.196zm3-1.226 4.5-2.599L8 3.577 3.5 6.175z"
        }
      )
    }
  );
}
const TC = /* @__PURE__ */ i(PC);
function WC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v2.05a2.5 2.5 0 0 1 0 4.9V13H3V9h.5a1.5 1.5 0 1 0 0-3H3zm9 6.95a2.5 2.5 0 0 1 0-4.9V4H4v1.05a2.5 2.5 0 0 1 0 4.9V12h8zM12.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
        }
      )
    }
  );
}
const GC = /* @__PURE__ */ i(WC);
function EC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.5 3H7v2.05A2.5 2.5 0 0 1 8.95 7h4.343l-1.647-1.646.708-.708L15.207 7.5l-2.853 2.854-.708-.708L13.293 8H8.95A2.5 2.5 0 0 1 7 9.95V13H2.5v-1H6V9.95a2.5 2.5 0 0 1 0-4.9V4H2.5zM5 7.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
        }
      )
    }
  );
}
const NC = /* @__PURE__ */ i(EC);
function jC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 4H2.5V3H7v2.05a2.5 2.5 0 0 1 0 4.9V13H2.5v-1H6V9.95a2.5 2.5 0 0 1 0-4.9zm.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m5.293 1.5-1.646-1.646.707-.708L12.5 6.793l1.646-1.647.707.708L13.208 7.5l1.647 1.646-.707.708L12.5 8.207l-1.646 1.647-.708-.708z"
        }
      )
    }
  );
}
const UC = /* @__PURE__ */ i(jC);
function IC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.646 8.647 10 9l.354.353.002-.002.002-.002.002-.002.001-.001-.014.016q-.024.03-.08.116a3.3 3.3 0 0 0-.297.63c-.204.56-.42 1.477-.463 2.892h1.026c.13-.978.619-1.783 1.08-2.348a6.6 6.6 0 0 1 1.067-1.037l.021-.016.007-.005.002-.001c.001-.001.001-.001.29.407l.289.408-.002.001-.012.009q-.135.097-.257.21a5.6 5.6 0 0 0-.63.655c-.374.459-.722 1.045-.843 1.717H14v1H2v-1h2.384c-.142-.318-.403-.629-.717-.91a5.5 5.5 0 0 0-.89-.642l-.013-.007-.002-.001L3 11l.238-.44.003.002.006.003.02.012q.165.09.32.196c.202.133.473.327.746.572.425.38.932.95 1.106 1.655h1.016c-.121-.672-.47-1.258-.843-1.717a5.6 5.6 0 0 0-.887-.865l-.012-.009H4.71L5 10l.289-.408h.001l.002.002.007.005.021.016.074.056c.365.29.699.62.994.981.46.565.95 1.37 1.079 2.348h1.04c.042-1.52.276-2.554.523-3.233.137-.376.277-.643.391-.823a2 2 0 0 1 .213-.285l.007-.007.003-.003zM4.71 10.408"
        }
      )
    }
  );
}
const QC = /* @__PURE__ */ i(IC);
function KC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.646 2.646 1-1 .708.708-1 1zM11.191 2h1.618l.8 1.599L12 5.207 10.392 3.6zm.618 1-.2.401.391.392.392-.392L12.19 3zm-6.174.928L7 5.293V7.39l-2.653.664-1.419-1.419.677-2.03zm-1.24 1.467-.323.97.581.581L6 6.61v-.903l-.635-.635zm4.251-.249 1-1 .708.708-1 1zm0 3.208-1-1 .708-.708 1 1zM10.793 8h2.097l.664 2.653-1.419 1.419-2.03-.677-.677-2.03zm.414 1-.635.635.323.97.97.323.581-.581L12.11 9zm-9.56.646 1-1 .707.708-1 1zM5.9 8.892l1.6.798v1.618l-1.599.8L4.293 10.5zm.198 1.216-.392.392.392.392.401-.201v-.382zm2.547 4.246-1-1 .708-.708 1 1z"
        }
      )
    }
  );
}
const JC = /* @__PURE__ */ i(KC);
function XC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 5V2h1v3h4V2h1v3h3v1h-3v4h3v1h-3v3h-1v-3H6v3H5v-3H2v-1h3V6H2V5zm1 1v4h4V6z"
        }
      )
    }
  );
}
const YC = /* @__PURE__ */ i(XC);
function ZC(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13.646 14.354 11 11.707V14h-1v-3H6v3H5v-3H2v-1h3V6H2V5h2.293L1.646 2.354l.708-.707 12 12zM9.293 10 6 6.707V10zM10 7.172V6H8.828l-1-1H10V2h1v3h3v1h-3v2.172z"
        }
      )
    }
  );
}
const _C = /* @__PURE__ */ i(ZC);
function nL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.5 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-9 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-9 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-9 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const lL = /* @__PURE__ */ i(nL);
function tL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-6 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const iL = /* @__PURE__ */ i(tL);
function eL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.5 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-9 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const oL = /* @__PURE__ */ i(eL);
function rL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const hL = /* @__PURE__ */ i(rL);
function aL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const cL = /* @__PURE__ */ i(aL);
function dL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 1h4v1H2v3H1zm13 1h-3V1h4v4h-1zM5 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M3 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m8-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M9 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-1 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-1 3v1H1v-4h1v3zm10-3v4h-4v-1h3v-3z"
        }
      )
    }
  );
}
const wL = /* @__PURE__ */ i(dL);
function vL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 7H8.5v1H11v3H8.5v3h-1v-3H5V8h2.5V7H3V4h4.5V2h1v2H13zM4 5v1h8V5zm6 5V9H6v1z"
        }
      )
    }
  );
}
const mL = /* @__PURE__ */ i(vL);
function gL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 2v12H3V2zm10 5H5V4h9zm-1-1V5H6v1zm-2 5H5V8h6zm-1-1V9H6v1z"
        }
      )
    }
  );
}
const sL = /* @__PURE__ */ i(gL);
function fL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 14h-1V2h1zM2 4h9v3H2zm1 1v1h7V5zm2 3h6v3H5zm1 1v1h4V9z"
        }
      )
    }
  );
}
const uL = /* @__PURE__ */ i(fL);
function pL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 5.5A.5.5 0 0 0 8 6v1H7v-.5a.5.5 0 0 0-1 0V9H5v-.915A1.5 1.5 0 0 0 4 9.5v1.038c0 .398.158.779.44 1.06L6.84 14h3.66a2.5 2.5 0 0 0 2.5-2.5V7a.5.5 0 0 0-1 0v.5h-1v-1a.5.5 0 0 0-1 0V7H9V6a.5.5 0 0 0-.5-.5m1.264-.308a1.5 1.5 0 0 1 2 .5A1.5 1.5 0 0 1 14 7v4.5a3.5 3.5 0 0 1-3.5 3.5H6.427l-2.695-2.694A2.5 2.5 0 0 1 3 10.538V9.5a2.5 2.5 0 0 1 2-2.45V6.5a1.5 1.5 0 0 1 2.236-1.307 1.5 1.5 0 0 1 2.528 0"
        }
      )
    }
  );
}
const HL = /* @__PURE__ */ i(pL);
function ML(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 2.5a1.5 1.5 0 0 1 2.948-.395A1.5 1.5 0 0 1 12 3.5v.085q.234-.084.5-.085A1.5 1.5 0 0 1 14 5v6.5a3.5 3.5 0 0 1-3.5 3.5H6.408l-.15-.168.375-.332-.374.332-.538-.608-1.214-1.37a529 529 0 0 1-2.046-2.32c-.535-.622-.574-1.495.026-2.095.613-.613 1.393-.48 1.988-.203.082.038.269.132.524.263V4a1.5 1.5 0 0 1 2-1.415zm1 5H7V4a.5.5 0 0 0-1 0v6.14l-.73-.378a61 61 0 0 0-1.216-.62c-.448-.208-.692-.163-.86.004-.18.182-.214.456.026.735.191.222 1.136 1.291 2.037 2.31l1.213 1.37.389.439H10.5a2.5 2.5 0 0 0 2.5-2.5V5a.5.5 0 0 0-1 0v2.5h-1v-4a.5.5 0 0 0-1 0v4H9v-5a.5.5 0 0 0-1 0z"
        }
      )
    }
  );
}
const xL = /* @__PURE__ */ i(ML);
function zL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 4H7V2.707L2.707 7H4v1H1V5h1v1.293L6.293 2H5V1h3zm0 1.5a1.5 1.5 0 1 1 3 0v1.616l2.147.576A2.5 2.5 0 0 1 15 10.106V12.5a2.5 2.5 0 0 1-2.5 2.5H8.523l-.15-.168a882 882 0 0 1-2.911-3.299c-.535-.62-.575-1.494.025-2.094.614-.613 1.394-.48 1.988-.203.083.038.27.132.525.263zM9.5 5a.5.5 0 0 0-.5.5v5.64l-.73-.378a61 61 0 0 0-1.216-.62c-.449-.208-.692-.163-.86.005-.18.18-.215.455.026.734.244.284 1.716 1.947 2.753 3.119H12.5a1.5 1.5 0 0 0 1.5-1.5v-2.394a1.5 1.5 0 0 0-1.112-1.448L10 7.884V5.5a.5.5 0 0 0-.5-.5"
        }
      )
    }
  );
}
const VL = /* @__PURE__ */ i(zL);
function CL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 3a.5.5 0 0 0-.5.5V9H5v-.915A1.5 1.5 0 0 0 4 9.5v1.038c0 .398.158.779.44 1.06L6.84 14h3.66a2.5 2.5 0 0 0 2.5-2.5V7a.5.5 0 0 0-1 0v.5h-1v-1a.5.5 0 0 0-1 0V7H9V6a.5.5 0 0 0-1-.001V6.5H7v-3a.5.5 0 0 0-.5-.5M8 4.585a1.5 1.5 0 0 1 1.764.608 1.5 1.5 0 0 1 2 .5A1.5 1.5 0 0 1 14 7v4.5a3.5 3.5 0 0 1-3.5 3.5H6.427l-2.695-2.694A2.5 2.5 0 0 1 3 10.538V9.5a2.5 2.5 0 0 1 2-2.45V3.5a1.5 1.5 0 1 1 3 0z"
        }
      )
    }
  );
}
const LL = /* @__PURE__ */ i(CL);
function $L(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 2.5a4.5 4.5 0 0 0-3.6 7.2l.1.133V13H3v-2.838a5.5 5.5 0 1 1 9.881-4.307l1.78 4.452-1.717.572-.52 3.121H8v-1h3.576l.48-2.88 1.283-.427-1.42-3.55-.009-.044A4.5 4.5 0 0 0 7.5 2.5"
        }
      )
    }
  );
}
const SL = /* @__PURE__ */ i($L);
function kL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 3h1v4h4V3h1v9h-1V8H6v4H5z" })
    }
  );
}
const yL = /* @__PURE__ */ i(kL);
function bL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 7v4H1.64L.973 9l.667-2h.426c.18-1.34.728-2.486 1.588-3.346C4.722 2.586 6.23 2 8 2s3.278.586 4.346 1.654c.861.86 1.409 2.007 1.589 3.346h.425l.667 2-.667 2H14v3H9v.5H7v-2h2v.5h4v-2h-1V7h.924c-.171-1.086-.624-1.978-1.284-2.64C10.786 3.507 9.545 3 8 3s-2.786.508-3.639 1.36C3.7 5.022 3.247 5.914 3.076 7zM2.36 8l-.334 1 .334 1H3V8zm11.278 0H13v2h.64l.333-1z"
        }
      )
    }
  );
}
const RL = /* @__PURE__ */ i(bL);
function BL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 3h4v3h3v4h-3v3H6v-3H3V6h3zm1 1v3H4v2h3v3h2V9h3V7H9V4z"
        }
      )
    }
  );
}
const FL = /* @__PURE__ */ i(BL);
function AL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.32 3.828a3.44 3.44 0 0 1 4.852 4.852l-.012.014L8 13.866 2.84 8.694l-.012-.014A3.44 3.44 0 0 1 7.68 3.828l.012.01.308.303.308-.302zm.664.748L8 5.542l-.984-.966a2.44 2.44 0 0 0-3.44 3.439L8 12.45l4.425-4.435a2.44 2.44 0 0 0-3.441-3.439"
        }
      )
    }
  );
}
const qL = /* @__PURE__ */ i(AL);
function OL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-3.07-3.07L8 13.865 2.84 8.694l-.012-.014a3.44 3.44 0 0 1 .33-4.814L1.647 2.354zm1.513 2.928a2.44 2.44 0 0 0-.292 3.44L8 12.45l1.87-1.874zm8.475 4.94-.707-.708.79-.791a2.44 2.44 0 0 0-3.441-3.439l-.797.783-2.334-2.334a3.43 3.43 0 0 1 1.827.803l.012.01.308.303.308-.302.013-.011a3.44 3.44 0 0 1 4.851 4.852l-.012.014z"
        }
      )
    }
  );
}
const DL = /* @__PURE__ */ i(OL);
function PL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 5H8.5v1.742c1.173.312 2.482.684 3.685 1.035a1.5 1.5 0 1 1-.028 1.393c-.964.248-1.784.74-2.67 1.271l-.18.108c-.96.573-1.997 1.164-3.307 1.373V13h4v1H2.793l-1.147-1.146.708-.708.853.854H5v-1a3 3 0 0 1-3-3c0-1.64 1.208-3 3-3 .296 0 .778.085 1.33.205.347.076.743.17 1.17.278V5H2V4h12zm-.965 3.683a.5.5 0 1 0 .045-.453zM3 9a2 2 0 0 0 2 2c1.508 0 2.613-.604 3.793-1.309l.216-.129c.627-.378 1.289-.774 2.035-1.074-.995-.287-2.02-.574-2.947-.819a52 52 0 0 0-1.98-.487C5.55 7.059 5.171 7 5 7c-1.208 0-2 .88-2 2"
        }
      )
    }
  );
}
const TL = /* @__PURE__ */ i(PL);
function WL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7-3a1 1 0 0 0-1 1H6a2 2 0 1 1 4 0c0 .466-.119.839-.31 1.146a2.8 2.8 0 0 1-.62.676l-.137.112c-.14.115-.238.196-.319.29-.082.096-.114.172-.114.276V10h-1V8.5c0-.396.156-.695.355-.927a3.6 3.6 0 0 1 .482-.443l.093-.077c.178-.148.314-.278.41-.434C8.932 6.473 9 6.284 9 6a1 1 0 0 0-1-1m-.5 7v-1h1v1z"
        }
      )
    }
  );
}
const GL = /* @__PURE__ */ i(WL);
function EL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 1.793 14.207 4.5l-7.5 7.5h-1l-1 1H3.293l-1-1L4 10.293v-1zm-7 9.414L3.707 12h.586l.5-.5zM5.707 11h.586l6.5-6.5L11.5 3.207 5 9.707v.586z"
        }
      )
    }
  );
}
const NL = /* @__PURE__ */ i(EL);
function jL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M0 2h16v11H0zm1 1v9h14V3zm2 7V5h1v2h2V5h1v5H6V8H4v2zm7.5-4a1.5 1.5 0 1 0 .647 2.854l-.5-.5.707-.708.5.5A1.5 1.5 0 0 0 10.5 6m2.854 3.646-.708.708-.767-.768a2.5 2.5 0 1 1 .707-.707z"
        }
      )
    }
  );
}
const UL = /* @__PURE__ */ i(jL);
function IL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.357 5.936a1.5 1.5 0 0 1 2.232.124L14.54 11H1.293l3.146-3.146a1.5 1.5 0 0 1 2.122 0L8.707 10h3.753L9.808 6.685a.5.5 0 0 0-.744-.041l-1.21 1.21-.707-.708zM7.293 10l-1.44-1.44a.5.5 0 0 0-.706 0L3.707 10z"
        }
      )
    }
  );
}
const QL = /* @__PURE__ */ i(IL);
function KL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 4a4 4 0 0 0-4 4v1.293l1.146-1.147.708.708L3.5 11.207 1.146 8.854l.708-.708L3 9.293V8a5 5 0 1 1 3.706 4.83l.258-.965A4.004 4.004 0 0 0 12 8a4 4 0 0 0-4-4m.5 1v2.616l2.528.678-.259.966L7.5 8.384V5z"
        }
      )
    }
  );
}
const JL = /* @__PURE__ */ i(KL);
function XL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 1.293 6.854 6.853-.707.708L13 7.707V14H9v-4H7v4H3V7.707L1.854 8.854l-.708-.708zM4 6.707V13h2V9h4v4h2V6.707l-4-4z"
        }
      )
    }
  );
}
const YL = /* @__PURE__ */ i(XL);
function ZL(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 7.707v2.465l-1-1V6.707l-4-4L6.768 3.94l-.707-.707L8 1.292l6.854 6.854-.707.708zM13 14H9v-4H7v4H3V7.707L1.854 8.854l-.708-.708L4.293 5 1.646 2.354l.708-.708 12 12-.708.708-.646-.647zm-3-3.293V13h2v-.293zm-6-4V13h2V9h2.293L5 5.707z"
        }
      )
    }
  );
}
const _L = /* @__PURE__ */ i(ZL);
function n$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.141 2.95C4.44 3.544 4 4.404 4 5.5c0 1.038.627 1.914 1.368 2.718q.245.264.486.51l.056.058c.175.18.347.36.498.531.149.17.29.35.396.533q.04.07.078.15h.068c-.075-.363-.225-.702-.412-1.127q-.06-.132-.122-.277C6.09 7.84 5.75 6.916 5.75 5.5c0-1.36.191-2.442.547-3.204l.004-.01c-.44.161-.831.385-1.16.664M8 1c1.341 0 2.586.41 3.505 1.186C12.432 2.97 13 4.11 13 5.5c0 1.448-.873 2.573-1.632 3.395-.173.188-.345.366-.504.53l-.056.057c-.176.182-.332.344-.463.494q-.198.225-.283.374c-.06.103-.062.148-.062.15v.5H6v-.5c0-.002-.002-.047-.062-.15a2.5 2.5 0 0 0-.283-.374c-.131-.15-.286-.312-.463-.494l-.056-.058q-.255-.261-.504-.528C3.873 8.072 3 6.947 3 5.5c0-1.389.568-2.529 1.495-3.314C5.414 1.409 6.66 1 8 1m0 1c-.229 0-.528.144-.797.719-.27.576-.453 1.494-.453 2.781 0 1.23.286 2.013.584 2.698l.114.258c.21.47.43.964.515 1.544h.074c.085-.58.306-1.074.515-1.544l.114-.258c.298-.685.584-1.468.584-2.698 0-1.287-.184-2.205-.453-2.781C8.528 2.144 8.229 2 8 2m1.118 8a2 2 0 0 1 .078-.15c.106-.183.247-.363.396-.533.151-.171.323-.351.498-.531q.275-.28.542-.568C11.373 7.414 12 6.538 12 5.5c0-1.096-.44-1.956-1.141-2.55a3.8 3.8 0 0 0-1.16-.664l.004.01c.356.762.547 1.844.547 3.204 0 1.416-.339 2.34-.666 3.096q-.062.145-.122.277c-.187.425-.337.764-.412 1.127zM5.5 13v-1h5v1H10v2H6v-2zM7 13v1h2v-1z"
        }
      )
    }
  );
}
const l$ = /* @__PURE__ */ i(n$);
function t$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h10v2.634L10.48 8 13 12.366V15H3v-2.634L5.52 8 3 3.634zm1 2h8V2H4zm7.634 1H4.366l2.31 4-2.31 4h7.268l-2.31-4zM12 14v-1H4v1z"
        }
      )
    }
  );
}
const i$ = /* @__PURE__ */ i(t$);
function e$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h10v2.634L10.48 8 13 12.366V15H3v-2.634L5.52 8 3 3.634zm1 1v1h8V2zm7.634 2H4.366l2.31 4-2.31 4h7.268l-2.31-4zM12 13H4v1h8zM9 9H7V8h2zm1 2H6v-1h4z"
        }
      )
    }
  );
}
const o$ = /* @__PURE__ */ i(e$);
function r$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h10v2.634L10.48 8 13 12.366V15H3v-2.634L5.52 8 3 3.634zm1 1v1h8V2zm7.634 2H4.366l2.31 4-2.31 4h7.268l-2.31-4zM12 13H4v1h8zM9.5 7h-3V6h3zm-1 1.5h-1v-1h1zm1 1.5h-3V9h3z"
        }
      )
    }
  );
}
const h$ = /* @__PURE__ */ i(r$);
function a$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h10v2.634L10.48 8 13 12.366V15H3v-2.634L5.52 8 3 3.634zm1 1v1h8V2zm7.634 2H4.366l2.31 4-2.31 4h7.268l-2.31-4zM12 13H4v1h8zm-2-7H6V5h4zM9 8H7V7h2z"
        }
      )
    }
  );
}
const c$ = /* @__PURE__ */ i(a$);
function d$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v8H8.902l.268 1H11v1H5v-1h1.831l.268-1H2zm11 7V4H3v6h4.367zm-5 1.5-.134.5h.268zM12 6h-1V5h1zM7.51 9H4.5V8h3.01zM10 9H9V8h1zm2 0h-1V8h1z"
        }
      )
    }
  );
}
const w$ = /* @__PURE__ */ i(d$);
function v$(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.5 8.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M8 8a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8.5 2.541A3 3 0 0 1 10.959 5h.541v1H11v1h2v1h.5v1H13v1h-2v3h1v1H4v-1h1v-3H3V9h-.5V8H3V7h2V6h-.5V5h.541A3 3 0 0 1 7.5 2.541V2h1zM5 9V8H4v1zm3-5.5A2 2 0 0 0 6.063 5h3.874A2 2 0 0 0 8 3.5m2 9.5V6H6v7zm1-5v1h1V8z"
          }
        )
      ]
    }
  );
}
const m$ = /* @__PURE__ */ i(v$);
function g$(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.92 9h4.16l1.072 4H4.849zm.768 1-.536 2h3.697l-.536-2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5 0v1h6V0h1v1h2v14H2V1h2V0zm0 2v1H4V2H3v12h10V2h-1v1h-1V2z"
          }
        )
      ]
    }
  );
}
const s$ = /* @__PURE__ */ i(g$);
function f$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v12H2zm1 1v5.211l3.534 2.036 3.483-2.007L13 9.96V3zm10 8.113-2.983-1.719-3.483 2.007L3 9.365V13h10zM6.5 6a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
        }
      )
    }
  );
}
const u$ = /* @__PURE__ */ i(f$);
function p$(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11.947 4.276 12.31 5H15v2.5h-1V6H9v1.5H8V5h3.19l-.137-.276z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m13.416 7.277-.001.002-.003.005-.01.014-.037.053q-.047.07-.134.188a11 11 0 0 1-.476.599c-.234.272-.53.589-.862.862H15v1h-3.5v.5A1.5 1.5 0 0 1 10 12h-.5v-1h.5a.5.5 0 0 0 .5-.5V10H8V9h2.5v-.31l.276-.137c.24-.12.494-.32.737-.553H9.5V7h2.586a.5.5 0 0 0 .353-.147l.207-.207zM6.511 9.819l-.933.362-.644-1.665H3.108l-.642 1.664-.933-.36L3.585 4.5h.866zM4.019 6.154l-.525 1.362h1.053z"
          }
        )
      ]
    }
  );
}
const H$ = /* @__PURE__ */ i(p$);
function M$(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m8.5 8.793 1.146-1.147.708.708L8 10.707 5.646 8.354l.708-.708L7.5 8.793V3h1z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 6H4v6h8V6h-1V5h2v8H3V5h2z" })
      ]
    }
  );
}
const x$ = /* @__PURE__ */ i(M$);
function z$(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m8.5 3.793 1.146-1.147.708.708L8 5.707 5.646 3.354l.708-.708L7.5 3.793V1h1z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 5h2v1H4v3.211l2.8 1.617 2.85-1.645L12 10.54V6h-1V5h2v9H3zm9 6.694-2.35-1.357-2.85 1.646L4 10.366V13h8z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.454 7.773a1.318 1.318 0 1 1 2.637 0 1.318 1.318 0 0 1-2.637 0m1.319-.318a.318.318 0 1 0 0 .636.318.318 0 0 0 0-.636"
          }
        )
      ]
    }
  );
}
const V$ = /* @__PURE__ */ i(z$);
function C$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.295 5H5.71l2.293 2.293L10.295 5h3.414l1.293 1.293v3.414L13.71 11h-3.414L8.002 8.707 5.71 11H2.295L1.002 9.707V6.293zm5 3-2-2H2.71l-.707.707v2.586L2.71 10h2.586zM8.71 8l2 2h2.586l.707-.707V6.707L13.295 6H10.71z"
        }
      )
    }
  );
}
const L$ = /* @__PURE__ */ i(C$);
function $$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7.5-4v1h-1V4zm0 2v6h-1V6z"
        }
      )
    }
  );
}
const S$ = /* @__PURE__ */ i($$);
function k$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.438 4.157 8 3.327l-1.437.829-.5-.866L8 2.173l1.938 1.118zm-4 1.732-.5.866L4 6.214v1.083H3V5.059l1.938-1.118.5.866-.938.541zm6.062-.541-.937-.541.5-.866L13 5.059v2.238h-1V6.214l-.937.541-.5-.866zM4 8.596v1.66l1.438.83-.5.865L3 10.833V8.596zm9 0v2.237l-1.937 1.118-.5-.865 1.437-.83v-1.66zm-3.562 3.138.5.866L8 13.72l-1.937-1.119.5-.866.937.541v-1.082h1v1.082zm.5-4.329-1.438.83v1.66h-1v-1.66l-1.437-.83.5-.866L8 7.369l1.438-.83z"
        }
      )
    }
  );
}
const y$ = /* @__PURE__ */ i(k$);
function b$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 6a5 5 0 1 1 5.5 4.975V12H10v1h4v1h-4v1H6v-1H2v-1h4v-1h1.5v-1.025A5 5 0 0 1 3 6m1 0a4 4 0 0 0 .126 1h1.91a14 14 0 0 1 0-2h-1.91Q4.001 5.48 4 6m.535 2a4 4 0 0 0 2.089 1.757 5 5 0 0 1-.158-.417A8.5 8.5 0 0 1 6.15 8zm3.473 1.998.033-.016a.6.6 0 0 0 .15-.145c.13-.165.269-.435.396-.813A7 7 0 0 0 8.837 8H7.164a7 7 0 0 0 .25 1.024c.125.378.265.648.395.813a.6.6 0 0 0 .15.145l.033.016L8 10zM8.96 7a13 13 0 0 0 0-2H7.04a13 13 0 0 0 0 2zM6.149 4c.079-.495.186-.948.316-1.34q.072-.218.158-.417A4 4 0 0 0 4.535 4H6.15m1.858-1.998L8 2l-.008.002-.033.016a.6.6 0 0 0-.15.145c-.13.165-.27.435-.395.813-.099.296-.184.64-.25 1.024h1.673a7 7 0 0 0-.25-1.024c-.127-.378-.266-.648-.396-.813a.6.6 0 0 0-.15-.145zM10 6q0 .513-.036 1h1.91a4 4 0 0 0 0-2h-1.91Q10 5.486 10 6m-.624-3.757q.09.206.158.417A8.4 8.4 0 0 1 9.85 4h1.615a4 4 0 0 0-2.088-1.757M9.851 8a8.6 8.6 0 0 1-.316 1.34q-.072.218-.158.417A4 4 0 0 0 11.465 8zM9 14v-1H7v1z"
        }
      )
    }
  );
}
const R$ = /* @__PURE__ */ i(b$);
function B$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 14 14-.708.708L13.293 14H10v1H6v-1H2v-1h4v-1h1.5v-1.025a5 5 0 0 1-4.12-6.889L.645 1.354zM4.293 5h-.167a4 4 0 0 0 0 2h1.91q-.01-.135-.017-.274zm3 3h-.13L8 10l.008-.002.033-.016a.6.6 0 0 0 .15-.145 2.4 2.4 0 0 0 .324-.615zm2.62 2.62a5 5 0 0 1-1.413.355V12H10v1h2.293zm-3.29-.863a5 5 0 0 1-.158-.417A8.4 8.4 0 0 1 6.149 8H4.535a4 4 0 0 0 2.088 1.757M9 14v-1H7v1zm4-8c0 1.17-.402 2.245-1.075 3.097l-.713-.713q.137-.184.253-.384h-.637l-1.83-1.83q.009-.585-.036-1.17H7.828L6.256 3.428q.09-.414.209-.768.07-.218.158-.417a4 4 0 0 0-1.007.545l-.713-.714A5 5 0 0 1 13 6M7.993 2.002l-.033.016a.6.6 0 0 0-.15.145c-.13.165-.269.435-.396.813A7 7 0 0 0 7.164 4h1.672a7 7 0 0 0-.25-1.024c-.125-.378-.265-.648-.395-.813a.6.6 0 0 0-.15-.145l-.033-.016L8 2zM9.964 5a14 14 0 0 1 0 2h1.91a4 4 0 0 0 0-2zm1.5-1a4 4 0 0 0-2.087-1.757q.086.2.158.417c.13.392.237.845.316 1.34z"
        }
      )
    }
  );
}
const F$ = /* @__PURE__ */ i(B$);
function A$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.55 4H7.2V3h4v1H9.585l-2.143 8H8.79v1h-4v-1h1.616z"
        }
      )
    }
  );
}
const q$ = /* @__PURE__ */ i(A$);
function O$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.647 4.354.707-.708L15.207 6.5l-2.853 2.854-.707-.708L13.293 7H7a2 2 0 1 0 1.932 1.482l.966-.258A3.003 3.003 0 0 1 7 12a3 3 0 0 1 0-6h6.293zM4 7H1V6h3z"
        }
      )
    }
  );
}
const D$ = /* @__PURE__ */ i(O$);
function P$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m9.5 9.642 1.338.36.308-1.15 2.966.794-.308 1.15 1.196.321v1.59L13.707 14H2.293L1 12.707v-1.591l5.5-1.473V2h3zM8.5 3.5V3h-1v.5zm-1 1v5.026h1V4.5zM2 12.293l.707.707h10.586l.707-.707v-.409l-5.066-1.358H7.066L2 11.884zm9.854-2.217-.05.184 1.034.277.05-.183z"
        }
      )
    }
  );
}
const T$ = /* @__PURE__ */ i(P$);
function W$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 5a3 3 0 1 1 1.262 2.445L6.707 9l1.647 1.646-.708.708L6 9.707l-.793.793 1.647 1.646-.708.708L4.5 11.207l-1.146 1.147-.708-.708 4.909-4.908A3 3 0 0 1 7 5m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
        }
      )
    }
  );
}
const G$ = /* @__PURE__ */ i(W$);
function E$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 3h14v9H1zm1 1v7h12V4zm2 2H3V5h1zm1.5 0h-1V5h1zM7 6H6V5h1zm1.5 0h-1V5h1zM10 6H9V5h1zm1.5 0h-1V5h1zM13 6h-1V5h1zM4 8H3V7h1zm1.5 0h-1V7h1zM7 8H6V7h1zm1.5 0h-1V7h1zM10 8H9V7h1zm1.5 0h-1V7h1zM13 8h-1V7h1zm-9 2H3V9h1zm7 0H5V9h6zm2 0h-1V9h1z"
        }
      )
    }
  );
}
const N$ = /* @__PURE__ */ i(E$);
function j$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2.293 13.707 8 8 13.707 2.293 8zM3.707 8 8 12.293 12.293 8 8 3.707z"
        }
      )
    }
  );
}
const U$ = /* @__PURE__ */ i(j$);
function I$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 9h-.5v5h-1V9H6V4.753L7.878 1.5H9zM7 8h1V3.29L7 5.02z"
        }
      )
    }
  );
}
const Q$ = /* @__PURE__ */ i(I$);
function K$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.724 1.5h6.66l1.876 7H11V11h-1V8.5H8.5V14H10v1H6v-1h1.5V8.5H2.849zm7.233 6-1.34-5H5.492l-1.34 5z"
        }
      )
    }
  );
}
const J$ = /* @__PURE__ */ i(K$);
function X$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M3 3h10v7H3zm1 1v5h8V4zm10 8H2v-1h12z" })
    }
  );
}
const Y$ = /* @__PURE__ */ i(X$);
function Z$(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.779 3.843a5 5 0 0 0-1.802-.748l.195-.981a6 6 0 0 1 2.162.897zm-3.754-.747a5 5 0 0 0-1.803.746l-.555-.832a6 6 0 0 1 2.163-.895zM3.844 5.222a5 5 0 0 0-.748 1.802l-.981-.195c.15-.752.446-1.487.897-2.162zm-.747 3.753c.127.64.378 1.254.746 1.804l-.832.555a6 6 0 0 1-.895-2.164zm2.126 3.182a5 5 0 0 0 1.802.748l-.195.981a6 6 0 0 1-2.162-.897zM9.707 14H8v-1.707l4.5-4.5L14.207 9.5zm-.414-1 3.5-3.5-.293-.293-3.5 3.5V13z"
        }
      )
    }
  );
}
const _$ = /* @__PURE__ */ i(Z$);
function nS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 .921 14.992 5 8 9.079 1.008 5zM2.992 5 8 7.921 13.008 5 8 2.079zM1.238 7.926l.524-.852L8 10.913l6.238-3.839.524.852L8 12.087zm0 3 .524-.852L8 13.913l6.238-3.839.524.852L8 15.087z"
        }
      )
    }
  );
}
const lS = /* @__PURE__ */ i(nS);
function tS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m14.762 10.926-.624.384-.727-.727.827-.509zm0-3-2.481 1.527-.727-.727 2.684-1.652zm-5.397 2.147-1.13-1.131L8 9.079 1.008 5l2.075-1.21-1.437-1.436.708-.708 12 12-.708.708-1.697-1.697L8 15.087l-6.762-4.161.524-.852L8 13.913l3.223-1.983-1.13-1.13L8 12.087 1.238 7.926l.524-.852L8 10.913zM3.814 4.52 2.992 5l3.122 1.82zM14.992 5l-4.524 2.64-.731-.732L13.007 5 8 2.079l-1.953 1.14-.731-.732L8 .921z"
        }
      )
    }
  );
}
const iS = /* @__PURE__ */ i(tS);
function eS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 2h10v12H3zm1 1v10h2V3zm3 0v10h2V3zm3 0v10h2V3z"
        }
      )
    }
  );
}
const oS = /* @__PURE__ */ i(eS);
function rS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v12H2zm1 1v10h3V3zm4 0v4.5h6V3zm6 5.5H7V13h6z"
        }
      )
    }
  );
}
const hS = /* @__PURE__ */ i(rS);
function aS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v10H2zm1 1v3.5h2.5V4zm3.5 0v3.5h3V4zm4 0v3.5H13V4zM13 8.5h-2.5V12H13zM9.5 12V8.5h-3V12zm-4 0V8.5H3V12z"
        }
      )
    }
  );
}
const cS = /* @__PURE__ */ i(aS);
function dS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h3v3H2zm1 1v1h1V3zm11 1H6V3h8zM2 6h3v3H2zm1 1v1h1V7zm11 1H6V7h8zM2 10h3v3H2zm1 1v1h1v-1zm11 1H6v-1h8z"
        }
      )
    }
  );
}
const wS = /* @__PURE__ */ i(dS);
function vS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v10H2zm1 1v2h10V4zm10 3H3v2h10zm0 3H3v2h10z"
        }
      )
    }
  );
}
const mS = /* @__PURE__ */ i(vS);
function gS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 3h3v1h2v1.053l1.785-.479 2.071 7.728-2.898.776L10 9.502V13H3V5h2zm1 9h1V4H6zm2 0h1V5H8zm-3 0V6H4v6zm5.112-5.942 1.553 5.796.966-.26L11.078 5.8z"
        }
      )
    }
  );
}
const sS = /* @__PURE__ */ i(gS);
function fS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 2h3v1h2v1.053l1.786-.479 2.07 7.728-2.898.776L10.464 6.5H10V4H9v2.5H8V3H7v3.5H6V5H5v1.5H4V4h2zm5.113 3.058 1.552 5.796.966-.26L12.078 4.8zm-5.88 2.255 1.016.272h.502l1.017-.272 1.979.53 1.274 4.052-.442 1.647-1.171.479-1.075-.288-.34-1.268-1.493-.4-1.493.4-.34 1.268-1.075.288-1.171-.479-.442-1.647 1.275-4.052zm0 1.035-1.19.319-1.022 3.25.237.887.4.164.193-.052.34-1.267 2.31-.62 2.309.62.34 1.267.192.052.4-.164.237-.887-1.022-3.25-1.19-.32-.884.238h-.766z"
        }
      )
    }
  );
}
const uS = /* @__PURE__ */ i(fS);
function pS(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M1 2h14v12H1zm1 1v10h12V3z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M4 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7-.5h-1v-1h1zM13 8h-3V7h3zM4.14 9h3.72l1 3H3.14zm.72 1-.333 1h2.946l-.333-1zM13 10h-3V9h3zm0 2h-3v-1h3z"
          }
        )
      ]
    }
  );
}
const HS = /* @__PURE__ */ i(pS);
function MS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.945 3.44 1.009 1.748a3 3 0 0 1 2.092 0l1.009-1.748A5 5 0 0 0 8 3a5 5 0 0 0-2.055.44m4.975.501L9.912 5.688q.22.18.4.4l1.747-1.009a5 5 0 0 0-1.139-1.138m1.64 2.004-1.748 1.008a3 3 0 0 1 0 2.093l1.748 1.01A5 5 0 0 0 13 8c0-.733-.158-1.429-.44-2.055m-.501 4.976-1.747-1.009q-.18.22-.4.4l1.009 1.747c.438-.316.822-.7 1.138-1.138m-2.004 1.639-1.009-1.748a3 3 0 0 1-2.093 0L5.944 12.56A5 5 0 0 0 8 13a5 5 0 0 0 2.055-.44m-4.976-.502 1.009-1.746a3 3 0 0 1-.4-.4L3.941 10.92c.316.438.7.823 1.138 1.139M3.44 10.056l1.748-1.009a3 3 0 0 1 0-2.092L3.44 5.944A5 5 0 0 0 3 8c0 .733.157 1.428.44 2.055m.501-4.976 1.747 1.009q.18-.22.4-.4L5.079 3.941c-.437.316-.822.7-1.138 1.138M5 2.803a6.002 6.002 0 1 1 6 10.398A6.002 6.002 0 0 1 5 2.802M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
        }
      )
    }
  );
}
const xS = /* @__PURE__ */ i(MS);
function zS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a4 4 0 0 0-4 4c0 1.038.627 1.914 1.368 2.718q.132.145.265.282h1.715l-.903-3.37.966-.26L8 8.569l.589-2.197.966.258L8.652 10h1.715q.132-.136.265-.282C11.373 8.914 12 8.038 12 7a4 4 0 0 0-4-4m1.44 8H8.383l-.268 1H9c0-.248.092-.47.196-.65q.105-.18.243-.35M9 13H7v.293l.707.707h.586L9 13.293zm-2-1h.884l-.268-1H6.561c.09.114.174.231.243.35.104.18.196.402.196.65M3 7a5 5 0 0 1 10 0c0 1.447-.873 2.572-1.632 3.396-.173.187-.345.365-.504.528l-.056.058c-.176.182-.332.344-.463.494a2.5 2.5 0 0 0-.283.374c-.06.103-.062.148-.062.15v1.707L8.707 15H7.293L6 13.707V12c0-.002-.002-.047-.062-.15a2.5 2.5 0 0 0-.283-.374c-.131-.15-.286-.312-.463-.494l-.056-.057a28 28 0 0 1-.504-.53C3.873 9.573 3 8.448 3 7"
        }
      )
    }
  );
}
const VS = /* @__PURE__ */ i(zS);
function CS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.116 2h4.035L9.08 6h3.283L7 15.383V10H3.972zm.767 1L5.276 9H8v2.617L10.638 7H7.776l1.072-4z"
        }
      )
    }
  );
}
const LS = /* @__PURE__ */ i(CS);
function $S(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v12H2zm1 1v10h10V3zm5 2a2 2 0 0 0-2 2c0 .486.293.917.701 1.36q.133.143.266.279l.031.032c.097.1.197.203.285.303.08.092.162.194.229.304h.976c.067-.11.15-.212.23-.304.087-.1.187-.204.284-.303l.03-.032q.134-.136.267-.28C9.707 7.918 10 7.487 10 7a2 2 0 0 0-2-2m.333 5.278h-.666v.126l.262.263h.142l.262-.263zM5 7a3 3 0 0 1 6 0c0 .895-.54 1.575-.966 2.037q-.155.165-.314.33a7 7 0 0 0-.25.266 1.2 1.2 0 0 0-.137.18v1.005l-.848.849h-.97l-.848-.849V9.814l-.005-.008a1 1 0 0 0-.132-.173 7 7 0 0 0-.25-.266l-.03-.032a9 9 0 0 1-.284-.298C5.54 8.575 5 7.895 5 7m1.674 2.829v-.002zm2.102-2.775.448.894L8 8.56l-1.224-.614.448-.894L8 7.44z"
        }
      )
    }
  );
}
const SS = /* @__PURE__ */ i($S);
function kS(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 0 1 6 6v.293l.647-.647.707.708-1.854 1.853-1.853-1.853.707-.708.646.647zM.647 7.646 2.5 5.793l1.854 1.853-.707.708L3 7.707V8a5 5 0 0 0 5 5v1a6 6 0 0 1-6-6v-.293l-.646.647z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.833 10.638V9.154a1 1 0 0 0-.084-.107 6 6 0 0 0-.196-.209l-.025-.025c-.07-.073-.15-.155-.23-.24-.341-.372-.798-.94-.798-1.698a2.5 2.5 0 0 1 5 0c0 .757-.457 1.326-.799 1.697q-.12.13-.229.24l-.025.026a6 6 0 0 0-.196.21 1 1 0 0 0-.084.106v1.484l-.738.737h-.858zM6.5 6.875c0 .348.21.668.534 1.02q.105.112.212.221l.025.026q.118.12.23.247c.071.08.148.176.208.28a.86.86 0 0 1 .124.428v1.126l.152.152h.03l.152-.152V9.097a.86.86 0 0 1 .124-.428c.06-.104.137-.2.208-.28.071-.083.153-.167.231-.247l.024-.026q.107-.108.212-.221c.324-.352.534-.672.534-1.02a1.5 1.5 0 1 0-3 0"
          }
        )
      ]
    }
  );
}
const yS = /* @__PURE__ */ i(kS);
function bS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 .984 1.723l-5.261 5.26a2 2 0 1 1-.707-.707l5.26-5.26A2 2 0 0 1 10 4m-6 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    }
  );
}
const RS = /* @__PURE__ */ i(bS);
function BS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 6h5v2h2V6h5v5H9V9H7v2H2zm4 1H3v3h3V9H4.5V8H6zm4 2v1h3V7h-3v1h1.5v1z"
        }
      )
    }
  );
}
const FS = /* @__PURE__ */ i(BS);
function AS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 2.5V5h-1V2.5zM5.854 3.646l1.5 1.5-.708.708-1.5-1.5zm5 .708-1.5 1.5-.708-.708 1.5-1.5zM5.268 5.438l.507 1.892 1.088-.31.274.96-1.103.316.528 1.972-4.83 1.294-1.294-4.83zm-.707 1.225-2.898.776.777 2.898 2.897-.776-.265-.99-1.435.41-.274-.962 1.45-.414zm6.172-1.225 4.829 1.294-1.294 4.83-4.83-1.294.529-1.972-1.104-.315.274-.962 1.088.311zm-.07 4.123 2.898.776.776-2.898-2.898-.776-.252.942 1.45.414-.274.962-1.435-.41z"
        }
      )
    }
  );
}
const qS = /* @__PURE__ */ i(AS);
function OS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M14 5H9V4h5zm-9.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 11.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m12 .5H9v-1h5z"
        }
      )
    }
  );
}
const DS = /* @__PURE__ */ i(OS);
function PS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.354 2.354 3.5 6.207 1.646 4.354l.708-.708L3.5 4.793l3.146-3.147zM14 5H9V4h5zM7.354 9.354 3.5 13.207l-1.854-1.854.708-.707L3.5 11.793l3.146-3.147zM14 12H9v-1h5z"
        }
      )
    }
  );
}
const TS = /* @__PURE__ */ i(PS);
function WS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 2h1.01v1H4v3h.01v1H3zm11 3H7V4h7zM2 9h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3v1h1v-.01h1V14H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-1H3v.01H2zm12 3H7v-1h7z"
        }
      )
    }
  );
}
const GS = /* @__PURE__ */ i(WS);
function ES(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3C5.765 3 4 4.83 4 6.647c0 1.742 1.033 3.53 2.142 4.93A18 18 0 0 0 8 13.581q.15-.14.353-.337a18 18 0 0 0 1.505-1.667C10.967 10.177 12 8.389 12 6.647 12 4.83 10.235 3 8 3m0 11.25-.321.383h-.001l-.004-.004-.01-.01-.042-.034-.15-.132a19 19 0 0 1-2.115-2.255C4.217 10.756 3 8.742 3 6.648 3 4.227 5.264 2 8 2s5 2.227 5 4.647c0 2.095-1.217 4.11-2.358 5.55a19 19 0 0 1-2.264 2.388l-.041.035-.011.01-.004.002c0 .001-.001.001-.322-.382m0 0 .321.383-.321.269-.321-.269zM8 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      )
    }
  );
}
const NS = /* @__PURE__ */ i(ES);
function jS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.582 10.875 2.772 2.771-.707.708-2.638-2.638q-.183.25-.367.482A18 18 0 0 1 8 14.902a19 19 0 0 1-1.053-.943 19 19 0 0 1-1.589-1.761C4.217 10.756 3 8.742 3 6.648c0-.8.247-1.58.677-2.264l-2.03-2.03.707-.708 8.501 8.502C11.516 9.052 12 7.84 12 6.648 12 4.828 10.235 3 8 3c-.637 0-1.237.149-1.768.404l-.74-.74A5.1 5.1 0 0 1 8 2c2.736 0 5 2.227 5 4.647 0 .985-.27 1.953-.673 2.851a11 11 0 0 1-.745 1.377M10.293 11 4.409 5.116A3.2 3.2 0 0 0 4 6.647c0 1.742 1.033 3.53 2.142 4.93A18 18 0 0 0 8 13.581q.15-.14.353-.337a18 18 0 0 0 1.505-1.667q.22-.28.435-.577"
        }
      )
    }
  );
}
const US = /* @__PURE__ */ i(jS);
function IS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 5a3 3 0 0 1 6 0v2h1v7H4V7h1zm0 3v5h6V8zm5-3a2 2 0 1 0-4 0v2h4z"
        }
      )
    }
  );
}
const QS = /* @__PURE__ */ i(IS);
function KS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 5a3 3 0 0 1 5.94-.6l.01.05V7h-1V4.553A2.001 2.001 0 0 0 9 5v2h1v7H2V7h6zm1 3H3v5h6z"
        }
      )
    }
  );
}
const JS = /* @__PURE__ */ i(KS);
function XS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 4a4 4 0 1 1 0 8v-1a3 3 0 0 0 0-6H5a3 3 0 0 0 0 6h2.293L6.146 9.854l.708-.708L9.207 11.5l-2.353 2.354-.708-.708L7.293 12H5a4 4 0 1 1 0-8z"
        }
      )
    }
  );
}
const YS = /* @__PURE__ */ i(XS);
function ZS(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.708-9.285-9.286A3.001 3.001 0 0 0 5 11h2.293L6.146 9.854l.708-.708L9.207 11.5l-2.353 2.354-.708-.707L7.293 12H5a4 4 0 0 1-1.44-7.733L1.646 2.354zM15 8a4 4 0 0 1-1.259 2.913l-.707-.708A3 3 0 0 0 11 5H7.828l-1-1H11a4 4 0 0 1 4 4"
        }
      )
    }
  );
}
const _S = /* @__PURE__ */ i(ZS);
function nk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v8H9.902l.268 1H11v1H5v-1h.831l.268-1H2zm5.134 8-.268 1h2.268l-.268-1zM3 4v4h10V4zm10 5H3v1h10z"
        }
      )
    }
  );
}
const lk = /* @__PURE__ */ i(nk);
function tk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 13 13-.707.708L10.293 11h-.391l.268 1H11v1H5v-1h.831l.268-1H2V3h.293L.646 1.354zM3.293 4H3v4h4.293zm5 5H3v1h6.293zm-1.159 2-.268 1h2.268l-.268-1zM14 11h-.172l-1-1H13V9h-1.172l-1-1H13V4H6.828l-1-1H14z"
        }
      )
    }
  );
}
const ik = /* @__PURE__ */ i(tk);
function ek(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 8.354a6 6 0 1 1 12 0v6h-4v-6a2 2 0 1 0-4 0v6H2zm6-5a5 5 0 0 0-5 5v3h2v-3a3 3 0 0 1 6 0v3h2v-3a5 5 0 0 0-5-5m5 9h-2v1h2zm-8 0H3v1h2z"
        }
      )
    }
  );
}
const ok = /* @__PURE__ */ i(ek);
function rk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6.5a4.5 4.5 0 1 1 8.016 2.809l4.338 4.338-.707.707-4.338-4.338A4.5 4.5 0 0 1 2 6.5"
        }
      )
    }
  );
}
const hk = /* @__PURE__ */ i(rk);
function ak(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6.5a4.5 4.5 0 1 1 8.016 2.809l4.338 4.337-.707.707-4.338-4.337A4.5 4.5 0 0 1 2 6.5M9 7H4V6h5z"
        }
      )
    }
  );
}
const ck = /* @__PURE__ */ i(ak);
function dk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6.5a4.5 4.5 0 1 1 8.016 2.809l4.338 4.337-.707.707-4.338-4.337A4.5 4.5 0 0 1 2 6.5M6 6V4h1v2h2v1H7v2H6V7H4V6z"
        }
      )
    }
  );
}
const wk = /* @__PURE__ */ i(dk);
function vk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4M7 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m3 8v4H9v-5h1V7H6v3h1v5H6v-4H5V6h6v5z"
        }
      )
    }
  );
}
const mk = /* @__PURE__ */ i(vk);
function gk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4M3 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m8-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-1 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-.338 3h2.676l2.4 6H13v3h-1v-4h1.261l-1.6-4H10.34l-1.6 4H10v4H9v-3H7.261zM6 11v4H5v-5h1V7H2v3h1v5H2v-4H1V6h6v5z"
        }
      )
    }
  );
}
const sk = /* @__PURE__ */ i(gk);
function fk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.5 1.779v10.568l-4.47 1.676L6 13.015 1.5 14.14V3.11l4.53-1.133L10 3.466zm-5 2.568-3-1.126v8.889l3 .75zm1 8.431 3-1.125v-8.43l-3 1.124zm-5-.668V3.14l-3 .75v8.97z"
        }
      )
    }
  );
}
const uk = /* @__PURE__ */ i(fk);
function pk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 14 14-.707.708-2.227-2.227-2.39.896L6 13.015 1.5 14.14V3.11l.722-.18L.646 1.353zm1.693 3.108L2.5 3.89v8.97l3-.75V6.207zM6.5 7.207v4.903l3 .75v-2.653zm4 4v1.571l1.143-.428zm4 .439-1-1.017V3.222l-3 1.125v3.23l-1-1.017V4.347L6.053 3.054 6 3l-.849-.803.879-.22L10 3.466l4.5-1.687z"
        }
      )
    }
  );
}
const Hk = /* @__PURE__ */ i(pk);
function Mk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.711 5H9v6H8V6h-.711L5.5 9.098 3.711 6H3v5H2V5h2.289L5.5 7.098zm7.936 2.646.707.708-2.854 2.853-2.854-2.853.708-.708L12 9.293V5h1v4.293z"
        }
      )
    }
  );
}
const xk = /* @__PURE__ */ i(Mk);
function zk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.288 2 11.639.646l.708.708L11.7 2H14v3.113L8.5 8.289V14H11v1H5v-1h2.5V8.29L2 5.113V2h7.402a2 2 0 0 1 .19 0zm-.736 1h-.11a.5.5 0 1 0 .11 0m1.36 0A1.5 1.5 0 0 1 8.85 4.851l-1 1-.708-.707 1-1A1.5 1.5 0 0 1 8.08 3H3v1.536l5 2.887 5-2.887V3z"
        }
      )
    }
  );
}
const Vk = /* @__PURE__ */ i(zk);
function Ck(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7.819 4.389 4.39 7.818l-.707-.707L7.11 3.682zm2.512.487-5.455 5.455-.707-.707 5.455-5.455zm1.5 1.5-5.455 5.455-.707-.707 5.455-5.455zm-3.65 5.235 3.43-3.429.707.707-3.429 3.429z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2M3 8a5 5 0 1 0 10 0A5 5 0 0 0 3 8"
          }
        )
      ]
    }
  );
}
const Lk = /* @__PURE__ */ i(Ck);
function $k(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.146 5.146 4-4 .708.708-4 4zm0-3 1-1 .708.708-1 1zm7.708-.292L7.228 3.479l-.707-.707 1.625-1.626zm3 0-1.798 1.797-.707-.707 1.798-1.798zm3 0-2.965 2.964-.707-.707 2.965-2.965zm-2.505 4.09 1.798-1.798.707.708-1.798 1.796zM3.48 7.226 1.854 8.854l-.708-.708 1.628-1.627zm11.374.628-1.628 1.627-.707-.707 1.628-1.628zM3.651 10.056l-1.797 1.797-.708-.707L2.944 9.35zm6.496 4.09 4-4 .707.708-4 4zm-5.329-2.257-2.964 2.964-.708-.707 2.964-2.964zm-.672 2.257 1.798-1.797.707.707-1.797 1.798zm5.335-.92-1.627 1.627-.708-.707 1.628-1.626zm3.666.92 1-1 .707.708-1 1zM8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8M5 8a3 3 0 1 0 6 0 3 3 0 0 0-6 0"
        }
      )
    }
  );
}
const Sk = /* @__PURE__ */ i($k);
function kk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m4.054-2.552c-.21.042-.469.173-.702.406-.2.19-.34.434-.406.702-.043.214.013.319.053.359s.144.095.359.052c.21-.042.469-.173.702-.406s.364-.49.406-.701c.043-.215-.013-.32-.053-.36s-.144-.095-.359-.052m-.196-.98c.425-.086.912-.025 1.262.326.35.35.411.837.326 1.262-.086.43-.326.86-.68 1.212-.352.353-.783.594-1.212.68-.425.085-.912.024-1.262-.326s-.411-.837-.326-1.262c.086-.43.326-.86.68-1.213.352-.353.783-.594 1.212-.68M8 11a3 3 0 0 0 3-3h1a4 4 0 0 1-4 4zm-2.286.283.503-.86 1 .482-.36.93a4 4 0 0 1-1.143-.552"
        }
      )
    }
  );
}
const yk = /* @__PURE__ */ i(kk);
function bk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 4.23v-2.5h1v2.5h2.5v1H5v2.5H4v-2.5H1.5v-1zm10.354-1.647-12 12-.708-.707 12-12zm.146 9.646h-6v-1h6z"
        }
      )
    }
  );
}
const Rk = /* @__PURE__ */ i(bk);
function Bk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.065 2.579 7.982 6H8a2 2 0 1 1-1.927 1.465L3.005 5.694a5.5 5.5 0 1 0 4.06-3.115M3.506 4.83 6.573 6.6q.197-.2.443-.34l-.917-3.422a5.5 5.5 0 0 0-2.593 1.991M6.318 1.72a6.502 6.502 0 1 1 3.369 12.56 6.502 6.502 0 1 1-3.37-12.56M8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    }
  );
}
const Fk = /* @__PURE__ */ i(Bk);
function Ak(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.5 3c-.7 0-1.334.288-1.788.753l-.004.005-2.122 2.12 3.536 3.536 2.125-2.125A2.5 2.5 0 0 0 10.5 3m-1.085 7.121L5.879 6.586 3.754 8.71a2.5 2.5 0 1 0 3.535 3.535l.004-.004zM7.999 3.052a3.5 3.5 0 0 1 4.95 4.95l-4.947 4.945a3.5 3.5 0 0 1-4.95-4.95z"
        }
      )
    }
  );
}
const qk = /* @__PURE__ */ i(Ak);
function Ok(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 5.585a1.5 1.5 0 0 1 0 2.83v2.824L7.404 9H6v4H3V9H2V5h1V4h3v1h1.404L13 2.761zM7.596 8 12 9.76V4.239L7.596 6H6v2zM4 6H3v2h1v4h1V5H4z"
        }
      )
    }
  );
}
const Dk = /* @__PURE__ */ i(Ok);
function Pk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 4H3V3h10zm0 4H3V7h10zm0 4H3v-1h10z" })
    }
  );
}
const Tk = /* @__PURE__ */ i(Pk);
function Wk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 4a3 3 0 0 1 6 0v4a3 3 0 0 1-6 0zm3-2a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2m-.103 9.999A4 4 0 0 0 12 8h1a5 5 0 0 1-3.448 4.755L10.151 15H5.848l.602-2.245A5 5 0 0 1 3 8h1a4 4 0 0 0 3.897 3.999m-.469.969L7.152 14h1.697l-.275-1.033a5 5 0 0 1-1.146 0"
        }
      )
    }
  );
}
const Gk = /* @__PURE__ */ i(Wk);
function Ek(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 8c0 .645-.122 1.261-.344 1.827l-.792-.79Q12 8.538 12 8zm-2 0q0 .084-.005.167L10 7.172V4a2 2 0 0 0-3.873-.702l-.752-.751A3 3 0 0 1 11 4zm-1.262 2.445A3 3 0 0 1 5 8V5.707L1.646 2.354l.708-.708 12 12-.708.707-2.482-2.482a5 5 0 0 1-1.612.883L10.151 15H5.848l.602-2.245A5 5 0 0 1 3 8h1a4 4 0 0 0 6.453 3.16zm-.722-.722L6 6.707V8a2 2 0 0 0 3.016 1.723m-1.588 3.245L7.152 14h1.697l-.275-1.033a5 5 0 0 1-1.146 0"
        }
      )
    }
  );
}
const Nk = /* @__PURE__ */ i(Ek);
function jk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 1h2v1h1v7h-1.117l-.267 1H9.384l-.268-1H8V5.915q-.183.065-.383.08L6.007 12h7.877l.803 3H1.313l.803-3h.857l2.143-8h.97A1.5 1.5 0 0 1 8 3.085V2h1zm0 2v5h2V3zM6.085 5h-.201l-1.876 7h.965L6.65 5.737A1.5 1.5 0 0 1 6.085 5M8 4.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M2.884 13l-.268 1h10.768l-.268-1z"
        }
      )
    }
  );
}
const Uk = /* @__PURE__ */ i(jk);
function Ik(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 14h-1V2h1zM2 3.293 6.707 8 2 12.707zm12 0v9.414L9.293 8zM3 5.707v4.586L5.293 8zM10.707 8 13 10.293V5.707z"
        }
      )
    }
  );
}
const Qk = /* @__PURE__ */ i(Ik);
function Kk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.293 2h9.414L8 6.707zm2.414 1L8 5.293 10.293 3zM14 7.5v1H2v-1zM8 9.293 12.707 14H3.293zM5.707 13h4.586L8 10.707z"
        }
      )
    }
  );
}
const Jk = /* @__PURE__ */ i(Kk);
function Xk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 1h4v1H2v3H1zm13 1h-3V1h4v4h-1zM8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0m1 6v1H1v-4h1v3zm10-3v4h-4v-1h3v-3z"
        }
      )
    }
  );
}
const Yk = /* @__PURE__ */ i(Xk);
function Zk(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.05 4.5c.09.07.248.153.487.233C4.017 4.893 4.71 5 5.5 5s1.484-.107 1.963-.267A1.7 1.7 0 0 0 7.95 4.5a1.7 1.7 0 0 0-.487-.233C6.983 4.107 6.29 4 5.5 4s-1.484.107-1.963.267a1.7 1.7 0 0 0-.487.233M8 5.6a4 4 0 0 1-.22.081C7.172 5.884 6.366 6 5.5 6s-1.673-.116-2.28-.319a4 4 0 0 1-.22-.08v.855q.013.015.045.04c.09.07.25.156.492.237C4.017 6.893 4.71 7 5.5 7s1.484-.107 1.963-.267c.243-.081.403-.166.492-.236A.4.4 0 0 0 8 6.457zm0 2a4 4 0 0 1-.22.081C7.172 7.884 6.366 8 5.5 8s-1.673-.116-2.28-.319a4 4 0 0 1-.22-.08v.855q.013.015.045.04c.09.07.25.156.492.237C4.017 8.893 4.71 9 5.5 9c.806 0 1.507-.112 1.982-.274A3.6 3.6 0 0 1 8 8.051zm1-.263a3.5 3.5 0 1 1-1.741 4.486A8.3 8.3 0 0 1 5.5 12c-.867 0-1.673-.116-2.28-.319-.3-.1-.58-.23-.794-.399C2.217 11.117 2 10.857 2 10.5v-6c0-.357.217-.617.426-.782.215-.169.494-.3.795-.4C3.827 3.117 4.633 3 5.5 3s1.673.116 2.28.319c.3.1.58.23.794.399.209.165.426.425.426.782zM3 9.601v.855q.013.015.045.04c.09.07.25.156.492.237.48.16 1.173.267 1.963.267.57 0 1.091-.056 1.518-.148a3.5 3.5 0 0 1 .04-.988A8.6 8.6 0 0 1 5.5 10c-.867 0-1.673-.116-2.28-.319a4 4 0 0 1-.22-.08M10.5 8c-.64 0-1.224.24-1.667.636A2.501 2.501 0 1 0 10.5 8"
        }
      )
    }
  );
}
const _k = /* @__PURE__ */ i(Zk);
function ny(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m5.854 5.146.767.768a2.5 2.5 0 0 1 2.758 0l.768-.768.707.708-.768.767a2.5 2.5 0 0 1 0 2.758l.768.768-.707.707-.768-.768a2.5 2.5 0 0 1-2.758 0l-.767.768-.708-.707.768-.768a2.5 2.5 0 0 1 0-2.758l-.768-.767zM6.94 6.94a1.5 1.5 0 1 0 2.12 2.12 1.5 1.5 0 0 0-2.12-2.121"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2M3 8a5 5 0 1 0 10 0A5 5 0 0 0 3 8"
          }
        )
      ]
    }
  );
}
const ly = /* @__PURE__ */ i(ny);
function ty(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4M7 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M15 12H1V4h14zM3 6V5H2v1zm1 3v2h8V9h2V7h-2V5H4v2H2v2zm10-3V5h-1v1zm-1 5h1v-1h-1zM2 10v1h1v-1z"
          }
        )
      ]
    }
  );
}
const iy = /* @__PURE__ */ i(ty);
function ey(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m7.311 2.946 1.004.063a5 5 0 1 1-4.48 7.76L3.28 9.93l1.004.063a4 4 0 0 0 3.584-6.209zm1.882 1.235A4.99 4.99 0 0 1 8.866 8.5a4.99 4.99 0 0 1-3.576 2.443q.32.293.71.521a4 4 0 1 0 3.193-7.283"
        }
      )
    }
  );
}
const oy = /* @__PURE__ */ i(ey);
function ry(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-2.482-2.482a5 5 0 0 1-7.33-1.104L3.28 9.93l1.004.063a4 4 0 0 0 3.435-1.568L1.646 2.354zM8.43 9.137a5 5 0 0 1-3.14 1.806q.32.293.71.521a4 4 0 0 0 4.453-.303zM10.5 3.67a5 5 0 0 1 2.155 6.157l-.79-.791a4 4 0 0 0-2.672-4.855c.306.783.413 1.638.3 2.483l-.968-.968a4 4 0 0 0-.658-1.912l-.556-.838 1.004.063a5 5 0 0 1 2.185.66"
        }
      )
    }
  );
}
const hy = /* @__PURE__ */ i(ry);
function ay(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      )
    }
  );
}
const cy = /* @__PURE__ */ i(ay);
function dy(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      )
    }
  );
}
const wy = /* @__PURE__ */ i(dy);
function vy(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 1.86 5.562 3h4.876L15 1.86v12.28L10.438 13H5.562L1 14.14zM6 12h4v-2H6zm0-3h4V7H6zm0-3h4V4H6zM5 3.89l-3-.75v2.42l3 .375zm0 3.051-3-.375v2.868l3-.375zm0 3.125-3 .375v2.419l3-.75zm6-6.176v2.044l3-.375V3.14zm3 2.676-3 .375V9.06l3 .375zm0 3.875-3-.375v2.044l3 .75z"
        }
      )
    }
  );
}
const my = /* @__PURE__ */ i(vy);
function gy(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1.456 14.842 14H1.158zm-1.675 5.16 1.111.74.89-.889 1.385.214L8 3.544zm3.988 1.17-1.639-.253-1.11 1.11-1.72-1.146L2.842 13h10.316z"
        }
      )
    }
  );
}
const sy = /* @__PURE__ */ i(gy);
function fy(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h10v9a5 5 0 0 1-10 0zm1 1v3.5h3.5V2zm4.5 0v3.5H12V2zM12 6.5H4V10a4 4 0 1 0 8 0z"
        }
      )
    }
  );
}
const uy = /* @__PURE__ */ i(fy);
function py(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h10v9a5 5 0 0 1-10 0zm1 1v3.5h3.5V2zm4.5 0v3.5H12V2zM12 6.5H4V10a4 4 0 1 0 8 0zm-1.75-3a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M9 3.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0"
        }
      )
    }
  );
}
const Hy = /* @__PURE__ */ i(py);
function My(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h10v9a5 5 0 0 1-10 0zm1 1v3.5h2V2zm3 0v3.5h2V2zm3 0v3.5h2V2zm2 4.5H4V10a4 4 0 1 0 8 0z"
        }
      )
    }
  );
}
const xy = /* @__PURE__ */ i(My);
function zy(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h10v9a5 5 0 0 1-10 0zm1 1v3.5h2.5V5a1.5 1.5 0 0 1 1-1.415V2zm4.5 0v1.585c.6.212 1 .779 1 1.415v.5H12V2zM12 6.5H9.5V7a1.5 1.5 0 1 1-3 0v-.5H4V10a4 4 0 1 0 8 0zm-4-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"
        }
      )
    }
  );
}
const Vy = /* @__PURE__ */ i(zy);
function Cy(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 1h10v9a5 5 0 0 1-10 0zm1 1v3.5h2.5V5a1.5 1.5 0 0 1 1-1.415V2zm4.5 0v1.585c.6.212 1 .779 1 1.415v.5H12V2zM12 6.5H9.5V7a1.5 1.5 0 1 1-3 0v-.5H4V10a4 4 0 1 0 8 0zM7.5 6a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0"
        }
      )
    }
  );
}
const Ly = /* @__PURE__ */ i(Cy);
function $y(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 1.293 2.354 2.353-.708.708L8.5 3.207V7.5h4.293l-1.146-1.146.707-.708L14.707 8l-2.353 2.354-.707-.708L12.793 8.5H8.5v4.293l1.146-1.146.708.707L8 14.707l-2.354-2.353.708-.707L7.5 12.793V8.5H3.207l1.147 1.146-.708.708L1.293 8l2.353-2.354.708.708L3.207 7.5H7.5V3.207L6.354 4.354l-.708-.708z"
        }
      )
    }
  );
}
const Sy = /* @__PURE__ */ i($y);
function ky(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.646 3.98 8.5 2.832V4.5h-1V2.832L6.354 3.978l-.708-.708L8 .918l2.354 2.353zM8 5.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M6.5 8a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0m-2-.5v1H2.832l1.147 1.146-.708.708L.918 8l2.354-2.354.708.708L2.832 7.5zm8.227 2.854-.707-.708L13.168 8.5H11.5v-1h1.668l-1.147-1.146.707-.708L15.082 8zm-7.081 2.375.708-.707L7.5 13.168V11.5h1v1.668l1.146-1.147.708.708L8 15.082z"
        }
      )
    }
  );
}
const yy = /* @__PURE__ */ i(ky);
function by(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 2.382.447.894c.13.258.312.539.519.856q.178.27.37.58c.166.269.327.552.449.83.118.274.215.58.215.887a2 2 0 1 1-4 0c0-.307.097-.613.216-.886.12-.279.283-.562.448-.83q.192-.31.37-.58c.207-.318.39-.599.519-.857zm-.867 3.56C7.037 6.16 7 6.32 7 6.428a1 1 0 0 0 2 0c0-.108-.037-.268-.133-.488a6 6 0 0 0-.382-.704 25 25 0 0 0-.311-.487L8 4.482l-.173.268c-.11.169-.218.334-.312.487-.156.254-.29.49-.382.704M7.5 14c0-.365-.077-.626-.19-.817a1.2 1.2 0 0 0-.486-.454c-.443-.24-1.084-.322-1.803-.292-.706.03-1.422.163-1.969.292a13 13 0 0 0-.835.227l-.046.014-.01.004h-.003L2 12.5l-.158-.474.002-.001.004-.001.015-.005.055-.018.2-.06c.17-.05.414-.117.705-.185a12 12 0 0 1 2.156-.318c.514-.022 1.063.004 1.572.129a5 5 0 0 0-.834-.717 6.5 6.5 0 0 0-1.806-.856l-.027-.008-.005-.001L4 9.5l.122-.485h.002l.003.001.012.004q.092.023.182.053c.697.22 1.358.542 1.962.953.633.434 1.285 1.047 1.717 1.877.432-.83 1.085-1.443 1.717-1.878A7.5 7.5 0 0 1 11.86 9.02l.012-.004h.004c.001 0 .002-.001.123.484l.122.485-.006.001-.026.008-.113.033a6.5 6.5 0 0 0-1.694.822 5 5 0 0 0-.834.718c.51-.125 1.058-.15 1.572-.13a12 12 0 0 1 2.156.319q.457.107.906.245l.054.018.015.005.004.001h.001L14 12.5l-.158.474h-.002l-.011-.004-.046-.014-.18-.055q-.325-.094-.655-.172a11 11 0 0 0-1.969-.292c-.72-.03-1.36.052-1.803.292a1.2 1.2 0 0 0-.487.454c-.111.191-.189.452-.189.817z"
        }
      )
    }
  );
}
const Ry = /* @__PURE__ */ i(by);
function By(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 4V1h1v3zM3 4V2h1v2zm5 0V2h1v2zM2 5h9v1h3.393l-1.607 6H11v.566L10.616 14H2.384L2 12.566zm9 6h1.018l1.072-4H11zm-1-5H3v6.434l.152.566h6.696l.152-.566z"
        }
      )
    }
  );
}
const Fy = /* @__PURE__ */ i(By);
function Ay(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 8v5H4V8zm2 3v2H6v-2zm2 0v2H8v-2z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4.5 1a2.5 2.5 0 0 1 2.112 1.162 2.49 2.49 0 0 1 2.214.219A2 2 0 1 1 11 5.732V6h3v7h-3v.566L10.616 15H2.384L2 13.565v-7.65a1.5 1.5 0 0 1 .036-2.842A2.5 2.5 0 0 1 4.5 1M10 6q-.238 0-.46-.053c-.15.21-.333.398-.54.553v2a1.5 1.5 0 1 1-3 0v-2a2.5 2.5 0 0 1-.612-.662 2.5 2.5 0 0 1-2.025-.111q-.167.117-.363.188v7.52l.152.565h6.696l.152-.566zM3 4h-.5a.5.5 0 0 0-.5.5.498.498 0 0 0 .9.3l.3-.4.4.3a1.5 1.5 0 0 0 1.734.047l.536-.36.214.61a1.5 1.5 0 0 0 .666.803l.25.144V8.5a.5.5 0 0 0 1 0V5.944l.25-.144c.268-.155.483-.391.613-.673l.218-.473.464.237a1 1 0 1 0-.308-1.538l-.337.398-.383-.354a1.5 1.5 0 0 0-1.851-.144l-.536.36-.214-.61A1.5 1.5 0 0 0 3 3.5zm10 3h-2v5h2z"
          }
        )
      ]
    }
  );
}
const qy = /* @__PURE__ */ i(Ay);
function Oy(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 3h14v9H1zm1 1v3h12V4zm12 4H2v3h12zM4 6H3V5h1zm0 4H3V9h1z"
        }
      )
    }
  );
}
const Dy = /* @__PURE__ */ i(Oy);
function Py(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 3a2 2 0 1 1 2.5 1.937v1.626c.512.132.944.461 1.211.902l1.29-.387L11 7a2 2 0 1 1 .289 1.035l-1.29.387L10 8.5c0 .513-.193.98-.51 1.334l.852 1.277a2 2 0 1 1-.832.555l-.852-1.277a2 2 0 0 1-1.316 0l-.852 1.277a2 2 0 1 1-.832-.555l.852-1.277A2 2 0 0 1 6 8.422l-1.29-.387a2 2 0 1 1 .287-.958l1.29.388c.268-.44.7-.77 1.212-.902V4.937A2 2 0 0 1 6 3M3 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2m10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M8 7.5a1 1 0 1 0 0 2.001A1 1 0 0 0 8 7.5M5 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2m6 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    }
  );
}
const Ty = /* @__PURE__ */ i(Py);
function Wy(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m4.147 4.646.707.708L2.207 8l2.647 2.646-.707.708L.793 8zM13.793 8l-2.646-2.646.707-.708L15.207 8l-3.353 3.354-.707-.707zM4 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const Gy = /* @__PURE__ */ i(Wy);
function Ey(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 2h4v3H6zm1 1v1h2V3zm3 4H6V6h4zm-1.5 3.08 1.63.437-.26.966L8 10.982l-1.87.501-.26-.966 1.63-.437V7.964h1zM1 9h4v3H1zm1 1v1h2v-1zm9-1h4v3h-4zm1 1v1h2v-1zm-7 4H1v-1h4zm10 0h-4v-1h4z"
        }
      )
    }
  );
}
const Ny = /* @__PURE__ */ i(Ey);
function jy(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 8c0-1.657.672-3.157 1.757-4.243l.708.707A4.98 4.98 0 0 0 2 8c0 1.38.56 2.63 1.465 3.536l-.708.707A5.98 5.98 0 0 1 1 8m12.243-4.243A5.98 5.98 0 0 1 15 8a5.98 5.98 0 0 1-1.757 4.243l-.707-.707A4.98 4.98 0 0 0 14 8c0-1.38-.559-2.63-1.464-3.536zM3 8c0-1.104.448-2.105 1.172-2.828l.707.707a3 3 0 0 0 0 4.242l-.707.707A4 4 0 0 1 3 8m8.829-2.828a4 4 0 0 1 0 5.656l-.708-.707a3 3 0 0 0 0-4.242zM8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      )
    }
  );
}
const Uy = /* @__PURE__ */ i(jy);
function Iy(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 12 12-.708.708-4.63-4.63a2 2 0 0 1-2.74-2.74l-4.63-4.63zm4.68 6.095a1 1 0 0 0 1.225 1.225zM11.83 9a3 3 0 0 0-.709-3.121l.707-.707a4 4 0 0 1 .763 4.591z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M15 8a5.97 5.97 0 0 1-.942 3.23l-.728-.728c.426-.736.67-1.59.67-2.502 0-1.38-.56-2.63-1.464-3.536l.707-.707A5.98 5.98 0 0 1 15 8M4.393 6.514a3 3 0 0 0 .486 3.607l-.707.707a4 4 0 0 1-.505-5.04z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 8a4.98 4.98 0 0 0 1.464 3.536l-.707.707a6 6 0 0 1-.523-7.888l.714.715A4.97 4.97 0 0 0 2 8"
          }
        )
      ]
    }
  );
}
const Qy = /* @__PURE__ */ i(Iy);
function Ky(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m4.286 8-.683-1.092a2 2 0 1 1 1.01-3.091l1.403-.562a2 2 0 1 1 3.968 0l1.404.561a2 2 0 1 1 1.01 3.091L11.715 8l.683 1.092q.285-.09.602-.092a2 2 0 1 1-1.612 3.184l-1.404.561q.015.126.016.255a2 2 0 1 1-3.984-.255l-1.404-.562a2 2 0 1 1-1.01-3.091zm.698-3.255a2 2 0 0 1-.066.823l.646.387.986-1.578a2 2 0 0 1-.162-.193zm4.466 6.878q.088.092.162.194l1.404-.562a2 2 0 0 1 .066-.823l-.645-.387zM8 11q.317 0 .603.092l.976-1.561-.176-.106a2 2 0 0 1-2.806 0l-.176.105.977 1.562q.285-.09.602-.092m-3.082-.568a2 2 0 0 1 .066.823l1.404.561a2 2 0 0 1 .162-.193l-.986-1.578zm4.694-6.249a2 2 0 0 1-.162.194l.987 1.578.645-.387a2 2 0 0 1-.066-.823zm-1.01.725a2 2 0 0 1-1.205 0L6.42 6.47l.177.105a2 2 0 0 1 2.806 0l.176-.105zM4.527 9.5l.507-.304-.159-.254zm6.009-1.501-.427-.682-.19.114a2 2 0 0 1 0 1.136l.19.114zM5.465 8l.426.682.19-.114a2 2 0 0 1 0-1.136l-.19-.114zm5.502-1.197.158.254.349-.558zm0 2.394.507.304-.349-.558zM5.034 6.803 4.527 6.5l.348.558zM8 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0M3 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m11 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0M3 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0M8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
        }
      )
    }
  );
}
const Jy = /* @__PURE__ */ i(Ky);
function Xy(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v12h-1.185l-.753-.646-1.312.716-1.375-.75L8 14.07l-1.375-.75-1.365.744-1.411-.706-.642.642H2zm1 1v9.793l.651-.651 1.589.794 1.385-.755L8 12.93l1.375-.75 1.375.75 1.438-.785.812.695V3zm1 1h4v3H4zm1 1v1h2V5zm7 0H9V4h3zm0 2H9V6h3zM4 9V8h8v1zm8 1v1H4v-1z"
        }
      )
    }
  );
}
const Yy = /* @__PURE__ */ i(Xy);
function Zy(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 7.713V3.5h1v9h-1V8.287L4 12.37V3.63zM5 10.63 9.508 8 5 5.37z"
        }
      )
    }
  );
}
const _y = /* @__PURE__ */ i(Zy);
function nb(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708L9.793 10.5H3.5v-1h5.293l-3-3H3.5v-1h1.293L1.646 2.354zM12.5 6.5H9.328l-1-1H12.5z"
        }
      )
    }
  );
}
const lb = /* @__PURE__ */ i(nb);
function tb(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 3h8v9a2 2 0 1 1-2-2h1V6H6v6a2 2 0 1 1-2-2h1zm0 8H4a1 1 0 1 0 1 1zm1-6h6V4H6zm6 6h-1a1 1 0 1 0 1 1z"
        }
      )
    }
  );
}
const ib = /* @__PURE__ */ i(tb);
function eb(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 1.5h1v5h-1zm1 7a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1v1h2v1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-1h-1v.01h-1V8.5zm3-3h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2v-1h2v-1h-1v-1h1v-1h-2z"
        }
      )
    }
  );
}
const ob = /* @__PURE__ */ i(eb);
function rb(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M15 12H1V4h14zM2 5.337v4.446l2.107-3.311zm2.99 1.61L2.41 11h7.317l.717-1.116zm6.337 3.413-.411.64h1.6zM14 6.202l-2.13 3.314L14 10.663zM13.584 5H3.483l7.504 4.04z"
        }
      )
    }
  );
}
const hb = /* @__PURE__ */ i(rb);
function ab(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.5 15v-1.23L4 12.484V1h8v14zM5 11.627l.89-.764 3.15-5.85L5 2.416zm4.884-6.072L6.947 11.01 11 13.59V6.272zM11 3.483l-.64 1.189.64.412zM10.663 2h-4.46l3.313 2.13zm-.881 12-3.451-2.197L3.768 14z"
        }
      )
    }
  );
}
const cb = /* @__PURE__ */ i(ab);
function db(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 7h-1V3.707L7.354 9.354l-.708-.708L12.293 3H9V2h5z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7 4H3v9h9V9h1v5H2V3h5z" })
      ]
    }
  );
}
const wb = /* @__PURE__ */ i(db);
function vb(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 9V6h1v3zm6-3v3h-1V6z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4.293 2h7.414L14 4.293v7.414L11.707 14H4.293L2 11.707V4.293zm.414 1L3 4.707v6.586L4.707 13h6.586L13 11.293V4.707L11.293 3z"
          }
        )
      ]
    }
  );
}
const mb = /* @__PURE__ */ i(vb);
function gb(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 5v3H5V5zm4 3V5h1v3zM8 9a1 1 0 0 1 1 1v1H7v-1a1 1 0 0 1 1-1"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 4.293v7.414L11.707 14H4.293L2 11.707V4.293L4.293 2h7.414zm-11 7L4.707 13h6.586L13 11.293V4.707L11.293 3H4.707L3 4.707z"
          }
        )
      ]
    }
  );
}
const sb = /* @__PURE__ */ i(gb);
function fb(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m5-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m6-5a5 5 0 1 0 0 10A5 5 0 0 0 8 3"
          }
        )
      ]
    }
  );
}
const ub = /* @__PURE__ */ i(fb);
function pb(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0M8 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2M3 8a5 5 0 1 0 10 0A5 5 0 0 0 3 8"
          }
        )
      ]
    }
  );
}
const Hb = /* @__PURE__ */ i(pb);
function Mb(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8.5 5v2h-1V5zM7 10H5V9h2zm2-1h2v1H9z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2M3 8a5 5 0 1 0 10 0A5 5 0 0 0 3 8"
          }
        )
      ]
    }
  );
}
const xb = /* @__PURE__ */ i(Mb);
function zb(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m5.354 6.146 1.5 1.5-.708.708-1.5-1.5zm3.792 1.5 1.5-1.5.708.708-1.5 1.5zM8.5 9.5V12h-1V9.5z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2M3 8a5 5 0 1 0 10 0A5 5 0 0 0 3 8"
          }
        )
      ]
    }
  );
}
const Vb = /* @__PURE__ */ i(zb);
function Cb(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m9.854 6.146 2 2-.708.708-2-2zm-5.708 2 2-2 .708.708-2 2zM8.5 9.5V12h-1V9.5z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2M3 8a5 5 0 1 0 10 0A5 5 0 0 0 3 8"
          }
        )
      ]
    }
  );
}
const Lb = /* @__PURE__ */ i(Cb);
function $b(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2M5 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2m5 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M15 5.793v4.414L13.207 12H2.793L1 10.207V5.793L2.793 4h10.414zm-13 4L3.207 11h9.586L14 9.793V6.207L12.793 5H3.207L2 6.207z"
          }
        )
      ]
    }
  );
}
const Sb = /* @__PURE__ */ i($b);
function kb(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2m4 3v1a1 1 0 0 1-2 0v-1zm2-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2M3 8a5 5 0 1 0 10 0A5 5 0 0 0 3 8"
          }
        )
      ]
    }
  );
}
const yb = /* @__PURE__ */ i(kb);
function bb(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m2 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M15 5.793v4.414L13.207 12H2.793L1 10.207V5.793L2.793 4h10.414zm-13 4L3.207 11h9.586L14 9.793V6.207L12.793 5H3.207L2 6.207z"
          }
        )
      ]
    }
  );
}
const Rb = /* @__PURE__ */ i(bb);
function Bb(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 9H2V2h7zM8 8V3H3v5zm3.353 2.146 2.354 2.354-2.354 2.353-.707-.707L11.793 13H2v-1h9.793l-1.147-1.146zM10 2h1v1h-1zm2 0h2v2h-1V3h-1zm2 3v1h-1V5zm0 2v2h-2V8h1V7zm-3 2h-1V8h1z"
        }
      )
    }
  );
}
const Fb = /* @__PURE__ */ i(Bb);
function Ab(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v12H2zm1 1v10h10V3h-3v3H6V3zm4 0v2h2V3zM4.646 7.568 8.51 8.603l-1.035 3.864L3.61 11.43zm.708 1.224-.518 1.932 1.932.518.517-1.932zM11.5 10H9V9h2.5zm-.5 1v1H9v-1z"
        }
      )
    }
  );
}
const qb = /* @__PURE__ */ i(Ab);
function Ob(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3C4.607 3 2 5.35 2 8c0 .948.146 1.75.545 2.473.398.723 1.074 1.415 2.212 2.098.933.56 1.658.547 1.957.38a.35.35 0 0 0 .194-.305c.011-.171-.052-.46-.324-.869-.388-.581-.456-1.201-.262-1.733.19-.518.613-.91 1.125-1.074.88-.281 1.75-.106 2.83.614.835.557 1.79.646 2.508.366C13.474 9.68 14 9.049 14 8c0-1.644-.66-2.874-1.713-3.703C11.22 3.457 9.712 3 8 3M1 8c0-3.35 3.213-6 7-6 1.877 0 3.62.499 4.906 1.511C14.204 4.534 15 6.055 15 8c0 1.451-.77 2.457-1.851 2.88-1.055.413-2.35.253-3.426-.464-.92-.613-1.473-.653-1.972-.493a.77.77 0 0 0-.49.464c-.074.205-.073.494.155.836.341.511.521 1.019.49 1.488a1.34 1.34 0 0 1-.705 1.114c-.76.423-1.897.24-2.958-.396-1.245-.747-2.069-1.555-2.575-2.474S1 9.052 1 8m6-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0m6 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M3 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
        }
      )
    }
  );
}
const Db = /* @__PURE__ */ i(Ob);
function Pb(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.725 8.732a2.5 2.5 0 1 0 3.535 3.536l4.89-4.89.707.708-4.89 4.889a3.5 3.5 0 0 1-4.95-4.95l5.658-5.657a2.5 2.5 0 0 1 3.535 3.536L6.553 11.56a1.5 1.5 0 0 1-2.121-2.122l4.89-4.889.706.707-4.889 4.89a.5.5 0 1 0 .707.707l5.657-5.657a1.5 1.5 0 0 0-2.121-2.122z"
        }
      )
    }
  );
}
const Tb = /* @__PURE__ */ i(Pb);
function Wb(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M.747 1.623 15.242 8 .747 14.377 2.456 8zM3.357 8.5l-1.104 4.123L12.758 8 2.253 3.377 3.357 7.5H8v1z"
        }
      )
    }
  );
}
const Gb = /* @__PURE__ */ i(Wb);
function Eb(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 13H9V4H7v9H6V8h-.5a2.5 2.5 0 0 1 0-5H12v1h-2zM5.5 4a1.5 1.5 0 1 0 0 3H6V4z"
        }
      )
    }
  );
}
const Nb = /* @__PURE__ */ i(Eb);
function jb(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 1a3.5 3.5 0 0 1 3.355 4.5A3.5 3.5 0 0 1 12 9.965V13h1.5v1H2v-1h.882l2-1-2-1H2.5v-1h7v1h-.382l-2 1 2 1H11V9.965A3.5 3.5 0 0 1 8.145 5.5 3.5 3.5 0 0 1 11.5 1M9 4.5c0 .284.048.565.142.833l.059.167-.059.167a2.5 2.5 0 1 0 4.716 0l-.059-.167.059-.167A2.5 2.5 0 1 0 9 4.5M6.882 13 6 12.559 5.118 13zm0-2H5.118l.882.441z"
        }
      )
    }
  );
}
const Ub = /* @__PURE__ */ i(jb);
function Ib(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 12V4h1v8zm5 0V4h1v8z" })
    }
  );
}
const Qb = /* @__PURE__ */ i(Ib);
function Kb(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M6 4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M2 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M3.5 7a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-.5 1.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0m1.5 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M8 7c.648 0 1.266.11 1.873.639.569.499 1.087 1.334 1.671 2.659.316.716.412 1.35.273 1.9-.142.563-.507.954-.943 1.215C10.042 13.912 8.856 14 8 14c-.898 0-2.074-.193-2.894-.74-.421-.281-.78-.676-.922-1.215s-.043-1.136.284-1.774c.583-1.133 1.096-1.944 1.64-2.473C6.68 7.243 7.285 7 8 7m-2.642 3.729c-.25.487-.269.827-.207 1.061.062.236.227.449.509.638.587.39 1.533.572 2.34.572.85 0 1.785-.1 2.359-.444.268-.161.426-.356.488-.602.066-.259.045-.656-.218-1.252-.573-1.3-1.019-1.964-1.415-2.31C8.856 8.078 8.51 8 8 8c-.442 0-.8.132-1.195.515-.42.408-.872 1.096-1.447 2.214"
        }
      )
    }
  );
}
const Jb = /* @__PURE__ */ i(Kb);
function Xb(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 3h14v10H1zm1 1v1h12V4zm12 2H2v.5h12zm0 1.5H2V12h12zM9 10H3V9h6zm4 0h-2V9h2z"
        }
      )
    }
  );
}
const Yb = /* @__PURE__ */ i(Xb);
function Zb(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 1.793 14.207 4.5l-9.5 9.5H2v-2.707zM3 11.707V13h1.293l6.5-6.5L9.5 5.207zM10.207 4.5 11.5 5.793 12.793 4.5 11.5 3.207z"
        }
      )
    }
  );
}
const _b = /* @__PURE__ */ i(Zb);
function nR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 0 0-3.213 11.068l-.536.845a7 7 0 1 1 7.498 0l-.536-.845A6 6 0 0 0 8 2m0 5.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M6.5 8a1.5 1.5 0 0 1 2.996-.117l2.981.799-.259.966-2.981-.799A1.5 1.5 0 0 1 6.5 8"
        }
      )
    }
  );
}
const lR = /* @__PURE__ */ i(nR);
function tR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 0 0-3.213 11.068l-.536.845a7 7 0 1 1 7.498 0l-.536-.845A6 6 0 0 0 8 2m0 5.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.496.383a1.5 1.5 0 1 1 .26.966l-2.982.799-.26-.966z"
        }
      )
    }
  );
}
const iR = /* @__PURE__ */ i(tR);
function eR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a6 6 0 0 0-3.213 11.068l-.536.845a7 7 0 1 1 7.498 0l-.536-.845A6 6 0 0 0 8 2m1.817 1.85.866.5-1.544 2.675a1.5 1.5 0 1 1-.866-.5zM8 7.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1"
        }
      )
    }
  );
}
const oR = /* @__PURE__ */ i(eR);
function rR(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 9H8V8h5V3H5v2H4V2h10zm-6 1h7v1H8z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7 14H2V6h5zm-1-3V7H5v1H4V7H3v4zm-3 1v1h3v-1z"
          }
        )
      ]
    }
  );
}
const hR = /* @__PURE__ */ i(rR);
function aR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 3h14v10H1zm1 1v8h12V4zm5 1h6v4H7zm1 1v2h4V6z"
        }
      )
    }
  );
}
const cR = /* @__PURE__ */ i(aR);
function dR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 5H2V2h12zm-1-1V3H3v1zM2 7h12v1H2zm0 3h12v1H2zm12 4H2v-1h12z"
        }
      )
    }
  );
}
const wR = /* @__PURE__ */ i(dR);
function vR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.454 2H4.5V1h7v1h-.954l.422 4.84L12 7.116V10H8.5v5h-1v-5H4V7.116l1.032-.276zm1.004 0-.49 5.624-.968.26V9h6V7.884l-.968-.26L9.542 2z"
        }
      )
    }
  );
}
const mR = /* @__PURE__ */ i(vR);
function gR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 7.116v2.056l-1-1v-.288l-.393-.106-.615-.614L9.542 2H6.458l-.13 1.5-.924-.924.05-.576h-.626L4.5 1.672V1h7v1h-.954l.422 4.84zM8.5 10v5h-1v-5H4V7.116l1.032-.276.089-1.012-3.475-3.474.708-.708 12 12-.707.708L9.293 10zM6.043 6.751l-.075.873-.968.26V9h3.293z"
        }
      )
    }
  );
}
const sR = /* @__PURE__ */ i(gR);
function fR(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8.5 7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M8 8.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3.5 2a12.5 12.5 0 0 1 10.827 6.249l.251.433L3 15.366V2zM4 13.634l1.608-.928A1.5 1.5 0 1 1 7.99 11.33l3.477-2.007A9.5 9.5 0 0 0 4 5.013v1.072a1.5 1.5 0 1 1 0 2.83zM4 7.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0m0-3.488c3.5.164 6.55 2.041 8.334 4.81l.867-.5A11.5 11.5 0 0 0 4 3.01zM6.5 11a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1"
          }
        )
      ]
    }
  );
}
const uR = /* @__PURE__ */ i(fR);
function pR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M2.5 8a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M7 4.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M2 6v5H1V6zm12 5V6h1v5zm-1-5v5h-1V6z"
        }
      )
    }
  );
}
const HR = /* @__PURE__ */ i(pR);
function MR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 3.63 12.492 8 5 12.37zm1 1.74v5.26L10.508 8z"
        }
      )
    }
  );
}
const xR = /* @__PURE__ */ i(MR);
function zR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 4V1h1v3h2V1h1v3h3v1h-1v2.365L11.294 10H8.5v1.5A2.5 2.5 0 0 1 6 14H3v-1h3a1.5 1.5 0 0 0 1.5-1.5V10H4.706L4 7.365V5H3V4zM5 5v2.233L5.473 9h5.054L11 7.233V5z"
        }
      )
    }
  );
}
const VR = /* @__PURE__ */ i(zR);
function CR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m13.647 1.646.707.708L12.708 4l.9.901-1.197 2.395-.704.704.647.646-.707.708L11 8.707 6.647 4.354l.707-.708.646.647.704-.704 2.395-1.197.901.901zM11 7.293l.59-.59.802-1.604-1.49-1.49-1.606.802L8.707 5zm-5.5.5 1.646-1.647.708.708L6.207 8.5 7.5 9.793l1.646-1.647.708.707L8.207 10.5l1.147 1.146-.708.707L8 11.708l-.704.704-2.395 1.197-.901-.9-1.646 1.646-.708-.708L3.293 12l-.901-.901 1.197-2.395L4.293 8l-.647-.646.708-.708.646.647zm-.5.914-.589.59-.803 1.604 1.49 1.49 1.606-.802.589-.589z"
        }
      )
    }
  );
}
const LR = /* @__PURE__ */ i(CR);
function $R(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 1h8v7h1v3.678l-3 .804V15H6v-2.518l-3-.804V8h1zm0 8v1.91l4 1.072 4-1.071V9zm7-7H5v6h6zM7 12.75V14h2v-1.25l-1 .268zM6 5V3h1v2zm3 0V3h1v2z"
        }
      )
    }
  );
}
const SR = /* @__PURE__ */ i($R);
function kR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 3h2.152l-1.34 5H8.5v5H10v1H6v-1h1.5V8H4.188l-1.34-5H5V2h6zM4.151 4l.804 3H7.5V5.5h1V7h2.544l.804-3z"
        }
      )
    }
  );
}
const yR = /* @__PURE__ */ i(kR);
function bR(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8.5 1v7h-1V1z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11.002 2.803a6 6 0 1 1-6.002 0l.5.866a5 5 0 1 0 5 0z"
          }
        )
      ]
    }
  );
}
const RR = /* @__PURE__ */ i(bR);
function BR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.5 1.293 1.5 1.5 1.5-1.5 4.488 4.488.484 8.219H15v1H1v-1h.529l.483-8.22zM2.53 14h3.187L7 11.862V7.5H5.99l-.49.85v2.15h-1V8.082l2.7-4.675-.7-.7L2.988 6.22zm4.353 0h2.234L8 12.139zm3.4 0h3.187l-.458-7.78L9.5 2.706l-.7.7 2.7 4.675V10.5h-1V8.35l-.49-.85H9v4.362zm-.851-7.5L8 4.02 6.568 6.5z"
        }
      )
    }
  );
}
const FR = /* @__PURE__ */ i(BR);
function AR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 12.5v-9h1v4.213l7-4.084v8.741L5 8.288V12.5zM6.492 8 11 10.63V5.37z"
        }
      )
    }
  );
}
const qR = /* @__PURE__ */ i(AR);
function OR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-.544 4h7.088l1.607 6H2.848zm.767 1-1.072 4h7.697l-1.072-4z"
        }
      )
    }
  );
}
const DR = /* @__PURE__ */ i(OR);
function PR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M3 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m6.844-1.495a2.5 2.5 0 0 1 .473 4.975l-.126-.992a1.5 1.5 0 0 0-.285-2.985zM2.456 8h7.088l1.607 6H.848zm.767 1-1.072 4h7.697L8.776 9zm9.021 1h-1.316V9h2.084l1.34 5H12v-1h1.048z"
        }
      )
    }
  );
}
const TR = /* @__PURE__ */ i(PR);
function WR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m12.582 11.875 1.772 1.771-.707.708-12-12 .707-.708 2.661 2.662a3 3 0 1 1 2.676 2.676L8.707 8h2.837zm-1.415-1.415L10.777 9h-1.07zM8 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M4.152 13h6.02l1 1H2.848l1.608-6h.716l1 1h-.949z"
        }
      )
    }
  );
}
const GR = /* @__PURE__ */ i(WR);
function ER(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 2h14v2h-1v7h-3.92l.903 3.37-.966.26L9.58 13H6.42l-.437 1.63-.966-.26L5.92 11H2V4H1zm12 8V4H3v6zm-6.045 1-.268 1h2.625l-.268-1z"
        }
      )
    }
  );
}
const NR = /* @__PURE__ */ i(ER);
function jR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.552 1.263 2.436 9.09 2.588-7L11.554 7H15v1h-4.214l-.362-1.352-2.589 7-2.387-8.91L4.36 8H1V7h2.64z"
        }
      )
    }
  );
}
const UR = /* @__PURE__ */ i(jR);
function IR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a1 1 0 0 0-1 1v1H5v2H4a1 1 0 0 0 0 2h1v3h1a2 2 0 1 1 4 0h2v-2a2 2 0 1 1 0-4V5H9V4a1 1 0 0 0-1-1M6 4a2 2 0 1 1 4 0h3v3h-1a1 1 0 0 0 0 2h1v4H9v-1a1 1 0 0 0-2 0v1H4v-3a2 2 0 1 1 0-4V4z"
        }
      )
    }
  );
}
const QR = /* @__PURE__ */ i(IR);
function KR(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2.5 2.5h2v2h-2z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 6H1V1h5zM5 5V2H2v3zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M2 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2m6 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2M7 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m7-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-4 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-8.5-1.5h2v2h-2z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 15H1v-5h5zm-1-1v-3H2v3zm6.5-11.5h2v2h-2z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M15 6h-5V1h5zm-1-1V2h-3v3z" })
      ]
    }
  );
}
const JR = /* @__PURE__ */ i(KR);
function XR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.694 2.008a6 6 0 1 0 5.344 9.253l.838.544A7 7 0 1 1 7.644 1.009zm1.635-.9.483.129a7.003 7.003 0 0 1 4.951 8.575l-.13.483-7.245-1.941zm.702 1.244L8.612 7.646l5.294 1.419a6 6 0 0 0-3.875-6.713M6.98 5.177a3.001 3.001 0 1 0 2.953 5.116l.645.764a4 4 0 1 1-3.937-6.82z"
        }
      )
    }
  );
}
const YR = /* @__PURE__ */ i(XR);
function ZR(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.443 2.57 6.7 4.75a3.5 3.5 0 0 1 2.599 0l1.257-2.18A6 6 0 0 0 8 2c-.915 0-1.782.205-2.557.57m-.944-.633A6.97 6.97 0 0 1 8 1a6.97 6.97 0 0 1 3.5.937l.433.25-2.25 3.898-.433-.25a2.5 2.5 0 0 0-2.5-.001l-.433.25-2.25-3.897zM8 7.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M1 7.5h4.5V8a2.5 2.5 0 0 0 1.25 2.166l.433.25-2.25 3.897-.434-.25A7 7 0 0 1 1 8zm1.02 1a6 6 0 0 0 2.557 4.429l1.258-2.179a3.5 3.5 0 0 1-1.3-2.25zm9.445 0a3.5 3.5 0 0 1-1.3 2.25l1.258 2.179A6 6 0 0 0 13.98 8.5zM15 7.5V8a7 7 0 0 1-3.5 6.063l-.432.25-2.25-3.897.432-.25A2.5 2.5 0 0 0 10.5 8v-.5z"
        }
      )
    }
  );
}
const _R = /* @__PURE__ */ i(ZR);
function nB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.5 3h1v2h1V3h1v2h1V3h1v2h1V3h1v2h1V3h1v2H14v6h-1.5v2h-1v-2h-1v2h-1v-2h-1v2h-1v-2h-1v2h-1v-2h-1v2h-1v-2H2V5h1.5zM3 6v4h10V6z"
        }
      )
    }
  );
}
const lB = /* @__PURE__ */ i(nB);
function tB(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m5.5 6.96.5.4.5-.4V6h1v1.44L6.8 8l.7.56V10h-1v-.96l-.5-.4-.5.4V10h-1V8.56L5.2 8l-.7-.56V6h1zM11 6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1v1H9V6zm-1 2h1V7h-1z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m14.001 11.464-6 3.464-6-3.464V4.536l6-3.464 6 3.464zm-6 2.311 5-2.887V5.114l-5-2.887-5 2.887v5.772z"
          }
        )
      ]
    }
  );
}
const iB = /* @__PURE__ */ i(tB);
function eB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M3 8a5 5 0 1 1 10 0A5 5 0 0 1 3 8m5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      )
    }
  );
}
const oB = /* @__PURE__ */ i(eB);
function rB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 2h5v6H3zm1 1v4h3V3zM2 9h6v5H2zm1 1v3h4v-3zm6-6h5v8H9zm1 1v6h3V5z"
        }
      )
    }
  );
}
const hB = /* @__PURE__ */ i(rB);
function aB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.175 5.172a4 4 0 0 0 0 5.656l-.707.708a5 5 0 0 1 0-7.072c1.98-1.979 4.961-1.742 6.886.182L13 6.292V4h1l-.002 3.998L10 8V7l2.292-.001-1.645-1.645c-1.591-1.591-3.936-1.718-5.472-.182"
        }
      )
    }
  );
}
const cB = /* @__PURE__ */ i(aB);
function dB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 2h4v4h-1V3.707l-3.646 3.647-.708-.708L13.293 3H11zM8.438 4.157 7 3.327l-1.437.829-.5-.866L7 2.173l1.938 1.118zm-4 1.732-.5.866L3 6.214v1.083H2V5.059l1.938-1.118.5.866-.938.541zM3 8.596v1.66l1.438.83-.5.865L2 10.833V8.596zm9 0v2.237l-1.937 1.118-.5-.865 1.437-.83v-1.66zm-3.562 3.138.5.866L7 13.72l-1.937-1.119.5-.866.937.541v-1.082h1v1.082zM7.5 9.895h-1v-1.66l-1.437-.83.5-.867L7.5 7.658z"
        }
      )
    }
  );
}
const wB = /* @__PURE__ */ i(dB);
function vB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a5 5 0 0 1 5 5v1.293l1.647-1.647.707.708-2.854 2.853-2.854-2.853.708-.708L12 9.293V8a4 4 0 1 0-2.964 3.865l.258.965A5 5 0 1 1 8 3"
        }
      )
    }
  );
}
const mB = /* @__PURE__ */ i(vB);
function gB(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4.749 1.37a6.5 6.5 0 0 1 6.501 0l-.5.866a5.5 5.5 0 0 0-5.5 0zM5.75 3.103a4.5 4.5 0 0 1 4.5 0l-.5.865a3.5 3.5 0 0 0-3.5 0zM8 6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M7.5 8a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0m-.75 3.5v-1h1v1zm2.5-1v1h-1v-1zM6.75 13v-1h1v1zm2.5-1v1h-1v-1z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M5 5h6v10H5zm1 1v8h4V6z" })
      ]
    }
  );
}
const sB = /* @__PURE__ */ i(gB);
function fB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 3h10v10H4zm1 1v4.211l2.8 1.617 2.85-1.645L13 9.54V4zm8 6.694-2.35-1.357-2.85 1.646L5 9.366V12h8zM2 12V4h1v8zm5.773-5.545a.318.318 0 1 0 0 .636.318.318 0 0 0 0-.636m-1.318.318a1.318 1.318 0 1 1 2.636 0 1.318 1.318 0 0 1-2.636 0"
        }
      )
    }
  );
}
const uB = /* @__PURE__ */ i(fB);
function pB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.354 1.646 9.707 4H8a4 4 0 0 0-2.116 7.395l-.53.848a5.001 5.001 0 0 1 1.983-9.2l-.69-.69zM12 8a4 4 0 0 0-1.884-3.395l.53-.848a5.001 5.001 0 0 1-1.983 9.2l.69.69-.707.707L6.293 12H8a4 4 0 0 0 4-4M8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      )
    }
  );
}
const HB = /* @__PURE__ */ i(pB);
function MB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.707-2.482-2.482c-.7.573-1.56.96-2.5 1.085l.69.69-.708.707L6.293 12H8c.924 0 1.775-.314 2.453-.84L9.016 9.723a2 2 0 0 1-2.74-2.74L4.84 5.548a3.997 3.997 0 0 0 1.044 5.848l-.53.848a4.997 4.997 0 0 1-1.225-7.407L1.646 2.354zm4.68 6.095a1.002 1.002 0 0 0 1.225 1.225zM13 8c0 .874-.224 1.696-.619 2.41l-.658-.945a4 4 0 0 0-1.607-4.86l.53-.848A5 5 0 0 1 13 8M8 4a4 4 0 0 0-1.036.136l-.791-.791a5 5 0 0 1 1.164-.301l-.69-.69.707-.708L9.707 4z"
        }
      )
    }
  );
}
const xB = /* @__PURE__ */ i(MB);
function zB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m13.322 5-2.045 7.63-.966-.26L12.018 6H4.707l1.647 1.646-.708.708L2.793 5.5l2.853-2.854.708.708L4.707 5z"
        }
      )
    }
  );
}
const VB = /* @__PURE__ */ i(zB);
function CB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m4 9.293 1.646-1.647.708.708L3.5 11.207.646 8.354l.708-.708L3 9.293V8a5 5 0 1 1 3.706 4.831l.258-.966A4 4 0 1 0 4 8z"
        }
      )
    }
  );
}
const LB = /* @__PURE__ */ i(CB);
function $B(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.354 6.354-.708-.708L9.293 4H8a4 4 0 1 0 4 4h1a5 5 0 1 1-5-5h1.293L7.646 1.354l.708-.708L11.207 3.5z"
        }
      )
    }
  );
}
const SB = /* @__PURE__ */ i($B);
function kB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m13.321 5-2.144 8H3v-1h7.411l1.607-6H4.707l1.647 1.646-.707.708L2.793 5.5l2.854-2.854.707.708L4.707 5z"
        }
      )
    }
  );
}
const yB = /* @__PURE__ */ i(kB);
function bB(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4 9.207 1.146 6.354l.708-.708 1.248 1.249A6 6 0 1 1 9 14v-1a5 5 0 1 0-5-5z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6 5h1.01v1.125H7v3.75h.01V11H6zm2 1.125C8 5.422 8.649 5 9.25 5h1.5c.601 0 1.25.422 1.25 1.125v3.75c0 .703-.649 1.125-1.25 1.125h-1.5C8.649 11 8 10.578 8 9.875zm1.04-.058C9 6.1 9 6.123 9 6.125v3.75c0 .002 0 .025.04.058a.33.33 0 0 0 .21.067h1.5a.33.33 0 0 0 .21-.067c.04-.033.04-.056.04-.058v-3.75c0-.002 0-.025-.04-.058A.33.33 0 0 0 10.75 6h-1.5a.33.33 0 0 0-.21.067"
          }
        )
      ]
    }
  );
}
const RB = /* @__PURE__ */ i(bB);
function BB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.348 6.541C1.858 6.214 1.5 5.694 1.5 5h1c0 .306.143.536.402.709C3.177 5.892 3.574 6 4 6s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709C7.177 5.892 7.574 6 8 6s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541C13.177 6.858 12.574 7 12 7s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29 2 2 0 0 1-.348.29C9.177 6.858 8.574 7 8 7s-1.177-.142-1.652-.459A2 2 0 0 1 6 6.251a2 2 0 0 1-.348.29C5.177 6.858 4.574 7 4 7s-1.177-.142-1.652-.459m0 4C1.858 10.214 1.5 9.694 1.5 9h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541-.475.317-1.078.459-1.652.459s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29 2 2 0 0 1-.348.29C9.177 10.858 8.574 11 8 11s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29 2 2 0 0 1-.348.29C5.177 10.858 4.574 11 4 11s-1.177-.142-1.652-.459"
        }
      )
    }
  );
}
const FB = /* @__PURE__ */ i(BB);
function AB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 3c0 .385-.11.744-.297 1.05l1.794 1.747.297-.297h1.914l1.645 1.646-.707.708L13.293 6.5h-1.086l-.353.354-.354.353v1.086l1.353 1.353-.707.708L10.5 8.707V6.793l.289-.289-1.807-1.761-.003.001c-.62.35-1.382.342-1.995-.021L5.586 6.122a2.5 2.5 0 0 1 .302 2.12L9.646 12h4.238l.804 3H1.313l.804-3h3.287L3.402 9.998a2.5 2.5 0 1 1 1.477-4.584l1.398-1.398A2 2 0 1 1 10 3M5.38 9.147a2.5 2.5 0 0 1-.804.61L6.818 12h1.414zM8 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M3.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-.616 7-.268 1h10.768l-.267-1z"
        }
      )
    }
  );
}
const qB = /* @__PURE__ */ i(AB);
function OB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m10.6 1.94 2.885 2.308.535 8.551-2.296 1.148-.447-.894 1.703-.852-.465-7.449L10.4 3.06l-2.481.828-.934 3.733-.97-.242 1.067-4.267zM4.462 7.96 7.77 9.063l2.23 2.23v2.475l-1.874 1.25-4.855-.54-1.806-1.806.584-3.505zm.076 1.08-1.587.793-.415 2.495 1.194 1.194 4.144.46L9 13.233v-1.525l-1.77-1.77z"
        }
      )
    }
  );
}
const DB = /* @__PURE__ */ i(OB);
function PB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m9.335 4.628 2.037 2.037c.589-.946.878-1.947.72-2.756-.81-.159-1.811.13-2.757.719m1.441 2.855L8.517 5.224a7 7 0 0 0-.42.387L4.206 9.5l.793.793.647-.647.707.708-.647.646.793.793 3.89-3.89q.201-.203.386-.42M8 13.707l-1.5 1.5L4.793 13.5l1-1L5 11.707l-1.146 1.147-.707-.708L4.293 11l-.793-.793-1 1L.793 9.5l1.5-1.5h2l3.096-3.096q.402-.402.867-.749c1.268-.947 2.956-1.611 4.402-1.13l.237.08.079.237c.482 1.447-.182 3.134-1.128 4.402-.23.309-.483.6-.75.867L8 11.707zm-1-1-.793.793.293.293.5-.5zM3.293 9h-.586l-.5.5.293.293z"
        }
      )
    }
  );
}
const TB = /* @__PURE__ */ i(PB);
function WB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 7.5c0 .516.474 1.142 1.613 1.667C4.71 9.674 6.26 10 8 10h.293l-.647-.646.708-.708 1.853 1.854-1.853 1.854-.708-.708.647-.646H8c-1.85 0-3.55-.345-4.806-.925C1.981 9.515 1 8.641 1 7.5s.981-2.015 2.194-2.575C4.45 4.345 6.15 4 8 4s3.55.345 4.806.925C14.019 5.485 15 6.359 15 7.5c0 .663-.34 1.241-.84 1.704-.499.461-1.19.842-1.99 1.131l-.339-.94c.72-.261 1.28-.582 1.65-.925.369-.342.519-.672.519-.97 0-.516-.474-1.141-1.613-1.667C11.29 5.326 9.74 5 8 5s-3.29.326-4.387.833C2.474 6.359 2 6.984 2 7.5"
        }
      )
    }
  );
}
const GB = /* @__PURE__ */ i(WB);
function EB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.016 7.31c.034-.708.118-1.387.246-2.02a8.4 8.4 0 0 0-1.649.543C2.474 6.359 2 6.984 2 7.5s.474 1.142 1.613 1.667C4.71 9.674 6.261 10 8 10h.293l-.647-.646.708-.708 1.853 1.854-1.853 1.854-.708-.708.647-.646H8c-1.85 0-3.55-.345-4.806-.925C1.981 9.515 1 8.641 1 7.5s.981-2.015 2.194-2.575c.67-.31 1.465-.551 2.342-.71q.171-.549.389-1.02C6.485 1.98 7.359 1 8.5 1s2.015.981 2.575 2.194c.178.384.333.81.463 1.268.458.13.884.286 1.268.463C14.019 5.485 15 6.359 15 7.5c0 1.007-.769 1.806-1.757 2.354l-.486-.874C13.642 8.489 14 7.95 14 7.5c0-.516-.474-1.141-1.613-1.667a7 7 0 0 0-.591-.24C11.928 6.346 12 7.157 12 8c0 1.85-.345 3.55-.925 4.806C10.515 14.019 9.641 15 8.5 15c-.663 0-1.24-.34-1.704-.84-.462-.499-.842-1.19-1.131-1.99l.94-.34c.26.721.582 1.28.925 1.651.342.37.672.519.97.519.516 0 1.142-.474 1.667-1.613C10.674 11.29 11 9.739 11 8c0-.98-.104-1.902-.285-2.715A12.6 12.6 0 0 0 8 5c-.582 0-1.143.037-1.673.104a12 12 0 0 0-.308 2.17l.627-.628.708.708L5.5 9.207 3.646 7.354l.708-.708zm1.817-3.697q-.1.222-.188.45a14.5 14.5 0 0 1 3.762.141 7 7 0 0 0-.24-.59C9.642 2.473 9.016 2 8.5 2s-1.141.474-1.667 1.613"
        }
      )
    }
  );
}
const NB = /* @__PURE__ */ i(EB);
function jB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.793 3.5 6.646 2.354l.708-.708L9.707 4 7.354 6.354l-.708-.708L7.793 4.5H6.5A2.5 2.5 0 0 0 4 7H3a3.5 3.5 0 0 1 3.5-3.5zM5 7h6v6H5zm1 1v4h4V8z"
        }
      )
    }
  );
}
const UB = /* @__PURE__ */ i(jB);
function IB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.5 3.5A3.5 3.5 0 0 1 13 7h-1a2.5 2.5 0 0 0-2.5-2.5H8.207l1.147 1.146-.708.708L6.293 4l2.353-2.354.708.708L8.207 3.5zM5 7h6v6H5zm1 1v4h4V8z"
        }
      )
    }
  );
}
const QB = /* @__PURE__ */ i(IB);
function KB(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 8a5 5 0 0 0-5-5V2a6 6 0 0 1 6 6v.293l.647-.647.707.708-1.854 1.853-1.853-1.853.707-.708.646.647zM.647 7.646 2.5 5.793l1.854 1.853-.707.708L3 7.707V8a5 5 0 0 0 5 5v1a6 6 0 0 1-6-6v-.293l-.646.647z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 5.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M6.5 8a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
          }
        )
      ]
    }
  );
}
const JB = /* @__PURE__ */ i(KB);
function XB(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11.642 9.939c-.337.426-.728.783-1.142 1.13-.414-.347-.805-.704-1.142-1.13-.391-.494-.858-1.241-.858-2.057C8.5 6.875 9.421 6 10.5 6s2 .875 2 1.882c0 .816-.467 1.563-.858 2.058M10.5 7c-.578 0-1 .477-1 .882 0 .464.283.983.642 1.437.124.157.25.295.358.408.109-.113.234-.251.358-.408.359-.454.642-.973.642-1.437 0-.405-.422-.882-1-.882"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14.5 1.779v10.568l-4.47 1.676L6 13.015 1.5 14.14V3.11l4.53-1.133L10 3.467zm-12 7.928v3.153l3.5-.875 3.97.992 3.53-1.323V3.222L10 4.534 5.97 3.023 2.5 3.89v4.403l1.5-1.5 2 2L6.793 8H8v1h-.793L6 10.207l-2-2z"
          }
        )
      ]
    }
  );
}
const YB = /* @__PURE__ */ i(XB);
function ZB(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 1.293 14.707 5 5 14.707 1.293 11zM2.707 11 5 13.293l.793-.793-.647-.646.708-.708.646.647.793-.793-1.647-1.646.708-.708L8 10.293l.793-.793-.647-.646.708-.708.646.647.793-.793-1.647-1.646.708-.708L11 7.293l.793-.793-.647-.646.707-.708.647.647.793-.793L11 2.707z"
        }
      )
    }
  );
}
const _B = /* @__PURE__ */ i(ZB);
function nF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-3.582-.357 6 3.464 1.96-1.96.708.707-2.504 2.503-3-1.732-1.768 1.768 3 1.732-3.46 3.46-.708-.706 2.54-2.54-2.104-1.214-5.228 5.229-.708-.708 7.54-7.539-2.104-1.214-1.96 1.96-.707-.707z"
        }
      )
    }
  );
}
const lF = /* @__PURE__ */ i(nF);
function tF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1v.866L11.541 8H8v1h6v4H4.293L1.5 10.207V9H7V1zm1.81 6L8 3.866V7zM13 12v-2H2.707l2 2z"
        }
      )
    }
  );
}
const iF = /* @__PURE__ */ i(tF);
function eF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 2v7h.5a.5.5 0 0 0 .5-.5V6h1v2.5a1.5 1.5 0 0 1-1.5 1.5H12v1.092Q13.5 11 15 11v1a47.2 47.2 0 0 0-9.647.99q-1.377.287-2.728.677-.452.132-.897.283l-.045.015-.01.004h-.002l-.525-.823L6.5 7.793l3.467 3.467A53 53 0 0 1 11 11.164V8h-.5A1.5 1.5 0 0 1 9 6.5V4h1v2.5a.5.5 0 0 0 .5.5h.5V2zm-3.299 9.408L6.5 9.208l-3.25 3.249c.533-.14 1.169-.293 1.897-.446a46 46 0 0 1 3.554-.603"
        }
      )
    }
  );
}
const oF = /* @__PURE__ */ i(eF);
function rF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.519 4.606v3.998l5.718-3.53.526.851-7.244 4.471V6.393L1.762 9.926l-.523-.852z"
        }
      )
    }
  );
}
const hF = /* @__PURE__ */ i(rF);
function aF(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 14h-4v-1h3V3H3v3H2V2h12z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9 5V4h3.003v3h-1V5.705l-1.65 1.648-.707-.708L10.294 5zm-1 9H2V8h6zm-1-1V9H3v4z"
          }
        )
      ]
    }
  );
}
const cF = /* @__PURE__ */ i(aF);
function dF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 4V3h1v1H15v1h-2v2h2.152l-.804 3h-3.696l-.804-3H12V5H8.5v7H10v1H6v-1h1.5V5H4v2h2.152l-.804 3H1.652L.848 7H3V5H1V4zM2.152 8l.268 1h2.16l.268-1zm9 0 .268 1h2.16l.268-1z"
        }
      )
    }
  );
}
const wF = /* @__PURE__ */ i(dF);
function vF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 1h1v2.793l1.146-1.147.708.708L8 5.707 5.646 3.354l.708-.708L7.5 3.793zM14 7.5H2v-1h12zm-12 1h12v1H2zm3.646 4.146L8 10.293l2.354 2.353-.708.707L8.5 12.207V15h-1v-2.793l-1.146 1.147z"
        }
      )
    }
  );
}
const mF = /* @__PURE__ */ i(vF);
function gF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 3h14v10.5H1zm1 1v8.5h12V4zm2 3.5H3v-1h1zm2 0H5v-1h1zm2 0H7v-1h1zm1 0v-1h1v1zm0 2v-1h1v1zm0 2v-1h1v1z"
        }
      )
    }
  );
}
const sF = /* @__PURE__ */ i(gF);
function fF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ a("g", { fill: "currentColor", children: [
        /* @__PURE__ */ l("path", { d: "M4 7.5H3v-1h1z" }),
        /* @__PURE__ */ l("path", { d: "m1.354.646 14 14-.707.708-1.854-1.854H1V3h1.293L.646 1.354zM3.293 4H2v8.5h9.793L10 10.707v.793H9v-1h.793L6 6.707V7.5H5v-1h.793zM15 3v9.172l-1-1V4H6.828l-1-1z" })
      ] })
    }
  );
}
const uF = /* @__PURE__ */ i(fF);
function pF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v1H2zm6 2a4 4 0 1 1 0 8v-1a3 3 0 1 0-3-3v.293l.646-.647.708.708L4.5 10.207 2.646 8.354l.708-.708.646.647V8a4 4 0 0 1 4-4M2 14v-1h12v1z"
        }
      )
    }
  );
}
const HF = /* @__PURE__ */ i(pF);
function MF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 3H2V2h12zM8.5 5.207v5.586l1.146-1.147.708.708L8 12.707l-2.354-2.353.708-.708L7.5 10.793V5.207L6.354 6.354l-.708-.708L8 3.293l2.354 2.353-.708.708zM14 14H2v-1h12z"
        }
      )
    }
  );
}
const xF = /* @__PURE__ */ i(MF);
function zF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 2H10v2H8.5v.26l2.5 2V9h3v5H2V9h3V6.26l2.5-2zM8 5.14l-2 1.6V13h1v-2h2v2h1V6.74zM11 13h2v-3h-2zm-6 0v-3H3v3zm3-5.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
        }
      )
    }
  );
}
const VF = /* @__PURE__ */ i(zF);
function CF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 4.5a2.5 2.5 0 1 1 4.45 1.564l2.354 1.359 4.946-2.856.5.866L9.804 8l4.446 2.567-.5.866-4.946-2.856-2.354 1.36a2.5 2.5 0 1 1-.834-.673L7.804 8 5.617 6.737A2.5 2.5 0 0 1 2 4.5M4.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
        }
      )
    }
  );
}
const LF = /* @__PURE__ */ i(CF);
function $F(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h4v4H4.5v4H6v.268l5.5-3.175V6H10V2h4v4h-1.5v1.67L6 11.423V14H2v-4h1.5V6H2zm1 1v2h2V3zm2 8H3v2h2zm8-6V3h-2v2z"
        }
      )
    }
  );
}
const SF = /* @__PURE__ */ i($F);
function kF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.646 6.354 7.293 4l2.353-2.354.707.708L9.207 3.5H12.5V10H14v4h-4v-4h1.5V4.5H9.207l1.147 1.146zM13 13v-2h-2v2zM6 6H4.5v5.5h2.293l-1.147-1.146.708-.708L8.707 12l-2.353 2.354-.708-.708L6.793 12.5H3.5V6H2V2h4zM5 5V3H3v2z"
        }
      )
    }
  );
}
const yF = /* @__PURE__ */ i(kF);
function bF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 6h-.946l.536 2h4.821l.536-2H10V2h4v4h-2.018l-.804 3H8.5v1H10v4H6v-4h1.5V9H4.822l-.804-3H2V2h4zM5 5V3H3v2zm8 0V3h-2v2zm-4 8v-2H7v2z"
        }
      )
    }
  );
}
const RF = /* @__PURE__ */ i(bF);
function BF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h4v2.577l6.5 3.753V10H14v4h-4v-4h1.5V8.908L6 5.732V6H4.5v4H6v4H2v-4h1.5V6H2zm3 3V3H3v2zm-2 6v2h2v-2zm10 2v-2h-2v2z"
        }
      )
    }
  );
}
const FF = /* @__PURE__ */ i(BF);
function AF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.354 2.354 9.207 3.5H12.5V10H14v4h-4v-4h1.5V4.5H9.207l1.146 1.146-.707.708L7.293 4l2.353-2.354zM13 13v-2h-2v2zm-8.5-3H6v4H2v-4h1.5V6H2V2h4v4H4.5zM5 5V3H3v2zm-2 6v2h2v-2z"
        }
      )
    }
  );
}
const qF = /* @__PURE__ */ i(AF);
function OF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.354 1.646 12 3.293l1.647-1.647.707.708L12.707 4l1.647 1.646-.708.708L12 4.707l-1.646 1.647-.708-.708L11.293 4 9.646 2.354zM6 6H4.5v4H6v4H2v-4h1.5V6H2V2h4zM5 5V3H3v2zm0 8v-2H3v2zm5-3h1.5V7h1v3H14v4h-4zm3 3v-2h-2v2z"
        }
      )
    }
  );
}
const DF = /* @__PURE__ */ i(OF);
function PF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h4v4H4.5v4H6v4H2v-4h1.5V6H2zm1 1v2h2V3zm0 8v2h2v-2zm7-1h4v4h-4zm1 1v2h2v-2zm0-5h2v2h-2zm2-1h-2V3h2z"
        }
      )
    }
  );
}
const TF = /* @__PURE__ */ i(PF);
function WF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.793 2H13v3h-.5v1h.5v8H3V3.793zM12 7h-.5V4h.5V3H5.207L4 4.207V13h8zM7 7V4h1v3zm2 0V4h1v3zM5 7V4.5h1V7z"
        }
      )
    }
  );
}
const GF = /* @__PURE__ */ i(WF);
function EF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.348 4.541C1.858 4.214 1.5 3.694 1.5 3h1c0 .306.143.536.402.709C3.177 3.892 3.574 4 4 4s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709C7.177 3.892 7.574 4 8 4s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541C13.177 4.858 12.574 5 12 5s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29 2 2 0 0 1-.348.29C9.177 4.858 8.574 5 8 5s-1.177-.142-1.652-.459A2 2 0 0 1 6 4.251a2 2 0 0 1-.348.29C5.177 4.858 4.574 5 4 5s-1.177-.142-1.652-.459m0 4C1.858 8.214 1.5 7.694 1.5 7h1c0 .306.143.536.402.709C3.177 7.892 3.574 8 4 8s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709C7.177 7.892 7.574 8 8 8s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541C13.177 8.858 12.574 9 12 9s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29 2 2 0 0 1-.348.29C9.177 8.858 8.574 9 8 9s-1.177-.142-1.652-.459A2 2 0 0 1 6 8.251a2 2 0 0 1-.348.29C5.177 8.858 4.574 9 4 9s-1.177-.142-1.652-.459m0 4c-.49-.327-.848-.847-.848-1.541h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .306.143.536.402.709.275.183.672.291 1.098.291s.823-.108 1.098-.291c.26-.173.402-.403.402-.709h1c0 .694-.357 1.214-.848 1.541-.475.317-1.078.459-1.652.459s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29 2 2 0 0 1-.348.29C9.177 12.858 8.574 13 8 13s-1.177-.142-1.652-.459a2 2 0 0 1-.348-.29q-.158.164-.348.29C5.177 12.858 4.574 13 4 13s-1.177-.142-1.652-.459"
        }
      )
    }
  );
}
const NF = /* @__PURE__ */ i(EF);
function jF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.967 13.665A6 6 0 0 1 9.062 2.114L9.393.87l.967.259L6.608 15.13l-.966-.26zm2.836-10.58a5 5 0 0 0-2.576 9.612zm-.37 9.918a5 5 0 0 0 1.678-.451l.423.906a6 6 0 0 1-2.013.54zm3.101-1.447c.406-.405.746-.883.996-1.422l.907.422a6 6 0 0 1-1.196 1.708zm1.446-3.1a5 5 0 0 0-.152-1.73l.966-.26c.179.665.245 1.367.182 2.078zm-.886-3.304a5 5 0 0 0-1.227-1.229l.573-.819c.58.406 1.076.907 1.473 1.475z"
        }
      )
    }
  );
}
const UF = /* @__PURE__ */ i(jF);
function IF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.02 7.5a6 6 0 0 1 11.96 0l1.266-.002.002 1H.752l.002-1zm1.005 0h9.95a5 5 0 0 0-9.95 0m.4 4.357a6 6 0 0 1-1.044-1.804l.94-.342c.2.553.497 1.06.869 1.503zm10.235-1.804a6 6 0 0 1-1.044 1.804l-.765-.643c.371-.443.668-.95.869-1.503zM6.979 13.91a6 6 0 0 1-1.96-.713l.501-.866a5 5 0 0 0 1.631.594zm4.042-.713a6 6 0 0 1-1.96.713l-.172-.985a5 5 0 0 0 1.631-.594z"
        }
      )
    }
  );
}
const QF = /* @__PURE__ */ i(IF);
function KF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.52 3.666a5 5 0 0 0-1.631-.594l.172-.985a6 6 0 0 1 1.96.713zm-3.37-.594a5 5 0 0 0-1.63.594L5.019 2.8a6 6 0 0 1 1.96-.713zm5.57 3.214a5 5 0 0 0-.87-1.503l.766-.643c.446.53.801 1.14 1.043 1.804zM4.19 4.783c-.373.443-.669.95-.87 1.503l-.94-.342A6 6 0 0 1 3.424 4.14zM2.5 7.497h11l1.747.002-.001 1-1.267-.001a6 6 0 0 1-11.959 0l-1.267.001-.001-1zm10.475 1h-9.95a5 5 0 0 0 9.95 0"
        }
      )
    }
  );
}
const JF = /* @__PURE__ */ i(KF);
function XF(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m5.146 7.853.708-.707 1.622 1.622 3.148-3.597.752.658-3.852 4.402z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 3.97v.01l.002.02q.02.69-.019 1.38a16 16 0 0 1-.5 3.188c-.645 2.384-2.102 5.102-5.362 5.917l-.121.03-.121-.03c-3.26-.815-4.717-3.533-5.362-5.917a16 16 0 0 1-.521-4.49L2 4v-.028s0-.002.5.028l-.499-.03.021-.36L8 2.01l5.978 1.6zm0 0-.5.03zM3.015 5.323a15 15 0 0 0 .468 2.984c.597 2.208 1.86 4.455 4.517 5.176 2.657-.721 3.921-2.968 4.517-5.176.301-1.114.423-2.186.468-2.984.022-.39.026-.711.025-.937L8 3.044 2.99 4.386c-.002.226.002.547.025.937"
          }
        )
      ]
    }
  );
}
const YF = /* @__PURE__ */ i(XF);
function ZF(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.5 3.453 4.632 1.241L14.018 8H12.75l-1.364 5.088L8 15.043l-3.387-1.955L3.25 8H1.982l.886-3.306L7.5 3.453v-1.66L8.646.646l.707.708-.853.853zm-.5.901L3.685 5.511 3.285 7h9.43l-.4-1.49zM11.714 8H4.285l1.187 4.43L8 13.888l2.527-1.46z"
        }
      )
    }
  );
}
const _F = /* @__PURE__ */ i(ZF);
function nA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h10v10H2zm1 1v5.293L8.293 4zm6.707 0-2.5 2.5L11 10.293V4zM11 11.707l-4.5-4.5-3.5 3.5V12h8zM13 12V4h1v8z"
        }
      )
    }
  );
}
const lA = /* @__PURE__ */ i(nA);
function tA(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m7 1.226 5.5 3.176-5 2.887v5.773L2 9.887V4.113zM6.5 11.33V7.288L3 5.268V9.31zM7 2.382l-3.5 2.02L7 6.422l3.5-2.019z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9.5 8.71 15 5.536v6.351l-5.5 3.175zm4.5 2.599V7.268L10.5 9.29v4.04z"
          }
        )
      ]
    }
  );
}
const iA = /* @__PURE__ */ i(tA);
function eA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m12.25 1.543 2.207 2.207L10 8.207v.043c0 1.544-1.104 2.558-2.43 2.745-.6.085-1.296.089-1.927-.078-.634-.167-1.255-.522-1.59-1.193l-.258-.516.547-.182c.47-.157.755-.603 1.145-1.274l.016-.027c.21-.36.456-.784.786-1.112A2 2 0 0 1 7.792 6zM9 8.24 7.76 7h-.01c-.324 0-.55.118-.756.322-.227.226-.414.54-.642.933l-.035.06c-.25.43-.563.97-1.055 1.34q.251.195.636.295c.465.123 1.02.127 1.532.055C8.33 9.878 9 9.23 9 8.25zm.5-2.534-.809.81.792.794.81-.81zm3.543-1.956-.793-.793L10.207 5l.793.793zM3.776 8.602a4 4 0 0 0-.505.392l-.677-.737a5 5 0 0 1 .63-.489zm8.953.392a4 4 0 0 0-.505-.392l.552-.835a5 5 0 0 1 .63.49zM2.594 9.96c-.145.408-.12.857.068 1.247l-.907.422A2.62 2.62 0 0 1 1.65 9.63zm11.906.54c0 .396-.091.775-.255 1.129l-.907-.422a1.62 1.62 0 0 0 .068-1.247l.944-.33q.148.418.15.87M3.754 12.384a6.1 6.1 0 0 0 1.586.732l-.295.956a7.1 7.1 0 0 1-1.847-.857zm6.906.732a6.1 6.1 0 0 0 1.586-.733l.556.832a7.1 7.1 0 0 1-1.847.857zm-3.562.343a10 10 0 0 0 1.804 0l.092.996a11 11 0 0 1-1.988 0z"
        }
      )
    }
  );
}
const oA = /* @__PURE__ */ i(eA);
function rA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.024 3.095a5 5 0 0 0-1.802.748l-.555-.832a6 6 0 0 1 2.162-.897zm3.755.747a5 5 0 0 0-1.803-.746l.195-.98a6 6 0 0 1 2.163.894zm-6.937 1.38a5 5 0 0 0-.746 1.802l-.98-.195a6 6 0 0 1 .894-2.163zm9.063 1.802a5 5 0 0 0-.748-1.802l.832-.555c.451.675.748 1.41.897 2.162zm-.747 3.755c.367-.55.619-1.164.746-1.804l.98.195a6 6 0 0 1-.894 2.164zM3.095 8.976c.124.625.37 1.237.748 1.802l-.832.555a6 6 0 0 1-.897-2.162zm5.88 3.93a5 5 0 0 0 1.803-.749l.555.832a6 6 0 0 1-2.162.897zm-3.754-.748c.55.368 1.164.619 1.804.746l-.195.98a6 6 0 0 1-2.164-.894z"
        }
      )
    }
  );
}
const hA = /* @__PURE__ */ i(rA);
function aA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 3H3v1H2V2h2zm5.5 0h-3V2h3zM3 6.5v3H2v-3zM3 13h1v1H2v-2h1zm3.5 0h3v1h-3zm5.854-9.146-.708-.708.354-.353V2h2.207zm-1 1-1.5 1.5-.707-.708 1.5-1.5zM8.207 8l.647.646-.707.708L6.793 8l1.354-1.354.707.708zm1.647 1.646 1.5 1.5-.707.708-1.5-1.5zm2.5 2.5L14.207 14H12v-.793l-.353-.353z"
        }
      )
    }
  );
}
const cA = /* @__PURE__ */ i(aA);
function dA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h2v1H3v1H2zm4.5 0h3v1h-3zM12 2h2v2h-1V3h-1zM2 9.5v-3h1v3zm12-3v3h-1v-3zM2 12h1v1h1v1H2zm12 0v2h-2v-1h1v-1zm-4.5 2h-3v-1h3z"
        }
      )
    }
  );
}
const wA = /* @__PURE__ */ i(dA);
function vA(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M9.646 4.354 8.5 3.207V6h-1V3.207L6.354 4.354l-.708-.708L8 1.293l2.354 2.353z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M3 5h2v1H4v3.211l2.8 1.617 2.85-1.645L12 10.54V6h-1V5h2v9H3zm9 6.694-2.35-1.357-2.85 1.646L4 10.366V13h8z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.454 7.773a1.318 1.318 0 1 1 2.637 0 1.318 1.318 0 0 1-2.637 0m1.319-.318a.318.318 0 1 0 0 .636.318.318 0 0 0 0-.636"
          }
        )
      ]
    }
  );
}
const mA = /* @__PURE__ */ i(vA);
function gA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 2a5 5 0 0 0 5 5v1a6 6 0 0 1-6-6zm2 0a3 3 0 0 0 3 3v1a4 4 0 0 1-4-4zm2 0a1 1 0 0 0 1 1v1a2 2 0 0 1-2-2zM4.94 4.111a3.5 3.5 0 0 0-.636 4.079 3.57 3.57 0 0 0 1.527 1.515c.237.121.484.214.733.277A3.5 3.5 0 0 0 9.89 9.06l.707.707a4.5 4.5 0 0 1-4.26 1.188l.815 3.04H1.848l1.48-5.525a4.5 4.5 0 0 1 .904-5.067zm-.874 5.474-.914 3.411h2.696l-.672-2.51a4.6 4.6 0 0 1-1.11-.901"
        }
      )
    }
  );
}
const sA = /* @__PURE__ */ i(gA);
function fA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a5 5 0 0 0-1.568 9.75l-.313.95a6 6 0 1 1 7.58-7.58l-.95.312A5 5 0 0 0 8 3M6.054 5.448c-.21.042-.469.173-.702.406-.2.19-.34.434-.406.702-.043.214.013.319.053.359s.144.095.359.052c.21-.042.469-.173.702-.406s.364-.49.406-.701c.043-.215-.013-.32-.053-.36s-.144-.095-.359-.052m-.196-.98c.425-.086.912-.025 1.262.326.35.35.411.837.326 1.262-.086.43-.326.86-.68 1.212-.352.353-.783.594-1.212.68-.425.085-.912.024-1.262-.326s-.411-.837-.326-1.262c.086-.43.326-.86.68-1.213.352-.353.783-.594 1.212-.68M11 8h1v1.05a2.5 2.5 0 0 1 1.371.792l.91-.525.5.866-.91.525a2.5 2.5 0 0 1 0 1.584l.91.525-.5.866-.91-.525A2.5 2.5 0 0 1 12 13.95V15h-1v-1.05a2.5 2.5 0 0 1-1.371-.792l-.91.525-.5-.866.91-.525a2.5 2.5 0 0 1 0-1.584l-.91-.525.5-.866.91.525A2.5 2.5 0 0 1 11 9.05zm.5 2a1.5 1.5 0 1 0-.001 3 1.5 1.5 0 0 0 .001-3"
        }
      )
    }
  );
}
const uA = /* @__PURE__ */ i(fA);
function pA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M2.5 6.5a5.5 5.5 0 1 1 9.283 3.992c.305.097.578.207.81.331.236.125.451.276.614.459.165.186.293.429.293.718v1c0 .45-.302.777-.604.992-.315.223-.738.404-1.217.548-.963.289-2.264.46-3.679.46s-2.716-.171-3.68-.46c-.478-.144-.901-.325-1.216-.548-.302-.215-.604-.543-.604-.992v-1c0-.289.128-.532.293-.718.163-.183.378-.334.613-.459a5 5 0 0 1 .811-.33A5.5 5.5 0 0 1 2.5 6.5m2.741 4.76c-.587.122-1.051.279-1.365.446a1.2 1.2 0 0 0-.334.24.2.2 0 0 0-.042.06v.987c.004.012.032.076.182.183.191.135.5.278.926.406C5.455 13.836 6.654 14 8 14s2.545-.164 3.392-.418c.426-.128.735-.27.926-.406.15-.107.178-.17.182-.183v-.988a.2.2 0 0 0-.042-.06 1.2 1.2 0 0 0-.334-.239c-.314-.167-.778-.324-1.365-.447A5.5 5.5 0 0 1 8 12a5.5 5.5 0 0 1-2.759-.74m1.313-6.812c-.21.042-.469.173-.702.406-.2.19-.34.434-.406.702-.043.214.013.319.053.359s.144.095.359.052c.21-.042.469-.173.702-.406s.364-.49.406-.701c.043-.215-.013-.32-.053-.36s-.144-.095-.359-.052m-.196-.98c.425-.086.912-.025 1.262.326.35.35.411.837.326 1.262-.086.43-.326.86-.68 1.212-.352.353-.783.594-1.212.68-.425.085-.912.024-1.262-.326s-.411-.837-.326-1.262c.086-.43.326-.86.68-1.213.352-.353.783-.594 1.212-.68M8 9.5a3 3 0 0 0 3-3h1a4 4 0 0 1-4 4zm-1.285-.288q.4.19.856.258l-.142.99a4 4 0 0 1-1.144-.345z"
        }
      )
    }
  );
}
const HA = /* @__PURE__ */ i(pA);
function MA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"
        }
      )
    }
  );
}
const xA = /* @__PURE__ */ i(MA);
function zA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.707-1.773-1.771a6 6 0 0 1-8.456-8.456L1.647 2.354zm1.775 3.19a5 5 0 0 0 7.036 7.036zM14 8c0 .926-.21 1.804-.585 2.587l-.76-.76a5 5 0 0 0-6.483-6.483l-.759-.76A6 6 0 0 1 14 8"
        }
      )
    }
  );
}
const VA = /* @__PURE__ */ i(zA);
function CA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m3 10.887 5 2.887 5-2.887V5.113L8 2.227 3 5.113zM2 4.536l6-3.464 6 3.464v6.928l-6 3.464-6-3.464z"
        }
      )
    }
  );
}
const LA = /* @__PURE__ */ i(CA);
function $A(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.515 2h4.97L14 5.515v4.97L10.485 14h-4.97L2 10.485v-4.97zm.414 1L3 5.929v4.142L5.929 13h4.142L13 10.071V5.93L10.071 3z"
        }
      )
    }
  );
}
const SA = /* @__PURE__ */ i($A);
function kA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1.638 7 4.5 1.992 7.362 7zM4.5 4.008 3.362 6h2.276zM11 3V2h3v3h-1V3.707l-2.646 2.647-.708-.708L12.293 3zM4.5 9a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M3 11.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M14 14H9V9h5zm-1-4h-3v3h3z"
        }
      )
    }
  );
}
const yA = /* @__PURE__ */ i(kA);
function bA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 2h12v12H2zm1 1v10h10V3z" })
    }
  );
}
const RA = /* @__PURE__ */ i(bA);
function BA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.353.646 14 14-.707.707L13.293 14H2V2.707L.646 1.354zM3 3.707V13h9.293zM14 2v9.172l-1-1V3H5.828l-1-1z"
        }
      )
    }
  );
}
const FA = /* @__PURE__ */ i(BA);
function AA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 1.24 7.366 12.758H.634zM2.366 12.998h11.268L8 3.24z"
        }
      )
    }
  );
}
const qA = /* @__PURE__ */ i(AA);
function OA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 3.5a2.5 2.5 0 1 1 .688 1.722l-2.53 1.582-.53-.848 2.53-1.581A2.5 2.5 0 0 1 9 3.5M3.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 8.5a2.5 2.5 0 1 1 4.915.648l2.23 1.116-.447.894-2.23-1.115A2.5 2.5 0 0 1 1 8.5m10-1h1v2.55a2.5 2.5 0 1 1-1 0zm.5 3.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
        }
      )
    }
  );
}
const DA = /* @__PURE__ */ i(OA);
function PA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 2.009 5.978 1.601.021.36-.5.03.5-.03v.01l.002.02.003.078q.005.102.006.286c.002.245-.002.594-.027 1.016a16 16 0 0 1-.5 3.188c-.645 2.384-2.102 5.102-5.362 5.917l-.121.03-.121-.03c-3.26-.815-4.717-3.533-5.362-5.917a16 16 0 0 1-.5-3.188q-.04-.69-.019-1.38L2 3.98v-.008L2.5 4 2 3.97l.022-.36zM2.99 4.386c-.002.226.002.547.025.937.045.798.167 1.87.468 2.984.596 2.208 1.86 4.455 4.517 5.176 2.657-.72 3.92-2.968 4.517-5.176.301-1.113.423-2.186.468-2.984.022-.39.026-.711.025-.937L8 3.044z"
        }
      )
    }
  );
}
const TA = /* @__PURE__ */ i(PA);
function WA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m1.354.646 13 13-.707.708-2.033-2.033a6.58 6.58 0 0 1-3.493 2.164l-.121.03-.121-.03c-3.26-.815-4.717-3.533-5.362-5.917a16 16 0 0 1-.5-3.188q-.03-.507-.027-1.016c.003-.3.015-.468.032-.754l.695-.186-2.07-2.07zm2.18 3.595-.544.145c-.002.226.003.547.025.937.045.798.167 1.87.468 2.984.596 2.208 1.86 4.455 4.517 5.176a5.6 5.6 0 0 0 2.904-1.872zm9.949 4.327c-.138.51-.313 1.034-.534 1.552l-.768-.768q.195-.519.336-1.045c.301-1.113.423-2.186.468-2.984.023-.39.027-.711.025-.937L8 3.044l-1.678.45-.817-.817L8 2.009l5.978 1.601c.015.252.03.502.032.754.002.245-.002.594-.026 1.016a16 16 0 0 1-.501 3.188"
        }
      )
    }
  );
}
const GA = /* @__PURE__ */ i(WA);
function EA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 7h1v2h1v4H3.217L1.5 10.139V9h2.691l1-2h4.621l.804-3H13zm-1 0V5h-.616l-.536 2zM5.809 8l-.5 1h7.69V8zm-3.226 2 1.2 2H14v-2z"
        }
      )
    }
  );
}
const NA = /* @__PURE__ */ i(EA);
function jA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 2.02V1h1v1.02a5.97 5.97 0 0 1 3.374 1.398l.722-.721.707.707-.722.722A5.97 5.97 0 0 1 13.98 7.5H15v1h-1.02a5.97 5.97 0 0 1-1.399 3.374l.722.722-.707.707-.722-.722A5.97 5.97 0 0 1 8.5 13.98V15h-1v-1.02a5.97 5.97 0 0 1-3.374-1.397l-.722.721-.707-.707.721-.722A5.97 5.97 0 0 1 2.021 8.5H1v-1h1.02a5.97 5.97 0 0 1 1.398-3.374l-.721-.722.707-.707.722.721A5.97 5.97 0 0 1 7.5 2.021m0 1.005A5 5 0 0 0 4.836 4.13l2.148 2.148a2 2 0 0 1 .516-.214zm1 3.038q.276.072.516.214l2.148-2.148A5 5 0 0 0 8.5 3.025zm3.371-1.227L9.724 6.984q.142.24.214.516h3.038a5 5 0 0 0-1.104-2.664M12.976 8.5H9.937q-.072.276-.214.516l2.148 2.148A5 5 0 0 0 12.976 8.5m-1.81 3.371-2.15-2.148q-.24.142-.515.214v3.038a5 5 0 0 0 2.664-1.104M7.5 12.976V9.937a2 2 0 0 1-.516-.214l-2.148 2.148A5 5 0 0 0 7.5 12.976m-3.371-1.81 2.148-2.15a2 2 0 0 1-.214-.515H3.025a5 5 0 0 0 1.104 2.664M3.025 7.5h3.038a2 2 0 0 1 .214-.516L4.129 4.836A5 5 0 0 0 3.025 7.5M8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        }
      )
    }
  );
}
const UA = /* @__PURE__ */ i(jA);
function IA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a2 2 0 0 0-2 2h4a2 2 0 0 0-2-2m5 2v10H3V4h2a3 3 0 0 1 6 0zM4 5v8h8V5zm2 1a2 2 0 1 0 4 0h1a3 3 0 0 1-6 0z"
        }
      )
    }
  );
}
const QA = /* @__PURE__ */ i(IA);
function KA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m4.796 7 1.149-4.289.966.26L5.83 7h4.338l-1.08-4.03.966-.259L11.205 7h2.947l-1.608 6H3.456L1.848 7zM3.152 8l1.071 4h7.554l1.071-4z"
        }
      )
    }
  );
}
const JA = /* @__PURE__ */ i(KA);
function XA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.877 3H1V2h2.643l.269 1h9.21l-1.306 5H5.255l.268 1H11v1H4.757zm2.11 4h6.057l.784-3H4.18zm.513 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
        }
      )
    }
  );
}
const YA = /* @__PURE__ */ i(XA);
function ZA(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.877 3H1V2h2.643l1.343 5h6.058l1.078-4.126.967.252L11.816 8H5.255l.268 1H11v1H4.757zM5.5 12a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
        }
      )
    }
  );
}
const _A = /* @__PURE__ */ i(ZA);
function nq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 3.793 10.207 5.5l-6.5 6.5H2v-1.707zM3 10.707V11h.293l5.5-5.5-.293-.293zM14 12H6v-1h8z"
        }
      )
    }
  );
}
const lq = /* @__PURE__ */ i(nq);
function tq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.707 4 2.5 2.5-2.5 2.5H8v5H7V9H3V4h4V2h1v2zm-.414 4 1.5-1.5-1.5-1.5H4v3z"
        }
      )
    }
  );
}
const iq = /* @__PURE__ */ i(tq);
function eq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2.297 6.322C2.927 5.612 3.74 5 5 5c1.75 0 2.64 1.185 3.364 2.152L8.4 7.2C9.17 8.226 9.78 9 11 9c.868 0 1.43-.395 1.955-.986.22-.249.423-.519.64-.808l.152-.202c.27-.355.565-.73.912-1.055l.682.731c-.279.26-.53.576-.796.927l-.14.187c-.218.29-.451.601-.702.884C13.073 9.388 12.26 10 11 10c-1.751 0-2.64-1.185-3.364-2.152L7.6 7.8C6.83 6.774 6.22 6 5 6c-.869 0-1.43.395-1.955.986-.221.249-.423.519-.64.808l-.152.202c-.27.355-.565.73-.912 1.055L.66 8.32c.279-.26.53-.576.796-.927l.14-.187c.218-.29.451-.601.702-.884"
        }
      )
    }
  );
}
const oq = /* @__PURE__ */ i(eq);
function rq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m5.84 5.854-3-3 .708-.708 3 3zm-9.389-.708 3-3 .707.708-3 3zM8.5 5v5h-1V5zm-3.946 9.87 1.34-5 .966.26-1.34 5zm5.926.26-1.34-5 .966-.26 1.34 5z"
        }
      )
    }
  );
}
const hq = /* @__PURE__ */ i(rq);
function aq(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 3a5 5 0 0 1 5 5v.293l.647-.647.707.708-1.854 1.853-1.853-1.853.707-.708.646.647V8a4 4 0 1 0-8 0v1H3V8a5 5 0 0 1 5-5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M7.5 8a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0"
          }
        )
      ]
    }
  );
}
const cq = /* @__PURE__ */ i(aq);
function dq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.19 2.487c-.369.056-.608.284-.675.61l-.2.98-.664-.749c-.22-.249-.541-.326-.89-.19-.358.14-.777.53-1.03 1.278l-.948-.32c.325-.96.92-1.618 1.615-1.89.476-.185.983-.18 1.422.024a1.8 1.8 0 0 1 1.22-.73c.738-.113 1.582.16 2.343.829l-.66.75c-.594-.521-1.152-.649-1.532-.59m4.991 2.743a1.8 1.8 0 0 1 1.422-.024c.696.272 1.29.93 1.614 1.89l-.947.32c-.253-.748-.672-1.138-1.031-1.278-.348-.136-.669-.059-.89.19l-.664.749-.2-.98c-.066-.326-.305-.554-.675-.609-.381-.059-.938.069-1.532.59l-.66-.75c.76-.669 1.604-.942 2.342-.83a1.8 1.8 0 0 1 1.22.732M8 10a2 2 0 0 0-1.733 3h3.466A2 2 0 0 0 8 10m5.999 3v1h-12v-1h3.173a3 3 0 1 1 5.658 0z"
        }
      )
    }
  );
}
const wq = /* @__PURE__ */ i(dq);
function vq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 2h3v2h6v1H8v2H5V5H2V4h3zm1 1v3h1V3zm2 5h3v2h3v1h-3v2H8v-2H2v-1h6zm1 1v3h1V9z"
        }
      )
    }
  );
}
const mq = /* @__PURE__ */ i(vq);
function gq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 2.5A1.5 1.5 0 0 1 5.5 1h5A1.5 1.5 0 0 1 12 2.5v11a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 13.5zM5.5 2a.5.5 0 0 0-.5.5V11h6V2.5a.5.5 0 0 0-.5-.5H9v1H7V2zM11 12H5v1.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5zm-2.5 1.5h-1v-1h1z"
        }
      )
    }
  );
}
const sq = /* @__PURE__ */ i(gq);
function fq(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12 2.5v6.672l-1-1V2.5a.5.5 0 0 0-.5-.5H9v1H7V2H5.5a.5.5 0 0 0-.429.243l-.714-.714A1.5 1.5 0 0 1 5.5 1h5A1.5 1.5 0 0 1 12 2.5m-3.5 11h-1v-1h1z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12 13.5a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 13.5V4.707L1.646 2.354l.708-.708 12 12-.708.708L12 12.707zM5 5.707V11h5.293zM11 12H5v1.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5z"
          }
        )
      ]
    }
  );
}
const uq = /* @__PURE__ */ i(fq);
function pq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 3.793V2h1v1.793l.647-.647.707.708L8.5 5.207v1.927l1.669-.963.495-1.85.966.26-.236.882 1.552-.896.5.866-1.552.896.883.237-.26.966-1.848-.495L9 8l1.669.963 1.849-.495.259.966-.883.237 1.552.896-.5.866-1.552-.896.236.883-.966.258-.495-1.849L8.5 8.866v1.927l1.354 1.353-.707.708-.647-.647V14h-1v-1.793l-.646.647-.707-.708L7.5 10.793V8.866l-1.669.963-.495 1.85-.966-.26.237-.882-1.553.896-.5-.866 1.553-.896-.883-.237.258-.966 1.85.495L7 8l-1.669-.963-1.849.495-.258-.966.883-.237-1.553-.896.5-.866 1.553.896-.237-.883.966-.258.495 1.849 1.67.963V5.207L6.146 3.854l.707-.708z"
        }
      )
    }
  );
}
const Hq = /* @__PURE__ */ i(pq);
function Mq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 6H3V5h10zM9 9H3V8h6zm-3 3H3v-1h3z" })
    }
  );
}
const xq = /* @__PURE__ */ i(Mq);
function zq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.146 5.854 12.5 4.207V9h-1V4.207L9.854 5.854l-.708-.707L12 2.293l2.854 2.854zM3 12h10v1H3zm0-3h6v1H3zm0-3h3v1H3z"
        }
      )
    }
  );
}
const Vq = /* @__PURE__ */ i(zq);
function Cq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 3h10v1H3zm0 3h6v1H3zm0 3h3v1H3zm11.854 1.854L12 13.707l-2.854-2.854.708-.707 1.646 1.647V7h1v4.793l1.646-1.647z"
        }
      )
    }
  );
}
const Lq = /* @__PURE__ */ i(Cq);
function $q(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 13V3h1v10zm-2-2V5h1v6zm4 0V5h1v6zm4 0V5h1v6zm-2-1V6h1v4zM2 9V7h1v2z"
        }
      )
    }
  );
}
const Sq = /* @__PURE__ */ i($q);
function kq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 5.5V4.366l-.982.567-.5-.866L9.5 3.5l-.982-.567.5-.866.982.567V1.5h1v1.134l.982-.567.5.866-.982.567.982.567-.5.866L11 4.366V5.5zm1 10v-3.134l-2.714 1.567-.5-.866L10.5 11.5 7.786 9.933l.5-.866L11 10.634V7.5h1v3.134l2.714-1.567.5.866L12.5 11.5l2.714 1.567-.5.866L12 12.366V15.5zm-7.5-8L1.652 6.433l.5-.866L4 6.634V4.5h1v2.134l1.848-1.067.5.866L5.5 7.5l1.848 1.067-.5.866L5 8.366V10.5H4V8.366L2.152 9.433l-.5-.866z"
        }
      )
    }
  );
}
const yq = /* @__PURE__ */ i(kq);
function bq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 2.413v11.174L6.815 10H5V6h1.815zm-1 2.174L7.185 7H6v2h1.185L10 11.413z"
        }
      )
    }
  );
}
const Rq = /* @__PURE__ */ i(bq);
function Bq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2.413v11.174L3.815 10H2V6h1.815zM7 4.587 4.185 7H3v2h1.185L7 11.413zM13 12V4h1v8zm-2-1V5h1v6zm-2-1V6h1v4z"
        }
      )
    }
  );
}
const Fq = /* @__PURE__ */ i(Bq);
function Aq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 2.413v11.174L5.815 10H4V6h1.815zM9 4.587 6.185 7H5v2h1.185L9 11.413zM11 10V6h1v4z"
        }
      )
    }
  );
}
const qq = /* @__PURE__ */ i(Aq);
function Oq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 2.413v11.174L4.815 10H3V6h1.815zM8 4.587 5.185 7H4v2h1.185L8 11.413zM12 11V5h1v6zm-2-1V6h1v4z"
        }
      )
    }
  );
}
const Dq = /* @__PURE__ */ i(Oq);
function Pq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2.413v11.174L3.815 10H2V6h1.815zM7 4.587 4.185 7H3v2h1.185L7 11.413zM10.793 8.5 9.146 6.854l.708-.708L11.5 7.793l1.646-1.647.708.708L12.207 8.5l1.647 1.646-.708.707L11.5 9.208l-1.646 1.646-.708-.707z"
        }
      )
    }
  );
}
const Tq = /* @__PURE__ */ i(Pq);
function Wq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.708L10 10.707v2.88L5.815 10H4V6h1.293L1.646 2.354zM6.243 6.95 6.185 7H5v2h1.185L9 11.413V9.707zM10 2.413v4.759l-1-1V4.587l-.853.731-.71-.709z"
        }
      )
    }
  );
}
const Gq = /* @__PURE__ */ i(Wq);
function Eq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.766 9.065c-.227.257-.266.384-.266.435V14h-1V9.5c0-.05-.039-.178-.266-.435a9 9 0 0 0-.492-.499 26 26 0 0 1-.346-.337C5.766 7.599 5 6.719 5 5.5 5 3.656 6.262 2 8 2s3 1.656 3 3.5c0 1.22-.766 2.098-1.396 2.729l-.346.337q-.256.24-.492.5M6 5.5c0 .781.484 1.401 1.104 2.02.091.093.191.188.291.285.209.202.423.408.589.598L8 8.42l.015-.016c.167-.189.381-.396.59-.598q.152-.146.291-.285C9.516 6.902 10 6.28 10 5.5 10 4.03 9.023 3 8 3S6 4.03 6 5.5"
        }
      )
    }
  );
}
const Nq = /* @__PURE__ */ i(Eq);
function jq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 5h6.5v4H13V5h1v5H7.5V6H3v4H2z" })
    }
  );
}
const Uq = /* @__PURE__ */ i(jq);
function Iq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 13H6V3h8zm-1-1V4H7v8zM5 4v8H4V4zM3 5v6H2V5z"
        }
      )
    }
  );
}
const Qq = /* @__PURE__ */ i(Iq);
function Kq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11 2h3v1h-2v3H9v3H6v3H3v2H2v-3h3V8h3V5h3z"
        }
      )
    }
  );
}
const Jq = /* @__PURE__ */ i(Kq);
function Xq(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 1.37 2.186 4.43 4.889.71-3.538 3.448.835 4.869L8 12.528l-4.372 2.299.835-4.869L.926 6.51l4.888-.71zm0 2.26L6.478 6.714l-3.403.494L5.537 9.61 4.956 13 8 11.399l3.044 1.6-.581-3.39 2.463-2.4-3.404-.495z"
        }
      )
    }
  );
}
const Yq = /* @__PURE__ */ i(Xq);
function Zq(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8 7.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2m4.969 5.438a5 5 0 0 0-9.938 0L8 6.107zM3.022 8.476l.005.05 4.057 1.086L7.992 13h.017l.908-3.388 4.056-1.086.005-.05L8 7.142zm6.053 4.408a5.01 5.01 0 0 0 3.655-3.258l-2.997.803zM3.27 9.626a5.01 5.01 0 0 0 3.655 3.258l-.658-2.455z"
          }
        )
      ]
    }
  );
}
const _q = /* @__PURE__ */ i(Zq);
function nO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 12.5v-9h1v9zm3-8.87L13.492 8 6 12.37zm1 1.74v5.26L11.508 8z"
        }
      )
    }
  );
}
const lO = /* @__PURE__ */ i(nO);
function tO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 12.5h-1v-9h1zm-3-8.87v8.74L2.508 8zM4.492 8 9 10.63V5.37z"
        }
      )
    }
  );
}
const iO = /* @__PURE__ */ i(tO);
function eO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 14H6.293L2 9.707V2h12zM7 9v4h6V3H3v6zm-3.293 1L6 12.293V10z"
        }
      )
    }
  );
}
const oO = /* @__PURE__ */ i(eO);
function rO(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M6.5 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M6 6.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 14H6.293L2 9.707V2h12zM7 9v4h6v-1.887l-2.983-1.719-1.767 1.018-.5-.866 2.267-1.306L13 9.959V3H3v6zm-3.293 1L6 12.293V10z"
          }
        )
      ]
    }
  );
}
const hO = /* @__PURE__ */ i(rO);
function aO(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m12.075 6.331-2.037 1.985.48 2.804-2.251-1.183.466-.885.457.24-.227-1.325.962-.938-1.33-.194L8 5.63l-.596 1.205-1.331.194.275.267-.698.716L3.926 6.33l2.814-.41L8 3.371l1.26 2.55z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 14H6.293L2 9.707V2h12zM7 9v4h6V3H3v6zm-3.293 1L6 12.293V10z"
          }
        )
      ]
    }
  );
}
const cO = /* @__PURE__ */ i(aO);
function dO(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6 5h5v1H9v5H8V6H6z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 14H6.293L2 9.707V2h12zM7 9v4h6V3H3v6zm-3.293 1L6 12.293V10z"
          }
        )
      ]
    }
  );
}
const wO = /* @__PURE__ */ i(dO);
function vO(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8.5 4a2.5 2.5 0 0 1 2.086 3.879l1.768 1.768-.707.707-1.768-1.768A2.5 2.5 0 1 1 8.5 4M7 6.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14 14H6.293L2 9.707V2h12zM7 9v4h6V3H3v6zm-3.293 1L6 12.293V10z"
          }
        )
      ]
    }
  );
}
const mO = /* @__PURE__ */ i(vO);
function gO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.348 1h9.304l-.804 3H11v8h.848l.804 3H3.348l.804-3H5V4h-.848zM6 4v8h1.5V4zm2.5 0v8H10V4zM4.652 2l.268 1h6.16l.268-1zm.268 11-.268 1h6.696l-.268-1z"
        }
      )
    }
  );
}
const sO = /* @__PURE__ */ i(gO);
function fO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M4 4h8v8H4zm1 1v6h6V5z" })
    }
  );
}
const uO = /* @__PURE__ */ i(fO);
function pO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.03 2.17 4.5 2l.47-.17.002.004.005.014.017.05q.024.065.066.19.534 1.63.927 3.298c.477 2.03.957 4.745 1.009 7.614h1.007a47.5 47.5 0 0 1 .502-6.386q.148-1.005.349-2.003.069-.342.148-.681l.01-.037.002-.01v-.004L9.5 4l.485.121v.002l-.002.007-.008.033-.03.13q-.04.176-.111.518-.196.97-.34 1.95A46.5 46.5 0 0 0 9.004 13h1.002c.05-2.869.53-5.585 1.008-7.615.253-1.075.506-1.96.697-2.579q.14-.456.296-.908l.017-.05.005-.014.002-.004.47.17.47.17-.001.004-.004.01-.016.045-.061.179c-.053.158-.13.392-.223.692-.184.6-.431 1.465-.678 2.515-.467 1.983-.931 4.618-.982 7.385H14v1H2v-1h1.992c-.066-2.035-.517-4.147-.974-5.805a35 35 0 0 0-.9-2.795l-.062-.162-.015-.04-.004-.01-.001-.002L2.5 4l.464-.186.002.005.005.012.018.045.065.172q.526 1.42.928 2.882c.469 1.7.944 3.91 1.01 6.07h1.003c-.05-2.767-.515-5.402-.982-7.385A39 39 0 0 0 4.335 3.1q-.135-.438-.284-.871l-.016-.045-.004-.01z"
        }
      )
    }
  );
}
const HO = /* @__PURE__ */ i(pO);
function MO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 4c-1.299 0-2 .846-2 1.5 0 .596.21.917.514 1.15.348.265.836.43 1.45.623l.072.023c.198.063.408.129.62.204H14v1h-3.671c.324.357.564.817.664 1.418.152.911-.16 1.702-.746 2.251C9.673 12.71 8.858 13 8 13c-1.683 0-3-1.035-3-2.5h1c0 .744.683 1.5 2 1.5.642 0 1.2-.219 1.563-.56.351-.33.538-.79.444-1.358-.1-.598-.386-.952-.777-1.213a3.7 3.7 0 0 0-.752-.369H2v-1h3.983l-.076-.056C5.353 7.021 5 6.404 5 5.5 5 4.154 6.299 3 8 3c1.683 0 3 1.035 3 2.5h-1C10 4.756 9.317 4 8 4"
        }
      )
    }
  );
}
const xO = /* @__PURE__ */ i(MO);
function zO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4H2V3h12zM2 5h12v3H2zm1 1v1h10V6zM2 9h12v4H2zm1 1v2h10v-2z"
        }
      )
    }
  );
}
const VO = /* @__PURE__ */ i(zO);
function CO(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m13.25.543 2.207 2.207-4.458 4.457.001.043c0 1.544-1.104 2.558-2.43 2.745-.6.085-1.296.089-1.927-.078-.634-.167-1.255-.522-1.59-1.193l-.258-.516.547-.182c.47-.157.755-.603 1.145-1.274l.016-.027c.21-.36.456-.784.786-1.112A2 2 0 0 1 8.792 5zM10 7.24 8.76 6h-.01c-.324 0-.55.118-.756.322-.227.226-.414.54-.642.933l-.035.06c-.25.43-.563.97-1.055 1.34q.251.195.636.295c.465.123 1.02.127 1.532.055C9.33 8.878 10 8.23 10 7.25zm.5-2.534-.809.81.792.794.81-.81zm3.543-1.956-.793-.793L11.207 4l.793.793z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8 4H2v8h12V6h1v7H1V3h7z" })
      ]
    }
  );
}
const LO = /* @__PURE__ */ i(CO);
function $O(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M3.5 7.5h9v1h-9z" })
    }
  );
}
const SO = /* @__PURE__ */ i($O);
function kO(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M12 8.5H4v-1h8z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1M2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8"
          }
        )
      ]
    }
  );
}
const yO = /* @__PURE__ */ i(kO);
function bO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.5 2H5V1h6v1H9.5v2.5H12V14h-1.5v1h-1v-1h-3v1h-1v-1H4V4.5h2.5zm1 0v2.5h1V2zM5 5.5V13h6V5.5zm4 2H7v-1h2zM5.812 9h4.375l-.803 3H6.616zm1.303 1 .268 1h1.233l.268-1z"
        }
      )
    }
  );
}
const RO = /* @__PURE__ */ i(bO);
function BO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a2 2 0 0 0-1.217 3.587l-.6.8A2 2 0 1 0 6.732 10l.915.38L6.946 13h2.108l-.702-2.619.916-.38a2 2 0 1 0 .55-2.614l-.6-.8A2 2 0 0 0 8 3M5 5a3 3 0 1 1 5.828 1.005Q10.913 6 11 6a3 3 0 1 1-1.252 5.727l.61 2.273H5.642l.609-2.273a3 3 0 1 1-1.08-5.722A3 3 0 0 1 5 5"
        }
      )
    }
  );
}
const FO = /* @__PURE__ */ i(BO);
function AO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.211 2h1.577l3.464 6-3.464 6H7.211L3.747 8zm.578 1L4.902 8l2.887 5h.422l2.887-5L8.21 3z"
        }
      )
    }
  );
}
const qO = /* @__PURE__ */ i(AO);
function OO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 1.492.434.76c.804 1.407 1.685 2.388 2.473 3.266l.47.528C12.26 7.056 13 8.053 13 9.5a2.5 2.5 0 0 1-3.205 2.399l.563 2.1H5.643l.563-2.1A2.503 2.503 0 0 1 3 9.5c0-1.447.74-2.444 1.624-3.454q.228-.26.47-.528c.788-.878 1.668-1.859 2.472-3.266zM5.376 6.704C4.51 7.694 4 8.447 4 9.5a1.5 1.5 0 0 0 2.638.977l.862.456L6.946 13h2.108l-.553-2.066.862-.456A1.5 1.5 0 0 0 12 9.5c0-1.053-.51-1.806-1.376-2.796q-.21-.24-.447-.5C9.517 5.468 8.74 4.603 8 3.46c-.74 1.143-1.517 2.008-2.177 2.742q-.236.26-.447.501"
        }
      )
    }
  );
}
const DO = /* @__PURE__ */ i(OO);
function PO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 4V2h1v2zM4.818 5.525 3.404 4.111l.707-.707 1.414 1.414zm6.364 0-.707-.707 1.414-1.414.707.707zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-1 .5H2v-1h2zm10 0h-2v-1h2zm-9.89 4.096-.706-.707 1.414-1.414.707.707zm7.78 0-1.415-1.414.707-.707 1.414 1.414zM8.5 12v2h-1v-2z"
        }
      )
    }
  );
}
const TO = /* @__PURE__ */ i(PO);
function WO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 4V3h1v1zM4.818 5.525l-.707-.707.707-.707.707.707zm5.657-.707.707-.707.707.707-.707.707zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0m-1 .5H3v-1h1zm9 0h-1v-1h1zm-8.89 2.682.708-.707.707.707-.707.707zm7.072.707-.707-.707.707-.707.707.707zM8.5 12v1h-1v-1z"
        }
      )
    }
  );
}
const GO = /* @__PURE__ */ i(WO);
function EO(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 12 12-.707.707-3.909-3.908a3 3 0 0 1-4.184-4.184L1.647 2.355zm3.923 5.338a2 2 0 0 0 2.74 2.74z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M11 8q0 .084-.005.167L7.834 5.005A3 3 0 0 1 11 8M7.5 4V2h1v2zm3.682 1.525-.707-.707 1.414-1.414.707.707zM4 8.5H2v-1h2zm10 0h-2v-1h2zm-9.89 4.096-.706-.707 1.414-1.414.707.707zM8.5 12v2h-1v-2z"
          }
        )
      ]
    }
  );
}
const NO = /* @__PURE__ */ i(EO);
function jO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.976 2.194 5.797 1.554-2.588 9.66L6.935 12h-1.37l-1.867.5-2.071-7.727L5 3.87V3h3.76zM8.492 4H6v7h.616zm-.88 7.147.966.258 2.9.777 2.07-7.727-3.865-1.036zM5 11.117V4.904l-2.148.575 1.553 5.796z"
        }
      )
    }
  );
}
const UO = /* @__PURE__ */ i(jO);
function IO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.354 6.355-.706-.71 1.647-1.64h-1.29A4 4 0 0 0 4.14 9.041l-.966.258a5 5 0 0 1 4.831-6.294h1.291l-1.65-1.652.708-.707 2.857 2.859zm4.48.346a5.006 5.006 0 0 1-4.83 6.295H6.707l1.646 1.651-.708.706-2.85-2.858 2.85-2.849.707.708-1.642 1.642h1.292a4 4 0 0 0 3.865-5.036z"
        }
      )
    }
  );
}
const QO = /* @__PURE__ */ i(IO);
function KO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13.003 7.996c0 .647-.123 1.265-.346 1.832l-.79-.79a4 4 0 0 0 .001-2.078l.966-.259c.11.414.17.848.17 1.295M8.005 4.005a4 4 0 0 0-1.036.134l-.791-.79a5 5 0 0 1 1.827-.344h1.291l-1.65-1.652.708-.707 2.856 2.859L8.767 5.94l-.707-.707 1.234-1.228zm2.447 7.154L4.844 5.551a4 4 0 0 0-.705 3.49l-.966.258a5 5 0 0 1 .96-4.46L1.646 2.355l.707-.708 12 12-.707.708-2.483-2.483a4.98 4.98 0 0 1-3.16 1.125H6.708l1.646 1.651-.708.706-2.85-2.858 2.85-2.849.707.708-1.642 1.642h1.292c.923 0 1.772-.313 2.449-.837"
        }
      )
    }
  );
}
const JO = /* @__PURE__ */ i(KO);
function XO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.354.647 3.357 3.358H8.003A4 4 0 0 0 4.139 9.04l-.966.258a5.006 5.006 0 0 1 4.83-6.294h1.294l-1.65-1.652zM8.002 5.5 10.6 10H5.404zM7.136 9h1.732l-.866-1.5zm5.698-2.299a5.006 5.006 0 0 1-4.83 6.295H6.707l1.646 1.651-.708.706-3.347-3.357h3.704a4 4 0 0 0 3.865-5.036z"
        }
      )
    }
  );
}
const YO = /* @__PURE__ */ i(XO);
function ZO(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v11a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5zM4.5 2a.5.5 0 0 0-.5.5V11h8V2.5a.5.5 0 0 0-.5-.5zM12 12H4v1.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5zm-3.5 1.5h-1v-1h1z"
        }
      )
    }
  );
}
const _O = /* @__PURE__ */ i(ZO);
function nD(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 2.5v7.672l-1-1V2.5a.5.5 0 0 0-.5-.5H4.828l-.89-.89Q4.198 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5m-4.5 11h-1v-1h1z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12.988 13.695A1.5 1.5 0 0 1 11.5 15h-7A1.5 1.5 0 0 1 3 13.5V3.707L1.646 2.354l.708-.708 13 13-.707.708zM4 4.707V11h6.293zM11.293 12H4v1.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-.793z"
          }
        )
      ]
    }
  );
}
const lD = /* @__PURE__ */ i(nD);
function tD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.293 2h3.414L14 4.293v3.414l-6.5 6.5L1.793 8.5zm.414 1-5.5 5.5L7.5 12.793l5.5-5.5V4.707L11.293 3zM10.5 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M9 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
        }
      )
    }
  );
}
const iD = /* @__PURE__ */ i(tD);
function eD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.293 2h3.414L14 4.293v3.414l-6.5 6.5L1.793 8.5zm.414 1-5.5 5.5L7.5 12.793l5.5-5.5V4.707L11.293 3zM10.5 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M9 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-.146 3.646-.707.708-2-2 .707-.708zm-1.707 1.708-2-2 .707-.708 2 2z"
        }
      )
    }
  );
}
const oD = /* @__PURE__ */ i(eD);
function rD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 4.5h2V5h1.91l.804 3h.403l.803-3h1.58v1h-.812l-.804 3h-.902l.518 1.934V11c0 .424-.332.685-.56.82-.262.154-.607.276-.99.372-.774.194-1.817.308-2.95.308s-2.176-.114-2.95-.308c-.383-.096-.729-.218-.99-.372-.229-.135-.56-.396-.56-.82v-.066L3.75 10H1.848L2.92 6h1.902l.268-1H7zM4.554 7h-.866l-.536 2h.866zm1.303-1-1.323 4.938.034.02c.144.085.384.179.725.264.673.168 1.63.278 2.707.278s2.033-.11 2.707-.278c.34-.085.58-.179.724-.263l.034-.021L10.143 6zm5.675 4.884-.005.006zm-7.06.006-.005-.006z"
        }
      )
    }
  );
}
const hD = /* @__PURE__ */ i(rD);
function aD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m13.575 2.804.096.22-.458.202c.458-.202.459-.2.459-.2v.002l.002.004.006.013.016.041a5 5 0 0 1 .184.647 6.2 6.2 0 0 1 .095 1.786c-.131 1.497-.81 3.481-2.91 5.562-2.097 2.078-4.08 2.756-5.57 2.892a6.2 6.2 0 0 1-1.776-.085 5 5 0 0 1-.504-.13l-.14-.049-.04-.016-.013-.006-.004-.002h-.004l.2-.46-.2.459-.221-.096-.669-2.495 3.528-2.037 1.759 1.016c.473-.186 1.024-.519 1.612-1.102.545-.541.872-1.051 1.065-1.498L9.044 5.665l2.037-3.529zm-2.012.496-1.364 2.365.991 1.716-.078.218c-.23.646-.655 1.357-1.385 2.081-.778.771-1.535 1.198-2.212 1.416l-.211.069-1.652-.954-2.363 1.365.337 1.262q.144.04.29.07c.348.07.858.127 1.488.07 1.251-.115 3.019-.687 4.957-2.608 1.937-1.919 2.508-3.685 2.618-4.938a5.2 5.2 0 0 0-.079-1.496q-.03-.15-.073-.296z"
        }
      )
    }
  );
}
const cD = /* @__PURE__ */ i(aD);
function dD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-2.935-2.935c-1.966 1.815-3.81 2.426-5.217 2.554a6.2 6.2 0 0 1-1.776-.086 5 5 0 0 1-.643-.178l-.041-.016-.013-.005-.004-.002-.002-.001.197-.46-.198.46-.222-.097-.669-2.495 3.528-2.037 1.76 1.016a4.5 4.5 0 0 0 1.213-.74L1.646 2.354zm6.98 8.396c-.638.547-1.257.873-1.819 1.054l-.211.069-1.652-.954-2.363 1.365.338 1.262q.116.033.29.07c.347.07.857.127 1.487.07 1.174-.107 2.802-.618 4.6-2.267zm4.641-4.522c-.099 1.124-.507 2.523-1.594 4.033l-.717-.718c.912-1.313 1.235-2.493 1.315-3.403a5.2 5.2 0 0 0-.078-1.496 4 4 0 0 0-.074-.296l-1.264-.34L10.2 5.665l.99 1.716-.077.218q-.09.246-.203.481L9.797 6.968l-.753-1.303 2.037-3.528 2.494.668.096.22-.458.2.458-.2.002.003.001.004.006.013q.038.09.066.182c.04.12.09.29.134.506.09.431.16 1.043.095 1.786"
        }
      )
    }
  );
}
const wD = /* @__PURE__ */ i(dD);
function vD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0M4.848 5.675h6.304L9.189 13H6.81zm1.304 1L7.578 12h.844l1.426-5.325zm-4.033 5.611c-.108.115-.119.186-.119.214 0 .04.027.172.305.374.267.194.684.39 1.246.562C4.668 13.78 6.24 14 8 14s3.332-.22 4.45-.564c.56-.172.979-.368 1.245-.562.278-.202.305-.335.305-.374 0-.028-.01-.099-.119-.214-.11-.117-.296-.252-.574-.39-.552-.275-1.373-.514-2.386-.677l.158-.987c1.067.17 1.996.432 2.673.769.338.168.637.366.858.6.223.239.39.542.39.899 0 .513-.336.906-.717 1.183-.39.284-.925.52-1.54.71C11.507 14.772 9.831 15 8 15c-1.83 0-3.507-.228-4.743-.608-.615-.19-1.15-.425-1.54-.71-.38-.276-.717-.67-.717-1.182 0-.357.167-.66.39-.898.22-.235.52-.434.858-.601.677-.337 1.606-.598 2.673-.77l.158.988c-1.013.163-1.834.402-2.386.677-.278.138-.464.272-.574.39"
        }
      )
    }
  );
}
const mD = /* @__PURE__ */ i(vD);
function gD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m13.016 1.828 1.357 5.064-2.332.625-.183-.683L9.74 7.4l1.74 6.492-.967.26-.634-2.369a4.5 4.5 0 0 1-2.765-.001l-.635 2.37-.966-.26L7.062 8.12l-2.034.545-.183-.683-1.767.473.074.273-.966.259-.777-2.898.966-.259.079.293L4.22 5.65l-.183-.683 6.83-1.83-.183-.683zM11.909 3.16l.839 3.132.4-.107-.84-3.132zm-.783.942L5.262 5.673l.473 1.766 5.864-1.571zM4.479 6.615l-1.766.473.107.4 1.766-.473zM8.177 7.82l-.803 2.995a3.5 3.5 0 0 0 2.247.002L8.775 7.66z"
        }
      )
    }
  );
}
const sD = /* @__PURE__ */ i(gD);
function fD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M15 12h-1.5v1h-1v-1h-9v1h-1v-1H1V3h14zm-1-1v-1H2v1zm0-2V4H2v5z"
        }
      )
    }
  );
}
const uD = /* @__PURE__ */ i(fD);
function pD(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M12 12H6V7h6zm-5-1h4V8H7zM3.5 8.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M5 11v1H4v-1z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8.117 4 8.955.87l.967.26L9.152 4h.927l.268 1H14v9H2V5h3.653l.267-1h.93l-.771-2.87.966-.26L7.884 4zM3 13h10V6H3z"
          }
        )
      ]
    }
  );
}
const HD = /* @__PURE__ */ i(pD);
function MD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M7.5 4H4V3h8v1H8.5v9h-1z" })
    }
  );
}
const xD = /* @__PURE__ */ i(MD);
function zD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4H2V3h12zm-2 3H4V6h8zm1 3H3V9h10zm-2 3H5v-1h6z"
        }
      )
    }
  );
}
const VD = /* @__PURE__ */ i(zD);
function CD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4H2V3h12zm0 3H2V6h12zm0 3H2V9h12zm-6 3H2v-1h6z"
        }
      )
    }
  );
}
const LD = /* @__PURE__ */ i(CD);
function $D(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4H2V3h12zm-4 3H2V6h8zm2 3H2V9h10zm-4 3H2v-1h6z"
        }
      )
    }
  );
}
const SD = /* @__PURE__ */ i($D);
function kD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4H2V3h12zm0 3H6V6h8zm0 3H4V9h10zm0 3H8v-1h6z"
        }
      )
    }
  );
}
const yD = /* @__PURE__ */ i(kD);
function bD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 2h12v12H2zm1 1v10h10V3zm4.5 3H5V5h6v1H8.5v5h-1z"
        }
      )
    }
  );
}
const RD = /* @__PURE__ */ i(bD);
function BD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 14H2V2h12zM3.293 3H3v.293zM3 4.707v1.586L6.293 3H4.707zM7.707 3 3 7.707v1.586L9.293 3zm3 0L3 10.707v1.586L12.293 3zM13 3.707 3.707 13h1.586L13 5.293zm0 3L6.707 13h1.586L13 8.293zm0 3L9.707 13h1.586L13 11.293zm0 3-.293.293H13z"
        }
      )
    }
  );
}
const FD = /* @__PURE__ */ i(BD);
function AD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 1h4v8.764a3 3 0 1 1-4 0zm3 8.17V8H8V7h1V6H8V5h1V4H8V3h1V2H7v8.25l-.2.15A2 2 0 1 0 8 10V9c.35 0 .687.06 1 .17"
        }
      )
    }
  );
}
const qD = /* @__PURE__ */ i(AD);
function OD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.5 3H14v8h-3.211l-1.895 3.281a1.437 1.437 0 0 1-2.633-1.09L6.848 11H2.482L1.72 8.152 3.1 3h5.6l1.801.482zm1 7H13V4h-1.5zM8.568 4H3.867L2.755 8.152 3.25 10h4.901l-.923 3.45a.437.437 0 0 0 .8.331l2.072-3.588.4-.4V4.518z"
        }
      )
    }
  );
}
const DD = /* @__PURE__ */ i(OD);
function PD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.35 2c-.156 0-.3.083-.378.219L5.9 5.807l-.4.4v5.275L7.432 12h4.701l1.113-4.152L12.75 6H7.848l.925-3.45A.437.437 0 0 0 8.35 2M4.5 12V6H3v6zm.711-7 1.895-3.281a1.437 1.437 0 0 1 2.633 1.09L9.152 5h4.366l.763 2.848L12.9 13H7.3l-1.8-.482V13H2V5z"
        }
      )
    }
  );
}
const TD = /* @__PURE__ */ i(PD);
function WD(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m10.074 7.378-1.037 1.01.245 1.428L8 9.142l-1.282.675.245-1.428-1.037-1.011 1.433-.208L8 5.87l.641 1.299z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M15 7h-1a1 1 0 0 0 0 2h1v4H1V9h1a1 1 0 0 0 0-2H1V3h14zM2 6a2 2 0 1 1 0 4v2h12v-2a2 2 0 1 1 0-4V4H2z"
          }
        )
      ]
    }
  );
}
const GD = /* @__PURE__ */ i(WD);
function ED(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 3H6V2h4v1H9v1.1A5.002 5.002 0 0 1 8 14a5 5 0 0 1-1-9.9zm1 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6.74 6.231l.966-.258.553 2.06a1 1 0 1 1-.966.26z"
        }
      )
    }
  );
}
const ND = /* @__PURE__ */ i(ED);
function jD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 2h6v2h3v9H2V4h3zm1 2h4V3H6zM3 5v2h3V6h4v1h3V5zm10 3h-3v1H6V8H3v4h10zM7 7v1h2V7z"
        }
      )
    }
  );
}
const UD = /* @__PURE__ */ i(jD);
function ID(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.614 3h2.768l2.411 9h2.205v1h-12v-1h2.205zm-1.376 9h5.52L8.614 4H7.382l-.938 3.5H8v1H6.176l-.268 1H9v1H5.64z"
        }
      )
    }
  );
}
const QD = /* @__PURE__ */ i(ID);
function KD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.707 4H12v1H4.707l2.147 2.146-.708.708L2.793 4.5l3.353-3.354.708.708zM4 11h7.293L9.146 8.854l.708-.708 3.353 3.354-3.353 3.354-.708-.707L11.293 12H4z"
        }
      )
    }
  );
}
const JD = /* @__PURE__ */ i(KD);
function XD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.146 6.854 12 4.707V12h-1V4.707L8.854 6.854l-.708-.708L11.5 2.793l3.354 3.353zM4 11.293V4h1v7.293l2.146-2.147.708.708L4.5 13.207 1.146 9.854l.708-.708z"
        }
      )
    }
  );
}
const YD = /* @__PURE__ */ i(XD);
function ZD(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.5 1H8a7 7 0 0 1 0 14h-.5zm1 1.02v11.96a6 6 0 0 0 0-11.96m-2.553.34a6 6 0 0 0-1.804 1.044L3.5 2.638c.62-.52 1.33-.935 2.105-1.217zM2.803 5a6 6 0 0 0-.713 1.957l-.985-.172c.144-.82.43-1.59.832-2.286zM2.09 9.043c.123.702.368 1.362.713 1.957l-.866.5a7 7 0 0 1-.832-2.285zm2.053 3.553a6 6 0 0 0 1.804 1.044l-.342.94A7 7 0 0 1 3.5 13.361z"
        }
      )
    }
  );
}
const _D = /* @__PURE__ */ i(ZD);
function nP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 1h4v2h3v1H3V3h3zm1 2h2V2H7zm4 10V5h1v9H4V5h1v8z"
        }
      )
    }
  );
}
const lP = /* @__PURE__ */ i(nP);
function tP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 1h4v2h3v1H3V3h3zm1 2h2V2H7zM4 5h1v8h1.89v1H4zm6.793 6.5L8.646 9.354l.708-.708 2.146 2.147 2.146-2.147.708.708-2.147 2.146 2.147 2.146-.708.708-2.146-2.147-2.146 2.147-.708-.708z"
        }
      )
    }
  );
}
const iP = /* @__PURE__ */ i(tP);
function eP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 2a1.5 1.5 0 0 0-1.341.827l-.188.374-.401-.119a2 2 0 0 0-2.266 2.979l.18.286-.199.273A1.5 1.5 0 0 0 5.538 9l.211-.006.15.148a3 3 0 0 0 4.941-1.176l.059-.17.152-.094A2 2 0 0 0 10.4 4.04l-.41-.083.01-.42V3.5A1.5 1.5 0 0 0 8.5 2m-2.027.037a2.5 2.5 0 0 1 4.505 1.126 3 3 0 0 1 .75 5.29A4 4 0 0 1 8.5 10.969V13H13v1H3v-1h4.5v-2.031a4 4 0 0 1-2.15-.973A2.5 2.5 0 0 1 3.3 6.31a3 3 0 0 1 3.172-4.273"
        }
      )
    }
  );
}
const oP = /* @__PURE__ */ i(eP);
function rP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8.866 7.696 3 5.196H7V15H6v-2.108H1.134l3-5.196H2.639L6.506 1l3.864 6.696zm-3-1-3 5.196h7.268l-3-5.196H8.64L6.506 3 4.37 6.696zM10 15v-1h1v1zm2.866-7.304 3 5.196h-3.134v-1h1.402l-3-5.196h1.505L10.504 3l-.7 1.214-.866-.5L10.506 1l3.864 6.696z"
        }
      )
    }
  );
}
const hP = /* @__PURE__ */ i(rP);
function aP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 1v6.977c.518-.048 1.054-.175 1.453-.408q.384-.225.529-.542c.094-.207.136-.495.033-.906a93 93 0 0 0-.744-2.794l-.04-.138-.01-.033-.002-.008-.454-1.492 2.54 1.947-.61.794-.115-.089q.173.643.405 1.57c.147.59.112 1.115-.094 1.564-.203.445-.55.765-.933.99-.59.345-1.319.498-1.958.548V14h-1V8.98c-.64-.05-1.369-.203-1.958-.549-.384-.224-.73-.544-.933-.989-.205-.45-.241-.974-.094-1.563q.233-.928.405-1.57l-.116.088-.608-.794 2.539-1.947-.453 1.49v.002l-.003.008-.01.033-.04.138q-.054.184-.158.556-.307 1.116-.586 2.238c-.103.411-.061.699.034.906q.144.314.529.542c.398.233.934.36 1.452.408V1z"
        }
      )
    }
  );
}
const cP = /* @__PURE__ */ i(aP);
function dP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.667 4.842 4.666 4 4.342-3.722.65.76-4.992 4.279-4.666-4-4.342 3.72-.65-.759z"
        }
      )
    }
  );
}
const wP = /* @__PURE__ */ i(dP);
function vP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.794 12.129-.876-3.272H3.082l-.877 3.273-.965-.26L3.616 3h1.767l2.377 8.87zM4.616 4h-.232L3.35 7.858h2.3zM14 6.793v3.641l.385 1.437-.966.258-.178-.663-.534.534H9.793L9 11.207V9.792l.741-.74L13 8.179v-.972L12.793 7h-2.586l-.353.354-.708-.708L9.793 6h3.414zm-4 3.414v.586l.207.207h2.086l.707-.707V9.214l-2.74.734z"
        }
      )
    }
  );
}
const mP = /* @__PURE__ */ i(vP);
function gP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 3v6.5a2.5 2.5 0 0 0 5 0V3h1v6.5a3.5 3.5 0 1 1-7 0V3zM14 14v1H2v-1z"
        }
      )
    }
  );
}
const sP = /* @__PURE__ */ i(gP);
function fP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.532 4.464a5 5 0 0 1 0 7.072l-.708-.708a4 4 0 0 0 0-5.656c-1.535-1.536-3.88-1.408-5.47.182L3.708 6.999 6 7v1l-3.998-.002L2 4h1l.001 2.292 1.645-1.646c1.926-1.924 4.906-2.162 6.886-.182"
        }
      )
    }
  );
}
const uP = /* @__PURE__ */ i(fP);
function pP(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M1.848 4.87 2.617 2h10.766l.77 2.87-.967.26-.57-2.13H3.383l-.57 2.13z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m4.354 9.354-.708-.708L8 4.293l4.353 4.353-.707.708L8.5 6.207V14h-1V6.207z"
          }
        )
      ]
    }
  );
}
const HP = /* @__PURE__ */ i(pP);
function MP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.146 3.354 8.5 2.708v5.64l2.5-.67V7h-1V4h3v3h-1v1.447l-3.5.937v1.68a2 2 0 1 1-1 0v-.179L4 9.946v-2.03a1.5 1.5 0 1 1 1 0v1.262l2.5.67V2.707l-.646.647-.708-.707L8 .793l1.854 1.854zM11 5v1h1V5zM4 6.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0M7 13a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
        }
      )
    }
  );
}
const xP = /* @__PURE__ */ i(MP);
function zP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 3v7h1V3zm2-1v9H4V2zm2 4v4h1V6zm2-1v6H8V5zm3 7v1H2v-1z"
        }
      )
    }
  );
}
const VP = /* @__PURE__ */ i(zP);
function CP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 13V8.5H2v-1h2V3h3v4.5h1V5h3v2.5h3v1h-3V11H8V8.5H7V13zm1-1h1V4H5zm5-6H9v4h1z"
        }
      )
    }
  );
}
const LP = /* @__PURE__ */ i(CP);
function $P(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 4H2V3h12zM7 5v9H4V5zM5 6v7h1V6zm3-1h3v6H8zm1 1v4h1V6z"
        }
      )
    }
  );
}
const SP = /* @__PURE__ */ i($P);
function kP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 4h11v1.691l3-1.5v7.618l-3-1.5V12H1zm1 1v6h9V8.691l3 1.5V5.809l-3 1.5V5z"
        }
      )
    }
  );
}
const yP = /* @__PURE__ */ i(kP);
function bP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.708.708L11.293 12H1V4h2.293L1.646 2.354zM4.293 5H2v6h8.293zM11 5H7.828l-1-1H12v1.691l3-1.5v7.618l-2.224-1.112.448-.894.776.388V5.809l-3 1.5z"
        }
      )
    }
  );
}
const RP = /* @__PURE__ */ i(bP);
function BP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 4H6V3h4zm2.384 1 .937 3.498-.937 3.497h-3.5L8.615 11H7.384l-.267.995h-3.5l-.938-3.498L3.616 5zm-8 1-.67 2.497.67 2.498H6.35L6.616 10h2.768l.266.995h1.966l.67-2.497L11.616 6zm-3-.13.965.26-.635 2.367.636 2.374-.966.258L.68 8.497zm12.902 2.628-.635-2.369.966-.258.704 2.627-.705 2.631-.966-.258z"
        }
      )
    }
  );
}
const FP = /* @__PURE__ */ i(BP);
function AP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.61 2.748 8.094.815 9.06.557l.518 1.932zm3.511.424 1.414-1.415.708.707-1.415 1.415zM10 3.792 12.207 6 3.5 14.707 1.293 12.5zM6.489 5.578 4.557 5.06l.258-.966 1.933.518zM8.457 6.75l.793.793L10.793 6 10 5.207zm.086 1.5-.793-.793L2.707 12.5l.793.793zm4.968-1.827 1.932.518-.259.966-1.932-.518zm-2.122 2.83.518 1.931-.966.26-.518-1.933z"
        }
      )
    }
  );
}
const qP = /* @__PURE__ */ i(AP);
function OP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 .984 7.357 13.014H.643zM2.357 12.998h11.286L8 3.016zM7.5 10V6.5h1V10zm0 2v-1h1v1z"
        }
      )
    }
  );
}
const DP = /* @__PURE__ */ i(OP);
function PP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 1h6v3a5 5 0 0 1 1.9 3h.6v2h-.6a5 5 0 0 1-1.9 3v3H5v-3a5 5 0 0 1 0-8zm1 2.416A5 5 0 0 1 8 3c.711 0 1.388.148 2 .416V2H6zm0 9.168V14h4v-1.416A5 5 0 0 1 8 13a5 5 0 0 1-2-.416M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m2.545 4.164-.259.966-2.694-.722-.722-2.694.966-.259.572 2.137z"
        }
      )
    }
  );
}
const TP = /* @__PURE__ */ i(PP);
function WP(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M15 10h-1V2H2v8H1V1h14z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M7 3.254 9.992 5 7 6.745zm1 1.75L8.008 5 8 4.995zM8 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M7.5 10a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0m-4.39 1H5.5v1H3.89l-.25 1H5v1H2.36zm10.53 3H11v-1h1.36l-.25-1H10.5v-1h2.39zm-3.5 1H5.86l.75-3h2.78zm-1.28-1-.25-1H7.39l-.25 1zm2.64-6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M11 9a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0M3 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1"
          }
        )
      ]
    }
  );
}
const GP = /* @__PURE__ */ i(WP);
function EP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m8 2.382.447.894c.317.633.779 1.344 1.278 2.11.27.416.551.848.826 1.293.38.616.737 1.246 1.001 1.853.262.602.448 1.219.448 1.801a4 4 0 1 1-8 0c0-.582.186-1.2.448-1.801.264-.607.622-1.237 1.001-1.853.275-.445.556-.877.826-1.293.499-.766.961-1.477 1.278-2.11zM5.365 8.931C5.126 9.479 5 9.949 5 10.333a3 3 0 0 0 6 0c0-.384-.127-.854-.365-1.402-.236-.543-.565-1.126-.936-1.727a61 61 0 0 0-.767-1.2Q8.453 5.275 8 4.53c-.281.471-.606.972-.932 1.474q-.39.596-.767 1.2c-.37.601-.7 1.184-.936 1.727"
        }
      )
    }
  );
}
const NP = /* @__PURE__ */ i(EP);
function jP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 6.5A3.5 3.5 0 0 1 4.5 3h7a3.5 3.5 0 1 1 0 7H9.902l.268 1H11v1H5v-1h.831l.268-1H4.5A3.5 3.5 0 0 1 1 6.5M7.134 10l-.268 1h2.268l-.268-1zM4.5 4a2.5 2.5 0 0 0 0 5h7a2.5 2.5 0 0 0 0-5zm0 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M3 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m9 .5h-1V6h1z"
        }
      )
    }
  );
}
const UP = /* @__PURE__ */ i(jP);
function IP(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 12 12-.708.707L11 11.708V12H5v-1h.831l.268-1H4.5a3.5 3.5 0 0 1-1.743-6.536l-1.11-1.11zM3.5 4.208A2.5 2.5 0 0 0 4.5 9h3.793L5.987 6.695a1.5 1.5 0 1 1-1.682-1.683zm6.623 6.624.046.168h.123zM7.134 10l-.268 1h2.268l-.268-1zM4.5 6a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m10.5.5a3.5 3.5 0 0 1-2.361 3.31l-.83-.829A2.5 2.5 0 0 0 11.5 4H6.828l-1-1H11.5A3.5 3.5 0 0 1 15 6.5"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M12 7h-1V6h1z" })
      ]
    }
  );
}
const QP = /* @__PURE__ */ i(IP);
function KP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 5.5A3.5 3.5 0 0 1 4.5 2h7a3.5 3.5 0 0 1 3.194 4.934l-.912-.41A2.5 2.5 0 0 0 11.5 3h-7a2.5 2.5 0 0 0 0 5h2.902L6.6 11H5v-1h.831L6.1 9H4.5A3.5 3.5 0 0 1 1 5.5M4.5 5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M3 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M11 8h1v1.05a2.5 2.5 0 0 1 1.371.792l.91-.525.5.866-.91.525a2.5 2.5 0 0 1 0 1.584l.91.525-.5.866-.91-.525a2.5 2.5 0 0 1-1.372.792V15h-1v-1.05a2.5 2.5 0 0 1-1.37-.792l-.91.525-.5-.866.91-.525a2.5 2.5 0 0 1 0-1.584l-.91-.525.5-.866.91.525A2.5 2.5 0 0 1 11 9.05zm.5 2a1.5 1.5 0 1 0-.08 2.999A1.5 1.5 0 0 0 11.5 10m.5-4h-1V5h1z"
        }
      )
    }
  );
}
const JP = /* @__PURE__ */ i(KP);
function XP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4.009 2 2.144 8H1.849l2.144-8h2.274a2 2 0 1 1 3.465 0zM4.76 6l-1.607 6h9.696l-1.607-6zM6 10V7h1v3zm3 0V7h1v3z"
        }
      )
    }
  );
}
const YP = /* @__PURE__ */ i(XP);
function ZP(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 4h1v3.5h6V4h1v8h-1V8.5H5V12H4zM2 7.5V5h1v6H2V8.5H1v-1zM13 5h1v2.5h1v1h-1V11h-1z"
        }
      )
    }
  );
}
const _P = /* @__PURE__ */ i(ZP);
function nT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m3.323 6.23 3.44.921a1.498 1.498 0 0 1 2.474 0l3.44-.922a5.002 5.002 0 0 0-9.354 0m9.613.965-3.44.922A1.5 1.5 0 0 1 8.5 9.415v3.56a5 5 0 0 0 4.436-5.78M7.5 12.975v-3.56a1.5 1.5 0 0 1-.996-1.298l-3.44-.922a5 5 0 0 0 4.436 5.78M2.203 6.447a6.002 6.002 0 0 1 11.594 0 6 6 0 1 1-11.594 0M8 7.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1"
        }
      )
    }
  );
}
const lT = /* @__PURE__ */ i(nT);
function tT(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M5.5 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6.188 7.254a3.501 3.501 0 1 0 4.045 5.433l.78.626a4.5 4.5 0 1 1-5.2-6.985z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M10 7v1H8v2h3.29l1.586 2.75-.865.5-1.3-2.25H7V6h1v1z"
          }
        )
      ]
    }
  );
}
const iT = /* @__PURE__ */ i(tT);
function eT(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M8 4a1.81 1.81 0 0 1 1.812 1.812c0 .153-.032.308-.08.456.148-.048.303-.081.456-.081H12V8c0 1-.811 1.811-1.812 1.812-.153 0-.308-.032-.456-.08.048.148.081.303.081.456V12H8a1.81 1.81 0 0 1-1.812-1.812c0-.153.032-.308.08-.456-.148.048-.303.08-.455.08H4V8a1.81 1.81 0 0 1 1.813-1.812 1.5 1.5 0 0 1 .455.08 1.5 1.5 0 0 1-.08-.456V4zm.25 2.886q.23-.312.413-.654c.115-.225.15-.363.15-.42A.813.813 0 0 0 8 5h-.813v.812c0 .057.035.195.15.419a5.4 5.4 0 0 0 .413.655q.12.168.25.332.13-.165.25-.332m-1.364.864a5 5 0 0 0-.655-.413c-.224-.116-.362-.15-.418-.15A.813.813 0 0 0 5 8v.813h.813c.056 0 .194-.035.418-.15a5.4 5.4 0 0 0 .655-.413A10 10 0 0 0 7.218 8a8 8 0 0 0-.332-.25M8.25 9.114A10 10 0 0 0 8 8.782q-.13.165-.25.332a5.4 5.4 0 0 0-.413.655c-.115.224-.15.362-.15.418 0 .45.364.813.813.813h.813v-.812c0-.057-.035-.195-.15-.42a5.4 5.4 0 0 0-.413-.654m.864-.864a5.4 5.4 0 0 0 .654.412c.225.116.363.15.42.15A.813.813 0 0 0 11 8v-.813h-.813c-.056 0-.194.035-.418.15a5 5 0 0 0-.655.413 10 10 0 0 0-.332.25q.165.13.332.25"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M14.001 4.536v6.928l-6 3.464-6-3.464V4.536l6-3.464zm-1 6.351V5.113l-5-2.887-5 2.887v5.774l5 2.887z"
          }
        )
      ]
    }
  );
}
const oT = /* @__PURE__ */ i(eT);
function rT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 4a8.97 8.97 0 0 0-6.364 2.636l-.707-.707A9.97 9.97 0 0 1 8 3a9.97 9.97 0 0 1 7.071 2.929l-.707.707A8.97 8.97 0 0 0 8 4m0 3a5.98 5.98 0 0 0-4.243 1.757L3.05 8.05A6.98 6.98 0 0 1 8 6a6.98 6.98 0 0 1 4.95 2.05l-.707.707A5.98 5.98 0 0 0 8 7m0 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        }
      )
    }
  );
}
const hT = /* @__PURE__ */ i(rT);
function aT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.707-3.672-3.671q.024.156.025.318a2 2 0 1 1-1.682-1.975L6.486 7.193a6 6 0 0 0-2.729 1.564L3.05 8.05a7 7 0 0 1 2.635-1.658L4.154 4.861a9 9 0 0 0-2.518 1.775l-.707-.707a10 10 0 0 1 2.479-1.814L1.646 2.354zM8 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4.243-1.243a6 6 0 0 0-1.969-1.311l-1.39-1.39A6.97 6.97 0 0 1 12.95 8.05zM8 4q-.56 0-1.105.067l-.871-.872Q6.984 3.001 8 3a9.97 9.97 0 0 1 7.071 2.929l-.707.707A8.97 8.97 0 0 0 8 4"
        }
      )
    }
  );
}
const cT = /* @__PURE__ */ i(aT);
function dT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M2 3h12v10H2zm1 1v1h10V4zm10 2H3v6h10z" })
    }
  );
}
const wT = /* @__PURE__ */ i(dT);
function vT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v10H2zm1 1v1h10V4zm10 2H3v6h10zm-6.141 4.842 1.333-4 .949.316-1.333 4zM5.646 7.146l.708.708L5.207 9l1.147 1.146-.708.708L3.793 9zM10.793 9 9.646 7.854l.708-.708L12.207 9l-1.853 1.854-.708-.708z"
        }
      )
    }
  );
}
const mT = /* @__PURE__ */ i(vT);
function gT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 1h6v6H1zm1 1v1h4V2zm4 2H2v2h4zm3-3h6v6H9zm1 1v1h4V2zm4 2h-4v2h4zM1 9h6v6H1zm1 1v1h4v-1zm4 2H2v2h4zm3-3h6v6H9zm1 1v1h4v-1zm4 2h-4v2h4z"
        }
      )
    }
  );
}
const sT = /* @__PURE__ */ i(gT);
function fT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h10v8H2zm1 1v1h8V4zm8 2H3v4h8zm2 6V5h1v8H3v-1z"
        }
      )
    }
  );
}
const uT = /* @__PURE__ */ i(fT);
function pT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v10H2zm1 1v1h10V4zm10 2H3v6h10zM5.293 9 4.146 7.854l.708-.708L6.707 9l-1.853 1.854-.708-.708zM10 11H7v-1h3z"
        }
      )
    }
  );
}
const HT = /* @__PURE__ */ i(pT);
function MT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M11.024 8.832 8.5 10.29V14H11v1H5v-1h2.5v-3.711L4.976 8.831 5.54 2h4.92zM8 9.422l1.976-1.14L9.54 3H6.46l-.436 5.282z"
        }
      )
    }
  );
}
const xT = /* @__PURE__ */ i(MT);
function zT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.535 3a4 4 0 0 0 0 4l-.866.5a5 5 0 0 1 .001-5zM12 5a4 4 0 0 0-.535-2l.866-.5a5 5 0 0 1-.001 5l-.865-.5A4 4 0 0 0 12 5M6.267 4a2 2 0 0 0 0 2l-.865.5a3 3 0 0 1 0-3zM10 5a2 2 0 0 0-.267-1l.865-.5a3 3 0 0 1 0 3L9.733 6A2 2 0 0 0 10 5M7 5a1 1 0 1 1 1.5.866V9H14v5H2V9h5.5V5.866A1 1 0 0 1 7 5m-4 5v3h10v-3zm5 1v1H7v-1zm2 1H9v-1h1zm2 0h-1v-1h1z"
        }
      )
    }
  );
}
const VT = /* @__PURE__ */ i(zT);
function CT(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8 11v1H7v-1zm2 1H9v-1h1z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 13 13-.707.708L13.293 14H2V9h5.5v-.793l-1.85-1.85-.248.144a3 3 0 0 1-.288-.68L4.01 4.717A4 4 0 0 0 4.535 7l-.865.5a5 5 0 0 1-.535-3.659L1.646 2.355zM9.293 10H3v3h9.293zM14 11.172l-1-1V10h-.172l-1-1H14zM9 5c0 .32-.15.605-.384.788L7.212 4.384A1 1 0 0 1 9 5m3 0a4 4 0 0 0-.535-2l.866-.5a5 5 0 0 1-.001 5l-.865-.5A4 4 0 0 0 12 5m-2 0a2 2 0 0 0-.267-1l.865-.5a3 3 0 0 1 0 3L9.733 6A2 2 0 0 0 10 5"
          }
        )
      ]
    }
  );
}
const LT = /* @__PURE__ */ i(CT);
function $T(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4M7 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4.739 9H10v3H9v-4h1.262l-1.6-4H7.339l-1.6 4H7v4H6v-3H4.262l2.4-6h2.677z"
        }
      )
    }
  );
}
const ST = /* @__PURE__ */ i($T);
function kT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h12v10H2zm1 1v3h10V4zm10 4H7v4h6zm-7 4V8H3v4z"
        }
      )
    }
  );
}
const yT = /* @__PURE__ */ i(kT);
function bT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 3h10v8H2zm1 1v2h8V4zm8 3H6v3h5zm-6 3V7H3v3zm8 2V5h1v8H3v-1z"
        }
      )
    }
  );
}
const RT = /* @__PURE__ */ i(bT);
function BT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4 2h8v12H4zm1 1v10h6V3zm5 2H9V4h1zm0 2H6V6h4zm0 2H6V8h4z"
        }
      )
    }
  );
}
const FT = /* @__PURE__ */ i(BT);
function AT(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 12 12-.707.708L12 12.707V14H4V4.707L1.646 2.354zM5 5.707V13h6v-1.293L8.293 9H6V8h1.293zm7 3.465-1-1V3H5.828l-1-1H12z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M10 7h-.172l-1-1H10zm0-2H9V4h1z" })
      ]
    }
  );
}
const qT = /* @__PURE__ */ i(AT);
function OT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 2h8v12h-5v-1h4V3H8v1H7zm5 2h1v1h-1zM1 5h10v1h2v1h-2v1h2v1h-2v3H6.902l.268 1H9v1H3v-1h1.831l.268-1H1zm5 7.5-.134.5h.268zM10 6H2v5h8z"
        }
      )
    }
  );
}
const DT = /* @__PURE__ */ i(OT);
function PT(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m2.354 1.646 13 13-.708.708L13.293 14H10v-1h2.293L11 11.707V12H6.902l.268 1H9v1H3v-1h1.831l.268-1H1V5h3.293L1.646 2.354zM5.293 6H2v5h8v-.293zM6 12.5l-.134.5h.268zm9-.328-1-1V3H8v1H7V2h8z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M13 9h-1.172L10 7.172V6H8.828l-1-1H11v1h2v1h-2v1h2zm-1-5h1v1h-1z"
          }
        )
      ]
    }
  );
}
const TT = /* @__PURE__ */ i(PT);
function WT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.1 7a5 5 0 0 0 0 2h1.94a12.6 12.6 0 0 1 0-2zm.316-1h1.747a8.6 8.6 0 0 1 .614-2.096 6 6 0 0 1 .26-.504A5.02 5.02 0 0 0 3.417 6M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2m0 1c-.374 0-.875.356-1.313 1.318A7.4 7.4 0 0 0 6.18 6h3.64a7.4 7.4 0 0 0-.508-1.682C8.875 3.356 8.373 3 8 3m4.583 3a5.02 5.02 0 0 0-2.62-2.6 6 6 0 0 1 .26.504A8.6 8.6 0 0 1 10.837 6zM9.957 7H6.043a11.5 11.5 0 0 0 0 2h3.914a11.5 11.5 0 0 0 0-2M12.9 9a5 5 0 0 0 0-2h-1.94a12.5 12.5 0 0 1 0 2zm-3.079 1H6.18c.12.642.295 1.213.508 1.682C7.125 12.644 7.627 13 8 13s.875-.356 1.313-1.318c.213-.47.388-1.04.508-1.682m.141 2.6a5.02 5.02 0 0 0 2.622-2.6h-1.747c-.133.786-.343 1.499-.615 2.096a5 5 0 0 1-.26.504m-3.924 0a6 6 0 0 1-.261-.504A8.6 8.6 0 0 1 5.163 10H3.416a5.02 5.02 0 0 0 2.622 2.6"
        }
      )
    }
  );
}
const GT = /* @__PURE__ */ i(WT);
function ET(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m2.354 1.646 12 12-.707.708-1.773-1.772a6 6 0 0 1-8.456-8.456L1.647 2.354zm1.775 3.19A5 5 0 0 0 3.416 6h1.747l.02-.11zM6.293 7h-.25a11.5 11.5 0 0 0 0 2h2.25zm-.113 3a7.4 7.4 0 0 0 .507 1.682C7.125 12.644 7.626 13 8 13c.373 0 .875-.356 1.313-1.318a7 7 0 0 0 .416-1.246L9.293 10zm4.363 1.25a7 7 0 0 1-.32.846 5 5 0 0 1-.261.505 5 5 0 0 0 1.202-.73zM3.1 7a5 5 0 0 0 0 2h1.94a12.6 12.6 0 0 1 0-2zm2.938 5.6a6 6 0 0 1-.26-.504A8.6 8.6 0 0 1 5.162 10H3.416a5.02 5.02 0 0 0 2.622 2.6M14 8c0 .926-.21 1.804-.585 2.587L11.828 9H12.9a5 5 0 0 0 0-2h-1.94A13 13 0 0 1 11 8.17L9.97 7.14 9.956 7h-.129l-1-1h.993a7.4 7.4 0 0 0-.508-1.682C8.875 3.356 8.373 3 8 3c-.33 0-.762.28-1.16 1.011L5.413 2.585A6 6 0 0 1 14 8m-1.417-2a5.02 5.02 0 0 0-2.62-2.6 5 5 0 0 1 .26.504A8.6 8.6 0 0 1 10.837 6z"
        }
      )
    }
  );
}
const NT = /* @__PURE__ */ i(ET);
function jT(n, t) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 6a4 4 0 0 1 7.66-1.616l.31.702h-3.66L9.852 6l.457.914h3.661l-.31.702a4 4 0 0 1-4.79 2.222l-5.37 5.37L.793 12.5l5.37-5.37A4 4 0 0 1 6 6m4-3a3 3 0 0 0-2.798 4.084l.117.304L2.207 12.5 3.5 13.793 8.612 8.68l.304.117a2.99 2.99 0 0 0 3.394-.884H9.691L8.734 6l.957-1.914h2.62A3 3 0 0 0 10 3"
        }
      )
    }
  );
}
const UT = /* @__PURE__ */ i(jT);
function IT(n, t) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      width: "1em",
      height: "1em",
      display: "inline-block",
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6 8h4v1H6z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M4 6h8v3h1.348l-.635-2.37.966-.26.972 3.63H12v.446l-4 1.072-4-1.072V10H1.348l.973-3.629.966.259L2.65 9H4zm1 1v2.679l3 .803 3-.804V7z"
          }
        )
      ]
    }
  );
}
const QT = /* @__PURE__ */ i(IT);
// @__NO_SIDE_EFFECTS__
function h(n, t) {
  return t.displayName = n, t;
}
const XT = /* @__PURE__ */ h(
  "AccountAdd",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "account-add",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Pg, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(p, { ...r, ...e, ref: o });
    }
  )
), YT = /* @__PURE__ */ h(
  "AccountCheck",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "account-check",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Wg, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(M, { ...r, ...e, ref: o });
    }
  )
), ZT = /* @__PURE__ */ h(
  "AccountMore",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "account-more",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Eg, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(z, { ...r, ...e, ref: o });
    }
  )
), _T = /* @__PURE__ */ h(
  "AccountRemove",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "account-remove",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(jg, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(C, { ...r, ...e, ref: o });
    }
  )
), nW = /* @__PURE__ */ h(
  "Add",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "add",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ig, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($, { ...r, ...e, ref: o });
    }
  )
), lW = /* @__PURE__ */ h(
  "AddCircle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "add-circle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Kg, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(k, { ...r, ...e, ref: o });
    }
  )
), tW = /* @__PURE__ */ h(
  "AddressBook",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "address-book",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Xg, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(b, { ...r, ...e, ref: o });
    }
  )
), iW = /* @__PURE__ */ h(
  "Airplane",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "airplane",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Zg, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(B, { ...r, ...e, ref: o });
    }
  )
), eW = /* @__PURE__ */ h(
  "Airport",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "airport",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ns, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(A, { ...r, ...e, ref: o });
    }
  )
), oW = /* @__PURE__ */ h(
  "Alarm",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "alarm",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ts, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(O, { ...r, ...e, ref: o });
    }
  )
), rW = /* @__PURE__ */ h(
  "Anchor",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "anchor",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(es, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(P, { ...r, ...e, ref: o });
    }
  )
), hW = /* @__PURE__ */ h(
  "AnchorCenter",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "anchor-center",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(rs, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(W, { ...r, ...e, ref: o });
    }
  )
), aW = /* @__PURE__ */ h(
  "AnchorE",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "anchor-e",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(as, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(E, { ...r, ...e, ref: o });
    }
  )
), cW = /* @__PURE__ */ h(
  "AnchorN",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "anchor-n",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ds, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(j, { ...r, ...e, ref: o });
    }
  )
), dW = /* @__PURE__ */ h(
  "AnchorNe",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "anchor-ne",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(vs, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(I, { ...r, ...e, ref: o });
    }
  )
), wW = /* @__PURE__ */ h(
  "AnchorNw",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "anchor-nw",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(gs, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(K, { ...r, ...e, ref: o });
    }
  )
), vW = /* @__PURE__ */ h(
  "AnchorS",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "anchor-s",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(fs, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(X, { ...r, ...e, ref: o });
    }
  )
), mW = /* @__PURE__ */ h(
  "AnchorSe",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "anchor-se",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ps, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Z, { ...r, ...e, ref: o });
    }
  )
), gW = /* @__PURE__ */ h(
  "AnchorSw",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "anchor-sw",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ms, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(n1, { ...r, ...e, ref: o });
    }
  )
), sW = /* @__PURE__ */ h(
  "AnchorW",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "anchor-w",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(zs, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(t1, { ...r, ...e, ref: o });
    }
  )
), fW = /* @__PURE__ */ h(
  "Approximately",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "approximately",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Cs, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(e1, { ...r, ...e, ref: o });
    }
  )
), uW = /* @__PURE__ */ h(
  "Apps",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "apps",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l($s, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(r1, { ...r, ...e, ref: o });
    }
  )
), pW = /* @__PURE__ */ h(
  "Archive",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "archive",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ks, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(a1, { ...r, ...e, ref: o });
    }
  )
), HW = /* @__PURE__ */ h(
  "Arrow",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(bs, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(d1, { ...r, ...e, ref: o });
    }
  )
), MW = /* @__PURE__ */ h(
  "ArrowDown",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-down",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Bs, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(v1, { ...r, ...e, ref: o });
    }
  )
), xW = /* @__PURE__ */ h(
  "ArrowDownLeft",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-down-left",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(As, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(g1, { ...r, ...e, ref: o });
    }
  )
), zW = /* @__PURE__ */ h(
  "ArrowDownMax",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-down-max",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Os, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(f1, { ...r, ...e, ref: o });
    }
  )
), VW = /* @__PURE__ */ h(
  "ArrowDownRight",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-down-right",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ps, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(p1, { ...r, ...e, ref: o });
    }
  )
), CW = /* @__PURE__ */ h(
  "ArrowLeft",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-left",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ws, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(M1, { ...r, ...e, ref: o });
    }
  )
), LW = /* @__PURE__ */ h(
  "ArrowLeftMax",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-left-max",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Es, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(z1, { ...r, ...e, ref: o });
    }
  )
), $W = /* @__PURE__ */ h(
  "ArrowLeftRight",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-left-right",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(js, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(C1, { ...r, ...e, ref: o });
    }
  )
), SW = /* @__PURE__ */ h(
  "ArrowRight",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-right",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Is, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($1, { ...r, ...e, ref: o });
    }
  )
), kW = /* @__PURE__ */ h(
  "ArrowRightMax",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-right-max",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ks, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(k1, { ...r, ...e, ref: o });
    }
  )
), yW = /* @__PURE__ */ h(
  "ArrowUp",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-up",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Xs, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(b1, { ...r, ...e, ref: o });
    }
  )
), bW = /* @__PURE__ */ h(
  "ArrowUpDown",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-up-down",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Zs, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(B1, { ...r, ...e, ref: o });
    }
  )
), RW = /* @__PURE__ */ h(
  "ArrowUpLeft",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-up-left",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(nf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(A1, { ...r, ...e, ref: o });
    }
  )
), BW = /* @__PURE__ */ h(
  "ArrowUpMax",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-up-max",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(tf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(O1, { ...r, ...e, ref: o });
    }
  )
), FW = /* @__PURE__ */ h(
  "ArrowUpRight",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "arrow-up-right",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(of, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(P1, { ...r, ...e, ref: o });
    }
  )
), AW = /* @__PURE__ */ h(
  "AtSymbol",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "at-symbol",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(W1, { ...r, ...e, ref: o });
    }
  )
), qW = /* @__PURE__ */ h(
  "AutoRecord",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "auto-record",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(E1, { ...r, ...e, ref: o });
    }
  )
), OW = /* @__PURE__ */ h(
  "AutoRecordOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "auto-record-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(j1, { ...r, ...e, ref: o });
    }
  )
), DW = /* @__PURE__ */ h(
  "AwardRibbon",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "award-ribbon",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(I1, { ...r, ...e, ref: o });
    }
  )
), PW = /* @__PURE__ */ h(
  "AwardTrophy",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "award-trophy",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(K1, { ...r, ...e, ref: o });
    }
  )
), TW = /* @__PURE__ */ h(
  "Baby",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "baby",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(X1, { ...r, ...e, ref: o });
    }
  )
), WW = /* @__PURE__ */ h(
  "Backspace",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "backspace",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Hf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Z1, { ...r, ...e, ref: o });
    }
  )
), GW = /* @__PURE__ */ h(
  "Bandaid",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bandaid",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(n0, { ...r, ...e, ref: o });
    }
  )
), EW = /* @__PURE__ */ h(
  "Bank",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bank",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Vf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(t0, { ...r, ...e, ref: o });
    }
  )
), NW = /* @__PURE__ */ h(
  "Barcode",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "barcode",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Lf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(e0, { ...r, ...e, ref: o });
    }
  )
), jW = /* @__PURE__ */ h(
  "Battery0",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "battery-0",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Sf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(r0, { ...r, ...e, ref: o });
    }
  )
), UW = /* @__PURE__ */ h(
  "Battery0Off",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "battery-0-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(a0, { ...r, ...e, ref: o });
    }
  )
), IW = /* @__PURE__ */ h(
  "Battery25",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "battery-25",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Rf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(d0, { ...r, ...e, ref: o });
    }
  )
), QW = /* @__PURE__ */ h(
  "Battery50",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "battery-50",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ff, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(v0, { ...r, ...e, ref: o });
    }
  )
), KW = /* @__PURE__ */ h(
  "Battery75",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "battery-75",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(g0, { ...r, ...e, ref: o });
    }
  )
), JW = /* @__PURE__ */ h(
  "Battery100",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "battery-100",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Df, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(f0, { ...r, ...e, ref: o });
    }
  )
), XW = /* @__PURE__ */ h(
  "BatteryBoost",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "battery-boost",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Tf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(p0, { ...r, ...e, ref: o });
    }
  )
), YW = /* @__PURE__ */ h(
  "BatteryCharging",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "battery-charging",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Gf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(M0, { ...r, ...e, ref: o });
    }
  )
), ZW = /* @__PURE__ */ h(
  "Beaker",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "beaker",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Nf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(z0, { ...r, ...e, ref: o });
    }
  )
), _W = /* @__PURE__ */ h(
  "Bed",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bed",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Uf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(C0, { ...r, ...e, ref: o });
    }
  )
), nG = /* @__PURE__ */ h(
  "Bell",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bell",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Qf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($0, { ...r, ...e, ref: o });
    }
  )
), lG = /* @__PURE__ */ h(
  "BellOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bell-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Jf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(k0, { ...r, ...e, ref: o });
    }
  )
), tG = /* @__PURE__ */ h(
  "Bicycle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bicycle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Yf, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(b0, { ...r, ...e, ref: o });
    }
  )
), iG = /* @__PURE__ */ h(
  "Blackboard",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "blackboard",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_f, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(B0, { ...r, ...e, ref: o });
    }
  )
), eG = /* @__PURE__ */ h(
  "Bluetooth",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bluetooth",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(A0, { ...r, ...e, ref: o });
    }
  )
), oG = /* @__PURE__ */ h(
  "BluetoothOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bluetooth-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(O0, { ...r, ...e, ref: o });
    }
  )
), rG = /* @__PURE__ */ h(
  "Bold",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bold",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ou, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(P0, { ...r, ...e, ref: o });
    }
  )
), hG = /* @__PURE__ */ h(
  "Book",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "book",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(W0, { ...r, ...e, ref: o });
    }
  )
), aG = /* @__PURE__ */ h(
  "Bookmark",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bookmark",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(E0, { ...r, ...e, ref: o });
    }
  )
), cG = /* @__PURE__ */ h(
  "BookmarkOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bookmark-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(j0, { ...r, ...e, ref: o });
    }
  )
), dG = /* @__PURE__ */ h(
  "Bottle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bottle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(I0, { ...r, ...e, ref: o });
    }
  )
), wG = /* @__PURE__ */ h(
  "BoundingBox",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bounding-box",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(su, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(K0, { ...r, ...e, ref: o });
    }
  )
), vG = /* @__PURE__ */ h(
  "Braille",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "braille",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(X0, { ...r, ...e, ref: o });
    }
  )
), mG = /* @__PURE__ */ h(
  "Briefcase",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "briefcase",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Hu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Z0, { ...r, ...e, ref: o });
    }
  )
), gG = /* @__PURE__ */ h(
  "Broadcast",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "broadcast",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(nn, { ...r, ...e, ref: o });
    }
  )
), sG = /* @__PURE__ */ h(
  "Brush",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "brush",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Vu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(tn, { ...r, ...e, ref: o });
    }
  )
), fG = /* @__PURE__ */ h(
  "Bucket",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bucket",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Lu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(on, { ...r, ...e, ref: o });
    }
  )
), uG = /* @__PURE__ */ h(
  "Bug",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bug",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Su, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(hn, { ...r, ...e, ref: o });
    }
  )
), pG = /* @__PURE__ */ h(
  "BugOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bug-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(cn, { ...r, ...e, ref: o });
    }
  )
), HG = /* @__PURE__ */ h(
  "Bush",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "bush",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ru, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(wn, { ...r, ...e, ref: o });
    }
  )
), MG = /* @__PURE__ */ h(
  "Business",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "business",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Fu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(mn, { ...r, ...e, ref: o });
    }
  )
), xG = /* @__PURE__ */ h(
  "Calculator",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "calculator",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(sn, { ...r, ...e, ref: o });
    }
  )
), zG = /* @__PURE__ */ h(
  "Calendar",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "calendar",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Du, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(un, { ...r, ...e, ref: o });
    }
  )
), VG = /* @__PURE__ */ h(
  "CalendarEvent",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "calendar-event",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Tu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Hn, { ...r, ...e, ref: o });
    }
  )
), CG = /* @__PURE__ */ h(
  "Camera",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "camera",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Gu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(xn, { ...r, ...e, ref: o });
    }
  )
), LG = /* @__PURE__ */ h(
  "Camera360",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "camera-360",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Nu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Vn, { ...r, ...e, ref: o });
    }
  )
), $G = /* @__PURE__ */ h(
  "CameraAdd",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "camera-add",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Uu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ln, { ...r, ...e, ref: o });
    }
  )
), SG = /* @__PURE__ */ h(
  "CameraLinked",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "camera-linked",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Qu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Sn, { ...r, ...e, ref: o });
    }
  )
), kG = /* @__PURE__ */ h(
  "CameraOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "camera-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ju, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(yn, { ...r, ...e, ref: o });
    }
  )
), yG = /* @__PURE__ */ h(
  "CameraSuper",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "camera-super",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Yu, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Rn, { ...r, ...e, ref: o });
    }
  )
), bG = /* @__PURE__ */ h(
  "Cancel",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "cancel",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_u, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Fn, { ...r, ...e, ref: o });
    }
  )
), RG = /* @__PURE__ */ h(
  "Car",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "car",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(qn, { ...r, ...e, ref: o });
    }
  )
), BG = /* @__PURE__ */ h(
  "CarouselHorizontal",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "carousel-horizontal",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ip, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Dn, { ...r, ...e, ref: o });
    }
  )
), FG = /* @__PURE__ */ h(
  "CarouselVertical",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "carousel-vertical",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(op, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Tn, { ...r, ...e, ref: o });
    }
  )
), AG = /* @__PURE__ */ h(
  "Castle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "castle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Gn, { ...r, ...e, ref: o });
    }
  )
), qG = /* @__PURE__ */ h(
  "Chart",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chart",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Nn, { ...r, ...e, ref: o });
    }
  )
), OG = /* @__PURE__ */ h(
  "ChartBar",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chart-bar",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Un, { ...r, ...e, ref: o });
    }
  )
), DG = /* @__PURE__ */ h(
  "ChartBubble",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chart-bubble",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Qn, { ...r, ...e, ref: o });
    }
  )
), PG = /* @__PURE__ */ h(
  "ChartFlow",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chart-flow",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Jn, { ...r, ...e, ref: o });
    }
  )
), TG = /* @__PURE__ */ h(
  "ChartHierarchy",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chart-hierarchy",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(up, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Yn, { ...r, ...e, ref: o });
    }
  )
), WG = /* @__PURE__ */ h(
  "ChartPerformance",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chart-performance",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Hp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(_n, { ...r, ...e, ref: o });
    }
  )
), GG = /* @__PURE__ */ h(
  "ChartPie",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chart-pie",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(l2, { ...r, ...e, ref: o });
    }
  )
), EG = /* @__PURE__ */ h(
  "ChartScatterplot",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chart-scatterplot",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Vp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(i2, { ...r, ...e, ref: o });
    }
  )
), NG = /* @__PURE__ */ h(
  "ChartTree",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chart-tree",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Lp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(o2, { ...r, ...e, ref: o });
    }
  )
), jG = /* @__PURE__ */ h(
  "Chatbot",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chatbot",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Sp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(h2, { ...r, ...e, ref: o });
    }
  )
), UG = /* @__PURE__ */ h(
  "ChatMessage",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chat-message",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(c2, { ...r, ...e, ref: o });
    }
  )
), IG = /* @__PURE__ */ h(
  "ChatMulti",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chat-multi",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Rp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(w2, { ...r, ...e, ref: o });
    }
  )
), QG = /* @__PURE__ */ h(
  "ChatNew",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chat-new",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Fp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(m2, { ...r, ...e, ref: o });
    }
  )
), KG = /* @__PURE__ */ h(
  "ChatSingle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chat-single",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(s2, { ...r, ...e, ref: o });
    }
  )
), JG = /* @__PURE__ */ h(
  "Check",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "check",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Dp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(u2, { ...r, ...e, ref: o });
    }
  )
), XG = /* @__PURE__ */ h(
  "CheckCircle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "check-circle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Tp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(H2, { ...r, ...e, ref: o });
    }
  )
), YG = /* @__PURE__ */ h(
  "CheckmarkBadge",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "checkmark-badge",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Gp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(x2, { ...r, ...e, ref: o });
    }
  )
), ZG = /* @__PURE__ */ h(
  "CheckMultiCircle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "check-multi-circle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Np, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(V2, { ...r, ...e, ref: o });
    }
  )
), _G = /* @__PURE__ */ h(
  "ChevronDoubleDown",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chevron-double-down",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Up, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(L2, { ...r, ...e, ref: o });
    }
  )
), nE = /* @__PURE__ */ h(
  "ChevronDoubleLeft",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chevron-double-left",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Qp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(S2, { ...r, ...e, ref: o });
    }
  )
), lE = /* @__PURE__ */ h(
  "ChevronDoubleRight",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chevron-double-right",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Jp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(y2, { ...r, ...e, ref: o });
    }
  )
), tE = /* @__PURE__ */ h(
  "ChevronDoubleUp",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chevron-double-up",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Yp, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(R2, { ...r, ...e, ref: o });
    }
  )
), iE = /* @__PURE__ */ h(
  "ChevronDown",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chevron-down",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_p, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(F2, { ...r, ...e, ref: o });
    }
  )
), eE = /* @__PURE__ */ h(
  "ChevronDownLeftUpRight",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chevron-down-left-up-right",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(
        lH,
        {
          ...r,
          ...e,
          ref: o
        }
      ) : /* @__PURE__ */ l(
        q2,
        {
          ...r,
          ...e,
          ref: o
        }
      );
    }
  )
), oE = /* @__PURE__ */ h(
  "ChevronLeft",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chevron-left",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(D2, { ...r, ...e, ref: o });
    }
  )
), rE = /* @__PURE__ */ h(
  "ChevronLeftRight",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chevron-left-right",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(T2, { ...r, ...e, ref: o });
    }
  )
), hE = /* @__PURE__ */ h(
  "ChevronRight",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chevron-right",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(G2, { ...r, ...e, ref: o });
    }
  )
), aE = /* @__PURE__ */ h(
  "ChevronUp",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chevron-up",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(N2, { ...r, ...e, ref: o });
    }
  )
), cE = /* @__PURE__ */ h(
  "ChevronUpDown",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chevron-up-down",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(U2, { ...r, ...e, ref: o });
    }
  )
), dE = /* @__PURE__ */ h(
  "ChevronUpLeftDownRight",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "chevron-up-left-down-right",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(
        mH,
        {
          ...r,
          ...e,
          ref: o
        }
      ) : /* @__PURE__ */ l(
        Q2,
        {
          ...r,
          ...e,
          ref: o
        }
      );
    }
  )
), wE = /* @__PURE__ */ h(
  "Circle1Q",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "circle-1-q",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(J2, { ...r, ...e, ref: o });
    }
  )
), vE = /* @__PURE__ */ h(
  "Circle2Q",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "circle-2-q",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Y2, { ...r, ...e, ref: o });
    }
  )
), mE = /* @__PURE__ */ h(
  "Circle3Q",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "circle-3-q",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(_2, { ...r, ...e, ref: o });
    }
  )
), gE = /* @__PURE__ */ h(
  "CircleTick",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "circle-tick",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ll, { ...r, ...e, ref: o });
    }
  )
), sE = /* @__PURE__ */ h(
  "City",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "city",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(il, { ...r, ...e, ref: o });
    }
  )
), fE = /* @__PURE__ */ h(
  "ClapBoard",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "clap-board",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ol, { ...r, ...e, ref: o });
    }
  )
), uE = /* @__PURE__ */ h(
  "Clipboard",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "clipboard",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(hl, { ...r, ...e, ref: o });
    }
  )
), pE = /* @__PURE__ */ h(
  "Clock",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "clock",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(cl, { ...r, ...e, ref: o });
    }
  )
), HE = /* @__PURE__ */ h(
  "Close",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "close",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(wl, { ...r, ...e, ref: o });
    }
  )
), ME = /* @__PURE__ */ h(
  "CloseCircle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "close-circle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ml, { ...r, ...e, ref: o });
    }
  )
), xE = /* @__PURE__ */ h(
  "ClosedCaption",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "closed-caption",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(sl, { ...r, ...e, ref: o });
    }
  )
), zE = /* @__PURE__ */ h(
  "Cloth",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "cloth",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ul, { ...r, ...e, ref: o });
    }
  )
), VE = /* @__PURE__ */ h(
  "Cloud",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "cloud",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Hl, { ...r, ...e, ref: o });
    }
  )
), CE = /* @__PURE__ */ h(
  "CloudOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "cloud-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(xl, { ...r, ...e, ref: o });
    }
  )
), LE = /* @__PURE__ */ h(
  "Code",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "code",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Vl, { ...r, ...e, ref: o });
    }
  )
), $E = /* @__PURE__ */ h(
  "Cog",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "cog",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ll, { ...r, ...e, ref: o });
    }
  )
), SE = /* @__PURE__ */ h(
  "CogOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "cog-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Sl, { ...r, ...e, ref: o });
    }
  )
), kE = /* @__PURE__ */ h(
  "Collapse",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "collapse",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(yl, { ...r, ...e, ref: o });
    }
  )
), yE = /* @__PURE__ */ h(
  "Collection",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "collection",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YH, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Rl, { ...r, ...e, ref: o });
    }
  )
), bE = /* @__PURE__ */ h(
  "Commit",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "commit",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_H, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Fl, { ...r, ...e, ref: o });
    }
  )
), RE = /* @__PURE__ */ h(
  "Compass",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "compass",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ql, { ...r, ...e, ref: o });
    }
  )
), BE = /* @__PURE__ */ h(
  "Connection",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "connection",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Dl, { ...r, ...e, ref: o });
    }
  )
), FE = /* @__PURE__ */ h(
  "CopyDoc",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "copy-doc",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Tl, { ...r, ...e, ref: o });
    }
  )
), AE = /* @__PURE__ */ h(
  "CopyGeneric",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "copy-generic",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Gl, { ...r, ...e, ref: o });
    }
  )
), qE = /* @__PURE__ */ h(
  "Cpu",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "cpu",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Nl, { ...r, ...e, ref: o });
    }
  )
), OE = /* @__PURE__ */ h(
  "CraftKnife",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "craft-knife",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ul, { ...r, ...e, ref: o });
    }
  )
), DE = /* @__PURE__ */ h(
  "Crop",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "crop",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ql, { ...r, ...e, ref: o });
    }
  )
), PE = /* @__PURE__ */ h(
  "Crosshair",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "crosshair",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Jl, { ...r, ...e, ref: o });
    }
  )
), TE = /* @__PURE__ */ h(
  "Crown",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "crown",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Yl, { ...r, ...e, ref: o });
    }
  )
), WE = /* @__PURE__ */ h(
  "Cube",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "cube",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(_l, { ...r, ...e, ref: o });
    }
  )
), GE = /* @__PURE__ */ h(
  "CubeStack",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "cube-stack",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(lt, { ...r, ...e, ref: o });
    }
  )
), EE = /* @__PURE__ */ h(
  "Data",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "data",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(it, { ...r, ...e, ref: o });
    }
  )
), NE = /* @__PURE__ */ h(
  "Datacenter",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "datacenter",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ot, { ...r, ...e, ref: o });
    }
  )
), jE = /* @__PURE__ */ h(
  "Db",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "db",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ht, { ...r, ...e, ref: o });
    }
  )
), UE = /* @__PURE__ */ h(
  "DeliveryTruck",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "delivery-truck",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ct, { ...r, ...e, ref: o });
    }
  )
), IE = /* @__PURE__ */ h(
  "Denoise",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "denoise",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(wt, { ...r, ...e, ref: o });
    }
  )
), QE = /* @__PURE__ */ h(
  "Diamond",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "diamond",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(mt, { ...r, ...e, ref: o });
    }
  )
), KE = /* @__PURE__ */ h(
  "DiamondOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "diamond-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(st, { ...r, ...e, ref: o });
    }
  )
), JE = /* @__PURE__ */ h(
  "Dirt",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "dirt",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ut, { ...r, ...e, ref: o });
    }
  )
), XE = /* @__PURE__ */ h(
  "Display",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "display",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ht, { ...r, ...e, ref: o });
    }
  )
), YE = /* @__PURE__ */ h(
  "DisplayCollection",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "display-collection",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(xt, { ...r, ...e, ref: o });
    }
  )
), ZE = /* @__PURE__ */ h(
  "DisplayColumn",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "display-column",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Vt, { ...r, ...e, ref: o });
    }
  )
), _E = /* @__PURE__ */ h(
  "DisplayOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "display-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Lt, { ...r, ...e, ref: o });
    }
  )
), nN = /* @__PURE__ */ h(
  "DisplayRow",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "display-row",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(St, { ...r, ...e, ref: o });
    }
  )
), lN = /* @__PURE__ */ h(
  "DisplayShare",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "display-share",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(yt, { ...r, ...e, ref: o });
    }
  )
), tN = /* @__PURE__ */ h(
  "DisplaySurround",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "display-surround",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YM, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Rt, { ...r, ...e, ref: o });
    }
  )
), iN = /* @__PURE__ */ h(
  "Divide",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "divide",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_M, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ft, { ...r, ...e, ref: o });
    }
  )
), eN = /* @__PURE__ */ h(
  "Document",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "document",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(qt, { ...r, ...e, ref: o });
    }
  )
), oN = /* @__PURE__ */ h(
  "DocumentCheckmark",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "document-checkmark",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ix, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Dt, { ...r, ...e, ref: o });
    }
  )
), rN = /* @__PURE__ */ h(
  "DocumentNew",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "document-new",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ox, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Tt, { ...r, ...e, ref: o });
    }
  )
), hN = /* @__PURE__ */ h(
  "DocumentPreview",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "document-preview",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Gt, { ...r, ...e, ref: o });
    }
  )
), aN = /* @__PURE__ */ h(
  "Dolly",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "dolly",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Nt, { ...r, ...e, ref: o });
    }
  )
), cN = /* @__PURE__ */ h(
  "Download",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "download",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ut, { ...r, ...e, ref: o });
    }
  )
), dN = /* @__PURE__ */ h(
  "DriveCloud",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "drive-cloud",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Qt, { ...r, ...e, ref: o });
    }
  )
), wN = /* @__PURE__ */ h(
  "DriveCloudOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "drive-cloud-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Jt, { ...r, ...e, ref: o });
    }
  )
), vN = /* @__PURE__ */ h(
  "DriveNetwork",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "drive-network",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ux, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Yt, { ...r, ...e, ref: o });
    }
  )
), mN = /* @__PURE__ */ h(
  "DriveNetworkOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "drive-network-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Hx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(_t, { ...r, ...e, ref: o });
    }
  )
), gN = /* @__PURE__ */ h(
  "DriveRemovable",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "drive-removable",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(li, { ...r, ...e, ref: o });
    }
  )
), sN = /* @__PURE__ */ h(
  "DriveRemovableOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "drive-removable-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Vx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ii, { ...r, ...e, ref: o });
    }
  )
), fN = /* @__PURE__ */ h(
  "DriveUsb",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "drive-usb",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Lx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(oi, { ...r, ...e, ref: o });
    }
  )
), uN = /* @__PURE__ */ h(
  "DriveUsbOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "drive-usb-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Sx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(hi, { ...r, ...e, ref: o });
    }
  )
), pN = /* @__PURE__ */ h(
  "Drone",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "drone",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ci, { ...r, ...e, ref: o });
    }
  )
), HN = /* @__PURE__ */ h(
  "Dual",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "dual",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Rx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(wi, { ...r, ...e, ref: o });
    }
  )
), MN = /* @__PURE__ */ h(
  "Easel",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "easel",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Fx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(mi, { ...r, ...e, ref: o });
    }
  )
), xN = /* @__PURE__ */ h(
  "Eject",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "eject",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(si, { ...r, ...e, ref: o });
    }
  )
), zN = /* @__PURE__ */ h(
  "Ekg",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "ekg",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Dx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ui, { ...r, ...e, ref: o });
    }
  )
), VN = /* @__PURE__ */ h(
  "Elevator",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "elevator",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Tx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Hi, { ...r, ...e, ref: o });
    }
  )
), CN = /* @__PURE__ */ h(
  "Emissive",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "emissive",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Gx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(xi, { ...r, ...e, ref: o });
    }
  )
), LN = /* @__PURE__ */ h(
  "Engine",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "engine",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Nx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Vi, { ...r, ...e, ref: o });
    }
  )
), $N = /* @__PURE__ */ h(
  "Enter",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "enter",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ux, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Li, { ...r, ...e, ref: o });
    }
  )
), SN = /* @__PURE__ */ h(
  "Envelope",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "envelope",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Qx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Si, { ...r, ...e, ref: o });
    }
  )
), kN = /* @__PURE__ */ h(
  "EnvelopeOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "envelope-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Jx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(yi, { ...r, ...e, ref: o });
    }
  )
), yN = /* @__PURE__ */ h(
  "Equal",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "equal",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Yx, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ri, { ...r, ...e, ref: o });
    }
  )
), bN = /* @__PURE__ */ h(
  "Equalizer",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "equalizer",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_x, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Fi, { ...r, ...e, ref: o });
    }
  )
), RN = /* @__PURE__ */ h(
  "Eraser",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "eraser",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(qi, { ...r, ...e, ref: o });
    }
  )
), BN = /* @__PURE__ */ h(
  "Error",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "error",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Di, { ...r, ...e, ref: o });
    }
  )
), FN = /* @__PURE__ */ h(
  "Escalator",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "escalator",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ti, { ...r, ...e, ref: o });
    }
  )
), AN = /* @__PURE__ */ h(
  "Ethernet",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "ethernet",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Gi, { ...r, ...e, ref: o });
    }
  )
), qN = /* @__PURE__ */ h(
  "Exit",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "exit",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ni, { ...r, ...e, ref: o });
    }
  )
), ON = /* @__PURE__ */ h(
  "Expand",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "expand",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ui, { ...r, ...e, ref: o });
    }
  )
), DN = /* @__PURE__ */ h(
  "Explode",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "explode",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Qi, { ...r, ...e, ref: o });
    }
  )
), PN = /* @__PURE__ */ h(
  "Export",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "export",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ji, { ...r, ...e, ref: o });
    }
  )
), TN = /* @__PURE__ */ h(
  "ExportToClipboard",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "export-to-clipboard",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Yi, { ...r, ...e, ref: o });
    }
  )
), WN = /* @__PURE__ */ h(
  "Eye",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "eye",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Hz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(_i, { ...r, ...e, ref: o });
    }
  )
), GN = /* @__PURE__ */ h(
  "Eyedropper",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "eyedropper",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(le, { ...r, ...e, ref: o });
    }
  )
), EN = /* @__PURE__ */ h(
  "EyeOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "eye-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Vz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ie, { ...r, ...e, ref: o });
    }
  )
), NN = /* @__PURE__ */ h(
  "Factory",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "factory",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Lz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(oe, { ...r, ...e, ref: o });
    }
  )
), jN = /* @__PURE__ */ h(
  "Faders",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "faders",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Sz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(he, { ...r, ...e, ref: o });
    }
  )
), UN = /* @__PURE__ */ h(
  "Fan",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fan",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ce, { ...r, ...e, ref: o });
    }
  )
), IN = /* @__PURE__ */ h(
  "FanLoud",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fan-loud",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Rz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(we, { ...r, ...e, ref: o });
    }
  )
), QN = /* @__PURE__ */ h(
  "FanQuiet",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fan-quiet",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Fz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(me, { ...r, ...e, ref: o });
    }
  )
), KN = /* @__PURE__ */ h(
  "Farm",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "farm",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(se, { ...r, ...e, ref: o });
    }
  )
), JN = /* @__PURE__ */ h(
  "FastForward",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fast-forward",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Dz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ue, { ...r, ...e, ref: o });
    }
  )
), XN = /* @__PURE__ */ h(
  "FastReverse",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fast-reverse",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Tz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(He, { ...r, ...e, ref: o });
    }
  )
), YN = /* @__PURE__ */ h(
  "Feedback",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "feedback",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Gz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(xe, { ...r, ...e, ref: o });
    }
  )
), ZN = /* @__PURE__ */ h(
  "FeelingHappy",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "feeling-happy",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Nz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ve, { ...r, ...e, ref: o });
    }
  )
), _N = /* @__PURE__ */ h(
  "FeelingNeutral",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "feeling-neutral",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Uz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Le, { ...r, ...e, ref: o });
    }
  )
), nj = /* @__PURE__ */ h(
  "FeelingSad",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "feeling-sad",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Qz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Se, { ...r, ...e, ref: o });
    }
  )
), lj = /* @__PURE__ */ h(
  "FeelingVeryHappy",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "feeling-very-happy",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Jz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ye, { ...r, ...e, ref: o });
    }
  )
), tj = /* @__PURE__ */ h(
  "FeelingVerySad",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "feeling-very-sad",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Yz, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Re, { ...r, ...e, ref: o });
    }
  )
), ij = /* @__PURE__ */ h(
  "FileReel",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "file-reel",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_z, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Fe, { ...r, ...e, ref: o });
    }
  )
), ej = /* @__PURE__ */ h(
  "Film",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "film",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(qe, { ...r, ...e, ref: o });
    }
  )
), oj = /* @__PURE__ */ h(
  "FilmAdd",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "film-add",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(De, { ...r, ...e, ref: o });
    }
  )
), rj = /* @__PURE__ */ h(
  "FilmCollection",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "film-collection",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Te, { ...r, ...e, ref: o });
    }
  )
), hj = /* @__PURE__ */ h(
  "Filter",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "filter",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ge, { ...r, ...e, ref: o });
    }
  )
), aj = /* @__PURE__ */ h(
  "Fingerprint",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fingerprint",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ne, { ...r, ...e, ref: o });
    }
  )
), cj = /* @__PURE__ */ h(
  "Fire",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fire",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ue, { ...r, ...e, ref: o });
    }
  )
), dj = /* @__PURE__ */ h(
  "Firecracker",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "firecracker",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Qe, { ...r, ...e, ref: o });
    }
  )
), wj = /* @__PURE__ */ h(
  "Firewall",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "firewall",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Je, { ...r, ...e, ref: o });
    }
  )
), vj = /* @__PURE__ */ h(
  "FirewallOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "firewall-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ye, { ...r, ...e, ref: o });
    }
  )
), mj = /* @__PURE__ */ h(
  "Firework",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "firework",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(_e, { ...r, ...e, ref: o });
    }
  )
), gj = /* @__PURE__ */ h(
  "Fit",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fit",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(l5, { ...r, ...e, ref: o });
    }
  )
), sj = /* @__PURE__ */ h(
  "FitToPage",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fit-to-page",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(i5, { ...r, ...e, ref: o });
    }
  )
), fj = /* @__PURE__ */ h(
  "Flag",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "flag",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(o5, { ...r, ...e, ref: o });
    }
  )
), uj = /* @__PURE__ */ h(
  "FlightStick",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "flight-stick",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(h5, { ...r, ...e, ref: o });
    }
  )
), pj = /* @__PURE__ */ h(
  "Floppy",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "floppy",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(c5, { ...r, ...e, ref: o });
    }
  )
), Hj = /* @__PURE__ */ h(
  "Flower",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "flower",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(w5, { ...r, ...e, ref: o });
    }
  )
), Mj = /* @__PURE__ */ h(
  "Fog",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fog",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(m5, { ...r, ...e, ref: o });
    }
  )
), xj = /* @__PURE__ */ h(
  "FolderClosed",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "folder-closed",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(s5, { ...r, ...e, ref: o });
    }
  )
), zj = /* @__PURE__ */ h(
  "FolderOpen",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "folder-open",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(u5, { ...r, ...e, ref: o });
    }
  )
), Vj = /* @__PURE__ */ h(
  "Food",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "food",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(H5, { ...r, ...e, ref: o });
    }
  )
), Cj = /* @__PURE__ */ h(
  "Footprint",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "footprint",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(x5, { ...r, ...e, ref: o });
    }
  )
), Lj = /* @__PURE__ */ h(
  "Fork",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fork",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(V5, { ...r, ...e, ref: o });
    }
  )
), $j = /* @__PURE__ */ h(
  "Forward",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "forward",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(L5, { ...r, ...e, ref: o });
    }
  )
), Sj = /* @__PURE__ */ h(
  "Forward10",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "forward-10",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(S5, { ...r, ...e, ref: o });
    }
  )
), kj = /* @__PURE__ */ h(
  "Founders",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "founders",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(y5, { ...r, ...e, ref: o });
    }
  )
), yj = /* @__PURE__ */ h(
  "FoundersTier1",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "founders-tier-1",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YV, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(R5, { ...r, ...e, ref: o });
    }
  )
), bj = /* @__PURE__ */ h(
  "FoundersTier2",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "founders-tier-2",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_V, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(F5, { ...r, ...e, ref: o });
    }
  )
), Rj = /* @__PURE__ */ h(
  "FoundersTier3",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "founders-tier-3",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(q5, { ...r, ...e, ref: o });
    }
  )
), Bj = /* @__PURE__ */ h(
  "Fps",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fps",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(D5, { ...r, ...e, ref: o });
    }
  )
), Fj = /* @__PURE__ */ h(
  "Freehand",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "freehand",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(T5, { ...r, ...e, ref: o });
    }
  )
), Aj = /* @__PURE__ */ h(
  "FuelCan",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fuel-can",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(G5, { ...r, ...e, ref: o });
    }
  )
), qj = /* @__PURE__ */ h(
  "FuelPump",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fuel-pump",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(N5, { ...r, ...e, ref: o });
    }
  )
), Oj = /* @__PURE__ */ h(
  "Fullscreen",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fullscreen",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(U5, { ...r, ...e, ref: o });
    }
  )
), Dj = /* @__PURE__ */ h(
  "FullscreenExit",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "fullscreen-exit",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Q5, { ...r, ...e, ref: o });
    }
  )
), Pj = /* @__PURE__ */ h(
  "Function",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "function",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(J5, { ...r, ...e, ref: o });
    }
  )
), Tj = /* @__PURE__ */ h(
  "GalleryStrip",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "gallery-strip",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Y5, { ...r, ...e, ref: o });
    }
  )
), Wj = /* @__PURE__ */ h(
  "Gamepad",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "gamepad",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(_5, { ...r, ...e, ref: o });
    }
  )
), Gj = /* @__PURE__ */ h(
  "GamepadOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "gamepad-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(l3, { ...r, ...e, ref: o });
    }
  )
), Ej = /* @__PURE__ */ h(
  "GamepadStart",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "gamepad-start",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(i3, { ...r, ...e, ref: o });
    }
  )
), Nj = /* @__PURE__ */ h(
  "Gift",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "gift",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(o3, { ...r, ...e, ref: o });
    }
  )
), jj = /* @__PURE__ */ h(
  "Government",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "government",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(h3, { ...r, ...e, ref: o });
    }
  )
), Uj = /* @__PURE__ */ h(
  "Gpu",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "gpu",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(c3, { ...r, ...e, ref: o });
    }
  )
), Ij = /* @__PURE__ */ h(
  "GpuCard",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "gpu-card",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(w3, { ...r, ...e, ref: o });
    }
  )
), Qj = /* @__PURE__ */ h(
  "GpuCardMulti",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "gpu-card-multi",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(m3, { ...r, ...e, ref: o });
    }
  )
), Kj = /* @__PURE__ */ h(
  "GpuCardOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "gpu-card-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(s3, { ...r, ...e, ref: o });
    }
  )
), Jj = /* @__PURE__ */ h(
  "GpuOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "gpu-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(u3, { ...r, ...e, ref: o });
    }
  )
), Xj = /* @__PURE__ */ h(
  "Graduate",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "graduate",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(H3, { ...r, ...e, ref: o });
    }
  )
), Yj = /* @__PURE__ */ h(
  "GraphNode",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "graph-node",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(x3, { ...r, ...e, ref: o });
    }
  )
), Zj = /* @__PURE__ */ h(
  "GraphNodeConnect",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "graph-node-connect",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(V3, { ...r, ...e, ref: o });
    }
  )
), _j = /* @__PURE__ */ h(
  "GraphNodeDelete",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "graph-node-delete",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(L3, { ...r, ...e, ref: o });
    }
  )
), nU = /* @__PURE__ */ h(
  "Grass",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "grass",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(S3, { ...r, ...e, ref: o });
    }
  )
), lU = /* @__PURE__ */ h(
  "Gravel",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "gravel",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(y3, { ...r, ...e, ref: o });
    }
  )
), tU = /* @__PURE__ */ h(
  "Grid",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "grid",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YC, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(R3, { ...r, ...e, ref: o });
    }
  )
), iU = /* @__PURE__ */ h(
  "GridOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "grid-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_C, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(F3, { ...r, ...e, ref: o });
    }
  )
), eU = /* @__PURE__ */ h(
  "GripArea",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "grip-area",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(q3, { ...r, ...e, ref: o });
    }
  )
), oU = /* @__PURE__ */ h(
  "GripCorner",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "grip-corner",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(D3, { ...r, ...e, ref: o });
    }
  )
), rU = /* @__PURE__ */ h(
  "GripEdgeHorizontal",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "grip-edge-horizontal",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(T3, { ...r, ...e, ref: o });
    }
  )
), hU = /* @__PURE__ */ h(
  "GripEdgeVertical",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "grip-edge-vertical",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(G3, { ...r, ...e, ref: o });
    }
  )
), aU = /* @__PURE__ */ h(
  "GripMini",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "grip-mini",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(N3, { ...r, ...e, ref: o });
    }
  )
), cU = /* @__PURE__ */ h(
  "Group",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "group",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(U3, { ...r, ...e, ref: o });
    }
  )
), dU = /* @__PURE__ */ h(
  "HAlignCenter",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "h-align-center",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Q3, { ...r, ...e, ref: o });
    }
  )
), wU = /* @__PURE__ */ h(
  "HAlignLeft",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "h-align-left",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(J3, { ...r, ...e, ref: o });
    }
  )
), vU = /* @__PURE__ */ h(
  "HAlignRight",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "h-align-right",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Y3, { ...r, ...e, ref: o });
    }
  )
), mU = /* @__PURE__ */ h(
  "HandClosed",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "hand-closed",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(_3, { ...r, ...e, ref: o });
    }
  )
), gU = /* @__PURE__ */ h(
  "HandOpen",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "hand-open",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(lo, { ...r, ...e, ref: o });
    }
  )
), sU = /* @__PURE__ */ h(
  "HandPinch",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "hand-pinch",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(io, { ...r, ...e, ref: o });
    }
  )
), fU = /* @__PURE__ */ h(
  "HandPoint",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "hand-point",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(oo, { ...r, ...e, ref: o });
    }
  )
), uU = /* @__PURE__ */ h(
  "Head",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "head",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ho, { ...r, ...e, ref: o });
    }
  )
), pU = /* @__PURE__ */ h(
  "Header",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "header",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(co, { ...r, ...e, ref: o });
    }
  )
), HU = /* @__PURE__ */ h(
  "Headset",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "headset",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(vo, { ...r, ...e, ref: o });
    }
  )
), MU = /* @__PURE__ */ h(
  "Health",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "health",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(go, { ...r, ...e, ref: o });
    }
  )
), xU = /* @__PURE__ */ h(
  "Heart",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "heart",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(fo, { ...r, ...e, ref: o });
    }
  )
), zU = /* @__PURE__ */ h(
  "HeartOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "heart-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(po, { ...r, ...e, ref: o });
    }
  )
), VU = /* @__PURE__ */ h(
  "Helicopter",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "helicopter",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Mo, { ...r, ...e, ref: o });
    }
  )
), CU = /* @__PURE__ */ h(
  "HelpCircle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "help-circle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(zo, { ...r, ...e, ref: o });
    }
  )
), LU = /* @__PURE__ */ h(
  "Highlighter",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "highlighter",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Co, { ...r, ...e, ref: o });
    }
  )
), $U = /* @__PURE__ */ h(
  "HighQuality",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "high-quality",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($o, { ...r, ...e, ref: o });
    }
  )
), SU = /* @__PURE__ */ h(
  "Hill",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "hill",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ko, { ...r, ...e, ref: o });
    }
  )
), kU = /* @__PURE__ */ h(
  "History",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "history",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(bo, { ...r, ...e, ref: o });
    }
  )
), yU = /* @__PURE__ */ h(
  "Home",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "home",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YL, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Bo, { ...r, ...e, ref: o });
    }
  )
), bU = /* @__PURE__ */ h(
  "HomeOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "home-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_L, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ao, { ...r, ...e, ref: o });
    }
  )
), RU = /* @__PURE__ */ h(
  "HotAirBalloon",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "hot-air-balloon",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(l$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Oo, { ...r, ...e, ref: o });
    }
  )
), BU = /* @__PURE__ */ h(
  "Hourglass",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "hourglass",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(i$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Po, { ...r, ...e, ref: o });
    }
  )
), FU = /* @__PURE__ */ h(
  "HourglassEnd",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "hourglass-end",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(o$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Wo, { ...r, ...e, ref: o });
    }
  )
), AU = /* @__PURE__ */ h(
  "HourglassMid",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "hourglass-mid",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(h$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Eo, { ...r, ...e, ref: o });
    }
  )
), qU = /* @__PURE__ */ h(
  "HourglassStart",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "hourglass-start",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(c$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(jo, { ...r, ...e, ref: o });
    }
  )
), OU = /* @__PURE__ */ h(
  "Hud",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "hud",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(w$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Io, { ...r, ...e, ref: o });
    }
  )
), DU = /* @__PURE__ */ h(
  "Hydrant",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "hydrant",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(m$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ko, { ...r, ...e, ref: o });
    }
  )
), PU = /* @__PURE__ */ h(
  "Identification",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "identification",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(s$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Xo, { ...r, ...e, ref: o });
    }
  )
), TU = /* @__PURE__ */ h(
  "Image",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "image",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(u$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Zo, { ...r, ...e, ref: o });
    }
  )
), WU = /* @__PURE__ */ h(
  "Ime",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "ime",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(H$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(n6, { ...r, ...e, ref: o });
    }
  )
), GU = /* @__PURE__ */ h(
  "Import",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "import",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(x$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(t6, { ...r, ...e, ref: o });
    }
  )
), EU = /* @__PURE__ */ h(
  "ImportImage",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "import-image",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(V$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(e6, { ...r, ...e, ref: o });
    }
  )
), NU = /* @__PURE__ */ h(
  "Infinity",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "infinity",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(L$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(r6, { ...r, ...e, ref: o });
    }
  )
), jU = /* @__PURE__ */ h(
  "InfoCircle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "info-circle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(S$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(a6, { ...r, ...e, ref: o });
    }
  )
), UU = /* @__PURE__ */ h(
  "Instance",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "instance",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(y$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(d6, { ...r, ...e, ref: o });
    }
  )
), IU = /* @__PURE__ */ h(
  "Isp",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "isp",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(R$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(v6, { ...r, ...e, ref: o });
    }
  )
), QU = /* @__PURE__ */ h(
  "IspOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "isp-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(F$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(g6, { ...r, ...e, ref: o });
    }
  )
), KU = /* @__PURE__ */ h(
  "Italic",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "italic",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(q$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(f6, { ...r, ...e, ref: o });
    }
  )
), JU = /* @__PURE__ */ h(
  "Iterate",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "iterate",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(D$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(p6, { ...r, ...e, ref: o });
    }
  )
), XU = /* @__PURE__ */ h(
  "JoystickClassic",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "joystick-classic",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(T$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(M6, { ...r, ...e, ref: o });
    }
  )
), YU = /* @__PURE__ */ h(
  "Key",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "key",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(G$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(z6, { ...r, ...e, ref: o });
    }
  )
), ZU = /* @__PURE__ */ h(
  "Keyboard",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "keyboard",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(N$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(C6, { ...r, ...e, ref: o });
    }
  )
), _U = /* @__PURE__ */ h(
  "Keyframe",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "keyframe",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(U$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($6, { ...r, ...e, ref: o });
    }
  )
), nI = /* @__PURE__ */ h(
  "Knife",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "knife",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Q$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(k6, { ...r, ...e, ref: o });
    }
  )
), lI = /* @__PURE__ */ h(
  "Lamp",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "lamp",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(J$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(b6, { ...r, ...e, ref: o });
    }
  )
), tI = /* @__PURE__ */ h(
  "Laptop",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "laptop",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Y$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(B6, { ...r, ...e, ref: o });
    }
  )
), iI = /* @__PURE__ */ h(
  "Lasso",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "lasso",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_$, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(A6, { ...r, ...e, ref: o });
    }
  )
), eI = /* @__PURE__ */ h(
  "Layers",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "layers",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(O6, { ...r, ...e, ref: o });
    }
  )
), oI = /* @__PURE__ */ h(
  "LayersOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "layers-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(P6, { ...r, ...e, ref: o });
    }
  )
), rI = /* @__PURE__ */ h(
  "LayoutColumns",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "layout-columns",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(W6, { ...r, ...e, ref: o });
    }
  )
), hI = /* @__PURE__ */ h(
  "LayoutDetail",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "layout-detail",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(E6, { ...r, ...e, ref: o });
    }
  )
), aI = /* @__PURE__ */ h(
  "LayoutGrid",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "layout-grid",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(j6, { ...r, ...e, ref: o });
    }
  )
), cI = /* @__PURE__ */ h(
  "LayoutList",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "layout-list",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(I6, { ...r, ...e, ref: o });
    }
  )
), dI = /* @__PURE__ */ h(
  "LayoutRows",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "layout-rows",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(K6, { ...r, ...e, ref: o });
    }
  )
), wI = /* @__PURE__ */ h(
  "Library",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "library",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(X6, { ...r, ...e, ref: o });
    }
  )
), vI = /* @__PURE__ */ h(
  "LibraryGames",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "library-games",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Z6, { ...r, ...e, ref: o });
    }
  )
), mI = /* @__PURE__ */ h(
  "License",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "license",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(nr, { ...r, ...e, ref: o });
    }
  )
), gI = /* @__PURE__ */ h(
  "Lifebouy",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "lifebouy",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(tr, { ...r, ...e, ref: o });
    }
  )
), sI = /* @__PURE__ */ h(
  "Lightbulb",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "lightbulb",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(er, { ...r, ...e, ref: o });
    }
  )
), fI = /* @__PURE__ */ h(
  "Lightning",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "lightning",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(rr, { ...r, ...e, ref: o });
    }
  )
), uI = /* @__PURE__ */ h(
  "LightRect",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "light-rect",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ar, { ...r, ...e, ref: o });
    }
  )
), pI = /* @__PURE__ */ h(
  "LightRotate",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "light-rotate",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(dr, { ...r, ...e, ref: o });
    }
  )
), HI = /* @__PURE__ */ h(
  "LineSegment",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "line-segment",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(vr, { ...r, ...e, ref: o });
    }
  )
), MI = /* @__PURE__ */ h(
  "Link",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "link",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(gr, { ...r, ...e, ref: o });
    }
  )
), xI = /* @__PURE__ */ h(
  "LinkBreak",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "link-break",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(fr, { ...r, ...e, ref: o });
    }
  )
), zI = /* @__PURE__ */ h(
  "ListBullet",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "list-bullet",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(pr, { ...r, ...e, ref: o });
    }
  )
), VI = /* @__PURE__ */ h(
  "ListCheckmark",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "list-checkmark",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Mr, { ...r, ...e, ref: o });
    }
  )
), CI = /* @__PURE__ */ h(
  "ListNumber",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "list-number",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(zr, { ...r, ...e, ref: o });
    }
  )
), LI = /* @__PURE__ */ h(
  "Location",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "location",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Cr, { ...r, ...e, ref: o });
    }
  )
), $I = /* @__PURE__ */ h(
  "LocationOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "location-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(US, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($r, { ...r, ...e, ref: o });
    }
  )
), SI = /* @__PURE__ */ h(
  "LockClosed",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "lock-closed",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(kr, { ...r, ...e, ref: o });
    }
  )
), kI = /* @__PURE__ */ h(
  "LockOpen",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "lock-open",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(br, { ...r, ...e, ref: o });
    }
  )
), yI = /* @__PURE__ */ h(
  "Loop",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "loop",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YS, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Br, { ...r, ...e, ref: o });
    }
  )
), bI = /* @__PURE__ */ h(
  "LoopOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "loop-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_S, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ar, { ...r, ...e, ref: o });
    }
  )
), RI = /* @__PURE__ */ h(
  "Mac",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mac",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Or, { ...r, ...e, ref: o });
    }
  )
), BI = /* @__PURE__ */ h(
  "MacOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mac-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ik, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Pr, { ...r, ...e, ref: o });
    }
  )
), FI = /* @__PURE__ */ h(
  "Magnet",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "magnet",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ok, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Wr, { ...r, ...e, ref: o });
    }
  )
), AI = /* @__PURE__ */ h(
  "MagnifyingGlass",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "magnifying-glass",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Er, { ...r, ...e, ref: o });
    }
  )
), qI = /* @__PURE__ */ h(
  "MagnifyingGlassMinus",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "magnifying-glass-minus",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(
        ck,
        {
          ...r,
          ...e,
          ref: o
        }
      ) : /* @__PURE__ */ l(
        jr,
        {
          ...r,
          ...e,
          ref: o
        }
      );
    }
  )
), OI = /* @__PURE__ */ h(
  "MagnifyingGlassPlus",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "magnifying-glass-plus",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ir, { ...r, ...e, ref: o });
    }
  )
), DI = /* @__PURE__ */ h(
  "Man",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "man",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Kr, { ...r, ...e, ref: o });
    }
  )
), PI = /* @__PURE__ */ h(
  "ManWoman",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "man-woman",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Xr, { ...r, ...e, ref: o });
    }
  )
), TI = /* @__PURE__ */ h(
  "Map",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "map",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Zr, { ...r, ...e, ref: o });
    }
  )
), WI = /* @__PURE__ */ h(
  "MapOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "map-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Hk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(nh, { ...r, ...e, ref: o });
    }
  )
), GI = /* @__PURE__ */ h(
  "Markdown",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "markdown",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(th, { ...r, ...e, ref: o });
    }
  )
), EI = /* @__PURE__ */ h(
  "Martini",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "martini",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Vk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(eh, { ...r, ...e, ref: o });
    }
  )
), NI = /* @__PURE__ */ h(
  "MaskInside",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mask-inside",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Lk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(rh, { ...r, ...e, ref: o });
    }
  )
), jI = /* @__PURE__ */ h(
  "MaskOutside",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mask-outside",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Sk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ah, { ...r, ...e, ref: o });
    }
  )
), UI = /* @__PURE__ */ h(
  "Material",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "material",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(dh, { ...r, ...e, ref: o });
    }
  )
), II = /* @__PURE__ */ h(
  "Math",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "math",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Rk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(vh, { ...r, ...e, ref: o });
    }
  )
), QI = /* @__PURE__ */ h(
  "MediaOptical",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "media-optical",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Fk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(gh, { ...r, ...e, ref: o });
    }
  )
), KI = /* @__PURE__ */ h(
  "Medicine",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "medicine",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(fh, { ...r, ...e, ref: o });
    }
  )
), JI = /* @__PURE__ */ h(
  "Megaphone",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "megaphone",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Dk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ph, { ...r, ...e, ref: o });
    }
  )
), XI = /* @__PURE__ */ h(
  "Menu",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "menu",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Tk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Mh, { ...r, ...e, ref: o });
    }
  )
), YI = /* @__PURE__ */ h(
  "Microphone",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "microphone",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Gk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(zh, { ...r, ...e, ref: o });
    }
  )
), ZI = /* @__PURE__ */ h(
  "MicrophoneOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "microphone-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Nk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ch, { ...r, ...e, ref: o });
    }
  )
), _I = /* @__PURE__ */ h(
  "Microscope",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "microscope",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Uk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($h, { ...r, ...e, ref: o });
    }
  )
), nQ = /* @__PURE__ */ h(
  "MirrorHorizontal",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mirror-horizontal",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Qk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(kh, { ...r, ...e, ref: o });
    }
  )
), lQ = /* @__PURE__ */ h(
  "MirrorVertical",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mirror-vertical",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Jk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(bh, { ...r, ...e, ref: o });
    }
  )
), tQ = /* @__PURE__ */ h(
  "ModeComponent",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mode-component",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Yk, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Bh, { ...r, ...e, ref: o });
    }
  )
), iQ = /* @__PURE__ */ h(
  "Money",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "money",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_k, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ah, { ...r, ...e, ref: o });
    }
  )
), eQ = /* @__PURE__ */ h(
  "MoneyCoin",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "money-coin",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ly, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Oh, { ...r, ...e, ref: o });
    }
  )
), oQ = /* @__PURE__ */ h(
  "MoneyPaper",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "money-paper",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ph, { ...r, ...e, ref: o });
    }
  )
), rQ = /* @__PURE__ */ h(
  "Moon",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "moon",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Wh, { ...r, ...e, ref: o });
    }
  )
), hQ = /* @__PURE__ */ h(
  "MoonOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "moon-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Eh, { ...r, ...e, ref: o });
    }
  )
), aQ = /* @__PURE__ */ h(
  "MoreHoriz",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "more-horiz",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(jh, { ...r, ...e, ref: o });
    }
  )
), cQ = /* @__PURE__ */ h(
  "MoreVert",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "more-vert",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ih, { ...r, ...e, ref: o });
    }
  )
), dQ = /* @__PURE__ */ h(
  "Mosaic",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mosaic",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(my, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Kh, { ...r, ...e, ref: o });
    }
  )
), wQ = /* @__PURE__ */ h(
  "Mountain",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mountain",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Xh, { ...r, ...e, ref: o });
    }
  )
), vQ = /* @__PURE__ */ h(
  "Mouse2B",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mouse-2-b",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Zh, { ...r, ...e, ref: o });
    }
  )
), mQ = /* @__PURE__ */ h(
  "Mouse2BRightClick",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mouse-2-b-right-click",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Hy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(n4, { ...r, ...e, ref: o });
    }
  )
), gQ = /* @__PURE__ */ h(
  "Mouse3B",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mouse-3-b",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(t4, { ...r, ...e, ref: o });
    }
  )
), sQ = /* @__PURE__ */ h(
  "MouseScrollwheel",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mouse-scrollwheel",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Vy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(e4, { ...r, ...e, ref: o });
    }
  )
), fQ = /* @__PURE__ */ h(
  "MouseScrollwheelActive",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mouse-scrollwheel-active",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(
        Ly,
        {
          ...r,
          ...e,
          ref: o
        }
      ) : /* @__PURE__ */ l(
        r4,
        {
          ...r,
          ...e,
          ref: o
        }
      );
    }
  )
), uQ = /* @__PURE__ */ h(
  "Move",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "move",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Sy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(a4, { ...r, ...e, ref: o });
    }
  )
), pQ = /* @__PURE__ */ h(
  "MoveGlobal",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "move-global",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(d4, { ...r, ...e, ref: o });
    }
  )
), HQ = /* @__PURE__ */ h(
  "Mud",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mud",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ry, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(v4, { ...r, ...e, ref: o });
    }
  )
), MQ = /* @__PURE__ */ h(
  "Mug",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mug",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Fy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(g4, { ...r, ...e, ref: o });
    }
  )
), xQ = /* @__PURE__ */ h(
  "MugBeer",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "mug-beer",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(f4, { ...r, ...e, ref: o });
    }
  )
), zQ = /* @__PURE__ */ h(
  "Multidrive",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "multidrive",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Dy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(p4, { ...r, ...e, ref: o });
    }
  )
), VQ = /* @__PURE__ */ h(
  "Network",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "network",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ty, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(M4, { ...r, ...e, ref: o });
    }
  )
), CQ = /* @__PURE__ */ h(
  "NetworkConnection",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "network-connection",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Gy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(z4, { ...r, ...e, ref: o });
    }
  )
), LQ = /* @__PURE__ */ h(
  "NetworkPcs",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "network-pcs",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ny, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(C4, { ...r, ...e, ref: o });
    }
  )
), $Q = /* @__PURE__ */ h(
  "NetworkSignal",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "network-signal",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Uy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($4, { ...r, ...e, ref: o });
    }
  )
), SQ = /* @__PURE__ */ h(
  "NetworkSignalOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "network-signal-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Qy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(k4, { ...r, ...e, ref: o });
    }
  )
), kQ = /* @__PURE__ */ h(
  "NeuralNetwork",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "neural-network",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Jy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(b4, { ...r, ...e, ref: o });
    }
  )
), yQ = /* @__PURE__ */ h(
  "News",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "news",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Yy, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(B4, { ...r, ...e, ref: o });
    }
  )
), bQ = /* @__PURE__ */ h(
  "Next",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "next",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_y, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(A4, { ...r, ...e, ref: o });
    }
  )
), RQ = /* @__PURE__ */ h(
  "NotEqual",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "not-equal",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(O4, { ...r, ...e, ref: o });
    }
  )
), BQ = /* @__PURE__ */ h(
  "Notes",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "notes",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ib, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(P4, { ...r, ...e, ref: o });
    }
  )
), FQ = /* @__PURE__ */ h(
  "Numbers",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "numbers",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ob, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(W4, { ...r, ...e, ref: o });
    }
  )
), AQ = /* @__PURE__ */ h(
  "NvidiaShield",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "nvidia-shield",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(E4, { ...r, ...e, ref: o });
    }
  )
), qQ = /* @__PURE__ */ h(
  "NvidiaShieldStand",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "nvidia-shield-stand",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(j4, { ...r, ...e, ref: o });
    }
  )
), OQ = /* @__PURE__ */ h(
  "OpenExternal",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "open-external",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(I4, { ...r, ...e, ref: o });
    }
  )
), DQ = /* @__PURE__ */ h(
  "OutletA",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "outlet-a",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(K4, { ...r, ...e, ref: o });
    }
  )
), PQ = /* @__PURE__ */ h(
  "OutletB",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "outlet-b",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(X4, { ...r, ...e, ref: o });
    }
  )
), TQ = /* @__PURE__ */ h(
  "OutletC",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "outlet-c",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ub, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Z4, { ...r, ...e, ref: o });
    }
  )
), WQ = /* @__PURE__ */ h(
  "OutletE",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "outlet-e",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Hb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(n7, { ...r, ...e, ref: o });
    }
  )
), GQ = /* @__PURE__ */ h(
  "OutletG",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "outlet-g",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(t7, { ...r, ...e, ref: o });
    }
  )
), EQ = /* @__PURE__ */ h(
  "OutletH",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "outlet-h",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Vb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(e7, { ...r, ...e, ref: o });
    }
  )
), NQ = /* @__PURE__ */ h(
  "OutletI",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "outlet-i",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Lb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(r7, { ...r, ...e, ref: o });
    }
  )
), jQ = /* @__PURE__ */ h(
  "OutletJ",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "outlet-j",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Sb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(a7, { ...r, ...e, ref: o });
    }
  )
), UQ = /* @__PURE__ */ h(
  "OutletK",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "outlet-k",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(d7, { ...r, ...e, ref: o });
    }
  )
), IQ = /* @__PURE__ */ h(
  "OutletL",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "outlet-l",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Rb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(v7, { ...r, ...e, ref: o });
    }
  )
), QQ = /* @__PURE__ */ h(
  "Outpainting",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "outpainting",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Fb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(g7, { ...r, ...e, ref: o });
    }
  )
), KQ = /* @__PURE__ */ h(
  "Package",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "package",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(f7, { ...r, ...e, ref: o });
    }
  )
), JQ = /* @__PURE__ */ h(
  "Palette",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "palette",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Db, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(p7, { ...r, ...e, ref: o });
    }
  )
), XQ = /* @__PURE__ */ h(
  "Paperclip",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "paperclip",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Tb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(M7, { ...r, ...e, ref: o });
    }
  )
), YQ = /* @__PURE__ */ h(
  "Paperplane",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "paperplane",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Gb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(z7, { ...r, ...e, ref: o });
    }
  )
), ZQ = /* @__PURE__ */ h(
  "Paragraph",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "paragraph",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Nb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(C7, { ...r, ...e, ref: o });
    }
  )
), _Q = /* @__PURE__ */ h(
  "Park",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "park",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ub, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($7, { ...r, ...e, ref: o });
    }
  )
), nK = /* @__PURE__ */ h(
  "Pause",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "pause",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Qb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(k7, { ...r, ...e, ref: o });
    }
  )
), lK = /* @__PURE__ */ h(
  "Pawprint",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "pawprint",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Jb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(b7, { ...r, ...e, ref: o });
    }
  )
), tK = /* @__PURE__ */ h(
  "PaymentCard",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "payment-card",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Yb, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(B7, { ...r, ...e, ref: o });
    }
  )
), iK = /* @__PURE__ */ h(
  "Pencil",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "pencil",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_b, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(A7, { ...r, ...e, ref: o });
    }
  )
), eK = /* @__PURE__ */ h(
  "PerformanceHigh",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "performance-high",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(O7, { ...r, ...e, ref: o });
    }
  )
), oK = /* @__PURE__ */ h(
  "PerformanceLow",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "performance-low",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(P7, { ...r, ...e, ref: o });
    }
  )
), rK = /* @__PURE__ */ h(
  "PerformanceMedium",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "performance-medium",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(W7, { ...r, ...e, ref: o });
    }
  )
), hK = /* @__PURE__ */ h(
  "PhoneLaptop",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "phone-laptop",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(E7, { ...r, ...e, ref: o });
    }
  )
), aK = /* @__PURE__ */ h(
  "PictureInPicture",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "picture-in-picture",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(j7, { ...r, ...e, ref: o });
    }
  )
), cK = /* @__PURE__ */ h(
  "PillBarStack",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "pill-bar-stack",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(I7, { ...r, ...e, ref: o });
    }
  )
), dK = /* @__PURE__ */ h(
  "Pin",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "pin",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(K7, { ...r, ...e, ref: o });
    }
  )
), wK = /* @__PURE__ */ h(
  "PinOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "pin-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(X7, { ...r, ...e, ref: o });
    }
  )
), vK = /* @__PURE__ */ h(
  "Pizza",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "pizza",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Z7, { ...r, ...e, ref: o });
    }
  )
), mK = /* @__PURE__ */ h(
  "Placesetting",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "placesetting",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(n8, { ...r, ...e, ref: o });
    }
  )
), gK = /* @__PURE__ */ h(
  "Play",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "play",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(t8, { ...r, ...e, ref: o });
    }
  )
), sK = /* @__PURE__ */ h(
  "Plugin",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "plugin",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(e8, { ...r, ...e, ref: o });
    }
  )
), fK = /* @__PURE__ */ h(
  "PlugRecepticle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "plug-recepticle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(r8, { ...r, ...e, ref: o });
    }
  )
), uK = /* @__PURE__ */ h(
  "PlugUsb",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "plug-usb",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(a8, { ...r, ...e, ref: o });
    }
  )
), pK = /* @__PURE__ */ h(
  "Podium",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "podium",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(d8, { ...r, ...e, ref: o });
    }
  )
), HK = /* @__PURE__ */ h(
  "Power",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "power",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(v8, { ...r, ...e, ref: o });
    }
  )
), MK = /* @__PURE__ */ h(
  "PrayerRoom",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "prayer-room",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(g8, { ...r, ...e, ref: o });
    }
  )
), xK = /* @__PURE__ */ h(
  "Previous",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "previous",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(f8, { ...r, ...e, ref: o });
    }
  )
), zK = /* @__PURE__ */ h(
  "Profile",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "profile",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(p8, { ...r, ...e, ref: o });
    }
  )
), VK = /* @__PURE__ */ h(
  "ProfileGroup",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "profile-group",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(M8, { ...r, ...e, ref: o });
    }
  )
), CK = /* @__PURE__ */ h(
  "ProfileOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "profile-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(z8, { ...r, ...e, ref: o });
    }
  )
), LK = /* @__PURE__ */ h(
  "Projector",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "projector",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(C8, { ...r, ...e, ref: o });
    }
  )
), $K = /* @__PURE__ */ h(
  "Pulse",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "pulse",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($8, { ...r, ...e, ref: o });
    }
  )
), SK = /* @__PURE__ */ h(
  "Puzzle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "puzzle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(k8, { ...r, ...e, ref: o });
    }
  )
), kK = /* @__PURE__ */ h(
  "Qrcode",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "qrcode",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(b8, { ...r, ...e, ref: o });
    }
  )
), yK = /* @__PURE__ */ h(
  "Radar",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "radar",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YR, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(B8, { ...r, ...e, ref: o });
    }
  )
), bK = /* @__PURE__ */ h(
  "Radioactive",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "radioactive",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_R, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(A8, { ...r, ...e, ref: o });
    }
  )
), RK = /* @__PURE__ */ h(
  "Ram",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "ram",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(O8, { ...r, ...e, ref: o });
    }
  )
), BK = /* @__PURE__ */ h(
  "RankingXp",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "ranking-xp",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(P8, { ...r, ...e, ref: o });
    }
  )
), FK = /* @__PURE__ */ h(
  "Record",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "record",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(W8, { ...r, ...e, ref: o });
    }
  )
), AK = /* @__PURE__ */ h(
  "RectangleGroup",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "rectangle-group",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(E8, { ...r, ...e, ref: o });
    }
  )
), qK = /* @__PURE__ */ h(
  "Redo",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "redo",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(j8, { ...r, ...e, ref: o });
    }
  )
), OK = /* @__PURE__ */ h(
  "Reference",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "reference",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(I8, { ...r, ...e, ref: o });
    }
  )
), DK = /* @__PURE__ */ h(
  "Refresh",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "refresh",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(K8, { ...r, ...e, ref: o });
    }
  )
), PK = /* @__PURE__ */ h(
  "Remote",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "remote",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(X8, { ...r, ...e, ref: o });
    }
  )
), TK = /* @__PURE__ */ h(
  "Render",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "render",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Z8, { ...r, ...e, ref: o });
    }
  )
), WK = /* @__PURE__ */ h(
  "Replay",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "replay",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(na, { ...r, ...e, ref: o });
    }
  )
), GK = /* @__PURE__ */ h(
  "ReplayOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "replay-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ta, { ...r, ...e, ref: o });
    }
  )
), EK = /* @__PURE__ */ h(
  "Reply",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "reply",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ea, { ...r, ...e, ref: o });
    }
  )
), NK = /* @__PURE__ */ h(
  "Reset",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "reset",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ra, { ...r, ...e, ref: o });
    }
  )
), jK = /* @__PURE__ */ h(
  "Retry",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "retry",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(aa, { ...r, ...e, ref: o });
    }
  )
), UK = /* @__PURE__ */ h(
  "Return",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "return",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(da, { ...r, ...e, ref: o });
    }
  )
), IK = /* @__PURE__ */ h(
  "Reverse10",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "reverse-10",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(va, { ...r, ...e, ref: o });
    }
  )
), QK = /* @__PURE__ */ h(
  "River",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "river",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ga, { ...r, ...e, ref: o });
    }
  )
), KK = /* @__PURE__ */ h(
  "RobotArm",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "robot-arm",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(fa, { ...r, ...e, ref: o });
    }
  )
), JK = /* @__PURE__ */ h(
  "Rock",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "rock",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(pa, { ...r, ...e, ref: o });
    }
  )
), XK = /* @__PURE__ */ h(
  "Rocket",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "rocket",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ma, { ...r, ...e, ref: o });
    }
  )
), YK = /* @__PURE__ */ h(
  "Rotate",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "rotate",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(za, { ...r, ...e, ref: o });
    }
  )
), ZK = /* @__PURE__ */ h(
  "Rotate3D",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "rotate-3-d",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ca, { ...r, ...e, ref: o });
    }
  )
), _K = /* @__PURE__ */ h(
  "Rotate90Clockwise",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "rotate-90-clockwise",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($a, { ...r, ...e, ref: o });
    }
  )
), nJ = /* @__PURE__ */ h(
  "Rotate90Counter",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "rotate-90-counter",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ka, { ...r, ...e, ref: o });
    }
  )
), lJ = /* @__PURE__ */ h(
  "RotateGlobal",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "rotate-global",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ba, { ...r, ...e, ref: o });
    }
  )
), tJ = /* @__PURE__ */ h(
  "Route",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "route",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YB, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ba, { ...r, ...e, ref: o });
    }
  )
), iJ = /* @__PURE__ */ h(
  "Ruler",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "ruler",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_B, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Aa, { ...r, ...e, ref: o });
    }
  )
), eJ = /* @__PURE__ */ h(
  "Running",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "running",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Oa, { ...r, ...e, ref: o });
    }
  )
), oJ = /* @__PURE__ */ h(
  "Sailboat",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sailboat",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Pa, { ...r, ...e, ref: o });
    }
  )
), rJ = /* @__PURE__ */ h(
  "Sand",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sand",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Wa, { ...r, ...e, ref: o });
    }
  )
), hJ = /* @__PURE__ */ h(
  "SawWave",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "saw-wave",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ea, { ...r, ...e, ref: o });
    }
  )
), aJ = /* @__PURE__ */ h(
  "Scale",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scale",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ja, { ...r, ...e, ref: o });
    }
  )
), cJ = /* @__PURE__ */ h(
  "ScaleBalance",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scale-balance",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ia, { ...r, ...e, ref: o });
    }
  )
), dJ = /* @__PURE__ */ h(
  "ScaleDown",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scale-down",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ka, { ...r, ...e, ref: o });
    }
  )
), wJ = /* @__PURE__ */ h(
  "ScaleRelative",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scale-relative",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Xa, { ...r, ...e, ref: o });
    }
  )
), vJ = /* @__PURE__ */ h(
  "ScaleRelativeOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scale-relative-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Za, { ...r, ...e, ref: o });
    }
  )
), mJ = /* @__PURE__ */ h(
  "ScaleReset",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scale-reset",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(nc, { ...r, ...e, ref: o });
    }
  )
), gJ = /* @__PURE__ */ h(
  "ScaleUp",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scale-up",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(tc, { ...r, ...e, ref: o });
    }
  )
), sJ = /* @__PURE__ */ h(
  "School",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "school",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ec, { ...r, ...e, ref: o });
    }
  )
), fJ = /* @__PURE__ */ h(
  "Scissors",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scissors",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(rc, { ...r, ...e, ref: o });
    }
  )
), uJ = /* @__PURE__ */ h(
  "ScmBranch",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scm-branch",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ac, { ...r, ...e, ref: o });
    }
  )
), pJ = /* @__PURE__ */ h(
  "ScmCompare",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scm-compare",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(dc, { ...r, ...e, ref: o });
    }
  )
), HJ = /* @__PURE__ */ h(
  "ScmFork",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scm-fork",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(vc, { ...r, ...e, ref: o });
    }
  )
), MJ = /* @__PURE__ */ h(
  "ScmMerge",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scm-merge",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(gc, { ...r, ...e, ref: o });
    }
  )
), xJ = /* @__PURE__ */ h(
  "ScmPull",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scm-pull",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(fc, { ...r, ...e, ref: o });
    }
  )
), zJ = /* @__PURE__ */ h(
  "ScmPullClose",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scm-pull-close",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(pc, { ...r, ...e, ref: o });
    }
  )
), VJ = /* @__PURE__ */ h(
  "ScmPullDraft",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "scm-pull-draft",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Mc, { ...r, ...e, ref: o });
    }
  )
), CJ = /* @__PURE__ */ h(
  "SdCard",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sd-card",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(zc, { ...r, ...e, ref: o });
    }
  )
), LJ = /* @__PURE__ */ h(
  "Sea",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sea",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Cc, { ...r, ...e, ref: o });
    }
  )
), $J = /* @__PURE__ */ h(
  "Section",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "section",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($c, { ...r, ...e, ref: o });
    }
  )
), SJ = /* @__PURE__ */ h(
  "SectionBottom",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "section-bottom",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(kc, { ...r, ...e, ref: o });
    }
  )
), kJ = /* @__PURE__ */ h(
  "SectionTop",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "section-top",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(bc, { ...r, ...e, ref: o });
    }
  )
), yJ = /* @__PURE__ */ h(
  "Secure",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "secure",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YF, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Bc, { ...r, ...e, ref: o });
    }
  )
), bJ = /* @__PURE__ */ h(
  "Seed",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "seed",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_F, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ac, { ...r, ...e, ref: o });
    }
  )
), RJ = /* @__PURE__ */ h(
  "Segmap",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "segmap",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Oc, { ...r, ...e, ref: o });
    }
  )
), BJ = /* @__PURE__ */ h(
  "Segment",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "segment",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Pc, { ...r, ...e, ref: o });
    }
  )
), FJ = /* @__PURE__ */ h(
  "SelectBrush",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "select-brush",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Wc, { ...r, ...e, ref: o });
    }
  )
), AJ = /* @__PURE__ */ h(
  "SelectEllipse",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "select-ellipse",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ec, { ...r, ...e, ref: o });
    }
  )
), qJ = /* @__PURE__ */ h(
  "SelectPolygon",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "select-polygon",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(jc, { ...r, ...e, ref: o });
    }
  )
), OJ = /* @__PURE__ */ h(
  "SelectRectangle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "select-rectangle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ic, { ...r, ...e, ref: o });
    }
  )
), DJ = /* @__PURE__ */ h(
  "SendImage",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "send-image",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Kc, { ...r, ...e, ref: o });
    }
  )
), PJ = /* @__PURE__ */ h(
  "Sensor",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sensor",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Xc, { ...r, ...e, ref: o });
    }
  )
), TJ = /* @__PURE__ */ h(
  "Shader",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shader",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Zc, { ...r, ...e, ref: o });
    }
  )
), WJ = /* @__PURE__ */ h(
  "ShaderBall",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shader-ball",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(nd, { ...r, ...e, ref: o });
    }
  )
), GJ = /* @__PURE__ */ h(
  "ShapeCircle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shape-circle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(td, { ...r, ...e, ref: o });
    }
  )
), EJ = /* @__PURE__ */ h(
  "ShapeCircleOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shape-circle-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ed, { ...r, ...e, ref: o });
    }
  )
), NJ = /* @__PURE__ */ h(
  "ShapeHexagon",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shape-hexagon",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(rd, { ...r, ...e, ref: o });
    }
  )
), jJ = /* @__PURE__ */ h(
  "ShapeOctogon",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shape-octogon",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ad, { ...r, ...e, ref: o });
    }
  )
), UJ = /* @__PURE__ */ h(
  "Shapes",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shapes",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(dd, { ...r, ...e, ref: o });
    }
  )
), IJ = /* @__PURE__ */ h(
  "ShapeSquare",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shape-square",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(vd, { ...r, ...e, ref: o });
    }
  )
), QJ = /* @__PURE__ */ h(
  "ShapeSquareOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shape-square-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(gd, { ...r, ...e, ref: o });
    }
  )
), KJ = /* @__PURE__ */ h(
  "ShapeTriangle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shape-triangle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(fd, { ...r, ...e, ref: o });
    }
  )
), JJ = /* @__PURE__ */ h(
  "Share",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "share",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(pd, { ...r, ...e, ref: o });
    }
  )
), XJ = /* @__PURE__ */ h(
  "Shield",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shield",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Md, { ...r, ...e, ref: o });
    }
  )
), YJ = /* @__PURE__ */ h(
  "ShieldOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shield-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(zd, { ...r, ...e, ref: o });
    }
  )
), ZJ = /* @__PURE__ */ h(
  "Ship",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "ship",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Cd, { ...r, ...e, ref: o });
    }
  )
), _J = /* @__PURE__ */ h(
  "ShipWheel",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "ship-wheel",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($d, { ...r, ...e, ref: o });
    }
  )
), nX = /* @__PURE__ */ h(
  "ShoppingBag",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shopping-bag",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(kd, { ...r, ...e, ref: o });
    }
  )
), lX = /* @__PURE__ */ h(
  "ShoppingBasket",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shopping-basket",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(bd, { ...r, ...e, ref: o });
    }
  )
), tX = /* @__PURE__ */ h(
  "ShoppingCart",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shopping-cart",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YA, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Bd, { ...r, ...e, ref: o });
    }
  )
), iX = /* @__PURE__ */ h(
  "ShoppingCartOpen",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "shopping-cart-open",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_A, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ad, { ...r, ...e, ref: o });
    }
  )
), eX = /* @__PURE__ */ h(
  "Signature",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "signature",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Od, { ...r, ...e, ref: o });
    }
  )
), oX = /* @__PURE__ */ h(
  "Signpost",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "signpost",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Pd, { ...r, ...e, ref: o });
    }
  )
), rX = /* @__PURE__ */ h(
  "SinWave",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sin-wave",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Wd, { ...r, ...e, ref: o });
    }
  )
), hX = /* @__PURE__ */ h(
  "Skeleton",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "skeleton",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ed, { ...r, ...e, ref: o });
    }
  )
), aX = /* @__PURE__ */ h(
  "Skip",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "skip",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(jd, { ...r, ...e, ref: o });
    }
  )
), cX = /* @__PURE__ */ h(
  "Sky",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sky",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Id, { ...r, ...e, ref: o });
    }
  )
), dX = /* @__PURE__ */ h(
  "Sliders",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sliders",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Kd, { ...r, ...e, ref: o });
    }
  )
), wX = /* @__PURE__ */ h(
  "Smartphone",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "smartphone",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Xd, { ...r, ...e, ref: o });
    }
  )
), vX = /* @__PURE__ */ h(
  "SmartphoneOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "smartphone-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Zd, { ...r, ...e, ref: o });
    }
  )
), mX = /* @__PURE__ */ h(
  "Snow",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "snow",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Hq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(nw, { ...r, ...e, ref: o });
    }
  )
), gX = /* @__PURE__ */ h(
  "Sort",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sort",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(tw, { ...r, ...e, ref: o });
    }
  )
), sX = /* @__PURE__ */ h(
  "SortAscending",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sort-ascending",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Vq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ew, { ...r, ...e, ref: o });
    }
  )
), fX = /* @__PURE__ */ h(
  "SortDescending",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sort-descending",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Lq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(rw, { ...r, ...e, ref: o });
    }
  )
), uX = /* @__PURE__ */ h(
  "Soundwaves",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "soundwaves",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Sq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(aw, { ...r, ...e, ref: o });
    }
  )
), pX = /* @__PURE__ */ h(
  "Sparkle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sparkle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(dw, { ...r, ...e, ref: o });
    }
  )
), HX = /* @__PURE__ */ h(
  "Speaker",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "speaker",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Rq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(vw, { ...r, ...e, ref: o });
    }
  )
), MX = /* @__PURE__ */ h(
  "SpeakerHigh",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "speaker-high",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Fq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(gw, { ...r, ...e, ref: o });
    }
  )
), xX = /* @__PURE__ */ h(
  "SpeakerLow",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "speaker-low",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(fw, { ...r, ...e, ref: o });
    }
  )
), zX = /* @__PURE__ */ h(
  "SpeakerMedium",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "speaker-medium",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Dq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(pw, { ...r, ...e, ref: o });
    }
  )
), VX = /* @__PURE__ */ h(
  "SpeakerMute",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "speaker-mute",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Tq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Mw, { ...r, ...e, ref: o });
    }
  )
), CX = /* @__PURE__ */ h(
  "SpeakerOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "speaker-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Gq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(zw, { ...r, ...e, ref: o });
    }
  )
), LX = /* @__PURE__ */ h(
  "Spoon",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "spoon",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Nq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Cw, { ...r, ...e, ref: o });
    }
  )
), $X = /* @__PURE__ */ h(
  "SquareWave",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "square-wave",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Uq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($w, { ...r, ...e, ref: o });
    }
  )
), SX = /* @__PURE__ */ h(
  "StackHorizontal",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "stack-horizontal",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Qq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(kw, { ...r, ...e, ref: o });
    }
  )
), kX = /* @__PURE__ */ h(
  "Stair",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "stair",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Jq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(bw, { ...r, ...e, ref: o });
    }
  )
), yX = /* @__PURE__ */ h(
  "Star",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "star",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Yq, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Bw, { ...r, ...e, ref: o });
    }
  )
), bX = /* @__PURE__ */ h(
  "SteeringWheel",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "steering-wheel",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_q, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Aw, { ...r, ...e, ref: o });
    }
  )
), RX = /* @__PURE__ */ h(
  "StepForward",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "step-forward",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ow, { ...r, ...e, ref: o });
    }
  )
), BX = /* @__PURE__ */ h(
  "StepReverse",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "step-reverse",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Pw, { ...r, ...e, ref: o });
    }
  )
), FX = /* @__PURE__ */ h(
  "Sticker",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sticker",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ww, { ...r, ...e, ref: o });
    }
  )
), AX = /* @__PURE__ */ h(
  "StickerImage",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sticker-image",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ew, { ...r, ...e, ref: o });
    }
  )
), qX = /* @__PURE__ */ h(
  "StickerShape",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sticker-shape",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(jw, { ...r, ...e, ref: o });
    }
  )
), OX = /* @__PURE__ */ h(
  "StickerText",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sticker-text",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Iw, { ...r, ...e, ref: o });
    }
  )
), DX = /* @__PURE__ */ h(
  "StickerZoom",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sticker-zoom",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Kw, { ...r, ...e, ref: o });
    }
  )
), PX = /* @__PURE__ */ h(
  "Stone",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "stone",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Xw, { ...r, ...e, ref: o });
    }
  )
), TX = /* @__PURE__ */ h(
  "Stop",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "stop",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Zw, { ...r, ...e, ref: o });
    }
  )
), WX = /* @__PURE__ */ h(
  "Straw",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "straw",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(n9, { ...r, ...e, ref: o });
    }
  )
), GX = /* @__PURE__ */ h(
  "Strikethrough",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "strikethrough",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(t9, { ...r, ...e, ref: o });
    }
  )
), EX = /* @__PURE__ */ h(
  "StrokeWidth",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "stroke-width",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(e9, { ...r, ...e, ref: o });
    }
  )
), NX = /* @__PURE__ */ h(
  "Style",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "style",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(r9, { ...r, ...e, ref: o });
    }
  )
), jX = /* @__PURE__ */ h(
  "Subtract",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "subtract",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(a9, { ...r, ...e, ref: o });
    }
  )
), UX = /* @__PURE__ */ h(
  "SubtractCircle",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "subtract-circle",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(d9, { ...r, ...e, ref: o });
    }
  )
), IX = /* @__PURE__ */ h(
  "Suitcase",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "suitcase",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(v9, { ...r, ...e, ref: o });
    }
  )
), QX = /* @__PURE__ */ h(
  "SuitClub",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "suit-club",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(g9, { ...r, ...e, ref: o });
    }
  )
), KX = /* @__PURE__ */ h(
  "SuitDiamond",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "suit-diamond",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(f9, { ...r, ...e, ref: o });
    }
  )
), JX = /* @__PURE__ */ h(
  "SuitSpade",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "suit-spade",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(p9, { ...r, ...e, ref: o });
    }
  )
), XX = /* @__PURE__ */ h(
  "SunHigh",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sun-high",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(M9, { ...r, ...e, ref: o });
    }
  )
), YX = /* @__PURE__ */ h(
  "SunLow",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sun-low",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(z9, { ...r, ...e, ref: o });
    }
  )
), ZX = /* @__PURE__ */ h(
  "SunOffHigh",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sun-off-high",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(C9, { ...r, ...e, ref: o });
    }
  )
), _X = /* @__PURE__ */ h(
  "Svg2BLeftClick",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "svg-2-b-left-click",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(bg, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(d, { ...r, ...e, ref: o });
    }
  )
), nY = /* @__PURE__ */ h(
  "Svg3DAxis",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "svg-3-d-axis",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Bg, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(v, { ...r, ...e, ref: o });
    }
  )
), lY = /* @__PURE__ */ h(
  "Svg3SquarePlus",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "svg-3-square-plus",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Ag, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(g, { ...r, ...e, ref: o });
    }
  )
), tY = /* @__PURE__ */ h(
  "Svg4Square",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "svg-4-square",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(Og, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(f, { ...r, ...e, ref: o });
    }
  )
), iY = /* @__PURE__ */ h(
  "Swatches",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "swatches",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($9, { ...r, ...e, ref: o });
    }
  )
), eY = /* @__PURE__ */ h(
  "Sync",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sync",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(k9, { ...r, ...e, ref: o });
    }
  )
), oY = /* @__PURE__ */ h(
  "SyncOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sync-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(b9, { ...r, ...e, ref: o });
    }
  )
), rY = /* @__PURE__ */ h(
  "SyncWarning",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "sync-warning",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YO, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(B9, { ...r, ...e, ref: o });
    }
  )
), hY = /* @__PURE__ */ h(
  "Tablet",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "tablet",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_O, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(A9, { ...r, ...e, ref: o });
    }
  )
), aY = /* @__PURE__ */ h(
  "TabletOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "tablet-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(O9, { ...r, ...e, ref: o });
    }
  )
), cY = /* @__PURE__ */ h(
  "Tag",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "tag",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(P9, { ...r, ...e, ref: o });
    }
  )
), dY = /* @__PURE__ */ h(
  "TagLabel",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "tag-label",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(W9, { ...r, ...e, ref: o });
    }
  )
), wY = /* @__PURE__ */ h(
  "Teapot",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "teapot",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(E9, { ...r, ...e, ref: o });
    }
  )
), vY = /* @__PURE__ */ h(
  "Telephone",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "telephone",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(j9, { ...r, ...e, ref: o });
    }
  )
), mY = /* @__PURE__ */ h(
  "TelephoneOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "telephone-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(I9, { ...r, ...e, ref: o });
    }
  )
), gY = /* @__PURE__ */ h(
  "Teleport",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "teleport",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(K9, { ...r, ...e, ref: o });
    }
  )
), sY = /* @__PURE__ */ h(
  "Telescope",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "telescope",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(X9, { ...r, ...e, ref: o });
    }
  )
), fY = /* @__PURE__ */ h(
  "Television",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "television",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Z9, { ...r, ...e, ref: o });
    }
  )
), uY = /* @__PURE__ */ h(
  "TelevisionRetro",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "television-retro",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(nv, { ...r, ...e, ref: o });
    }
  )
), pY = /* @__PURE__ */ h(
  "Text",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "text",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(tv, { ...r, ...e, ref: o });
    }
  )
), HY = /* @__PURE__ */ h(
  "TextAlignCenter",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "text-align-center",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ev, { ...r, ...e, ref: o });
    }
  )
), MY = /* @__PURE__ */ h(
  "TextAlignFull",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "text-align-full",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(rv, { ...r, ...e, ref: o });
    }
  )
), xY = /* @__PURE__ */ h(
  "TextAlignLeft",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "text-align-left",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(av, { ...r, ...e, ref: o });
    }
  )
), zY = /* @__PURE__ */ h(
  "TextAlignRight",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "text-align-right",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(dv, { ...r, ...e, ref: o });
    }
  )
), VY = /* @__PURE__ */ h(
  "TextFramed",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "text-framed",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(vv, { ...r, ...e, ref: o });
    }
  )
), CY = /* @__PURE__ */ h(
  "Texture",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "texture",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(gv, { ...r, ...e, ref: o });
    }
  )
), LY = /* @__PURE__ */ h(
  "Thermometer",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "thermometer",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(fv, { ...r, ...e, ref: o });
    }
  )
), $Y = /* @__PURE__ */ h(
  "ThumbDown",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "thumb-down",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(pv, { ...r, ...e, ref: o });
    }
  )
), SY = /* @__PURE__ */ h(
  "ThumbUp",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "thumb-up",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Mv, { ...r, ...e, ref: o });
    }
  )
), kY = /* @__PURE__ */ h(
  "Ticket",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "ticket",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(zv, { ...r, ...e, ref: o });
    }
  )
), yY = /* @__PURE__ */ h(
  "Timer",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "timer",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ND, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Cv, { ...r, ...e, ref: o });
    }
  )
), bY = /* @__PURE__ */ h(
  "Toolbox",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "toolbox",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($v, { ...r, ...e, ref: o });
    }
  )
), RY = /* @__PURE__ */ h(
  "TrafficCone",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "traffic-cone",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(kv, { ...r, ...e, ref: o });
    }
  )
), BY = /* @__PURE__ */ h(
  "TransferHorizontal",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "transfer-horizontal",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(bv, { ...r, ...e, ref: o });
    }
  )
), FY = /* @__PURE__ */ h(
  "TransferVertical",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "transfer-vertical",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YD, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Bv, { ...r, ...e, ref: o });
    }
  )
), AY = /* @__PURE__ */ h(
  "Transparency",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "transparency",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_D, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Av, { ...r, ...e, ref: o });
    }
  )
), qY = /* @__PURE__ */ h(
  "Trash",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "trash",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ov, { ...r, ...e, ref: o });
    }
  )
), OY = /* @__PURE__ */ h(
  "TrashDelete",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "trash-delete",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Pv, { ...r, ...e, ref: o });
    }
  )
), DY = /* @__PURE__ */ h(
  "Tree",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "tree",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Wv, { ...r, ...e, ref: o });
    }
  )
), PY = /* @__PURE__ */ h(
  "Trees",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "trees",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Ev, { ...r, ...e, ref: o });
    }
  )
), TY = /* @__PURE__ */ h(
  "Trident",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "trident",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(jv, { ...r, ...e, ref: o });
    }
  )
), WY = /* @__PURE__ */ h(
  "TringleWave",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "tringle-wave",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Iv, { ...r, ...e, ref: o });
    }
  )
), GY = /* @__PURE__ */ h(
  "Typography",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "typography",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Kv, { ...r, ...e, ref: o });
    }
  )
), EY = /* @__PURE__ */ h(
  "Underline",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "underline",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Xv, { ...r, ...e, ref: o });
    }
  )
), NY = /* @__PURE__ */ h(
  "Undo",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "undo",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Zv, { ...r, ...e, ref: o });
    }
  )
), jY = /* @__PURE__ */ h(
  "Upload",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "upload",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(nm, { ...r, ...e, ref: o });
    }
  )
), UY = /* @__PURE__ */ h(
  "Usb",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "usb",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(tm, { ...r, ...e, ref: o });
    }
  )
), IY = /* @__PURE__ */ h(
  "VAlignBottom",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "v-align-bottom",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(em, { ...r, ...e, ref: o });
    }
  )
), QY = /* @__PURE__ */ h(
  "VAlignCenter",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "v-align-center",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(rm, { ...r, ...e, ref: o });
    }
  )
), KY = /* @__PURE__ */ h(
  "VAlignTop",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "v-align-top",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(SP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(am, { ...r, ...e, ref: o });
    }
  )
), JY = /* @__PURE__ */ h(
  "Videocam",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "videocam",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(dm, { ...r, ...e, ref: o });
    }
  )
), XY = /* @__PURE__ */ h(
  "VideocamOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "videocam-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(vm, { ...r, ...e, ref: o });
    }
  )
), YY = /* @__PURE__ */ h(
  "Vr",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "vr",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(gm, { ...r, ...e, ref: o });
    }
  )
), ZY = /* @__PURE__ */ h(
  "Wand",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "wand",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(fm, { ...r, ...e, ref: o });
    }
  )
), _Y = /* @__PURE__ */ h(
  "Warning",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "warning",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(pm, { ...r, ...e, ref: o });
    }
  )
), nZ = /* @__PURE__ */ h(
  "Watch",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "watch",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(TP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Mm, { ...r, ...e, ref: o });
    }
  )
), lZ = /* @__PURE__ */ h(
  "WatchParty",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "watch-party",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(zm, { ...r, ...e, ref: o });
    }
  )
), tZ = /* @__PURE__ */ h(
  "Water",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "water",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Cm, { ...r, ...e, ref: o });
    }
  )
), iZ = /* @__PURE__ */ h(
  "Webcam",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "webcam",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($m, { ...r, ...e, ref: o });
    }
  )
), eZ = /* @__PURE__ */ h(
  "WebcamOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "webcam-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(km, { ...r, ...e, ref: o });
    }
  )
), oZ = /* @__PURE__ */ h(
  "WebcamSettings",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "webcam-settings",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(JP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(bm, { ...r, ...e, ref: o });
    }
  )
), rZ = /* @__PURE__ */ h(
  "Weight",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "weight",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(YP, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Bm, { ...r, ...e, ref: o });
    }
  )
), hZ = /* @__PURE__ */ h(
  "WeightBar",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "weight-bar",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(_P, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Am, { ...r, ...e, ref: o });
    }
  )
), aZ = /* @__PURE__ */ h(
  "Wheel",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "wheel",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(lT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Om, { ...r, ...e, ref: o });
    }
  )
), cZ = /* @__PURE__ */ h(
  "Wheelchair",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "wheelchair",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(iT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Pm, { ...r, ...e, ref: o });
    }
  )
), dZ = /* @__PURE__ */ h(
  "Whispermode",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "whispermode",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(oT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Wm, { ...r, ...e, ref: o });
    }
  )
), wZ = /* @__PURE__ */ h(
  "Wifi",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "wifi",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(hT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Em, { ...r, ...e, ref: o });
    }
  )
), vZ = /* @__PURE__ */ h(
  "WifiOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "wifi-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(cT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(jm, { ...r, ...e, ref: o });
    }
  )
), mZ = /* @__PURE__ */ h(
  "Window",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "window",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(wT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Im, { ...r, ...e, ref: o });
    }
  )
), gZ = /* @__PURE__ */ h(
  "WindowCode",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "window-code",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(mT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Km, { ...r, ...e, ref: o });
    }
  )
), sZ = /* @__PURE__ */ h(
  "WindowGrid",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "window-grid",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(sT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Xm, { ...r, ...e, ref: o });
    }
  )
), fZ = /* @__PURE__ */ h(
  "WindowStack",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "window-stack",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(uT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Zm, { ...r, ...e, ref: o });
    }
  )
), uZ = /* @__PURE__ */ h(
  "WindowTerminal",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "window-terminal",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(HT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ng, { ...r, ...e, ref: o });
    }
  )
), pZ = /* @__PURE__ */ h(
  "WineGlass",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "wine-glass",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(xT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(tg, { ...r, ...e, ref: o });
    }
  )
), HZ = /* @__PURE__ */ h(
  "WirelessModem",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "wireless-modem",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(VT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(eg, { ...r, ...e, ref: o });
    }
  )
), MZ = /* @__PURE__ */ h(
  "WirelessModemOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "wireless-modem-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(LT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(rg, { ...r, ...e, ref: o });
    }
  )
), xZ = /* @__PURE__ */ h(
  "Woman",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "woman",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(ST, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(ag, { ...r, ...e, ref: o });
    }
  )
), zZ = /* @__PURE__ */ h(
  "Workspace",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "workspace",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(yT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(dg, { ...r, ...e, ref: o });
    }
  )
), VZ = /* @__PURE__ */ h(
  "WorkspaceGroup",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "workspace-group",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(RT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(vg, { ...r, ...e, ref: o });
    }
  )
), CZ = /* @__PURE__ */ h(
  "Workstation",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "workstation",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(FT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(gg, { ...r, ...e, ref: o });
    }
  )
), LZ = /* @__PURE__ */ h(
  "WorkstationOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "workstation-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(qT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(fg, { ...r, ...e, ref: o });
    }
  )
), $Z = /* @__PURE__ */ h(
  "WorkstationSystem",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "workstation-system",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(DT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(pg, { ...r, ...e, ref: o });
    }
  )
), SZ = /* @__PURE__ */ h(
  "WorkstationSystemOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "workstation-system-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(
        TT,
        {
          ...r,
          ...e,
          ref: o
        }
      ) : /* @__PURE__ */ l(
        Mg,
        {
          ...r,
          ...e,
          ref: o
        }
      );
    }
  )
), kZ = /* @__PURE__ */ h(
  "World",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "world",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(GT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(zg, { ...r, ...e, ref: o });
    }
  )
), yZ = /* @__PURE__ */ h(
  "WorldOff",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "world-off",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(NT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(Cg, { ...r, ...e, ref: o });
    }
  )
), bZ = /* @__PURE__ */ h(
  "Wrench",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "wrench",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(UT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l($g, { ...r, ...e, ref: o });
    }
  )
), RZ = /* @__PURE__ */ h(
  "Yoke",
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ i(
    ({ size: n, variant: t = "line", ...e }, o) => {
      const r = {
        "data-icon-name": "yoke",
        ...n ? { height: n, width: n } : {}
      };
      return t === "line" ? /* @__PURE__ */ l(QT, { ...r, ...e, ref: o }) : /* @__PURE__ */ l(kg, { ...r, ...e, ref: o });
    }
  )
);
export {
  XT as AccountAdd,
  YT as AccountCheck,
  ZT as AccountMore,
  _T as AccountRemove,
  nW as Add,
  lW as AddCircle,
  tW as AddressBook,
  iW as Airplane,
  eW as Airport,
  oW as Alarm,
  rW as Anchor,
  hW as AnchorCenter,
  aW as AnchorE,
  cW as AnchorN,
  dW as AnchorNe,
  wW as AnchorNw,
  vW as AnchorS,
  mW as AnchorSe,
  gW as AnchorSw,
  sW as AnchorW,
  fW as Approximately,
  uW as Apps,
  pW as Archive,
  HW as Arrow,
  MW as ArrowDown,
  xW as ArrowDownLeft,
  zW as ArrowDownMax,
  VW as ArrowDownRight,
  CW as ArrowLeft,
  LW as ArrowLeftMax,
  $W as ArrowLeftRight,
  SW as ArrowRight,
  kW as ArrowRightMax,
  yW as ArrowUp,
  bW as ArrowUpDown,
  RW as ArrowUpLeft,
  BW as ArrowUpMax,
  FW as ArrowUpRight,
  AW as AtSymbol,
  qW as AutoRecord,
  OW as AutoRecordOff,
  DW as AwardRibbon,
  PW as AwardTrophy,
  TW as Baby,
  WW as Backspace,
  GW as Bandaid,
  EW as Bank,
  NW as Barcode,
  jW as Battery0,
  UW as Battery0Off,
  JW as Battery100,
  IW as Battery25,
  QW as Battery50,
  KW as Battery75,
  XW as BatteryBoost,
  YW as BatteryCharging,
  ZW as Beaker,
  _W as Bed,
  nG as Bell,
  lG as BellOff,
  tG as Bicycle,
  iG as Blackboard,
  eG as Bluetooth,
  oG as BluetoothOff,
  rG as Bold,
  hG as Book,
  aG as Bookmark,
  cG as BookmarkOff,
  dG as Bottle,
  wG as BoundingBox,
  vG as Braille,
  mG as Briefcase,
  gG as Broadcast,
  sG as Brush,
  fG as Bucket,
  uG as Bug,
  pG as BugOff,
  HG as Bush,
  MG as Business,
  xG as Calculator,
  zG as Calendar,
  VG as CalendarEvent,
  CG as Camera,
  LG as Camera360,
  $G as CameraAdd,
  SG as CameraLinked,
  kG as CameraOff,
  yG as CameraSuper,
  bG as Cancel,
  RG as Car,
  BG as CarouselHorizontal,
  FG as CarouselVertical,
  AG as Castle,
  qG as Chart,
  OG as ChartBar,
  DG as ChartBubble,
  PG as ChartFlow,
  TG as ChartHierarchy,
  WG as ChartPerformance,
  GG as ChartPie,
  EG as ChartScatterplot,
  NG as ChartTree,
  UG as ChatMessage,
  IG as ChatMulti,
  QG as ChatNew,
  KG as ChatSingle,
  jG as Chatbot,
  JG as Check,
  XG as CheckCircle,
  ZG as CheckMultiCircle,
  YG as CheckmarkBadge,
  _G as ChevronDoubleDown,
  nE as ChevronDoubleLeft,
  lE as ChevronDoubleRight,
  tE as ChevronDoubleUp,
  iE as ChevronDown,
  eE as ChevronDownLeftUpRight,
  oE as ChevronLeft,
  rE as ChevronLeftRight,
  hE as ChevronRight,
  aE as ChevronUp,
  cE as ChevronUpDown,
  dE as ChevronUpLeftDownRight,
  wE as Circle1Q,
  vE as Circle2Q,
  mE as Circle3Q,
  gE as CircleTick,
  sE as City,
  fE as ClapBoard,
  uE as Clipboard,
  pE as Clock,
  HE as Close,
  ME as CloseCircle,
  xE as ClosedCaption,
  zE as Cloth,
  VE as Cloud,
  CE as CloudOff,
  LE as Code,
  $E as Cog,
  SE as CogOff,
  kE as Collapse,
  yE as Collection,
  bE as Commit,
  RE as Compass,
  BE as Connection,
  FE as CopyDoc,
  AE as CopyGeneric,
  qE as Cpu,
  OE as CraftKnife,
  DE as Crop,
  PE as Crosshair,
  TE as Crown,
  WE as Cube,
  GE as CubeStack,
  EE as Data,
  NE as Datacenter,
  jE as Db,
  UE as DeliveryTruck,
  IE as Denoise,
  QE as Diamond,
  KE as DiamondOff,
  JE as Dirt,
  XE as Display,
  YE as DisplayCollection,
  ZE as DisplayColumn,
  _E as DisplayOff,
  nN as DisplayRow,
  lN as DisplayShare,
  tN as DisplaySurround,
  iN as Divide,
  eN as Document,
  oN as DocumentCheckmark,
  rN as DocumentNew,
  hN as DocumentPreview,
  aN as Dolly,
  cN as Download,
  dN as DriveCloud,
  wN as DriveCloudOff,
  vN as DriveNetwork,
  mN as DriveNetworkOff,
  gN as DriveRemovable,
  sN as DriveRemovableOff,
  fN as DriveUsb,
  uN as DriveUsbOff,
  pN as Drone,
  HN as Dual,
  MN as Easel,
  xN as Eject,
  zN as Ekg,
  VN as Elevator,
  CN as Emissive,
  LN as Engine,
  $N as Enter,
  SN as Envelope,
  kN as EnvelopeOff,
  yN as Equal,
  bN as Equalizer,
  RN as Eraser,
  BN as Error,
  FN as Escalator,
  AN as Ethernet,
  qN as Exit,
  ON as Expand,
  DN as Explode,
  PN as Export,
  TN as ExportToClipboard,
  WN as Eye,
  EN as EyeOff,
  GN as Eyedropper,
  NN as Factory,
  jN as Faders,
  UN as Fan,
  IN as FanLoud,
  QN as FanQuiet,
  KN as Farm,
  JN as FastForward,
  XN as FastReverse,
  YN as Feedback,
  ZN as FeelingHappy,
  _N as FeelingNeutral,
  nj as FeelingSad,
  lj as FeelingVeryHappy,
  tj as FeelingVerySad,
  ij as FileReel,
  ej as Film,
  oj as FilmAdd,
  rj as FilmCollection,
  hj as Filter,
  aj as Fingerprint,
  cj as Fire,
  dj as Firecracker,
  wj as Firewall,
  vj as FirewallOff,
  mj as Firework,
  gj as Fit,
  sj as FitToPage,
  fj as Flag,
  uj as FlightStick,
  pj as Floppy,
  Hj as Flower,
  Mj as Fog,
  xj as FolderClosed,
  zj as FolderOpen,
  Vj as Food,
  Cj as Footprint,
  Lj as Fork,
  $j as Forward,
  Sj as Forward10,
  kj as Founders,
  yj as FoundersTier1,
  bj as FoundersTier2,
  Rj as FoundersTier3,
  Bj as Fps,
  Fj as Freehand,
  Aj as FuelCan,
  qj as FuelPump,
  Oj as Fullscreen,
  Dj as FullscreenExit,
  Pj as Function,
  Tj as GalleryStrip,
  Wj as Gamepad,
  Gj as GamepadOff,
  Ej as GamepadStart,
  Nj as Gift,
  jj as Government,
  Uj as Gpu,
  Ij as GpuCard,
  Qj as GpuCardMulti,
  Kj as GpuCardOff,
  Jj as GpuOff,
  Xj as Graduate,
  Yj as GraphNode,
  Zj as GraphNodeConnect,
  _j as GraphNodeDelete,
  nU as Grass,
  lU as Gravel,
  tU as Grid,
  iU as GridOff,
  eU as GripArea,
  oU as GripCorner,
  rU as GripEdgeHorizontal,
  hU as GripEdgeVertical,
  aU as GripMini,
  cU as Group,
  dU as HAlignCenter,
  wU as HAlignLeft,
  vU as HAlignRight,
  mU as HandClosed,
  gU as HandOpen,
  sU as HandPinch,
  fU as HandPoint,
  uU as Head,
  pU as Header,
  HU as Headset,
  MU as Health,
  xU as Heart,
  zU as HeartOff,
  VU as Helicopter,
  CU as HelpCircle,
  $U as HighQuality,
  LU as Highlighter,
  SU as Hill,
  kU as History,
  yU as Home,
  bU as HomeOff,
  RU as HotAirBalloon,
  BU as Hourglass,
  FU as HourglassEnd,
  AU as HourglassMid,
  qU as HourglassStart,
  OU as Hud,
  DU as Hydrant,
  PU as Identification,
  TU as Image,
  WU as Ime,
  GU as Import,
  EU as ImportImage,
  NU as Infinity,
  jU as InfoCircle,
  UU as Instance,
  IU as Isp,
  QU as IspOff,
  KU as Italic,
  JU as Iterate,
  XU as JoystickClassic,
  YU as Key,
  ZU as Keyboard,
  _U as Keyframe,
  nI as Knife,
  lI as Lamp,
  tI as Laptop,
  iI as Lasso,
  eI as Layers,
  oI as LayersOff,
  rI as LayoutColumns,
  hI as LayoutDetail,
  aI as LayoutGrid,
  cI as LayoutList,
  dI as LayoutRows,
  wI as Library,
  vI as LibraryGames,
  mI as License,
  gI as Lifebouy,
  uI as LightRect,
  pI as LightRotate,
  sI as Lightbulb,
  fI as Lightning,
  HI as LineSegment,
  MI as Link,
  xI as LinkBreak,
  zI as ListBullet,
  VI as ListCheckmark,
  CI as ListNumber,
  LI as Location,
  $I as LocationOff,
  SI as LockClosed,
  kI as LockOpen,
  yI as Loop,
  bI as LoopOff,
  RI as Mac,
  BI as MacOff,
  FI as Magnet,
  AI as MagnifyingGlass,
  qI as MagnifyingGlassMinus,
  OI as MagnifyingGlassPlus,
  DI as Man,
  PI as ManWoman,
  TI as Map,
  WI as MapOff,
  GI as Markdown,
  EI as Martini,
  NI as MaskInside,
  jI as MaskOutside,
  UI as Material,
  II as Math,
  QI as MediaOptical,
  KI as Medicine,
  JI as Megaphone,
  XI as Menu,
  YI as Microphone,
  ZI as MicrophoneOff,
  _I as Microscope,
  nQ as MirrorHorizontal,
  lQ as MirrorVertical,
  tQ as ModeComponent,
  iQ as Money,
  eQ as MoneyCoin,
  oQ as MoneyPaper,
  rQ as Moon,
  hQ as MoonOff,
  aQ as MoreHoriz,
  cQ as MoreVert,
  dQ as Mosaic,
  wQ as Mountain,
  vQ as Mouse2B,
  mQ as Mouse2BRightClick,
  gQ as Mouse3B,
  sQ as MouseScrollwheel,
  fQ as MouseScrollwheelActive,
  uQ as Move,
  pQ as MoveGlobal,
  HQ as Mud,
  MQ as Mug,
  xQ as MugBeer,
  zQ as Multidrive,
  VQ as Network,
  CQ as NetworkConnection,
  LQ as NetworkPcs,
  $Q as NetworkSignal,
  SQ as NetworkSignalOff,
  kQ as NeuralNetwork,
  yQ as News,
  bQ as Next,
  RQ as NotEqual,
  BQ as Notes,
  FQ as Numbers,
  AQ as NvidiaShield,
  qQ as NvidiaShieldStand,
  OQ as OpenExternal,
  DQ as OutletA,
  PQ as OutletB,
  TQ as OutletC,
  WQ as OutletE,
  GQ as OutletG,
  EQ as OutletH,
  NQ as OutletI,
  jQ as OutletJ,
  UQ as OutletK,
  IQ as OutletL,
  QQ as Outpainting,
  KQ as Package,
  JQ as Palette,
  XQ as Paperclip,
  YQ as Paperplane,
  ZQ as Paragraph,
  _Q as Park,
  nK as Pause,
  lK as Pawprint,
  tK as PaymentCard,
  iK as Pencil,
  eK as PerformanceHigh,
  oK as PerformanceLow,
  rK as PerformanceMedium,
  hK as PhoneLaptop,
  aK as PictureInPicture,
  cK as PillBarStack,
  dK as Pin,
  wK as PinOff,
  vK as Pizza,
  mK as Placesetting,
  gK as Play,
  fK as PlugRecepticle,
  uK as PlugUsb,
  sK as Plugin,
  pK as Podium,
  HK as Power,
  MK as PrayerRoom,
  xK as Previous,
  zK as Profile,
  VK as ProfileGroup,
  CK as ProfileOff,
  LK as Projector,
  $K as Pulse,
  SK as Puzzle,
  kK as Qrcode,
  yK as Radar,
  bK as Radioactive,
  RK as Ram,
  BK as RankingXp,
  FK as Record,
  AK as RectangleGroup,
  qK as Redo,
  OK as Reference,
  DK as Refresh,
  PK as Remote,
  TK as Render,
  WK as Replay,
  GK as ReplayOff,
  EK as Reply,
  NK as Reset,
  jK as Retry,
  UK as Return,
  IK as Reverse10,
  QK as River,
  KK as RobotArm,
  JK as Rock,
  XK as Rocket,
  YK as Rotate,
  ZK as Rotate3D,
  _K as Rotate90Clockwise,
  nJ as Rotate90Counter,
  lJ as RotateGlobal,
  tJ as Route,
  iJ as Ruler,
  eJ as Running,
  oJ as Sailboat,
  rJ as Sand,
  hJ as SawWave,
  aJ as Scale,
  cJ as ScaleBalance,
  dJ as ScaleDown,
  wJ as ScaleRelative,
  vJ as ScaleRelativeOff,
  mJ as ScaleReset,
  gJ as ScaleUp,
  sJ as School,
  fJ as Scissors,
  uJ as ScmBranch,
  pJ as ScmCompare,
  HJ as ScmFork,
  MJ as ScmMerge,
  xJ as ScmPull,
  zJ as ScmPullClose,
  VJ as ScmPullDraft,
  CJ as SdCard,
  LJ as Sea,
  $J as Section,
  SJ as SectionBottom,
  kJ as SectionTop,
  yJ as Secure,
  bJ as Seed,
  RJ as Segmap,
  BJ as Segment,
  FJ as SelectBrush,
  AJ as SelectEllipse,
  qJ as SelectPolygon,
  OJ as SelectRectangle,
  DJ as SendImage,
  PJ as Sensor,
  TJ as Shader,
  WJ as ShaderBall,
  GJ as ShapeCircle,
  EJ as ShapeCircleOff,
  NJ as ShapeHexagon,
  jJ as ShapeOctogon,
  IJ as ShapeSquare,
  QJ as ShapeSquareOff,
  KJ as ShapeTriangle,
  UJ as Shapes,
  JJ as Share,
  XJ as Shield,
  YJ as ShieldOff,
  ZJ as Ship,
  _J as ShipWheel,
  nX as ShoppingBag,
  lX as ShoppingBasket,
  tX as ShoppingCart,
  iX as ShoppingCartOpen,
  eX as Signature,
  oX as Signpost,
  rX as SinWave,
  hX as Skeleton,
  aX as Skip,
  cX as Sky,
  dX as Sliders,
  wX as Smartphone,
  vX as SmartphoneOff,
  mX as Snow,
  gX as Sort,
  sX as SortAscending,
  fX as SortDescending,
  uX as Soundwaves,
  pX as Sparkle,
  HX as Speaker,
  MX as SpeakerHigh,
  xX as SpeakerLow,
  zX as SpeakerMedium,
  VX as SpeakerMute,
  CX as SpeakerOff,
  LX as Spoon,
  $X as SquareWave,
  SX as StackHorizontal,
  kX as Stair,
  yX as Star,
  bX as SteeringWheel,
  RX as StepForward,
  BX as StepReverse,
  FX as Sticker,
  AX as StickerImage,
  qX as StickerShape,
  OX as StickerText,
  DX as StickerZoom,
  PX as Stone,
  TX as Stop,
  WX as Straw,
  GX as Strikethrough,
  EX as StrokeWidth,
  NX as Style,
  jX as Subtract,
  UX as SubtractCircle,
  QX as SuitClub,
  KX as SuitDiamond,
  JX as SuitSpade,
  IX as Suitcase,
  XX as SunHigh,
  YX as SunLow,
  ZX as SunOffHigh,
  _X as Svg2BLeftClick,
  nY as Svg3DAxis,
  lY as Svg3SquarePlus,
  tY as Svg4Square,
  iY as Swatches,
  eY as Sync,
  oY as SyncOff,
  rY as SyncWarning,
  hY as Tablet,
  aY as TabletOff,
  cY as Tag,
  dY as TagLabel,
  wY as Teapot,
  vY as Telephone,
  mY as TelephoneOff,
  gY as Teleport,
  sY as Telescope,
  fY as Television,
  uY as TelevisionRetro,
  pY as Text,
  HY as TextAlignCenter,
  MY as TextAlignFull,
  xY as TextAlignLeft,
  zY as TextAlignRight,
  VY as TextFramed,
  CY as Texture,
  LY as Thermometer,
  $Y as ThumbDown,
  SY as ThumbUp,
  kY as Ticket,
  yY as Timer,
  bY as Toolbox,
  RY as TrafficCone,
  BY as TransferHorizontal,
  FY as TransferVertical,
  AY as Transparency,
  qY as Trash,
  OY as TrashDelete,
  DY as Tree,
  PY as Trees,
  TY as Trident,
  WY as TringleWave,
  GY as Typography,
  EY as Underline,
  NY as Undo,
  jY as Upload,
  UY as Usb,
  IY as VAlignBottom,
  QY as VAlignCenter,
  KY as VAlignTop,
  JY as Videocam,
  XY as VideocamOff,
  YY as Vr,
  ZY as Wand,
  _Y as Warning,
  nZ as Watch,
  lZ as WatchParty,
  tZ as Water,
  iZ as Webcam,
  eZ as WebcamOff,
  oZ as WebcamSettings,
  rZ as Weight,
  hZ as WeightBar,
  aZ as Wheel,
  cZ as Wheelchair,
  dZ as Whispermode,
  wZ as Wifi,
  vZ as WifiOff,
  mZ as Window,
  gZ as WindowCode,
  sZ as WindowGrid,
  fZ as WindowStack,
  uZ as WindowTerminal,
  pZ as WineGlass,
  HZ as WirelessModem,
  MZ as WirelessModemOff,
  xZ as Woman,
  zZ as Workspace,
  VZ as WorkspaceGroup,
  CZ as Workstation,
  LZ as WorkstationOff,
  $Z as WorkstationSystem,
  SZ as WorkstationSystemOff,
  kZ as World,
  yZ as WorldOff,
  bZ as Wrench,
  RZ as Yoke
};
